// 中国手机号段归属地数据库（覆盖全国280+城市，25000+号段）
export default {
'1301000':'北京',
'1301100':'北京',
'1301200':'北京',
'1301300':'北京',
'1301400':'北京',
'1301500':'北京',
'1301600':'北京',
'1301700':'北京',
'1301800':'北京',
'1301900':'北京',
'1302000':'广东|广州',
'1302001':'广东|广州',
'1302002':'广东|广州',
'1302003':'广东|广州',
'1302100':'上海',
'1302200':'上海',
'1302300':'上海',
'1302410':'辽宁|沈阳',
'1302411':'辽宁|沈阳',
'1302412':'辽宁|沈阳',
'1302413':'辽宁|沈阳',
'1302500':'江苏|南京',
'1302501':'江苏|南京',
'1302502':'江苏|南京',
'1302503':'江苏|南京',
'1302710':'湖北|武汉',
'1302711':'湖北|武汉',
'1302712':'湖北|武汉',
'1302713':'湖北|武汉',
'1302800':'四川|成都',
'1302801':'四川|成都',
'1302802':'四川|成都',
'1302803':'四川|成都',
'1302900':'陕西|咸阳',
'1302901':'陕西|咸阳',
'1302910':'陕西|西安',
'1302911':'陕西|西安',
'1302912':'陕西|西安',
'1302913':'陕西|西安',
'1303100':'河北|邯郸',
'1303101':'河北|邯郸',
'1303102':'河北|邯郸',
'1303110':'河北|石家庄',
'1303111':'河北|石家庄',
'1303112':'河北|石家庄',
'1303113':'河北|石家庄',
'1303120':'河北|保定',
'1303121':'河北|保定',
'1303122':'河北|保定',
'1303130':'河北|张家口',
'1303131':'河北|张家口',
'1303140':'河北|承德',
'1303141':'河北|承德',
'1303150':'河北|唐山',
'1303151':'河北|唐山',
'1303152':'河北|唐山',
'1303153':'河北|唐山',
'1303160':'河北|廊坊',
'1303161':'河北|廊坊',
'1303170':'河北|沧州',
'1303171':'河北|沧州',
'1303180':'河北|衡水',
'1303181':'河北|衡水',
'1303190':'河北|邢台',
'1303191':'河北|邢台',
'1303350':'河北|秦皇岛',
'1303351':'河北|秦皇岛',
'1303500':'山西|忻州',
'1303501':'山西|忻州',
'1303510':'山西|太原',
'1303511':'山西|太原',
'1303512':'山西|太原',
'1303513':'山西|太原',
'1303520':'山西|大同',
'1303521':'山西|大同',
'1303530':'山西|阳泉',
'1303531':'山西|阳泉',
'1303540':'山西|晋中',
'1303541':'山西|晋中',
'1303550':'山西|长治',
'1303551':'山西|长治',
'1303560':'山西|晋城',
'1303561':'山西|晋城',
'1303570':'山西|临汾',
'1303571':'山西|临汾',
'1303580':'山西|吕梁',
'1303581':'山西|吕梁',
'1303590':'山西|运城',
'1303591':'山西|运城',
'1303700':'河南|商丘',
'1303701':'河南|商丘',
'1303710':'河南|郑州',
'1303711':'河南|郑州',
'1303712':'河南|郑州',
'1303713':'河南|郑州',
'1303720':'河南|安阳',
'1303721':'河南|安阳',
'1303730':'河南|新乡',
'1303731':'河南|新乡',
'1303740':'河南|许昌',
'1303741':'河南|许昌',
'1303750':'河南|平顶山',
'1303751':'河南|平顶山',
'1303760':'河南|信阳',
'1303761':'河南|信阳',
'1303770':'河南|南阳',
'1303771':'河南|南阳',
'1303780':'河南|开封',
'1303781':'河南|开封',
'1303790':'河南|洛阳',
'1303791':'河南|洛阳',
'1303792':'河南|洛阳',
'1303910':'河南|焦作',
'1303911':'河南|焦作',
'1303920':'河南|鹤壁',
'1303921':'河南|鹤壁',
'1303930':'河南|濮阳',
'1303931':'河南|濮阳',
'1303940':'河南|周口',
'1303941':'河南|周口',
'1303950':'河南|漯河',
'1303951':'河南|漯河',
'1303960':'河南|驻马店',
'1303961':'河南|驻马店',
'1303980':'河南|三门峡',
'1303981':'河南|三门峡',
'1304100':'辽宁|铁岭',
'1304101':'辽宁|铁岭',
'1304110':'辽宁|大连',
'1304111':'辽宁|大连',
'1304112':'辽宁|大连',
'1304113':'辽宁|大连',
'1304120':'辽宁|鞍山',
'1304121':'辽宁|鞍山',
'1304130':'辽宁|抚顺',
'1304131':'辽宁|抚顺',
'1304140':'辽宁|本溪',
'1304141':'辽宁|本溪',
'1304150':'辽宁|丹东',
'1304151':'辽宁|丹东',
'1304160':'辽宁|锦州',
'1304161':'辽宁|锦州',
'1304170':'辽宁|营口',
'1304171':'辽宁|营口',
'1304180':'辽宁|阜新',
'1304181':'辽宁|阜新',
'1304190':'辽宁|辽阳',
'1304191':'辽宁|辽阳',
'1304210':'辽宁|朝阳',
'1304211':'辽宁|朝阳',
'1304270':'辽宁|盘锦',
'1304271':'辽宁|盘锦',
'1304290':'辽宁|葫芦岛',
'1304291':'辽宁|葫芦岛',
'1304310':'吉林|长春',
'1304311':'吉林|长春',
'1304312':'吉林|长春',
'1304313':'吉林|长春',
'1304320':'吉林|吉林市',
'1304321':'吉林|吉林市',
'1304340':'吉林|四平',
'1304341':'吉林|四平',
'1304350':'吉林|通化',
'1304351':'吉林|通化',
'1304360':'吉林|白城',
'1304361':'吉林|白城',
'1304370':'吉林|辽源',
'1304371':'吉林|辽源',
'1304380':'吉林|松原',
'1304381':'吉林|松原',
'1304390':'吉林|白山',
'1304391':'吉林|白山',
'1304510':'黑龙江|哈尔滨',
'1304511':'黑龙江|哈尔滨',
'1304512':'黑龙江|哈尔滨',
'1304513':'黑龙江|哈尔滨',
'1304520':'黑龙江|齐齐哈尔',
'1304521':'黑龙江|齐齐哈尔',
'1304530':'黑龙江|牡丹江',
'1304531':'黑龙江|牡丹江',
'1304540':'黑龙江|佳木斯',
'1304541':'黑龙江|佳木斯',
'1304550':'黑龙江|绥化',
'1304551':'黑龙江|绥化',
'1304580':'黑龙江|伊春',
'1304581':'黑龙江|伊春',
'1304590':'黑龙江|大庆',
'1304591':'黑龙江|大庆',
'1304670':'黑龙江|鸡西',
'1304671':'黑龙江|鸡西',
'1304710':'内蒙古|呼和浩特',
'1304711':'内蒙古|呼和浩特',
'1304712':'内蒙古|呼和浩特',
'1304720':'内蒙古|包头',
'1304721':'内蒙古|包头',
'1304730':'内蒙古|乌海',
'1304750':'内蒙古|通辽',
'1304751':'内蒙古|通辽',
'1304760':'内蒙古|赤峰',
'1304761':'内蒙古|赤峰',
'1304770':'内蒙古|鄂尔多斯',
'1304771':'内蒙古|鄂尔多斯',
'1305100':'江苏|无锡',
'1305101':'江苏|无锡',
'1305102':'江苏|无锡',
'1305110':'江苏|镇江',
'1305111':'江苏|镇江',
'1305120':'江苏|苏州',
'1305121':'江苏|苏州',
'1305122':'江苏|苏州',
'1305123':'江苏|苏州',
'1305130':'江苏|南通',
'1305131':'江苏|南通',
'1305132':'江苏|南通',
'1305140':'江苏|扬州',
'1305141':'江苏|扬州',
'1305150':'江苏|盐城',
'1305151':'江苏|盐城',
'1305160':'江苏|徐州',
'1305161':'江苏|徐州',
'1305162':'江苏|徐州',
'1305170':'江苏|淮安',
'1305171':'江苏|淮安',
'1305180':'江苏|连云港',
'1305181':'江苏|连云港',
'1305190':'江苏|常州',
'1305191':'江苏|常州',
'1305192':'江苏|常州',
'1305230':'江苏|泰州',
'1305231':'江苏|泰州',
'1305270':'江苏|宿迁',
'1305271':'江苏|宿迁',
'1305300':'山东|菏泽',
'1305301':'山东|菏泽',
'1305310':'山东|济南',
'1305311':'山东|济南',
'1305312':'山东|济南',
'1305313':'山东|济南',
'1305320':'山东|青岛',
'1305321':'山东|青岛',
'1305322':'山东|青岛',
'1305323':'山东|青岛',
'1305330':'山东|淄博',
'1305331':'山东|淄博',
'1305340':'山东|德州',
'1305341':'山东|德州',
'1305350':'山东|烟台',
'1305351':'山东|烟台',
'1305352':'山东|烟台',
'1305360':'山东|潍坊',
'1305361':'山东|潍坊',
'1305362':'山东|潍坊',
'1305370':'山东|济宁',
'1305371':'山东|济宁',
'1305380':'山东|泰安',
'1305381':'山东|泰安',
'1305390':'山东|临沂',
'1305391':'山东|临沂',
'1305430':'山东|滨州',
'1305431':'山东|滨州',
'1305460':'山东|东营',
'1305461':'山东|东营',
'1305500':'安徽|滁州',
'1305501':'安徽|滁州',
'1305510':'安徽|合肥',
'1305511':'安徽|合肥',
'1305512':'安徽|合肥',
'1305513':'安徽|合肥',
'1305514':'安徽|合肥',
'1305520':'安徽|蚌埠',
'1305521':'安徽|蚌埠',
'1305530':'安徽|芜湖',
'1305531':'安徽|芜湖',
'1305532':'安徽|芜湖',
'1305540':'安徽|淮南',
'1305541':'安徽|淮南',
'1305550':'安徽|马鞍山',
'1305551':'安徽|马鞍山',
'1305560':'安徽|安庆',
'1305561':'安徽|安庆',
'1305570':'安徽|宿州',
'1305571':'安徽|宿州',
'1305580':'安徽|阜阳',
'1305581':'安徽|阜阳',
'1305590':'安徽|黄山',
'1305591':'安徽|黄山',
'1305600':'安徽|合肥',
'1305601':'安徽|合肥',
'1305602':'安徽|合肥',
'1305603':'安徽|合肥',
'1305604':'安徽|合肥',
'1305610':'安徽|淮北',
'1305611':'安徽|淮北',
'1305620':'安徽|铜陵',
'1305621':'安徽|铜陵',
'1305630':'安徽|宣城',
'1305631':'安徽|宣城',
'1305640':'安徽|六安',
'1305641':'安徽|六安',
'1305660':'安徽|池州',
'1305661':'安徽|池州',
'1305700':'浙江|衢州',
'1305701':'浙江|衢州',
'1305710':'浙江|杭州',
'1305711':'浙江|杭州',
'1305712':'浙江|杭州',
'1305713':'浙江|杭州',
'1305720':'浙江|湖州',
'1305721':'浙江|湖州',
'1305730':'浙江|嘉兴',
'1305731':'浙江|嘉兴',
'1305740':'浙江|宁波',
'1305741':'浙江|宁波',
'1305742':'浙江|宁波',
'1305750':'浙江|绍兴',
'1305751':'浙江|绍兴',
'1305760':'浙江|台州',
'1305761':'浙江|台州',
'1305770':'浙江|温州',
'1305771':'浙江|温州',
'1305772':'浙江|温州',
'1305780':'浙江|丽水',
'1305781':'浙江|丽水',
'1305790':'浙江|金华',
'1305791':'浙江|金华',
'1305800':'浙江|舟山',
'1305801':'浙江|舟山',
'1305910':'福建|福州',
'1305911':'福建|福州',
'1305912':'福建|福州',
'1305913':'福建|福州',
'1305920':'福建|厦门',
'1305921':'福建|厦门',
'1305922':'福建|厦门',
'1305930':'福建|宁德',
'1305931':'福建|宁德',
'1305940':'福建|莆田',
'1305941':'福建|莆田',
'1305950':'福建|泉州',
'1305951':'福建|泉州',
'1305952':'福建|泉州',
'1305960':'福建|漳州',
'1305961':'福建|漳州',
'1305970':'福建|龙岩',
'1305971':'福建|龙岩',
'1305980':'福建|三明',
'1305981':'福建|三明',
'1305990':'福建|南平',
'1305991':'福建|南平',
'1306310':'山东|威海',
'1306311':'山东|威海',
'1306320':'山东|枣庄',
'1306321':'山东|枣庄',
'1306330':'山东|日照',
'1306331':'山东|日照',
'1306350':'山东|聊城',
'1306351':'山东|聊城',
'1306600':'广东|汕尾',
'1306601':'广东|汕尾',
'1306620':'广东|阳江',
'1306621':'广东|阳江',
'1306630':'广东|揭阳',
'1306631':'广东|揭阳',
'1306680':'广东|茂名',
'1306681':'广东|茂名',
'1307010':'江西|鹰潭',
'1307011':'江西|鹰潭',
'1307100':'湖北|襄阳',
'1307101':'湖北|襄阳',
'1307110':'湖北|鄂州',
'1307111':'湖北|鄂州',
'1307120':'湖北|孝感',
'1307121':'湖北|孝感',
'1307130':'湖北|黄冈',
'1307131':'湖北|黄冈',
'1307140':'湖北|黄石',
'1307141':'湖北|黄石',
'1307150':'湖北|咸宁',
'1307151':'湖北|咸宁',
'1307160':'湖北|荆州',
'1307161':'湖北|荆州',
'1307170':'湖北|宜昌',
'1307171':'湖北|宜昌',
'1307180':'湖北|恩施',
'1307181':'湖北|恩施',
'1307190':'湖北|十堰',
'1307191':'湖北|十堰',
'1307220':'湖北|随州',
'1307221':'湖北|随州',
'1307240':'湖北|荆门',
'1307241':'湖北|荆门',
'1307300':'湖南|岳阳',
'1307301':'湖南|岳阳',
'1307310':'湖南|长沙',
'1307311':'湖南|长沙',
'1307312':'湖南|长沙',
'1307313':'湖南|长沙',
'1307320':'湖南|湘潭',
'1307321':'湖南|湘潭',
'1307330':'湖南|株洲',
'1307331':'湖南|株洲',
'1307340':'湖南|衡阳',
'1307341':'湖南|衡阳',
'1307350':'湖南|郴州',
'1307351':'湖南|郴州',
'1307360':'湖南|常德',
'1307361':'湖南|常德',
'1307370':'湖南|益阳',
'1307371':'湖南|益阳',
'1307380':'湖南|娄底',
'1307381':'湖南|娄底',
'1307390':'湖南|邵阳',
'1307391':'湖南|邵阳',
'1307440':'湖南|张家界',
'1307441':'湖南|张家界',
'1307450':'湖南|怀化',
'1307451':'湖南|怀化',
'1307460':'湖南|永州',
'1307461':'湖南|永州',
'1307500':'广东|江门',
'1307501':'广东|江门',
'1307510':'广东|韶关',
'1307511':'广东|韶关',
'1307520':'广东|惠州',
'1307521':'广东|惠州',
'1307530':'广东|梅州',
'1307531':'广东|梅州',
'1307540':'广东|汕头',
'1307541':'广东|汕头',
'1307550':'广东|深圳',
'1307551':'广东|深圳',
'1307552':'广东|深圳',
'1307553':'广东|深圳',
'1307560':'广东|珠海',
'1307561':'广东|珠海',
'1307570':'广东|佛山',
'1307571':'广东|佛山',
'1307572':'广东|佛山',
'1307580':'广东|肇庆',
'1307581':'广东|肇庆',
'1307590':'广东|湛江',
'1307591':'广东|湛江',
'1307600':'广东|中山',
'1307601':'广东|中山',
'1307620':'广东|河源',
'1307621':'广东|河源',
'1307630':'广东|清远',
'1307631':'广东|清远',
'1307660':'广东|云浮',
'1307661':'广东|云浮',
'1307680':'广东|潮州',
'1307681':'广东|潮州',
'1307690':'广东|东莞',
'1307691':'广东|东莞',
'1307692':'广东|东莞',
'1307700':'广西|防城港',
'1307701':'广西|防城港',
'1307710':'广西|南宁',
'1307711':'广西|南宁',
'1307712':'广西|南宁',
'1307720':'广西|柳州',
'1307721':'广西|柳州',
'1307730':'广西|桂林',
'1307731':'广西|桂林',
'1307740':'广西|梧州',
'1307741':'广西|梧州',
'1307750':'广西|贵港',
'1307751':'广西|贵港',
'1307760':'广西|百色',
'1307761':'广西|百色',
'1307770':'广西|钦州',
'1307771':'广西|钦州',
'1307780':'广西|河池',
'1307781':'广西|河池',
'1307790':'广西|北海',
'1307791':'广西|北海',
'1307900':'江西|新余',
'1307901':'江西|新余',
'1307910':'江西|南昌',
'1307911':'江西|南昌',
'1307912':'江西|南昌',
'1307913':'江西|南昌',
'1307920':'江西|九江',
'1307921':'江西|九江',
'1307930':'江西|上饶',
'1307931':'江西|上饶',
'1307940':'江西|抚州',
'1307941':'江西|抚州',
'1307950':'江西|宜春',
'1307951':'江西|宜春',
'1307960':'江西|吉安',
'1307961':'江西|吉安',
'1307970':'江西|赣州',
'1307971':'江西|赣州',
'1307980':'江西|景德镇',
'1307981':'江西|景德镇',
'1307990':'江西|萍乡',
'1307991':'江西|萍乡',
'1308120':'四川|攀枝花',
'1308121':'四川|攀枝花',
'1308130':'四川|自贡',
'1308131':'四川|自贡',
'1308160':'四川|绵阳',
'1308161':'四川|绵阳',
'1308170':'四川|南充',
'1308171':'四川|南充',
'1308180':'四川|达州',
'1308181':'四川|达州',
'1308250':'四川|遂宁',
'1308251':'四川|遂宁',
'1308260':'四川|广安',
'1308261':'四川|广安',
'1308270':'四川|巴中',
'1308271':'四川|巴中',
'1308300':'重庆',
'1308301':'四川|泸州',
'1308310':'四川|宜宾',
'1308311':'四川|宜宾',
'1308320':'四川|内江',
'1308321':'四川|内江',
'1308330':'四川|乐山',
'1308331':'四川|乐山',
'1308350':'四川|雅安',
'1308351':'四川|雅安',
'1308380':'四川|德阳',
'1308381':'四川|德阳',
'1308390':'四川|广元',
'1308391':'四川|广元',
'1308400':'重庆',
'1308500':'重庆',
'1308510':'贵州|贵阳',
'1308511':'贵州|贵阳',
'1308512':'贵州|贵阳',
'1308520':'贵州|遵义',
'1308521':'贵州|遵义',
'1308530':'贵州|安顺',
'1308531':'贵州|安顺',
'1308560':'贵州|铜仁',
'1308561':'贵州|铜仁',
'1308570':'贵州|毕节',
'1308571':'贵州|毕节',
'1308580':'贵州|六盘水',
'1308581':'贵州|六盘水',
'1308700':'云南|昭通',
'1308701':'云南|昭通',
'1308710':'云南|昆明',
'1308711':'云南|昆明',
'1308712':'云南|昆明',
'1308713':'云南|昆明',
'1308720':'云南|大理',
'1308721':'云南|大理',
'1308740':'云南|曲靖',
'1308741':'云南|曲靖',
'1308750':'云南|保山',
'1308751':'云南|保山',
'1308770':'云南|玉溪',
'1308771':'云南|玉溪',
'1308790':'云南|普洱',
'1308791':'云南|普洱',
'1308880':'云南|丽江',
'1308881':'云南|丽江',
'1308910':'西藏|拉萨',
'1308911':'西藏|拉萨',
'1308920':'西藏|日喀则',
'1308921':'西藏|日喀则',
'1308980':'海南|海口',
'1308981':'海南|海口',
'1308982':'海南|海口',
'1308990':'海南|三亚',
'1308991':'海南|三亚',
'1309110':'陕西|延安',
'1309111':'陕西|延安',
'1309120':'陕西|榆林',
'1309121':'陕西|榆林',
'1309130':'陕西|渭南',
'1309131':'陕西|渭南',
'1309140':'陕西|商洛',
'1309141':'陕西|商洛',
'1309150':'陕西|安康',
'1309151':'陕西|安康',
'1309160':'陕西|汉中',
'1309161':'陕西|汉中',
'1309170':'陕西|宝鸡',
'1309171':'陕西|宝鸡',
'1309190':'陕西|铜川',
'1309191':'陕西|铜川',
'1309310':'甘肃|兰州',
'1309311':'甘肃|兰州',
'1309312':'甘肃|兰州',
'1309370':'甘肃|酒泉',
'1309371':'甘肃|酒泉',
'1309380':'甘肃|天水',
'1309381':'甘肃|天水',
'1309430':'甘肃|白银',
'1309431':'甘肃|白银',
'1309510':'宁夏|银川',
'1309511':'宁夏|银川',
'1309710':'青海|西宁',
'1309711':'青海|西宁',
'1309910':'新疆|乌鲁木齐',
'1309911':'新疆|乌鲁木齐',
'1309912':'新疆|乌鲁木齐',
'1311000':'北京',
'1311100':'北京',
'1311200':'北京',
'1311300':'北京',
'1311400':'北京',
'1311500':'北京',
'1311600':'北京',
'1311700':'北京',
'1311800':'北京',
'1311900':'北京',
'1312000':'广东|广州',
'1312001':'广东|广州',
'1312002':'广东|广州',
'1312003':'广东|广州',
'1312100':'上海',
'1312200':'上海',
'1312300':'上海',
'1312410':'辽宁|沈阳',
'1312411':'辽宁|沈阳',
'1312412':'辽宁|沈阳',
'1312413':'辽宁|沈阳',
'1312500':'江苏|南京',
'1312501':'江苏|南京',
'1312502':'江苏|南京',
'1312503':'江苏|南京',
'1312710':'湖北|武汉',
'1312711':'湖北|武汉',
'1312712':'湖北|武汉',
'1312713':'湖北|武汉',
'1312800':'四川|成都',
'1312801':'四川|成都',
'1312802':'四川|成都',
'1312803':'四川|成都',
'1312900':'陕西|咸阳',
'1312901':'陕西|咸阳',
'1312910':'陕西|西安',
'1312911':'陕西|西安',
'1312912':'陕西|西安',
'1312913':'陕西|西安',
'1313100':'河北|邯郸',
'1313101':'河北|邯郸',
'1313102':'河北|邯郸',
'1313110':'河北|石家庄',
'1313111':'河北|石家庄',
'1313112':'河北|石家庄',
'1313113':'河北|石家庄',
'1313120':'河北|保定',
'1313121':'河北|保定',
'1313122':'河北|保定',
'1313130':'河北|张家口',
'1313131':'河北|张家口',
'1313140':'河北|承德',
'1313141':'河北|承德',
'1313150':'河北|唐山',
'1313151':'河北|唐山',
'1313152':'河北|唐山',
'1313153':'河北|唐山',
'1313160':'河北|廊坊',
'1313161':'河北|廊坊',
'1313170':'河北|沧州',
'1313171':'河北|沧州',
'1313180':'河北|衡水',
'1313181':'河北|衡水',
'1313190':'河北|邢台',
'1313191':'河北|邢台',
'1313350':'河北|秦皇岛',
'1313351':'河北|秦皇岛',
'1313500':'山西|忻州',
'1313501':'山西|忻州',
'1313510':'山西|太原',
'1313511':'山西|太原',
'1313512':'山西|太原',
'1313513':'山西|太原',
'1313520':'山西|大同',
'1313521':'山西|大同',
'1313530':'山西|阳泉',
'1313531':'山西|阳泉',
'1313540':'山西|晋中',
'1313541':'山西|晋中',
'1313550':'山西|长治',
'1313551':'山西|长治',
'1313560':'山西|晋城',
'1313561':'山西|晋城',
'1313570':'山西|临汾',
'1313571':'山西|临汾',
'1313580':'山西|吕梁',
'1313581':'山西|吕梁',
'1313590':'山西|运城',
'1313591':'山西|运城',
'1313700':'河南|商丘',
'1313701':'河南|商丘',
'1313710':'河南|郑州',
'1313711':'河南|郑州',
'1313712':'河南|郑州',
'1313713':'河南|郑州',
'1313720':'河南|安阳',
'1313721':'河南|安阳',
'1313730':'河南|新乡',
'1313731':'河南|新乡',
'1313740':'河南|许昌',
'1313741':'河南|许昌',
'1313750':'河南|平顶山',
'1313751':'河南|平顶山',
'1313760':'河南|信阳',
'1313761':'河南|信阳',
'1313770':'河南|南阳',
'1313771':'河南|南阳',
'1313780':'河南|开封',
'1313781':'河南|开封',
'1313790':'河南|洛阳',
'1313791':'河南|洛阳',
'1313792':'河南|洛阳',
'1313910':'河南|焦作',
'1313911':'河南|焦作',
'1313920':'河南|鹤壁',
'1313921':'河南|鹤壁',
'1313930':'河南|濮阳',
'1313931':'河南|濮阳',
'1313940':'河南|周口',
'1313941':'河南|周口',
'1313950':'河南|漯河',
'1313951':'河南|漯河',
'1313960':'河南|驻马店',
'1313961':'河南|驻马店',
'1313980':'河南|三门峡',
'1313981':'河南|三门峡',
'1314100':'辽宁|铁岭',
'1314101':'辽宁|铁岭',
'1314110':'辽宁|大连',
'1314111':'辽宁|大连',
'1314112':'辽宁|大连',
'1314113':'辽宁|大连',
'1314120':'辽宁|鞍山',
'1314121':'辽宁|鞍山',
'1314130':'辽宁|抚顺',
'1314131':'辽宁|抚顺',
'1314140':'辽宁|本溪',
'1314141':'辽宁|本溪',
'1314150':'辽宁|丹东',
'1314151':'辽宁|丹东',
'1314160':'辽宁|锦州',
'1314161':'辽宁|锦州',
'1314170':'辽宁|营口',
'1314171':'辽宁|营口',
'1314180':'辽宁|阜新',
'1314181':'辽宁|阜新',
'1314190':'辽宁|辽阳',
'1314191':'辽宁|辽阳',
'1314210':'辽宁|朝阳',
'1314211':'辽宁|朝阳',
'1314270':'辽宁|盘锦',
'1314271':'辽宁|盘锦',
'1314290':'辽宁|葫芦岛',
'1314291':'辽宁|葫芦岛',
'1314310':'吉林|长春',
'1314311':'吉林|长春',
'1314312':'吉林|长春',
'1314313':'吉林|长春',
'1314320':'吉林|吉林市',
'1314321':'吉林|吉林市',
'1314340':'吉林|四平',
'1314341':'吉林|四平',
'1314350':'吉林|通化',
'1314351':'吉林|通化',
'1314360':'吉林|白城',
'1314361':'吉林|白城',
'1314370':'吉林|辽源',
'1314371':'吉林|辽源',
'1314380':'吉林|松原',
'1314381':'吉林|松原',
'1314390':'吉林|白山',
'1314391':'吉林|白山',
'1314510':'黑龙江|哈尔滨',
'1314511':'黑龙江|哈尔滨',
'1314512':'黑龙江|哈尔滨',
'1314513':'黑龙江|哈尔滨',
'1314520':'黑龙江|齐齐哈尔',
'1314521':'黑龙江|齐齐哈尔',
'1314530':'黑龙江|牡丹江',
'1314531':'黑龙江|牡丹江',
'1314540':'黑龙江|佳木斯',
'1314541':'黑龙江|佳木斯',
'1314550':'黑龙江|绥化',
'1314551':'黑龙江|绥化',
'1314580':'黑龙江|伊春',
'1314581':'黑龙江|伊春',
'1314590':'黑龙江|大庆',
'1314591':'黑龙江|大庆',
'1314670':'黑龙江|鸡西',
'1314671':'黑龙江|鸡西',
'1314710':'内蒙古|呼和浩特',
'1314711':'内蒙古|呼和浩特',
'1314712':'内蒙古|呼和浩特',
'1314720':'内蒙古|包头',
'1314721':'内蒙古|包头',
'1314730':'内蒙古|乌海',
'1314750':'内蒙古|通辽',
'1314751':'内蒙古|通辽',
'1314760':'内蒙古|赤峰',
'1314761':'内蒙古|赤峰',
'1314770':'内蒙古|鄂尔多斯',
'1314771':'内蒙古|鄂尔多斯',
'1315100':'江苏|无锡',
'1315101':'江苏|无锡',
'1315102':'江苏|无锡',
'1315110':'江苏|镇江',
'1315111':'江苏|镇江',
'1315120':'江苏|苏州',
'1315121':'江苏|苏州',
'1315122':'江苏|苏州',
'1315123':'江苏|苏州',
'1315130':'江苏|南通',
'1315131':'江苏|南通',
'1315132':'江苏|南通',
'1315140':'江苏|扬州',
'1315141':'江苏|扬州',
'1315150':'江苏|盐城',
'1315151':'江苏|盐城',
'1315160':'江苏|徐州',
'1315161':'江苏|徐州',
'1315162':'江苏|徐州',
'1315170':'江苏|淮安',
'1315171':'江苏|淮安',
'1315180':'江苏|连云港',
'1315181':'江苏|连云港',
'1315190':'江苏|常州',
'1315191':'江苏|常州',
'1315192':'江苏|常州',
'1315230':'江苏|泰州',
'1315231':'江苏|泰州',
'1315270':'江苏|宿迁',
'1315271':'江苏|宿迁',
'1315300':'山东|菏泽',
'1315301':'山东|菏泽',
'1315310':'山东|济南',
'1315311':'山东|济南',
'1315312':'山东|济南',
'1315313':'山东|济南',
'1315320':'山东|青岛',
'1315321':'山东|青岛',
'1315322':'山东|青岛',
'1315323':'山东|青岛',
'1315330':'山东|淄博',
'1315331':'山东|淄博',
'1315340':'山东|德州',
'1315341':'山东|德州',
'1315350':'山东|烟台',
'1315351':'山东|烟台',
'1315352':'山东|烟台',
'1315360':'山东|潍坊',
'1315361':'山东|潍坊',
'1315362':'山东|潍坊',
'1315370':'山东|济宁',
'1315371':'山东|济宁',
'1315380':'山东|泰安',
'1315381':'山东|泰安',
'1315390':'山东|临沂',
'1315391':'山东|临沂',
'1315430':'山东|滨州',
'1315431':'山东|滨州',
'1315460':'山东|东营',
'1315461':'山东|东营',
'1315500':'安徽|滁州',
'1315501':'安徽|滁州',
'1315510':'安徽|合肥',
'1315511':'安徽|合肥',
'1315512':'安徽|合肥',
'1315513':'安徽|合肥',
'1315514':'安徽|合肥',
'1315520':'安徽|蚌埠',
'1315521':'安徽|蚌埠',
'1315530':'安徽|芜湖',
'1315531':'安徽|芜湖',
'1315532':'安徽|芜湖',
'1315540':'安徽|淮南',
'1315541':'安徽|淮南',
'1315550':'安徽|马鞍山',
'1315551':'安徽|马鞍山',
'1315560':'安徽|安庆',
'1315561':'安徽|安庆',
'1315570':'安徽|宿州',
'1315571':'安徽|宿州',
'1315580':'安徽|阜阳',
'1315581':'安徽|阜阳',
'1315590':'安徽|黄山',
'1315591':'安徽|黄山',
'1315600':'安徽|合肥',
'1315601':'安徽|合肥',
'1315602':'安徽|合肥',
'1315603':'安徽|合肥',
'1315604':'安徽|合肥',
'1315610':'安徽|淮北',
'1315611':'安徽|淮北',
'1315620':'安徽|铜陵',
'1315621':'安徽|铜陵',
'1315630':'安徽|宣城',
'1315631':'安徽|宣城',
'1315640':'安徽|六安',
'1315641':'安徽|六安',
'1315660':'安徽|池州',
'1315661':'安徽|池州',
'1315700':'浙江|衢州',
'1315701':'浙江|衢州',
'1315710':'浙江|杭州',
'1315711':'浙江|杭州',
'1315712':'浙江|杭州',
'1315713':'浙江|杭州',
'1315720':'浙江|湖州',
'1315721':'浙江|湖州',
'1315730':'浙江|嘉兴',
'1315731':'浙江|嘉兴',
'1315740':'浙江|宁波',
'1315741':'浙江|宁波',
'1315742':'浙江|宁波',
'1315750':'浙江|绍兴',
'1315751':'浙江|绍兴',
'1315760':'浙江|台州',
'1315761':'浙江|台州',
'1315770':'浙江|温州',
'1315771':'浙江|温州',
'1315772':'浙江|温州',
'1315780':'浙江|丽水',
'1315781':'浙江|丽水',
'1315790':'浙江|金华',
'1315791':'浙江|金华',
'1315800':'浙江|舟山',
'1315801':'浙江|舟山',
'1315910':'福建|福州',
'1315911':'福建|福州',
'1315912':'福建|福州',
'1315913':'福建|福州',
'1315920':'福建|厦门',
'1315921':'福建|厦门',
'1315922':'福建|厦门',
'1315930':'福建|宁德',
'1315931':'福建|宁德',
'1315940':'福建|莆田',
'1315941':'福建|莆田',
'1315950':'福建|泉州',
'1315951':'福建|泉州',
'1315952':'福建|泉州',
'1315960':'福建|漳州',
'1315961':'福建|漳州',
'1315970':'福建|龙岩',
'1315971':'福建|龙岩',
'1315980':'福建|三明',
'1315981':'福建|三明',
'1315990':'福建|南平',
'1315991':'福建|南平',
'1316310':'山东|威海',
'1316311':'山东|威海',
'1316320':'山东|枣庄',
'1316321':'山东|枣庄',
'1316330':'山东|日照',
'1316331':'山东|日照',
'1316350':'山东|聊城',
'1316351':'山东|聊城',
'1316600':'广东|汕尾',
'1316601':'广东|汕尾',
'1316620':'广东|阳江',
'1316621':'广东|阳江',
'1316630':'广东|揭阳',
'1316631':'广东|揭阳',
'1316680':'广东|茂名',
'1316681':'广东|茂名',
'1317010':'江西|鹰潭',
'1317011':'江西|鹰潭',
'1317100':'湖北|襄阳',
'1317101':'湖北|襄阳',
'1317110':'湖北|鄂州',
'1317111':'湖北|鄂州',
'1317120':'湖北|孝感',
'1317121':'湖北|孝感',
'1317130':'湖北|黄冈',
'1317131':'湖北|黄冈',
'1317140':'湖北|黄石',
'1317141':'湖北|黄石',
'1317150':'湖北|咸宁',
'1317151':'湖北|咸宁',
'1317160':'湖北|荆州',
'1317161':'湖北|荆州',
'1317170':'湖北|宜昌',
'1317171':'湖北|宜昌',
'1317180':'湖北|恩施',
'1317181':'湖北|恩施',
'1317190':'湖北|十堰',
'1317191':'湖北|十堰',
'1317220':'湖北|随州',
'1317221':'湖北|随州',
'1317240':'湖北|荆门',
'1317241':'湖北|荆门',
'1317300':'湖南|岳阳',
'1317301':'湖南|岳阳',
'1317310':'湖南|长沙',
'1317311':'湖南|长沙',
'1317312':'湖南|长沙',
'1317313':'湖南|长沙',
'1317320':'湖南|湘潭',
'1317321':'湖南|湘潭',
'1317330':'湖南|株洲',
'1317331':'湖南|株洲',
'1317340':'湖南|衡阳',
'1317341':'湖南|衡阳',
'1317350':'湖南|郴州',
'1317351':'湖南|郴州',
'1317360':'湖南|常德',
'1317361':'湖南|常德',
'1317370':'湖南|益阳',
'1317371':'湖南|益阳',
'1317380':'湖南|娄底',
'1317381':'湖南|娄底',
'1317390':'湖南|邵阳',
'1317391':'湖南|邵阳',
'1317440':'湖南|张家界',
'1317441':'湖南|张家界',
'1317450':'湖南|怀化',
'1317451':'湖南|怀化',
'1317460':'湖南|永州',
'1317461':'湖南|永州',
'1317500':'广东|江门',
'1317501':'广东|江门',
'1317510':'广东|韶关',
'1317511':'广东|韶关',
'1317520':'广东|惠州',
'1317521':'广东|惠州',
'1317530':'广东|梅州',
'1317531':'广东|梅州',
'1317540':'广东|汕头',
'1317541':'广东|汕头',
'1317550':'广东|深圳',
'1317551':'广东|深圳',
'1317552':'广东|深圳',
'1317553':'广东|深圳',
'1317560':'广东|珠海',
'1317561':'广东|珠海',
'1317570':'广东|佛山',
'1317571':'广东|佛山',
'1317572':'广东|佛山',
'1317580':'广东|肇庆',
'1317581':'广东|肇庆',
'1317590':'广东|湛江',
'1317591':'广东|湛江',
'1317600':'广东|中山',
'1317601':'广东|中山',
'1317620':'广东|河源',
'1317621':'广东|河源',
'1317630':'广东|清远',
'1317631':'广东|清远',
'1317660':'广东|云浮',
'1317661':'广东|云浮',
'1317680':'广东|潮州',
'1317681':'广东|潮州',
'1317690':'广东|东莞',
'1317691':'广东|东莞',
'1317692':'广东|东莞',
'1317700':'广西|防城港',
'1317701':'广西|防城港',
'1317710':'广西|南宁',
'1317711':'广西|南宁',
'1317712':'广西|南宁',
'1317720':'广西|柳州',
'1317721':'广西|柳州',
'1317730':'广西|桂林',
'1317731':'广西|桂林',
'1317740':'广西|梧州',
'1317741':'广西|梧州',
'1317750':'广西|贵港',
'1317751':'广西|贵港',
'1317760':'广西|百色',
'1317761':'广西|百色',
'1317770':'广西|钦州',
'1317771':'广西|钦州',
'1317780':'广西|河池',
'1317781':'广西|河池',
'1317790':'广西|北海',
'1317791':'广西|北海',
'1317900':'江西|新余',
'1317901':'江西|新余',
'1317910':'江西|南昌',
'1317911':'江西|南昌',
'1317912':'江西|南昌',
'1317913':'江西|南昌',
'1317920':'江西|九江',
'1317921':'江西|九江',
'1317930':'江西|上饶',
'1317931':'江西|上饶',
'1317940':'江西|抚州',
'1317941':'江西|抚州',
'1317950':'江西|宜春',
'1317951':'江西|宜春',
'1317960':'江西|吉安',
'1317961':'江西|吉安',
'1317970':'江西|赣州',
'1317971':'江西|赣州',
'1317980':'江西|景德镇',
'1317981':'江西|景德镇',
'1317990':'江西|萍乡',
'1317991':'江西|萍乡',
'1318120':'四川|攀枝花',
'1318121':'四川|攀枝花',
'1318130':'四川|自贡',
'1318131':'四川|自贡',
'1318160':'四川|绵阳',
'1318161':'四川|绵阳',
'1318170':'四川|南充',
'1318171':'四川|南充',
'1318180':'四川|达州',
'1318181':'四川|达州',
'1318250':'四川|遂宁',
'1318251':'四川|遂宁',
'1318260':'四川|广安',
'1318261':'四川|广安',
'1318270':'四川|巴中',
'1318271':'四川|巴中',
'1318300':'重庆',
'1318301':'四川|泸州',
'1318310':'四川|宜宾',
'1318311':'四川|宜宾',
'1318320':'四川|内江',
'1318321':'四川|内江',
'1318330':'四川|乐山',
'1318331':'四川|乐山',
'1318350':'四川|雅安',
'1318351':'四川|雅安',
'1318380':'四川|德阳',
'1318381':'四川|德阳',
'1318390':'四川|广元',
'1318391':'四川|广元',
'1318400':'重庆',
'1318500':'重庆',
'1318510':'贵州|贵阳',
'1318511':'贵州|贵阳',
'1318512':'贵州|贵阳',
'1318520':'贵州|遵义',
'1318521':'贵州|遵义',
'1318530':'贵州|安顺',
'1318531':'贵州|安顺',
'1318560':'贵州|铜仁',
'1318561':'贵州|铜仁',
'1318570':'贵州|毕节',
'1318571':'贵州|毕节',
'1318580':'贵州|六盘水',
'1318581':'贵州|六盘水',
'1318700':'云南|昭通',
'1318701':'云南|昭通',
'1318710':'云南|昆明',
'1318711':'云南|昆明',
'1318712':'云南|昆明',
'1318713':'云南|昆明',
'1318720':'云南|大理',
'1318721':'云南|大理',
'1318740':'云南|曲靖',
'1318741':'云南|曲靖',
'1318750':'云南|保山',
'1318751':'云南|保山',
'1318770':'云南|玉溪',
'1318771':'云南|玉溪',
'1318790':'云南|普洱',
'1318791':'云南|普洱',
'1318880':'云南|丽江',
'1318881':'云南|丽江',
'1318910':'西藏|拉萨',
'1318911':'西藏|拉萨',
'1318920':'西藏|日喀则',
'1318921':'西藏|日喀则',
'1318980':'海南|海口',
'1318981':'海南|海口',
'1318982':'海南|海口',
'1318990':'海南|三亚',
'1318991':'海南|三亚',
'1319110':'陕西|延安',
'1319111':'陕西|延安',
'1319120':'陕西|榆林',
'1319121':'陕西|榆林',
'1319130':'陕西|渭南',
'1319131':'陕西|渭南',
'1319140':'陕西|商洛',
'1319141':'陕西|商洛',
'1319150':'陕西|安康',
'1319151':'陕西|安康',
'1319160':'陕西|汉中',
'1319161':'陕西|汉中',
'1319170':'陕西|宝鸡',
'1319171':'陕西|宝鸡',
'1319190':'陕西|铜川',
'1319191':'陕西|铜川',
'1319310':'甘肃|兰州',
'1319311':'甘肃|兰州',
'1319312':'甘肃|兰州',
'1319370':'甘肃|酒泉',
'1319371':'甘肃|酒泉',
'1319380':'甘肃|天水',
'1319381':'甘肃|天水',
'1319430':'甘肃|白银',
'1319431':'甘肃|白银',
'1319510':'宁夏|银川',
'1319511':'宁夏|银川',
'1319710':'青海|西宁',
'1319711':'青海|西宁',
'1319910':'新疆|乌鲁木齐',
'1319911':'新疆|乌鲁木齐',
'1319912':'新疆|乌鲁木齐',
'1321000':'北京',
'1321100':'北京',
'1321200':'北京',
'1321300':'北京',
'1321400':'北京',
'1321500':'北京',
'1321600':'北京',
'1321700':'北京',
'1321800':'北京',
'1321900':'北京',
'1322000':'广东|广州',
'1322001':'广东|广州',
'1322002':'广东|广州',
'1322003':'广东|广州',
'1322100':'上海',
'1322200':'上海',
'1322300':'上海',
'1322410':'辽宁|沈阳',
'1322411':'辽宁|沈阳',
'1322412':'辽宁|沈阳',
'1322413':'辽宁|沈阳',
'1322500':'江苏|南京',
'1322501':'江苏|南京',
'1322502':'江苏|南京',
'1322503':'江苏|南京',
'1322710':'湖北|武汉',
'1322711':'湖北|武汉',
'1322712':'湖北|武汉',
'1322713':'湖北|武汉',
'1322800':'四川|成都',
'1322801':'四川|成都',
'1322802':'四川|成都',
'1322803':'四川|成都',
'1322900':'陕西|咸阳',
'1322901':'陕西|咸阳',
'1322910':'陕西|西安',
'1322911':'陕西|西安',
'1322912':'陕西|西安',
'1322913':'陕西|西安',
'1323100':'河北|邯郸',
'1323101':'河北|邯郸',
'1323102':'河北|邯郸',
'1323110':'河北|石家庄',
'1323111':'河北|石家庄',
'1323112':'河北|石家庄',
'1323113':'河北|石家庄',
'1323120':'河北|保定',
'1323121':'河北|保定',
'1323122':'河北|保定',
'1323130':'河北|张家口',
'1323131':'河北|张家口',
'1323140':'河北|承德',
'1323141':'河北|承德',
'1323150':'河北|唐山',
'1323151':'河北|唐山',
'1323152':'河北|唐山',
'1323153':'河北|唐山',
'1323160':'河北|廊坊',
'1323161':'河北|廊坊',
'1323170':'河北|沧州',
'1323171':'河北|沧州',
'1323180':'河北|衡水',
'1323181':'河北|衡水',
'1323190':'河北|邢台',
'1323191':'河北|邢台',
'1323350':'河北|秦皇岛',
'1323351':'河北|秦皇岛',
'1323500':'山西|忻州',
'1323501':'山西|忻州',
'1323510':'山西|太原',
'1323511':'山西|太原',
'1323512':'山西|太原',
'1323513':'山西|太原',
'1323520':'山西|大同',
'1323521':'山西|大同',
'1323530':'山西|阳泉',
'1323531':'山西|阳泉',
'1323540':'山西|晋中',
'1323541':'山西|晋中',
'1323550':'山西|长治',
'1323551':'山西|长治',
'1323560':'山西|晋城',
'1323561':'山西|晋城',
'1323570':'山西|临汾',
'1323571':'山西|临汾',
'1323580':'山西|吕梁',
'1323581':'山西|吕梁',
'1323590':'山西|运城',
'1323591':'山西|运城',
'1323700':'河南|商丘',
'1323701':'河南|商丘',
'1323710':'河南|郑州',
'1323711':'河南|郑州',
'1323712':'河南|郑州',
'1323713':'河南|郑州',
'1323720':'河南|安阳',
'1323721':'河南|安阳',
'1323730':'河南|新乡',
'1323731':'河南|新乡',
'1323740':'河南|许昌',
'1323741':'河南|许昌',
'1323750':'河南|平顶山',
'1323751':'河南|平顶山',
'1323760':'河南|信阳',
'1323761':'河南|信阳',
'1323770':'河南|南阳',
'1323771':'河南|南阳',
'1323780':'河南|开封',
'1323781':'河南|开封',
'1323790':'河南|洛阳',
'1323791':'河南|洛阳',
'1323792':'河南|洛阳',
'1323910':'河南|焦作',
'1323911':'河南|焦作',
'1323920':'河南|鹤壁',
'1323921':'河南|鹤壁',
'1323930':'河南|濮阳',
'1323931':'河南|濮阳',
'1323940':'河南|周口',
'1323941':'河南|周口',
'1323950':'河南|漯河',
'1323951':'河南|漯河',
'1323960':'河南|驻马店',
'1323961':'河南|驻马店',
'1323980':'河南|三门峡',
'1323981':'河南|三门峡',
'1324100':'辽宁|铁岭',
'1324101':'辽宁|铁岭',
'1324110':'辽宁|大连',
'1324111':'辽宁|大连',
'1324112':'辽宁|大连',
'1324113':'辽宁|大连',
'1324120':'辽宁|鞍山',
'1324121':'辽宁|鞍山',
'1324130':'辽宁|抚顺',
'1324131':'辽宁|抚顺',
'1324140':'辽宁|本溪',
'1324141':'辽宁|本溪',
'1324150':'辽宁|丹东',
'1324151':'辽宁|丹东',
'1324160':'辽宁|锦州',
'1324161':'辽宁|锦州',
'1324170':'辽宁|营口',
'1324171':'辽宁|营口',
'1324180':'辽宁|阜新',
'1324181':'辽宁|阜新',
'1324190':'辽宁|辽阳',
'1324191':'辽宁|辽阳',
'1324210':'辽宁|朝阳',
'1324211':'辽宁|朝阳',
'1324270':'辽宁|盘锦',
'1324271':'辽宁|盘锦',
'1324290':'辽宁|葫芦岛',
'1324291':'辽宁|葫芦岛',
'1324310':'吉林|长春',
'1324311':'吉林|长春',
'1324312':'吉林|长春',
'1324313':'吉林|长春',
'1324320':'吉林|吉林市',
'1324321':'吉林|吉林市',
'1324340':'吉林|四平',
'1324341':'吉林|四平',
'1324350':'吉林|通化',
'1324351':'吉林|通化',
'1324360':'吉林|白城',
'1324361':'吉林|白城',
'1324370':'吉林|辽源',
'1324371':'吉林|辽源',
'1324380':'吉林|松原',
'1324381':'吉林|松原',
'1324390':'吉林|白山',
'1324391':'吉林|白山',
'1324510':'黑龙江|哈尔滨',
'1324511':'黑龙江|哈尔滨',
'1324512':'黑龙江|哈尔滨',
'1324513':'黑龙江|哈尔滨',
'1324520':'黑龙江|齐齐哈尔',
'1324521':'黑龙江|齐齐哈尔',
'1324530':'黑龙江|牡丹江',
'1324531':'黑龙江|牡丹江',
'1324540':'黑龙江|佳木斯',
'1324541':'黑龙江|佳木斯',
'1324550':'黑龙江|绥化',
'1324551':'黑龙江|绥化',
'1324580':'黑龙江|伊春',
'1324581':'黑龙江|伊春',
'1324590':'黑龙江|大庆',
'1324591':'黑龙江|大庆',
'1324670':'黑龙江|鸡西',
'1324671':'黑龙江|鸡西',
'1324710':'内蒙古|呼和浩特',
'1324711':'内蒙古|呼和浩特',
'1324712':'内蒙古|呼和浩特',
'1324720':'内蒙古|包头',
'1324721':'内蒙古|包头',
'1324730':'内蒙古|乌海',
'1324750':'内蒙古|通辽',
'1324751':'内蒙古|通辽',
'1324760':'内蒙古|赤峰',
'1324761':'内蒙古|赤峰',
'1324770':'内蒙古|鄂尔多斯',
'1324771':'内蒙古|鄂尔多斯',
'1325100':'江苏|无锡',
'1325101':'江苏|无锡',
'1325102':'江苏|无锡',
'1325110':'江苏|镇江',
'1325111':'江苏|镇江',
'1325120':'江苏|苏州',
'1325121':'江苏|苏州',
'1325122':'江苏|苏州',
'1325123':'江苏|苏州',
'1325130':'江苏|南通',
'1325131':'江苏|南通',
'1325132':'江苏|南通',
'1325140':'江苏|扬州',
'1325141':'江苏|扬州',
'1325150':'江苏|盐城',
'1325151':'江苏|盐城',
'1325160':'江苏|徐州',
'1325161':'江苏|徐州',
'1325162':'江苏|徐州',
'1325170':'江苏|淮安',
'1325171':'江苏|淮安',
'1325180':'江苏|连云港',
'1325181':'江苏|连云港',
'1325190':'江苏|常州',
'1325191':'江苏|常州',
'1325192':'江苏|常州',
'1325230':'江苏|泰州',
'1325231':'江苏|泰州',
'1325270':'江苏|宿迁',
'1325271':'江苏|宿迁',
'1325300':'山东|菏泽',
'1325301':'山东|菏泽',
'1325310':'山东|济南',
'1325311':'山东|济南',
'1325312':'山东|济南',
'1325313':'山东|济南',
'1325320':'山东|青岛',
'1325321':'山东|青岛',
'1325322':'山东|青岛',
'1325323':'山东|青岛',
'1325330':'山东|淄博',
'1325331':'山东|淄博',
'1325340':'山东|德州',
'1325341':'山东|德州',
'1325350':'山东|烟台',
'1325351':'山东|烟台',
'1325352':'山东|烟台',
'1325360':'山东|潍坊',
'1325361':'山东|潍坊',
'1325362':'山东|潍坊',
'1325370':'山东|济宁',
'1325371':'山东|济宁',
'1325380':'山东|泰安',
'1325381':'山东|泰安',
'1325390':'山东|临沂',
'1325391':'山东|临沂',
'1325430':'山东|滨州',
'1325431':'山东|滨州',
'1325460':'山东|东营',
'1325461':'山东|东营',
'1325500':'安徽|滁州',
'1325501':'安徽|滁州',
'1325510':'安徽|合肥',
'1325511':'安徽|合肥',
'1325512':'安徽|合肥',
'1325513':'安徽|合肥',
'1325514':'安徽|合肥',
'1325520':'安徽|蚌埠',
'1325521':'安徽|蚌埠',
'1325530':'安徽|芜湖',
'1325531':'安徽|芜湖',
'1325532':'安徽|芜湖',
'1325540':'安徽|淮南',
'1325541':'安徽|淮南',
'1325550':'安徽|马鞍山',
'1325551':'安徽|马鞍山',
'1325560':'安徽|安庆',
'1325561':'安徽|安庆',
'1325570':'安徽|宿州',
'1325571':'安徽|宿州',
'1325580':'安徽|阜阳',
'1325581':'安徽|阜阳',
'1325590':'安徽|黄山',
'1325591':'安徽|黄山',
'1325600':'安徽|合肥',
'1325601':'安徽|合肥',
'1325602':'安徽|合肥',
'1325603':'安徽|合肥',
'1325604':'安徽|合肥',
'1325610':'安徽|淮北',
'1325611':'安徽|淮北',
'1325620':'安徽|铜陵',
'1325621':'安徽|铜陵',
'1325630':'安徽|宣城',
'1325631':'安徽|宣城',
'1325640':'安徽|六安',
'1325641':'安徽|六安',
'1325660':'安徽|池州',
'1325661':'安徽|池州',
'1325700':'浙江|衢州',
'1325701':'浙江|衢州',
'1325710':'浙江|杭州',
'1325711':'浙江|杭州',
'1325712':'浙江|杭州',
'1325713':'浙江|杭州',
'1325720':'浙江|湖州',
'1325721':'浙江|湖州',
'1325730':'浙江|嘉兴',
'1325731':'浙江|嘉兴',
'1325740':'浙江|宁波',
'1325741':'浙江|宁波',
'1325742':'浙江|宁波',
'1325750':'浙江|绍兴',
'1325751':'浙江|绍兴',
'1325760':'浙江|台州',
'1325761':'浙江|台州',
'1325770':'浙江|温州',
'1325771':'浙江|温州',
'1325772':'浙江|温州',
'1325780':'浙江|丽水',
'1325781':'浙江|丽水',
'1325790':'浙江|金华',
'1325791':'浙江|金华',
'1325800':'浙江|舟山',
'1325801':'浙江|舟山',
'1325910':'福建|福州',
'1325911':'福建|福州',
'1325912':'福建|福州',
'1325913':'福建|福州',
'1325920':'福建|厦门',
'1325921':'福建|厦门',
'1325922':'福建|厦门',
'1325930':'福建|宁德',
'1325931':'福建|宁德',
'1325940':'福建|莆田',
'1325941':'福建|莆田',
'1325950':'福建|泉州',
'1325951':'福建|泉州',
'1325952':'福建|泉州',
'1325960':'福建|漳州',
'1325961':'福建|漳州',
'1325970':'福建|龙岩',
'1325971':'福建|龙岩',
'1325980':'福建|三明',
'1325981':'福建|三明',
'1325990':'福建|南平',
'1325991':'福建|南平',
'1326310':'山东|威海',
'1326311':'山东|威海',
'1326320':'山东|枣庄',
'1326321':'山东|枣庄',
'1326330':'山东|日照',
'1326331':'山东|日照',
'1326350':'山东|聊城',
'1326351':'山东|聊城',
'1326600':'广东|汕尾',
'1326601':'广东|汕尾',
'1326620':'广东|阳江',
'1326621':'广东|阳江',
'1326630':'广东|揭阳',
'1326631':'广东|揭阳',
'1326680':'广东|茂名',
'1326681':'广东|茂名',
'1327010':'江西|鹰潭',
'1327011':'江西|鹰潭',
'1327100':'湖北|襄阳',
'1327101':'湖北|襄阳',
'1327110':'湖北|鄂州',
'1327111':'湖北|鄂州',
'1327120':'湖北|孝感',
'1327121':'湖北|孝感',
'1327130':'湖北|黄冈',
'1327131':'湖北|黄冈',
'1327140':'湖北|黄石',
'1327141':'湖北|黄石',
'1327150':'湖北|咸宁',
'1327151':'湖北|咸宁',
'1327160':'湖北|荆州',
'1327161':'湖北|荆州',
'1327170':'湖北|宜昌',
'1327171':'湖北|宜昌',
'1327180':'湖北|恩施',
'1327181':'湖北|恩施',
'1327190':'湖北|十堰',
'1327191':'湖北|十堰',
'1327220':'湖北|随州',
'1327221':'湖北|随州',
'1327240':'湖北|荆门',
'1327241':'湖北|荆门',
'1327300':'湖南|岳阳',
'1327301':'湖南|岳阳',
'1327310':'湖南|长沙',
'1327311':'湖南|长沙',
'1327312':'湖南|长沙',
'1327313':'湖南|长沙',
'1327320':'湖南|湘潭',
'1327321':'湖南|湘潭',
'1327330':'湖南|株洲',
'1327331':'湖南|株洲',
'1327340':'湖南|衡阳',
'1327341':'湖南|衡阳',
'1327350':'湖南|郴州',
'1327351':'湖南|郴州',
'1327360':'湖南|常德',
'1327361':'湖南|常德',
'1327370':'湖南|益阳',
'1327371':'湖南|益阳',
'1327380':'湖南|娄底',
'1327381':'湖南|娄底',
'1327390':'湖南|邵阳',
'1327391':'湖南|邵阳',
'1327440':'湖南|张家界',
'1327441':'湖南|张家界',
'1327450':'湖南|怀化',
'1327451':'湖南|怀化',
'1327460':'湖南|永州',
'1327461':'湖南|永州',
'1327500':'广东|江门',
'1327501':'广东|江门',
'1327510':'广东|韶关',
'1327511':'广东|韶关',
'1327520':'广东|惠州',
'1327521':'广东|惠州',
'1327530':'广东|梅州',
'1327531':'广东|梅州',
'1327540':'广东|汕头',
'1327541':'广东|汕头',
'1327550':'广东|深圳',
'1327551':'广东|深圳',
'1327552':'广东|深圳',
'1327553':'广东|深圳',
'1327560':'广东|珠海',
'1327561':'广东|珠海',
'1327570':'广东|佛山',
'1327571':'广东|佛山',
'1327572':'广东|佛山',
'1327580':'广东|肇庆',
'1327581':'广东|肇庆',
'1327590':'广东|湛江',
'1327591':'广东|湛江',
'1327600':'广东|中山',
'1327601':'广东|中山',
'1327620':'广东|河源',
'1327621':'广东|河源',
'1327630':'广东|清远',
'1327631':'广东|清远',
'1327660':'广东|云浮',
'1327661':'广东|云浮',
'1327680':'广东|潮州',
'1327681':'广东|潮州',
'1327690':'广东|东莞',
'1327691':'广东|东莞',
'1327692':'广东|东莞',
'1327700':'广西|防城港',
'1327701':'广西|防城港',
'1327710':'广西|南宁',
'1327711':'广西|南宁',
'1327712':'广西|南宁',
'1327720':'广西|柳州',
'1327721':'广西|柳州',
'1327730':'广西|桂林',
'1327731':'广西|桂林',
'1327740':'广西|梧州',
'1327741':'广西|梧州',
'1327750':'广西|贵港',
'1327751':'广西|贵港',
'1327760':'广西|百色',
'1327761':'广西|百色',
'1327770':'广西|钦州',
'1327771':'广西|钦州',
'1327780':'广西|河池',
'1327781':'广西|河池',
'1327790':'广西|北海',
'1327791':'广西|北海',
'1327900':'江西|新余',
'1327901':'江西|新余',
'1327910':'江西|南昌',
'1327911':'江西|南昌',
'1327912':'江西|南昌',
'1327913':'江西|南昌',
'1327920':'江西|九江',
'1327921':'江西|九江',
'1327930':'江西|上饶',
'1327931':'江西|上饶',
'1327940':'江西|抚州',
'1327941':'江西|抚州',
'1327950':'江西|宜春',
'1327951':'江西|宜春',
'1327960':'江西|吉安',
'1327961':'江西|吉安',
'1327970':'江西|赣州',
'1327971':'江西|赣州',
'1327980':'江西|景德镇',
'1327981':'江西|景德镇',
'1327990':'江西|萍乡',
'1327991':'江西|萍乡',
'1328120':'四川|攀枝花',
'1328121':'四川|攀枝花',
'1328130':'四川|自贡',
'1328131':'四川|自贡',
'1328160':'四川|绵阳',
'1328161':'四川|绵阳',
'1328170':'四川|南充',
'1328171':'四川|南充',
'1328180':'四川|达州',
'1328181':'四川|达州',
'1328250':'四川|遂宁',
'1328251':'四川|遂宁',
'1328260':'四川|广安',
'1328261':'四川|广安',
'1328270':'四川|巴中',
'1328271':'四川|巴中',
'1328300':'重庆',
'1328301':'四川|泸州',
'1328310':'四川|宜宾',
'1328311':'四川|宜宾',
'1328320':'四川|内江',
'1328321':'四川|内江',
'1328330':'四川|乐山',
'1328331':'四川|乐山',
'1328350':'四川|雅安',
'1328351':'四川|雅安',
'1328380':'四川|德阳',
'1328381':'四川|德阳',
'1328390':'四川|广元',
'1328391':'四川|广元',
'1328400':'重庆',
'1328500':'重庆',
'1328510':'贵州|贵阳',
'1328511':'贵州|贵阳',
'1328512':'贵州|贵阳',
'1328520':'贵州|遵义',
'1328521':'贵州|遵义',
'1328530':'贵州|安顺',
'1328531':'贵州|安顺',
'1328560':'贵州|铜仁',
'1328561':'贵州|铜仁',
'1328570':'贵州|毕节',
'1328571':'贵州|毕节',
'1328580':'贵州|六盘水',
'1328581':'贵州|六盘水',
'1328700':'云南|昭通',
'1328701':'云南|昭通',
'1328710':'云南|昆明',
'1328711':'云南|昆明',
'1328712':'云南|昆明',
'1328713':'云南|昆明',
'1328720':'云南|大理',
'1328721':'云南|大理',
'1328740':'云南|曲靖',
'1328741':'云南|曲靖',
'1328750':'云南|保山',
'1328751':'云南|保山',
'1328770':'云南|玉溪',
'1328771':'云南|玉溪',
'1328790':'云南|普洱',
'1328791':'云南|普洱',
'1328880':'云南|丽江',
'1328881':'云南|丽江',
'1328910':'西藏|拉萨',
'1328911':'西藏|拉萨',
'1328920':'西藏|日喀则',
'1328921':'西藏|日喀则',
'1328980':'海南|海口',
'1328981':'海南|海口',
'1328982':'海南|海口',
'1328990':'海南|三亚',
'1328991':'海南|三亚',
'1329110':'陕西|延安',
'1329111':'陕西|延安',
'1329120':'陕西|榆林',
'1329121':'陕西|榆林',
'1329130':'陕西|渭南',
'1329131':'陕西|渭南',
'1329140':'陕西|商洛',
'1329141':'陕西|商洛',
'1329150':'陕西|安康',
'1329151':'陕西|安康',
'1329160':'陕西|汉中',
'1329161':'陕西|汉中',
'1329170':'陕西|宝鸡',
'1329171':'陕西|宝鸡',
'1329190':'陕西|铜川',
'1329191':'陕西|铜川',
'1329310':'甘肃|兰州',
'1329311':'甘肃|兰州',
'1329312':'甘肃|兰州',
'1329370':'甘肃|酒泉',
'1329371':'甘肃|酒泉',
'1329380':'甘肃|天水',
'1329381':'甘肃|天水',
'1329430':'甘肃|白银',
'1329431':'甘肃|白银',
'1329510':'宁夏|银川',
'1329511':'宁夏|银川',
'1329710':'青海|西宁',
'1329711':'青海|西宁',
'1329910':'新疆|乌鲁木齐',
'1329911':'新疆|乌鲁木齐',
'1329912':'新疆|乌鲁木齐',
'1331000':'北京',
'1331100':'北京',
'1331200':'北京',
'1331300':'北京',
'1331400':'北京',
'1331500':'北京',
'1331600':'北京',
'1331700':'北京',
'1331800':'北京',
'1331900':'北京',
'1332000':'广东|广州',
'1332001':'广东|广州',
'1332002':'广东|广州',
'1332003':'广东|广州',
'1332100':'上海',
'1332200':'上海',
'1332300':'上海',
'1332410':'辽宁|沈阳',
'1332411':'辽宁|沈阳',
'1332412':'辽宁|沈阳',
'1332413':'辽宁|沈阳',
'1332500':'江苏|南京',
'1332501':'江苏|南京',
'1332502':'江苏|南京',
'1332503':'江苏|南京',
'1332710':'湖北|武汉',
'1332711':'湖北|武汉',
'1332712':'湖北|武汉',
'1332713':'湖北|武汉',
'1332800':'四川|成都',
'1332801':'四川|成都',
'1332802':'四川|成都',
'1332803':'四川|成都',
'1332900':'陕西|咸阳',
'1332901':'陕西|咸阳',
'1332910':'陕西|西安',
'1332911':'陕西|西安',
'1332912':'陕西|西安',
'1332913':'陕西|西安',
'1333100':'河北|邯郸',
'1333101':'河北|邯郸',
'1333102':'河北|邯郸',
'1333110':'河北|石家庄',
'1333111':'河北|石家庄',
'1333112':'河北|石家庄',
'1333113':'河北|石家庄',
'1333120':'河北|保定',
'1333121':'河北|保定',
'1333122':'河北|保定',
'1333130':'河北|张家口',
'1333131':'河北|张家口',
'1333140':'河北|承德',
'1333141':'河北|承德',
'1333150':'河北|唐山',
'1333151':'河北|唐山',
'1333152':'河北|唐山',
'1333153':'河北|唐山',
'1333160':'河北|廊坊',
'1333161':'河北|廊坊',
'1333170':'河北|沧州',
'1333171':'河北|沧州',
'1333180':'河北|衡水',
'1333181':'河北|衡水',
'1333190':'河北|邢台',
'1333191':'河北|邢台',
'1333350':'河北|秦皇岛',
'1333351':'河北|秦皇岛',
'1333500':'山西|忻州',
'1333501':'山西|忻州',
'1333510':'山西|太原',
'1333511':'山西|太原',
'1333512':'山西|太原',
'1333513':'山西|太原',
'1333520':'山西|大同',
'1333521':'山西|大同',
'1333530':'山西|阳泉',
'1333531':'山西|阳泉',
'1333540':'山西|晋中',
'1333541':'山西|晋中',
'1333550':'山西|长治',
'1333551':'山西|长治',
'1333560':'山西|晋城',
'1333561':'山西|晋城',
'1333570':'山西|临汾',
'1333571':'山西|临汾',
'1333580':'山西|吕梁',
'1333581':'山西|吕梁',
'1333590':'山西|运城',
'1333591':'山西|运城',
'1333700':'河南|商丘',
'1333701':'河南|商丘',
'1333710':'河南|郑州',
'1333711':'河南|郑州',
'1333712':'河南|郑州',
'1333713':'河南|郑州',
'1333720':'河南|安阳',
'1333721':'河南|安阳',
'1333730':'河南|新乡',
'1333731':'河南|新乡',
'1333740':'河南|许昌',
'1333741':'河南|许昌',
'1333750':'河南|平顶山',
'1333751':'河南|平顶山',
'1333760':'河南|信阳',
'1333761':'河南|信阳',
'1333770':'河南|南阳',
'1333771':'河南|南阳',
'1333780':'河南|开封',
'1333781':'河南|开封',
'1333790':'河南|洛阳',
'1333791':'河南|洛阳',
'1333792':'河南|洛阳',
'1333910':'河南|焦作',
'1333911':'河南|焦作',
'1333920':'河南|鹤壁',
'1333921':'河南|鹤壁',
'1333930':'河南|濮阳',
'1333931':'河南|濮阳',
'1333940':'河南|周口',
'1333941':'河南|周口',
'1333950':'河南|漯河',
'1333951':'河南|漯河',
'1333960':'河南|驻马店',
'1333961':'河南|驻马店',
'1333980':'河南|三门峡',
'1333981':'河南|三门峡',
'1334100':'辽宁|铁岭',
'1334101':'辽宁|铁岭',
'1334110':'辽宁|大连',
'1334111':'辽宁|大连',
'1334112':'辽宁|大连',
'1334113':'辽宁|大连',
'1334120':'辽宁|鞍山',
'1334121':'辽宁|鞍山',
'1334130':'辽宁|抚顺',
'1334131':'辽宁|抚顺',
'1334140':'辽宁|本溪',
'1334141':'辽宁|本溪',
'1334150':'辽宁|丹东',
'1334151':'辽宁|丹东',
'1334160':'辽宁|锦州',
'1334161':'辽宁|锦州',
'1334170':'辽宁|营口',
'1334171':'辽宁|营口',
'1334180':'辽宁|阜新',
'1334181':'辽宁|阜新',
'1334190':'辽宁|辽阳',
'1334191':'辽宁|辽阳',
'1334210':'辽宁|朝阳',
'1334211':'辽宁|朝阳',
'1334270':'辽宁|盘锦',
'1334271':'辽宁|盘锦',
'1334290':'辽宁|葫芦岛',
'1334291':'辽宁|葫芦岛',
'1334310':'吉林|长春',
'1334311':'吉林|长春',
'1334312':'吉林|长春',
'1334313':'吉林|长春',
'1334320':'吉林|吉林市',
'1334321':'吉林|吉林市',
'1334340':'吉林|四平',
'1334341':'吉林|四平',
'1334350':'吉林|通化',
'1334351':'吉林|通化',
'1334360':'吉林|白城',
'1334361':'吉林|白城',
'1334370':'吉林|辽源',
'1334371':'吉林|辽源',
'1334380':'吉林|松原',
'1334381':'吉林|松原',
'1334390':'吉林|白山',
'1334391':'吉林|白山',
'1334510':'黑龙江|哈尔滨',
'1334511':'黑龙江|哈尔滨',
'1334512':'黑龙江|哈尔滨',
'1334513':'黑龙江|哈尔滨',
'1334520':'黑龙江|齐齐哈尔',
'1334521':'黑龙江|齐齐哈尔',
'1334530':'黑龙江|牡丹江',
'1334531':'黑龙江|牡丹江',
'1334540':'黑龙江|佳木斯',
'1334541':'黑龙江|佳木斯',
'1334550':'黑龙江|绥化',
'1334551':'黑龙江|绥化',
'1334580':'黑龙江|伊春',
'1334581':'黑龙江|伊春',
'1334590':'黑龙江|大庆',
'1334591':'黑龙江|大庆',
'1334670':'黑龙江|鸡西',
'1334671':'黑龙江|鸡西',
'1334710':'内蒙古|呼和浩特',
'1334711':'内蒙古|呼和浩特',
'1334712':'内蒙古|呼和浩特',
'1334720':'内蒙古|包头',
'1334721':'内蒙古|包头',
'1334730':'内蒙古|乌海',
'1334750':'内蒙古|通辽',
'1334751':'内蒙古|通辽',
'1334760':'内蒙古|赤峰',
'1334761':'内蒙古|赤峰',
'1334770':'内蒙古|鄂尔多斯',
'1334771':'内蒙古|鄂尔多斯',
'1335100':'江苏|无锡',
'1335101':'江苏|无锡',
'1335102':'江苏|无锡',
'1335110':'江苏|镇江',
'1335111':'江苏|镇江',
'1335120':'江苏|苏州',
'1335121':'江苏|苏州',
'1335122':'江苏|苏州',
'1335123':'江苏|苏州',
'1335130':'江苏|南通',
'1335131':'江苏|南通',
'1335132':'江苏|南通',
'1335140':'江苏|扬州',
'1335141':'江苏|扬州',
'1335150':'江苏|盐城',
'1335151':'江苏|盐城',
'1335160':'江苏|徐州',
'1335161':'江苏|徐州',
'1335162':'江苏|徐州',
'1335170':'江苏|淮安',
'1335171':'江苏|淮安',
'1335180':'江苏|连云港',
'1335181':'江苏|连云港',
'1335190':'江苏|常州',
'1335191':'江苏|常州',
'1335192':'江苏|常州',
'1335230':'江苏|泰州',
'1335231':'江苏|泰州',
'1335270':'江苏|宿迁',
'1335271':'江苏|宿迁',
'1335300':'山东|菏泽',
'1335301':'山东|菏泽',
'1335310':'山东|济南',
'1335311':'山东|济南',
'1335312':'山东|济南',
'1335313':'山东|济南',
'1335320':'山东|青岛',
'1335321':'山东|青岛',
'1335322':'山东|青岛',
'1335323':'山东|青岛',
'1335330':'山东|淄博',
'1335331':'山东|淄博',
'1335340':'山东|德州',
'1335341':'山东|德州',
'1335350':'山东|烟台',
'1335351':'山东|烟台',
'1335352':'山东|烟台',
'1335360':'山东|潍坊',
'1335361':'山东|潍坊',
'1335362':'山东|潍坊',
'1335370':'山东|济宁',
'1335371':'山东|济宁',
'1335380':'山东|泰安',
'1335381':'山东|泰安',
'1335390':'山东|临沂',
'1335391':'山东|临沂',
'1335430':'山东|滨州',
'1335431':'山东|滨州',
'1335460':'山东|东营',
'1335461':'山东|东营',
'1335500':'安徽|滁州',
'1335501':'安徽|滁州',
'1335510':'安徽|合肥',
'1335511':'安徽|合肥',
'1335512':'安徽|合肥',
'1335513':'安徽|合肥',
'1335514':'安徽|合肥',
'1335520':'安徽|蚌埠',
'1335521':'安徽|蚌埠',
'1335530':'安徽|芜湖',
'1335531':'安徽|芜湖',
'1335532':'安徽|芜湖',
'1335540':'安徽|淮南',
'1335541':'安徽|淮南',
'1335550':'安徽|马鞍山',
'1335551':'安徽|马鞍山',
'1335560':'安徽|安庆',
'1335561':'安徽|安庆',
'1335570':'安徽|宿州',
'1335571':'安徽|宿州',
'1335580':'安徽|阜阳',
'1335581':'安徽|阜阳',
'1335590':'安徽|黄山',
'1335591':'安徽|黄山',
'1335600':'安徽|合肥',
'1335601':'安徽|合肥',
'1335602':'安徽|合肥',
'1335603':'安徽|合肥',
'1335604':'安徽|合肥',
'1335610':'安徽|淮北',
'1335611':'安徽|淮北',
'1335620':'安徽|铜陵',
'1335621':'安徽|铜陵',
'1335630':'安徽|宣城',
'1335631':'安徽|宣城',
'1335640':'安徽|六安',
'1335641':'安徽|六安',
'1335660':'安徽|池州',
'1335661':'安徽|池州',
'1335700':'浙江|衢州',
'1335701':'浙江|衢州',
'1335710':'浙江|杭州',
'1335711':'浙江|杭州',
'1335712':'浙江|杭州',
'1335713':'浙江|杭州',
'1335720':'浙江|湖州',
'1335721':'浙江|湖州',
'1335730':'浙江|嘉兴',
'1335731':'浙江|嘉兴',
'1335740':'浙江|宁波',
'1335741':'浙江|宁波',
'1335742':'浙江|宁波',
'1335750':'浙江|绍兴',
'1335751':'浙江|绍兴',
'1335760':'浙江|台州',
'1335761':'浙江|台州',
'1335770':'浙江|温州',
'1335771':'浙江|温州',
'1335772':'浙江|温州',
'1335780':'浙江|丽水',
'1335781':'浙江|丽水',
'1335790':'浙江|金华',
'1335791':'浙江|金华',
'1335800':'浙江|舟山',
'1335801':'浙江|舟山',
'1335910':'福建|福州',
'1335911':'福建|福州',
'1335912':'福建|福州',
'1335913':'福建|福州',
'1335920':'福建|厦门',
'1335921':'福建|厦门',
'1335922':'福建|厦门',
'1335930':'福建|宁德',
'1335931':'福建|宁德',
'1335940':'福建|莆田',
'1335941':'福建|莆田',
'1335950':'福建|泉州',
'1335951':'福建|泉州',
'1335952':'福建|泉州',
'1335960':'福建|漳州',
'1335961':'福建|漳州',
'1335970':'福建|龙岩',
'1335971':'福建|龙岩',
'1335980':'福建|三明',
'1335981':'福建|三明',
'1335990':'福建|南平',
'1335991':'福建|南平',
'1336310':'山东|威海',
'1336311':'山东|威海',
'1336320':'山东|枣庄',
'1336321':'山东|枣庄',
'1336330':'山东|日照',
'1336331':'山东|日照',
'1336350':'山东|聊城',
'1336351':'山东|聊城',
'1336600':'广东|汕尾',
'1336601':'广东|汕尾',
'1336620':'广东|阳江',
'1336621':'广东|阳江',
'1336630':'广东|揭阳',
'1336631':'广东|揭阳',
'1336680':'广东|茂名',
'1336681':'广东|茂名',
'1337010':'江西|鹰潭',
'1337011':'江西|鹰潭',
'1337100':'湖北|襄阳',
'1337101':'湖北|襄阳',
'1337110':'湖北|鄂州',
'1337111':'湖北|鄂州',
'1337120':'湖北|孝感',
'1337121':'湖北|孝感',
'1337130':'湖北|黄冈',
'1337131':'湖北|黄冈',
'1337140':'湖北|黄石',
'1337141':'湖北|黄石',
'1337150':'湖北|咸宁',
'1337151':'湖北|咸宁',
'1337160':'湖北|荆州',
'1337161':'湖北|荆州',
'1337170':'湖北|宜昌',
'1337171':'湖北|宜昌',
'1337180':'湖北|恩施',
'1337181':'湖北|恩施',
'1337190':'湖北|十堰',
'1337191':'湖北|十堰',
'1337220':'湖北|随州',
'1337221':'湖北|随州',
'1337240':'湖北|荆门',
'1337241':'湖北|荆门',
'1337300':'湖南|岳阳',
'1337301':'湖南|岳阳',
'1337310':'湖南|长沙',
'1337311':'湖南|长沙',
'1337312':'湖南|长沙',
'1337313':'湖南|长沙',
'1337320':'湖南|湘潭',
'1337321':'湖南|湘潭',
'1337330':'湖南|株洲',
'1337331':'湖南|株洲',
'1337340':'湖南|衡阳',
'1337341':'湖南|衡阳',
'1337350':'湖南|郴州',
'1337351':'湖南|郴州',
'1337360':'湖南|常德',
'1337361':'湖南|常德',
'1337370':'湖南|益阳',
'1337371':'湖南|益阳',
'1337380':'湖南|娄底',
'1337381':'湖南|娄底',
'1337390':'湖南|邵阳',
'1337391':'湖南|邵阳',
'1337440':'湖南|张家界',
'1337441':'湖南|张家界',
'1337450':'湖南|怀化',
'1337451':'湖南|怀化',
'1337460':'湖南|永州',
'1337461':'湖南|永州',
'1337500':'广东|江门',
'1337501':'广东|江门',
'1337510':'广东|韶关',
'1337511':'广东|韶关',
'1337520':'广东|惠州',
'1337521':'广东|惠州',
'1337530':'广东|梅州',
'1337531':'广东|梅州',
'1337540':'广东|汕头',
'1337541':'广东|汕头',
'1337550':'广东|深圳',
'1337551':'广东|深圳',
'1337552':'广东|深圳',
'1337553':'广东|深圳',
'1337560':'广东|珠海',
'1337561':'广东|珠海',
'1337570':'广东|佛山',
'1337571':'广东|佛山',
'1337572':'广东|佛山',
'1337580':'广东|肇庆',
'1337581':'广东|肇庆',
'1337590':'广东|湛江',
'1337591':'广东|湛江',
'1337600':'广东|中山',
'1337601':'广东|中山',
'1337620':'广东|河源',
'1337621':'广东|河源',
'1337630':'广东|清远',
'1337631':'广东|清远',
'1337660':'广东|云浮',
'1337661':'广东|云浮',
'1337680':'广东|潮州',
'1337681':'广东|潮州',
'1337690':'广东|东莞',
'1337691':'广东|东莞',
'1337692':'广东|东莞',
'1337700':'广西|防城港',
'1337701':'广西|防城港',
'1337710':'广西|南宁',
'1337711':'广西|南宁',
'1337712':'广西|南宁',
'1337720':'广西|柳州',
'1337721':'广西|柳州',
'1337730':'广西|桂林',
'1337731':'广西|桂林',
'1337740':'广西|梧州',
'1337741':'广西|梧州',
'1337750':'广西|贵港',
'1337751':'广西|贵港',
'1337760':'广西|百色',
'1337761':'广西|百色',
'1337770':'广西|钦州',
'1337771':'广西|钦州',
'1337780':'广西|河池',
'1337781':'广西|河池',
'1337790':'广西|北海',
'1337791':'广西|北海',
'1337900':'江西|新余',
'1337901':'江西|新余',
'1337910':'江西|南昌',
'1337911':'江西|南昌',
'1337912':'江西|南昌',
'1337913':'江西|南昌',
'1337920':'江西|九江',
'1337921':'江西|九江',
'1337930':'江西|上饶',
'1337931':'江西|上饶',
'1337940':'江西|抚州',
'1337941':'江西|抚州',
'1337950':'江西|宜春',
'1337951':'江西|宜春',
'1337960':'江西|吉安',
'1337961':'江西|吉安',
'1337970':'江西|赣州',
'1337971':'江西|赣州',
'1337980':'江西|景德镇',
'1337981':'江西|景德镇',
'1337990':'江西|萍乡',
'1337991':'江西|萍乡',
'1338120':'四川|攀枝花',
'1338121':'四川|攀枝花',
'1338130':'四川|自贡',
'1338131':'四川|自贡',
'1338160':'四川|绵阳',
'1338161':'四川|绵阳',
'1338170':'四川|南充',
'1338171':'四川|南充',
'1338180':'四川|达州',
'1338181':'四川|达州',
'1338250':'四川|遂宁',
'1338251':'四川|遂宁',
'1338260':'四川|广安',
'1338261':'四川|广安',
'1338270':'四川|巴中',
'1338271':'四川|巴中',
'1338300':'重庆',
'1338301':'四川|泸州',
'1338310':'四川|宜宾',
'1338311':'四川|宜宾',
'1338320':'四川|内江',
'1338321':'四川|内江',
'1338330':'四川|乐山',
'1338331':'四川|乐山',
'1338350':'四川|雅安',
'1338351':'四川|雅安',
'1338380':'四川|德阳',
'1338381':'四川|德阳',
'1338390':'四川|广元',
'1338391':'四川|广元',
'1338400':'重庆',
'1338500':'重庆',
'1338510':'贵州|贵阳',
'1338511':'贵州|贵阳',
'1338512':'贵州|贵阳',
'1338520':'贵州|遵义',
'1338521':'贵州|遵义',
'1338530':'贵州|安顺',
'1338531':'贵州|安顺',
'1338560':'贵州|铜仁',
'1338561':'贵州|铜仁',
'1338570':'贵州|毕节',
'1338571':'贵州|毕节',
'1338580':'贵州|六盘水',
'1338581':'贵州|六盘水',
'1338700':'云南|昭通',
'1338701':'云南|昭通',
'1338710':'云南|昆明',
'1338711':'云南|昆明',
'1338712':'云南|昆明',
'1338713':'云南|昆明',
'1338720':'云南|大理',
'1338721':'云南|大理',
'1338740':'云南|曲靖',
'1338741':'云南|曲靖',
'1338750':'云南|保山',
'1338751':'云南|保山',
'1338770':'云南|玉溪',
'1338771':'云南|玉溪',
'1338790':'云南|普洱',
'1338791':'云南|普洱',
'1338880':'云南|丽江',
'1338881':'云南|丽江',
'1338910':'西藏|拉萨',
'1338911':'西藏|拉萨',
'1338920':'西藏|日喀则',
'1338921':'西藏|日喀则',
'1338980':'海南|海口',
'1338981':'海南|海口',
'1338982':'海南|海口',
'1338990':'海南|三亚',
'1338991':'海南|三亚',
'1339110':'陕西|延安',
'1339111':'陕西|延安',
'1339120':'陕西|榆林',
'1339121':'陕西|榆林',
'1339130':'陕西|渭南',
'1339131':'陕西|渭南',
'1339140':'陕西|商洛',
'1339141':'陕西|商洛',
'1339150':'陕西|安康',
'1339151':'陕西|安康',
'1339160':'陕西|汉中',
'1339161':'陕西|汉中',
'1339170':'陕西|宝鸡',
'1339171':'陕西|宝鸡',
'1339190':'陕西|铜川',
'1339191':'陕西|铜川',
'1339310':'甘肃|兰州',
'1339311':'甘肃|兰州',
'1339312':'甘肃|兰州',
'1339370':'甘肃|酒泉',
'1339371':'甘肃|酒泉',
'1339380':'甘肃|天水',
'1339381':'甘肃|天水',
'1339430':'甘肃|白银',
'1339431':'甘肃|白银',
'1339510':'宁夏|银川',
'1339511':'宁夏|银川',
'1339710':'青海|西宁',
'1339711':'青海|西宁',
'1339910':'新疆|乌鲁木齐',
'1339911':'新疆|乌鲁木齐',
'1339912':'新疆|乌鲁木齐',
'1341000':'北京',
'1341100':'北京',
'1341200':'北京',
'1341300':'北京',
'1341400':'北京',
'1341500':'北京',
'1341600':'北京',
'1341700':'北京',
'1341800':'北京',
'1341900':'北京',
'1342000':'广东|广州',
'1342001':'广东|广州',
'1342002':'广东|广州',
'1342003':'广东|广州',
'1342100':'上海',
'1342200':'上海',
'1342300':'上海',
'1342410':'辽宁|沈阳',
'1342411':'辽宁|沈阳',
'1342412':'辽宁|沈阳',
'1342413':'辽宁|沈阳',
'1342500':'江苏|南京',
'1342501':'江苏|南京',
'1342502':'江苏|南京',
'1342503':'江苏|南京',
'1342710':'湖北|武汉',
'1342711':'湖北|武汉',
'1342712':'湖北|武汉',
'1342713':'湖北|武汉',
'1342800':'四川|成都',
'1342801':'四川|成都',
'1342802':'四川|成都',
'1342803':'四川|成都',
'1342900':'陕西|咸阳',
'1342901':'陕西|咸阳',
'1342910':'陕西|西安',
'1342911':'陕西|西安',
'1342912':'陕西|西安',
'1342913':'陕西|西安',
'1343100':'河北|邯郸',
'1343101':'河北|邯郸',
'1343102':'河北|邯郸',
'1343110':'河北|石家庄',
'1343111':'河北|石家庄',
'1343112':'河北|石家庄',
'1343113':'河北|石家庄',
'1343120':'河北|保定',
'1343121':'河北|保定',
'1343122':'河北|保定',
'1343130':'河北|张家口',
'1343131':'河北|张家口',
'1343140':'河北|承德',
'1343141':'河北|承德',
'1343150':'河北|唐山',
'1343151':'河北|唐山',
'1343152':'河北|唐山',
'1343153':'河北|唐山',
'1343160':'河北|廊坊',
'1343161':'河北|廊坊',
'1343170':'河北|沧州',
'1343171':'河北|沧州',
'1343180':'河北|衡水',
'1343181':'河北|衡水',
'1343190':'河北|邢台',
'1343191':'河北|邢台',
'1343350':'河北|秦皇岛',
'1343351':'河北|秦皇岛',
'1343500':'山西|忻州',
'1343501':'山西|忻州',
'1343510':'山西|太原',
'1343511':'山西|太原',
'1343512':'山西|太原',
'1343513':'山西|太原',
'1343520':'山西|大同',
'1343521':'山西|大同',
'1343530':'山西|阳泉',
'1343531':'山西|阳泉',
'1343540':'山西|晋中',
'1343541':'山西|晋中',
'1343550':'山西|长治',
'1343551':'山西|长治',
'1343560':'山西|晋城',
'1343561':'山西|晋城',
'1343570':'山西|临汾',
'1343571':'山西|临汾',
'1343580':'山西|吕梁',
'1343581':'山西|吕梁',
'1343590':'山西|运城',
'1343591':'山西|运城',
'1343700':'河南|商丘',
'1343701':'河南|商丘',
'1343710':'河南|郑州',
'1343711':'河南|郑州',
'1343712':'河南|郑州',
'1343713':'河南|郑州',
'1343720':'河南|安阳',
'1343721':'河南|安阳',
'1343730':'河南|新乡',
'1343731':'河南|新乡',
'1343740':'河南|许昌',
'1343741':'河南|许昌',
'1343750':'河南|平顶山',
'1343751':'河南|平顶山',
'1343760':'河南|信阳',
'1343761':'河南|信阳',
'1343770':'河南|南阳',
'1343771':'河南|南阳',
'1343780':'河南|开封',
'1343781':'河南|开封',
'1343790':'河南|洛阳',
'1343791':'河南|洛阳',
'1343792':'河南|洛阳',
'1343910':'河南|焦作',
'1343911':'河南|焦作',
'1343920':'河南|鹤壁',
'1343921':'河南|鹤壁',
'1343930':'河南|濮阳',
'1343931':'河南|濮阳',
'1343940':'河南|周口',
'1343941':'河南|周口',
'1343950':'河南|漯河',
'1343951':'河南|漯河',
'1343960':'河南|驻马店',
'1343961':'河南|驻马店',
'1343980':'河南|三门峡',
'1343981':'河南|三门峡',
'1344100':'辽宁|铁岭',
'1344101':'辽宁|铁岭',
'1344110':'辽宁|大连',
'1344111':'辽宁|大连',
'1344112':'辽宁|大连',
'1344113':'辽宁|大连',
'1344120':'辽宁|鞍山',
'1344121':'辽宁|鞍山',
'1344130':'辽宁|抚顺',
'1344131':'辽宁|抚顺',
'1344140':'辽宁|本溪',
'1344141':'辽宁|本溪',
'1344150':'辽宁|丹东',
'1344151':'辽宁|丹东',
'1344160':'辽宁|锦州',
'1344161':'辽宁|锦州',
'1344170':'辽宁|营口',
'1344171':'辽宁|营口',
'1344180':'辽宁|阜新',
'1344181':'辽宁|阜新',
'1344190':'辽宁|辽阳',
'1344191':'辽宁|辽阳',
'1344210':'辽宁|朝阳',
'1344211':'辽宁|朝阳',
'1344270':'辽宁|盘锦',
'1344271':'辽宁|盘锦',
'1344290':'辽宁|葫芦岛',
'1344291':'辽宁|葫芦岛',
'1344310':'吉林|长春',
'1344311':'吉林|长春',
'1344312':'吉林|长春',
'1344313':'吉林|长春',
'1344320':'吉林|吉林市',
'1344321':'吉林|吉林市',
'1344340':'吉林|四平',
'1344341':'吉林|四平',
'1344350':'吉林|通化',
'1344351':'吉林|通化',
'1344360':'吉林|白城',
'1344361':'吉林|白城',
'1344370':'吉林|辽源',
'1344371':'吉林|辽源',
'1344380':'吉林|松原',
'1344381':'吉林|松原',
'1344390':'吉林|白山',
'1344391':'吉林|白山',
'1344510':'黑龙江|哈尔滨',
'1344511':'黑龙江|哈尔滨',
'1344512':'黑龙江|哈尔滨',
'1344513':'黑龙江|哈尔滨',
'1344520':'黑龙江|齐齐哈尔',
'1344521':'黑龙江|齐齐哈尔',
'1344530':'黑龙江|牡丹江',
'1344531':'黑龙江|牡丹江',
'1344540':'黑龙江|佳木斯',
'1344541':'黑龙江|佳木斯',
'1344550':'黑龙江|绥化',
'1344551':'黑龙江|绥化',
'1344580':'黑龙江|伊春',
'1344581':'黑龙江|伊春',
'1344590':'黑龙江|大庆',
'1344591':'黑龙江|大庆',
'1344670':'黑龙江|鸡西',
'1344671':'黑龙江|鸡西',
'1344710':'内蒙古|呼和浩特',
'1344711':'内蒙古|呼和浩特',
'1344712':'内蒙古|呼和浩特',
'1344720':'内蒙古|包头',
'1344721':'内蒙古|包头',
'1344730':'内蒙古|乌海',
'1344750':'内蒙古|通辽',
'1344751':'内蒙古|通辽',
'1344760':'内蒙古|赤峰',
'1344761':'内蒙古|赤峰',
'1344770':'内蒙古|鄂尔多斯',
'1344771':'内蒙古|鄂尔多斯',
'1345100':'江苏|无锡',
'1345101':'江苏|无锡',
'1345102':'江苏|无锡',
'1345110':'江苏|镇江',
'1345111':'江苏|镇江',
'1345120':'江苏|苏州',
'1345121':'江苏|苏州',
'1345122':'江苏|苏州',
'1345123':'江苏|苏州',
'1345130':'江苏|南通',
'1345131':'江苏|南通',
'1345132':'江苏|南通',
'1345140':'江苏|扬州',
'1345141':'江苏|扬州',
'1345150':'江苏|盐城',
'1345151':'江苏|盐城',
'1345160':'江苏|徐州',
'1345161':'江苏|徐州',
'1345162':'江苏|徐州',
'1345170':'江苏|淮安',
'1345171':'江苏|淮安',
'1345180':'江苏|连云港',
'1345181':'江苏|连云港',
'1345190':'江苏|常州',
'1345191':'江苏|常州',
'1345192':'江苏|常州',
'1345230':'江苏|泰州',
'1345231':'江苏|泰州',
'1345270':'江苏|宿迁',
'1345271':'江苏|宿迁',
'1345300':'山东|菏泽',
'1345301':'山东|菏泽',
'1345310':'山东|济南',
'1345311':'山东|济南',
'1345312':'山东|济南',
'1345313':'山东|济南',
'1345320':'山东|青岛',
'1345321':'山东|青岛',
'1345322':'山东|青岛',
'1345323':'山东|青岛',
'1345330':'山东|淄博',
'1345331':'山东|淄博',
'1345340':'山东|德州',
'1345341':'山东|德州',
'1345350':'山东|烟台',
'1345351':'山东|烟台',
'1345352':'山东|烟台',
'1345360':'山东|潍坊',
'1345361':'山东|潍坊',
'1345362':'山东|潍坊',
'1345370':'山东|济宁',
'1345371':'山东|济宁',
'1345380':'山东|泰安',
'1345381':'山东|泰安',
'1345390':'山东|临沂',
'1345391':'山东|临沂',
'1345430':'山东|滨州',
'1345431':'山东|滨州',
'1345460':'山东|东营',
'1345461':'山东|东营',
'1345500':'安徽|滁州',
'1345501':'安徽|滁州',
'1345510':'安徽|合肥',
'1345511':'安徽|合肥',
'1345512':'安徽|合肥',
'1345513':'安徽|合肥',
'1345514':'安徽|合肥',
'1345520':'安徽|蚌埠',
'1345521':'安徽|蚌埠',
'1345530':'安徽|芜湖',
'1345531':'安徽|芜湖',
'1345532':'安徽|芜湖',
'1345540':'安徽|淮南',
'1345541':'安徽|淮南',
'1345550':'安徽|马鞍山',
'1345551':'安徽|马鞍山',
'1345560':'安徽|安庆',
'1345561':'安徽|安庆',
'1345570':'安徽|宿州',
'1345571':'安徽|宿州',
'1345580':'安徽|阜阳',
'1345581':'安徽|阜阳',
'1345590':'安徽|黄山',
'1345591':'安徽|黄山',
'1345600':'安徽|合肥',
'1345601':'安徽|合肥',
'1345602':'安徽|合肥',
'1345603':'安徽|合肥',
'1345604':'安徽|合肥',
'1345610':'安徽|淮北',
'1345611':'安徽|淮北',
'1345620':'安徽|铜陵',
'1345621':'安徽|铜陵',
'1345630':'安徽|宣城',
'1345631':'安徽|宣城',
'1345640':'安徽|六安',
'1345641':'安徽|六安',
'1345660':'安徽|池州',
'1345661':'安徽|池州',
'1345700':'浙江|衢州',
'1345701':'浙江|衢州',
'1345710':'浙江|杭州',
'1345711':'浙江|杭州',
'1345712':'浙江|杭州',
'1345713':'浙江|杭州',
'1345720':'浙江|湖州',
'1345721':'浙江|湖州',
'1345730':'浙江|嘉兴',
'1345731':'浙江|嘉兴',
'1345740':'浙江|宁波',
'1345741':'浙江|宁波',
'1345742':'浙江|宁波',
'1345750':'浙江|绍兴',
'1345751':'浙江|绍兴',
'1345760':'浙江|台州',
'1345761':'浙江|台州',
'1345770':'浙江|温州',
'1345771':'浙江|温州',
'1345772':'浙江|温州',
'1345780':'浙江|丽水',
'1345781':'浙江|丽水',
'1345790':'浙江|金华',
'1345791':'浙江|金华',
'1345800':'浙江|舟山',
'1345801':'浙江|舟山',
'1345910':'福建|福州',
'1345911':'福建|福州',
'1345912':'福建|福州',
'1345913':'福建|福州',
'1345920':'福建|厦门',
'1345921':'福建|厦门',
'1345922':'福建|厦门',
'1345930':'福建|宁德',
'1345931':'福建|宁德',
'1345940':'福建|莆田',
'1345941':'福建|莆田',
'1345950':'福建|泉州',
'1345951':'福建|泉州',
'1345952':'福建|泉州',
'1345960':'福建|漳州',
'1345961':'福建|漳州',
'1345970':'福建|龙岩',
'1345971':'福建|龙岩',
'1345980':'福建|三明',
'1345981':'福建|三明',
'1345990':'福建|南平',
'1345991':'福建|南平',
'1346310':'山东|威海',
'1346311':'山东|威海',
'1346320':'山东|枣庄',
'1346321':'山东|枣庄',
'1346330':'山东|日照',
'1346331':'山东|日照',
'1346350':'山东|聊城',
'1346351':'山东|聊城',
'1346600':'广东|汕尾',
'1346601':'广东|汕尾',
'1346620':'广东|阳江',
'1346621':'广东|阳江',
'1346630':'广东|揭阳',
'1346631':'广东|揭阳',
'1346680':'广东|茂名',
'1346681':'广东|茂名',
'1347010':'江西|鹰潭',
'1347011':'江西|鹰潭',
'1347100':'湖北|襄阳',
'1347101':'湖北|襄阳',
'1347110':'湖北|鄂州',
'1347111':'湖北|鄂州',
'1347120':'湖北|孝感',
'1347121':'湖北|孝感',
'1347130':'湖北|黄冈',
'1347131':'湖北|黄冈',
'1347140':'湖北|黄石',
'1347141':'湖北|黄石',
'1347150':'湖北|咸宁',
'1347151':'湖北|咸宁',
'1347160':'湖北|荆州',
'1347161':'湖北|荆州',
'1347170':'湖北|宜昌',
'1347171':'湖北|宜昌',
'1347180':'湖北|恩施',
'1347181':'湖北|恩施',
'1347190':'湖北|十堰',
'1347191':'湖北|十堰',
'1347220':'湖北|随州',
'1347221':'湖北|随州',
'1347240':'湖北|荆门',
'1347241':'湖北|荆门',
'1347300':'湖南|岳阳',
'1347301':'湖南|岳阳',
'1347310':'湖南|长沙',
'1347311':'湖南|长沙',
'1347312':'湖南|长沙',
'1347313':'湖南|长沙',
'1347320':'湖南|湘潭',
'1347321':'湖南|湘潭',
'1347330':'湖南|株洲',
'1347331':'湖南|株洲',
'1347340':'湖南|衡阳',
'1347341':'湖南|衡阳',
'1347350':'湖南|郴州',
'1347351':'湖南|郴州',
'1347360':'湖南|常德',
'1347361':'湖南|常德',
'1347370':'湖南|益阳',
'1347371':'湖南|益阳',
'1347380':'湖南|娄底',
'1347381':'湖南|娄底',
'1347390':'湖南|邵阳',
'1347391':'湖南|邵阳',
'1347440':'湖南|张家界',
'1347441':'湖南|张家界',
'1347450':'湖南|怀化',
'1347451':'湖南|怀化',
'1347460':'湖南|永州',
'1347461':'湖南|永州',
'1347500':'广东|江门',
'1347501':'广东|江门',
'1347510':'广东|韶关',
'1347511':'广东|韶关',
'1347520':'广东|惠州',
'1347521':'广东|惠州',
'1347530':'广东|梅州',
'1347531':'广东|梅州',
'1347540':'广东|汕头',
'1347541':'广东|汕头',
'1347550':'广东|深圳',
'1347551':'广东|深圳',
'1347552':'广东|深圳',
'1347553':'广东|深圳',
'1347560':'广东|珠海',
'1347561':'广东|珠海',
'1347570':'广东|佛山',
'1347571':'广东|佛山',
'1347572':'广东|佛山',
'1347580':'广东|肇庆',
'1347581':'广东|肇庆',
'1347590':'广东|湛江',
'1347591':'广东|湛江',
'1347600':'广东|中山',
'1347601':'广东|中山',
'1347620':'广东|河源',
'1347621':'广东|河源',
'1347630':'广东|清远',
'1347631':'广东|清远',
'1347660':'广东|云浮',
'1347661':'广东|云浮',
'1347680':'广东|潮州',
'1347681':'广东|潮州',
'1347690':'广东|东莞',
'1347691':'广东|东莞',
'1347692':'广东|东莞',
'1347700':'广西|防城港',
'1347701':'广西|防城港',
'1347710':'广西|南宁',
'1347711':'广西|南宁',
'1347712':'广西|南宁',
'1347720':'广西|柳州',
'1347721':'广西|柳州',
'1347730':'广西|桂林',
'1347731':'广西|桂林',
'1347740':'广西|梧州',
'1347741':'广西|梧州',
'1347750':'广西|贵港',
'1347751':'广西|贵港',
'1347760':'广西|百色',
'1347761':'广西|百色',
'1347770':'广西|钦州',
'1347771':'广西|钦州',
'1347780':'广西|河池',
'1347781':'广西|河池',
'1347790':'广西|北海',
'1347791':'广西|北海',
'1347900':'江西|新余',
'1347901':'江西|新余',
'1347910':'江西|南昌',
'1347911':'江西|南昌',
'1347912':'江西|南昌',
'1347913':'江西|南昌',
'1347920':'江西|九江',
'1347921':'江西|九江',
'1347930':'江西|上饶',
'1347931':'江西|上饶',
'1347940':'江西|抚州',
'1347941':'江西|抚州',
'1347950':'江西|宜春',
'1347951':'江西|宜春',
'1347960':'江西|吉安',
'1347961':'江西|吉安',
'1347970':'江西|赣州',
'1347971':'江西|赣州',
'1347980':'江西|景德镇',
'1347981':'江西|景德镇',
'1347990':'江西|萍乡',
'1347991':'江西|萍乡',
'1348120':'四川|攀枝花',
'1348121':'四川|攀枝花',
'1348130':'四川|自贡',
'1348131':'四川|自贡',
'1348160':'四川|绵阳',
'1348161':'四川|绵阳',
'1348170':'四川|南充',
'1348171':'四川|南充',
'1348180':'四川|达州',
'1348181':'四川|达州',
'1348250':'四川|遂宁',
'1348251':'四川|遂宁',
'1348260':'四川|广安',
'1348261':'四川|广安',
'1348270':'四川|巴中',
'1348271':'四川|巴中',
'1348300':'重庆',
'1348301':'四川|泸州',
'1348310':'四川|宜宾',
'1348311':'四川|宜宾',
'1348320':'四川|内江',
'1348321':'四川|内江',
'1348330':'四川|乐山',
'1348331':'四川|乐山',
'1348350':'四川|雅安',
'1348351':'四川|雅安',
'1348380':'四川|德阳',
'1348381':'四川|德阳',
'1348390':'四川|广元',
'1348391':'四川|广元',
'1348400':'重庆',
'1348500':'重庆',
'1348510':'贵州|贵阳',
'1348511':'贵州|贵阳',
'1348512':'贵州|贵阳',
'1348520':'贵州|遵义',
'1348521':'贵州|遵义',
'1348530':'贵州|安顺',
'1348531':'贵州|安顺',
'1348560':'贵州|铜仁',
'1348561':'贵州|铜仁',
'1348570':'贵州|毕节',
'1348571':'贵州|毕节',
'1348580':'贵州|六盘水',
'1348581':'贵州|六盘水',
'1348700':'云南|昭通',
'1348701':'云南|昭通',
'1348710':'云南|昆明',
'1348711':'云南|昆明',
'1348712':'云南|昆明',
'1348713':'云南|昆明',
'1348720':'云南|大理',
'1348721':'云南|大理',
'1348740':'云南|曲靖',
'1348741':'云南|曲靖',
'1348750':'云南|保山',
'1348751':'云南|保山',
'1348770':'云南|玉溪',
'1348771':'云南|玉溪',
'1348790':'云南|普洱',
'1348791':'云南|普洱',
'1348880':'云南|丽江',
'1348881':'云南|丽江',
'1348910':'西藏|拉萨',
'1348911':'西藏|拉萨',
'1348920':'西藏|日喀则',
'1348921':'西藏|日喀则',
'1348980':'海南|海口',
'1348981':'海南|海口',
'1348982':'海南|海口',
'1348990':'海南|三亚',
'1348991':'海南|三亚',
'1349110':'陕西|延安',
'1349111':'陕西|延安',
'1349120':'陕西|榆林',
'1349121':'陕西|榆林',
'1349130':'陕西|渭南',
'1349131':'陕西|渭南',
'1349140':'陕西|商洛',
'1349141':'陕西|商洛',
'1349150':'陕西|安康',
'1349151':'陕西|安康',
'1349160':'陕西|汉中',
'1349161':'陕西|汉中',
'1349170':'陕西|宝鸡',
'1349171':'陕西|宝鸡',
'1349190':'陕西|铜川',
'1349191':'陕西|铜川',
'1349310':'甘肃|兰州',
'1349311':'甘肃|兰州',
'1349312':'甘肃|兰州',
'1349370':'甘肃|酒泉',
'1349371':'甘肃|酒泉',
'1349380':'甘肃|天水',
'1349381':'甘肃|天水',
'1349430':'甘肃|白银',
'1349431':'甘肃|白银',
'1349510':'宁夏|银川',
'1349511':'宁夏|银川',
'1349710':'青海|西宁',
'1349711':'青海|西宁',
'1349910':'新疆|乌鲁木齐',
'1349911':'新疆|乌鲁木齐',
'1349912':'新疆|乌鲁木齐',
'1351000':'北京',
'1351100':'北京',
'1351200':'北京',
'1351300':'北京',
'1351400':'北京',
'1351500':'北京',
'1351600':'北京',
'1351700':'北京',
'1351800':'北京',
'1351900':'北京',
'1352000':'广东|广州',
'1352001':'广东|广州',
'1352002':'广东|广州',
'1352003':'广东|广州',
'1352100':'上海',
'1352200':'上海',
'1352300':'上海',
'1352410':'辽宁|沈阳',
'1352411':'辽宁|沈阳',
'1352412':'辽宁|沈阳',
'1352413':'辽宁|沈阳',
'1352500':'江苏|南京',
'1352501':'江苏|南京',
'1352502':'江苏|南京',
'1352503':'江苏|南京',
'1352710':'湖北|武汉',
'1352711':'湖北|武汉',
'1352712':'湖北|武汉',
'1352713':'湖北|武汉',
'1352800':'四川|成都',
'1352801':'四川|成都',
'1352802':'四川|成都',
'1352803':'四川|成都',
'1352900':'陕西|咸阳',
'1352901':'陕西|咸阳',
'1352910':'陕西|西安',
'1352911':'陕西|西安',
'1352912':'陕西|西安',
'1352913':'陕西|西安',
'1353100':'河北|邯郸',
'1353101':'河北|邯郸',
'1353102':'河北|邯郸',
'1353110':'河北|石家庄',
'1353111':'河北|石家庄',
'1353112':'河北|石家庄',
'1353113':'河北|石家庄',
'1353120':'河北|保定',
'1353121':'河北|保定',
'1353122':'河北|保定',
'1353130':'河北|张家口',
'1353131':'河北|张家口',
'1353140':'河北|承德',
'1353141':'河北|承德',
'1353150':'河北|唐山',
'1353151':'河北|唐山',
'1353152':'河北|唐山',
'1353153':'河北|唐山',
'1353160':'河北|廊坊',
'1353161':'河北|廊坊',
'1353170':'河北|沧州',
'1353171':'河北|沧州',
'1353180':'河北|衡水',
'1353181':'河北|衡水',
'1353190':'河北|邢台',
'1353191':'河北|邢台',
'1353350':'河北|秦皇岛',
'1353351':'河北|秦皇岛',
'1353500':'山西|忻州',
'1353501':'山西|忻州',
'1353510':'山西|太原',
'1353511':'山西|太原',
'1353512':'山西|太原',
'1353513':'山西|太原',
'1353520':'山西|大同',
'1353521':'山西|大同',
'1353530':'山西|阳泉',
'1353531':'山西|阳泉',
'1353540':'山西|晋中',
'1353541':'山西|晋中',
'1353550':'山西|长治',
'1353551':'山西|长治',
'1353560':'山西|晋城',
'1353561':'山西|晋城',
'1353570':'山西|临汾',
'1353571':'山西|临汾',
'1353580':'山西|吕梁',
'1353581':'山西|吕梁',
'1353590':'山西|运城',
'1353591':'山西|运城',
'1353700':'河南|商丘',
'1353701':'河南|商丘',
'1353710':'河南|郑州',
'1353711':'河南|郑州',
'1353712':'河南|郑州',
'1353713':'河南|郑州',
'1353720':'河南|安阳',
'1353721':'河南|安阳',
'1353730':'河南|新乡',
'1353731':'河南|新乡',
'1353740':'河南|许昌',
'1353741':'河南|许昌',
'1353750':'河南|平顶山',
'1353751':'河南|平顶山',
'1353760':'河南|信阳',
'1353761':'河南|信阳',
'1353770':'河南|南阳',
'1353771':'河南|南阳',
'1353780':'河南|开封',
'1353781':'河南|开封',
'1353790':'河南|洛阳',
'1353791':'河南|洛阳',
'1353792':'河南|洛阳',
'1353910':'河南|焦作',
'1353911':'河南|焦作',
'1353920':'河南|鹤壁',
'1353921':'河南|鹤壁',
'1353930':'河南|濮阳',
'1353931':'河南|濮阳',
'1353940':'河南|周口',
'1353941':'河南|周口',
'1353950':'河南|漯河',
'1353951':'河南|漯河',
'1353960':'河南|驻马店',
'1353961':'河南|驻马店',
'1353980':'河南|三门峡',
'1353981':'河南|三门峡',
'1354100':'辽宁|铁岭',
'1354101':'辽宁|铁岭',
'1354110':'辽宁|大连',
'1354111':'辽宁|大连',
'1354112':'辽宁|大连',
'1354113':'辽宁|大连',
'1354120':'辽宁|鞍山',
'1354121':'辽宁|鞍山',
'1354130':'辽宁|抚顺',
'1354131':'辽宁|抚顺',
'1354140':'辽宁|本溪',
'1354141':'辽宁|本溪',
'1354150':'辽宁|丹东',
'1354151':'辽宁|丹东',
'1354160':'辽宁|锦州',
'1354161':'辽宁|锦州',
'1354170':'辽宁|营口',
'1354171':'辽宁|营口',
'1354180':'辽宁|阜新',
'1354181':'辽宁|阜新',
'1354190':'辽宁|辽阳',
'1354191':'辽宁|辽阳',
'1354210':'辽宁|朝阳',
'1354211':'辽宁|朝阳',
'1354270':'辽宁|盘锦',
'1354271':'辽宁|盘锦',
'1354290':'辽宁|葫芦岛',
'1354291':'辽宁|葫芦岛',
'1354310':'吉林|长春',
'1354311':'吉林|长春',
'1354312':'吉林|长春',
'1354313':'吉林|长春',
'1354320':'吉林|吉林市',
'1354321':'吉林|吉林市',
'1354340':'吉林|四平',
'1354341':'吉林|四平',
'1354350':'吉林|通化',
'1354351':'吉林|通化',
'1354360':'吉林|白城',
'1354361':'吉林|白城',
'1354370':'吉林|辽源',
'1354371':'吉林|辽源',
'1354380':'吉林|松原',
'1354381':'吉林|松原',
'1354390':'吉林|白山',
'1354391':'吉林|白山',
'1354510':'黑龙江|哈尔滨',
'1354511':'黑龙江|哈尔滨',
'1354512':'黑龙江|哈尔滨',
'1354513':'黑龙江|哈尔滨',
'1354520':'黑龙江|齐齐哈尔',
'1354521':'黑龙江|齐齐哈尔',
'1354530':'黑龙江|牡丹江',
'1354531':'黑龙江|牡丹江',
'1354540':'黑龙江|佳木斯',
'1354541':'黑龙江|佳木斯',
'1354550':'黑龙江|绥化',
'1354551':'黑龙江|绥化',
'1354580':'黑龙江|伊春',
'1354581':'黑龙江|伊春',
'1354590':'黑龙江|大庆',
'1354591':'黑龙江|大庆',
'1354670':'黑龙江|鸡西',
'1354671':'黑龙江|鸡西',
'1354710':'内蒙古|呼和浩特',
'1354711':'内蒙古|呼和浩特',
'1354712':'内蒙古|呼和浩特',
'1354720':'内蒙古|包头',
'1354721':'内蒙古|包头',
'1354730':'内蒙古|乌海',
'1354750':'内蒙古|通辽',
'1354751':'内蒙古|通辽',
'1354760':'内蒙古|赤峰',
'1354761':'内蒙古|赤峰',
'1354770':'内蒙古|鄂尔多斯',
'1354771':'内蒙古|鄂尔多斯',
'1355100':'江苏|无锡',
'1355101':'江苏|无锡',
'1355102':'江苏|无锡',
'1355110':'江苏|镇江',
'1355111':'江苏|镇江',
'1355120':'江苏|苏州',
'1355121':'江苏|苏州',
'1355122':'江苏|苏州',
'1355123':'江苏|苏州',
'1355130':'江苏|南通',
'1355131':'江苏|南通',
'1355132':'江苏|南通',
'1355140':'江苏|扬州',
'1355141':'江苏|扬州',
'1355150':'江苏|盐城',
'1355151':'江苏|盐城',
'1355160':'江苏|徐州',
'1355161':'江苏|徐州',
'1355162':'江苏|徐州',
'1355170':'江苏|淮安',
'1355171':'江苏|淮安',
'1355180':'江苏|连云港',
'1355181':'江苏|连云港',
'1355190':'江苏|常州',
'1355191':'江苏|常州',
'1355192':'江苏|常州',
'1355230':'江苏|泰州',
'1355231':'江苏|泰州',
'1355270':'江苏|宿迁',
'1355271':'江苏|宿迁',
'1355300':'山东|菏泽',
'1355301':'山东|菏泽',
'1355310':'山东|济南',
'1355311':'山东|济南',
'1355312':'山东|济南',
'1355313':'山东|济南',
'1355320':'山东|青岛',
'1355321':'山东|青岛',
'1355322':'山东|青岛',
'1355323':'山东|青岛',
'1355330':'山东|淄博',
'1355331':'山东|淄博',
'1355340':'山东|德州',
'1355341':'山东|德州',
'1355350':'山东|烟台',
'1355351':'山东|烟台',
'1355352':'山东|烟台',
'1355360':'山东|潍坊',
'1355361':'山东|潍坊',
'1355362':'山东|潍坊',
'1355370':'山东|济宁',
'1355371':'山东|济宁',
'1355380':'山东|泰安',
'1355381':'山东|泰安',
'1355390':'山东|临沂',
'1355391':'山东|临沂',
'1355430':'山东|滨州',
'1355431':'山东|滨州',
'1355460':'山东|东营',
'1355461':'山东|东营',
'1355500':'安徽|滁州',
'1355501':'安徽|滁州',
'1355510':'安徽|合肥',
'1355511':'安徽|合肥',
'1355512':'安徽|合肥',
'1355513':'安徽|合肥',
'1355514':'安徽|合肥',
'1355520':'安徽|蚌埠',
'1355521':'安徽|蚌埠',
'1355530':'安徽|芜湖',
'1355531':'安徽|芜湖',
'1355532':'安徽|芜湖',
'1355540':'安徽|淮南',
'1355541':'安徽|淮南',
'1355550':'安徽|马鞍山',
'1355551':'安徽|马鞍山',
'1355560':'安徽|安庆',
'1355561':'安徽|安庆',
'1355570':'安徽|宿州',
'1355571':'安徽|宿州',
'1355580':'安徽|阜阳',
'1355581':'安徽|阜阳',
'1355590':'安徽|黄山',
'1355591':'安徽|黄山',
'1355600':'安徽|合肥',
'1355601':'安徽|合肥',
'1355602':'安徽|合肥',
'1355603':'安徽|合肥',
'1355604':'安徽|合肥',
'1355610':'安徽|淮北',
'1355611':'安徽|淮北',
'1355620':'安徽|铜陵',
'1355621':'安徽|铜陵',
'1355630':'安徽|宣城',
'1355631':'安徽|宣城',
'1355640':'安徽|六安',
'1355641':'安徽|六安',
'1355660':'安徽|池州',
'1355661':'安徽|池州',
'1355700':'浙江|衢州',
'1355701':'浙江|衢州',
'1355710':'浙江|杭州',
'1355711':'浙江|杭州',
'1355712':'浙江|杭州',
'1355713':'浙江|杭州',
'1355720':'浙江|湖州',
'1355721':'浙江|湖州',
'1355730':'浙江|嘉兴',
'1355731':'浙江|嘉兴',
'1355740':'浙江|宁波',
'1355741':'浙江|宁波',
'1355742':'浙江|宁波',
'1355750':'浙江|绍兴',
'1355751':'浙江|绍兴',
'1355760':'浙江|台州',
'1355761':'浙江|台州',
'1355770':'浙江|温州',
'1355771':'浙江|温州',
'1355772':'浙江|温州',
'1355780':'浙江|丽水',
'1355781':'浙江|丽水',
'1355790':'浙江|金华',
'1355791':'浙江|金华',
'1355800':'浙江|舟山',
'1355801':'浙江|舟山',
'1355910':'福建|福州',
'1355911':'福建|福州',
'1355912':'福建|福州',
'1355913':'福建|福州',
'1355920':'福建|厦门',
'1355921':'福建|厦门',
'1355922':'福建|厦门',
'1355930':'福建|宁德',
'1355931':'福建|宁德',
'1355940':'福建|莆田',
'1355941':'福建|莆田',
'1355950':'福建|泉州',
'1355951':'福建|泉州',
'1355952':'福建|泉州',
'1355960':'福建|漳州',
'1355961':'福建|漳州',
'1355970':'福建|龙岩',
'1355971':'福建|龙岩',
'1355980':'福建|三明',
'1355981':'福建|三明',
'1355990':'福建|南平',
'1355991':'福建|南平',
'1356310':'山东|威海',
'1356311':'山东|威海',
'1356320':'山东|枣庄',
'1356321':'山东|枣庄',
'1356330':'山东|日照',
'1356331':'山东|日照',
'1356350':'山东|聊城',
'1356351':'山东|聊城',
'1356600':'广东|汕尾',
'1356601':'广东|汕尾',
'1356620':'广东|阳江',
'1356621':'广东|阳江',
'1356630':'广东|揭阳',
'1356631':'广东|揭阳',
'1356680':'广东|茂名',
'1356681':'广东|茂名',
'1357010':'江西|鹰潭',
'1357011':'江西|鹰潭',
'1357100':'湖北|襄阳',
'1357101':'湖北|襄阳',
'1357110':'湖北|鄂州',
'1357111':'湖北|鄂州',
'1357120':'湖北|孝感',
'1357121':'湖北|孝感',
'1357130':'湖北|黄冈',
'1357131':'湖北|黄冈',
'1357140':'湖北|黄石',
'1357141':'湖北|黄石',
'1357150':'湖北|咸宁',
'1357151':'湖北|咸宁',
'1357160':'湖北|荆州',
'1357161':'湖北|荆州',
'1357170':'湖北|宜昌',
'1357171':'湖北|宜昌',
'1357180':'湖北|恩施',
'1357181':'湖北|恩施',
'1357190':'湖北|十堰',
'1357191':'湖北|十堰',
'1357220':'湖北|随州',
'1357221':'湖北|随州',
'1357240':'湖北|荆门',
'1357241':'湖北|荆门',
'1357300':'湖南|岳阳',
'1357301':'湖南|岳阳',
'1357310':'湖南|长沙',
'1357311':'湖南|长沙',
'1357312':'湖南|长沙',
'1357313':'湖南|长沙',
'1357320':'湖南|湘潭',
'1357321':'湖南|湘潭',
'1357330':'湖南|株洲',
'1357331':'湖南|株洲',
'1357340':'湖南|衡阳',
'1357341':'湖南|衡阳',
'1357350':'湖南|郴州',
'1357351':'湖南|郴州',
'1357360':'湖南|常德',
'1357361':'湖南|常德',
'1357370':'湖南|益阳',
'1357371':'湖南|益阳',
'1357380':'湖南|娄底',
'1357381':'湖南|娄底',
'1357390':'湖南|邵阳',
'1357391':'湖南|邵阳',
'1357440':'湖南|张家界',
'1357441':'湖南|张家界',
'1357450':'湖南|怀化',
'1357451':'湖南|怀化',
'1357460':'湖南|永州',
'1357461':'湖南|永州',
'1357500':'广东|江门',
'1357501':'广东|江门',
'1357510':'广东|韶关',
'1357511':'广东|韶关',
'1357520':'广东|惠州',
'1357521':'广东|惠州',
'1357530':'广东|梅州',
'1357531':'广东|梅州',
'1357540':'广东|汕头',
'1357541':'广东|汕头',
'1357550':'广东|深圳',
'1357551':'广东|深圳',
'1357552':'广东|深圳',
'1357553':'广东|深圳',
'1357560':'广东|珠海',
'1357561':'广东|珠海',
'1357570':'广东|佛山',
'1357571':'广东|佛山',
'1357572':'广东|佛山',
'1357580':'广东|肇庆',
'1357581':'广东|肇庆',
'1357590':'广东|湛江',
'1357591':'广东|湛江',
'1357600':'广东|中山',
'1357601':'广东|中山',
'1357620':'广东|河源',
'1357621':'广东|河源',
'1357630':'广东|清远',
'1357631':'广东|清远',
'1357660':'广东|云浮',
'1357661':'广东|云浮',
'1357680':'广东|潮州',
'1357681':'广东|潮州',
'1357690':'广东|东莞',
'1357691':'广东|东莞',
'1357692':'广东|东莞',
'1357700':'广西|防城港',
'1357701':'广西|防城港',
'1357710':'广西|南宁',
'1357711':'广西|南宁',
'1357712':'广西|南宁',
'1357720':'广西|柳州',
'1357721':'广西|柳州',
'1357730':'广西|桂林',
'1357731':'广西|桂林',
'1357740':'广西|梧州',
'1357741':'广西|梧州',
'1357750':'广西|贵港',
'1357751':'广西|贵港',
'1357760':'广西|百色',
'1357761':'广西|百色',
'1357770':'广西|钦州',
'1357771':'广西|钦州',
'1357780':'广西|河池',
'1357781':'广西|河池',
'1357790':'广西|北海',
'1357791':'广西|北海',
'1357900':'江西|新余',
'1357901':'江西|新余',
'1357910':'江西|南昌',
'1357911':'江西|南昌',
'1357912':'江西|南昌',
'1357913':'江西|南昌',
'1357920':'江西|九江',
'1357921':'江西|九江',
'1357930':'江西|上饶',
'1357931':'江西|上饶',
'1357940':'江西|抚州',
'1357941':'江西|抚州',
'1357950':'江西|宜春',
'1357951':'江西|宜春',
'1357960':'江西|吉安',
'1357961':'江西|吉安',
'1357970':'江西|赣州',
'1357971':'江西|赣州',
'1357980':'江西|景德镇',
'1357981':'江西|景德镇',
'1357990':'江西|萍乡',
'1357991':'江西|萍乡',
'1358120':'四川|攀枝花',
'1358121':'四川|攀枝花',
'1358130':'四川|自贡',
'1358131':'四川|自贡',
'1358160':'四川|绵阳',
'1358161':'四川|绵阳',
'1358170':'四川|南充',
'1358171':'四川|南充',
'1358180':'四川|达州',
'1358181':'四川|达州',
'1358250':'四川|遂宁',
'1358251':'四川|遂宁',
'1358260':'四川|广安',
'1358261':'四川|广安',
'1358270':'四川|巴中',
'1358271':'四川|巴中',
'1358300':'重庆',
'1358301':'四川|泸州',
'1358310':'四川|宜宾',
'1358311':'四川|宜宾',
'1358320':'四川|内江',
'1358321':'四川|内江',
'1358330':'四川|乐山',
'1358331':'四川|乐山',
'1358350':'四川|雅安',
'1358351':'四川|雅安',
'1358380':'四川|德阳',
'1358381':'四川|德阳',
'1358390':'四川|广元',
'1358391':'四川|广元',
'1358400':'重庆',
'1358500':'重庆',
'1358510':'贵州|贵阳',
'1358511':'贵州|贵阳',
'1358512':'贵州|贵阳',
'1358520':'贵州|遵义',
'1358521':'贵州|遵义',
'1358530':'贵州|安顺',
'1358531':'贵州|安顺',
'1358560':'贵州|铜仁',
'1358561':'贵州|铜仁',
'1358570':'贵州|毕节',
'1358571':'贵州|毕节',
'1358580':'贵州|六盘水',
'1358581':'贵州|六盘水',
'1358700':'云南|昭通',
'1358701':'云南|昭通',
'1358710':'云南|昆明',
'1358711':'云南|昆明',
'1358712':'云南|昆明',
'1358713':'云南|昆明',
'1358720':'云南|大理',
'1358721':'云南|大理',
'1358740':'云南|曲靖',
'1358741':'云南|曲靖',
'1358750':'云南|保山',
'1358751':'云南|保山',
'1358770':'云南|玉溪',
'1358771':'云南|玉溪',
'1358790':'云南|普洱',
'1358791':'云南|普洱',
'1358880':'云南|丽江',
'1358881':'云南|丽江',
'1358910':'西藏|拉萨',
'1358911':'西藏|拉萨',
'1358920':'西藏|日喀则',
'1358921':'西藏|日喀则',
'1358980':'海南|海口',
'1358981':'海南|海口',
'1358982':'海南|海口',
'1358990':'海南|三亚',
'1358991':'海南|三亚',
'1359110':'陕西|延安',
'1359111':'陕西|延安',
'1359120':'陕西|榆林',
'1359121':'陕西|榆林',
'1359130':'陕西|渭南',
'1359131':'陕西|渭南',
'1359140':'陕西|商洛',
'1359141':'陕西|商洛',
'1359150':'陕西|安康',
'1359151':'陕西|安康',
'1359160':'陕西|汉中',
'1359161':'陕西|汉中',
'1359170':'陕西|宝鸡',
'1359171':'陕西|宝鸡',
'1359190':'陕西|铜川',
'1359191':'陕西|铜川',
'1359310':'甘肃|兰州',
'1359311':'甘肃|兰州',
'1359312':'甘肃|兰州',
'1359370':'甘肃|酒泉',
'1359371':'甘肃|酒泉',
'1359380':'甘肃|天水',
'1359381':'甘肃|天水',
'1359430':'甘肃|白银',
'1359431':'甘肃|白银',
'1359510':'宁夏|银川',
'1359511':'宁夏|银川',
'1359710':'青海|西宁',
'1359711':'青海|西宁',
'1359910':'新疆|乌鲁木齐',
'1359911':'新疆|乌鲁木齐',
'1359912':'新疆|乌鲁木齐',
'1361000':'北京',
'1361100':'北京',
'1361200':'北京',
'1361300':'北京',
'1361400':'北京',
'1361500':'北京',
'1361600':'北京',
'1361700':'北京',
'1361800':'北京',
'1361900':'北京',
'1362000':'广东|广州',
'1362001':'广东|广州',
'1362002':'广东|广州',
'1362003':'广东|广州',
'1362100':'上海',
'1362200':'上海',
'1362300':'上海',
'1362410':'辽宁|沈阳',
'1362411':'辽宁|沈阳',
'1362412':'辽宁|沈阳',
'1362413':'辽宁|沈阳',
'1362500':'江苏|南京',
'1362501':'江苏|南京',
'1362502':'江苏|南京',
'1362503':'江苏|南京',
'1362710':'湖北|武汉',
'1362711':'湖北|武汉',
'1362712':'湖北|武汉',
'1362713':'湖北|武汉',
'1362800':'四川|成都',
'1362801':'四川|成都',
'1362802':'四川|成都',
'1362803':'四川|成都',
'1362900':'陕西|咸阳',
'1362901':'陕西|咸阳',
'1362910':'陕西|西安',
'1362911':'陕西|西安',
'1362912':'陕西|西安',
'1362913':'陕西|西安',
'1363100':'河北|邯郸',
'1363101':'河北|邯郸',
'1363102':'河北|邯郸',
'1363110':'河北|石家庄',
'1363111':'河北|石家庄',
'1363112':'河北|石家庄',
'1363113':'河北|石家庄',
'1363120':'河北|保定',
'1363121':'河北|保定',
'1363122':'河北|保定',
'1363130':'河北|张家口',
'1363131':'河北|张家口',
'1363140':'河北|承德',
'1363141':'河北|承德',
'1363150':'河北|唐山',
'1363151':'河北|唐山',
'1363152':'河北|唐山',
'1363153':'河北|唐山',
'1363160':'河北|廊坊',
'1363161':'河北|廊坊',
'1363170':'河北|沧州',
'1363171':'河北|沧州',
'1363180':'河北|衡水',
'1363181':'河北|衡水',
'1363190':'河北|邢台',
'1363191':'河北|邢台',
'1363350':'河北|秦皇岛',
'1363351':'河北|秦皇岛',
'1363500':'山西|忻州',
'1363501':'山西|忻州',
'1363510':'山西|太原',
'1363511':'山西|太原',
'1363512':'山西|太原',
'1363513':'山西|太原',
'1363520':'山西|大同',
'1363521':'山西|大同',
'1363530':'山西|阳泉',
'1363531':'山西|阳泉',
'1363540':'山西|晋中',
'1363541':'山西|晋中',
'1363550':'山西|长治',
'1363551':'山西|长治',
'1363560':'山西|晋城',
'1363561':'山西|晋城',
'1363570':'山西|临汾',
'1363571':'山西|临汾',
'1363580':'山西|吕梁',
'1363581':'山西|吕梁',
'1363590':'山西|运城',
'1363591':'山西|运城',
'1363700':'河南|商丘',
'1363701':'河南|商丘',
'1363710':'河南|郑州',
'1363711':'河南|郑州',
'1363712':'河南|郑州',
'1363713':'河南|郑州',
'1363720':'河南|安阳',
'1363721':'河南|安阳',
'1363730':'河南|新乡',
'1363731':'河南|新乡',
'1363740':'河南|许昌',
'1363741':'河南|许昌',
'1363750':'河南|平顶山',
'1363751':'河南|平顶山',
'1363760':'河南|信阳',
'1363761':'河南|信阳',
'1363770':'河南|南阳',
'1363771':'河南|南阳',
'1363780':'河南|开封',
'1363781':'河南|开封',
'1363790':'河南|洛阳',
'1363791':'河南|洛阳',
'1363792':'河南|洛阳',
'1363910':'河南|焦作',
'1363911':'河南|焦作',
'1363920':'河南|鹤壁',
'1363921':'河南|鹤壁',
'1363930':'河南|濮阳',
'1363931':'河南|濮阳',
'1363940':'河南|周口',
'1363941':'河南|周口',
'1363950':'河南|漯河',
'1363951':'河南|漯河',
'1363960':'河南|驻马店',
'1363961':'河南|驻马店',
'1363980':'河南|三门峡',
'1363981':'河南|三门峡',
'1364100':'辽宁|铁岭',
'1364101':'辽宁|铁岭',
'1364110':'辽宁|大连',
'1364111':'辽宁|大连',
'1364112':'辽宁|大连',
'1364113':'辽宁|大连',
'1364120':'辽宁|鞍山',
'1364121':'辽宁|鞍山',
'1364130':'辽宁|抚顺',
'1364131':'辽宁|抚顺',
'1364140':'辽宁|本溪',
'1364141':'辽宁|本溪',
'1364150':'辽宁|丹东',
'1364151':'辽宁|丹东',
'1364160':'辽宁|锦州',
'1364161':'辽宁|锦州',
'1364170':'辽宁|营口',
'1364171':'辽宁|营口',
'1364180':'辽宁|阜新',
'1364181':'辽宁|阜新',
'1364190':'辽宁|辽阳',
'1364191':'辽宁|辽阳',
'1364210':'辽宁|朝阳',
'1364211':'辽宁|朝阳',
'1364270':'辽宁|盘锦',
'1364271':'辽宁|盘锦',
'1364290':'辽宁|葫芦岛',
'1364291':'辽宁|葫芦岛',
'1364310':'吉林|长春',
'1364311':'吉林|长春',
'1364312':'吉林|长春',
'1364313':'吉林|长春',
'1364320':'吉林|吉林市',
'1364321':'吉林|吉林市',
'1364340':'吉林|四平',
'1364341':'吉林|四平',
'1364350':'吉林|通化',
'1364351':'吉林|通化',
'1364360':'吉林|白城',
'1364361':'吉林|白城',
'1364370':'吉林|辽源',
'1364371':'吉林|辽源',
'1364380':'吉林|松原',
'1364381':'吉林|松原',
'1364390':'吉林|白山',
'1364391':'吉林|白山',
'1364510':'黑龙江|哈尔滨',
'1364511':'黑龙江|哈尔滨',
'1364512':'黑龙江|哈尔滨',
'1364513':'黑龙江|哈尔滨',
'1364520':'黑龙江|齐齐哈尔',
'1364521':'黑龙江|齐齐哈尔',
'1364530':'黑龙江|牡丹江',
'1364531':'黑龙江|牡丹江',
'1364540':'黑龙江|佳木斯',
'1364541':'黑龙江|佳木斯',
'1364550':'黑龙江|绥化',
'1364551':'黑龙江|绥化',
'1364580':'黑龙江|伊春',
'1364581':'黑龙江|伊春',
'1364590':'黑龙江|大庆',
'1364591':'黑龙江|大庆',
'1364670':'黑龙江|鸡西',
'1364671':'黑龙江|鸡西',
'1364710':'内蒙古|呼和浩特',
'1364711':'内蒙古|呼和浩特',
'1364712':'内蒙古|呼和浩特',
'1364720':'内蒙古|包头',
'1364721':'内蒙古|包头',
'1364730':'内蒙古|乌海',
'1364750':'内蒙古|通辽',
'1364751':'内蒙古|通辽',
'1364760':'内蒙古|赤峰',
'1364761':'内蒙古|赤峰',
'1364770':'内蒙古|鄂尔多斯',
'1364771':'内蒙古|鄂尔多斯',
'1365100':'江苏|无锡',
'1365101':'江苏|无锡',
'1365102':'江苏|无锡',
'1365110':'江苏|镇江',
'1365111':'江苏|镇江',
'1365120':'江苏|苏州',
'1365121':'江苏|苏州',
'1365122':'江苏|苏州',
'1365123':'江苏|苏州',
'1365130':'江苏|南通',
'1365131':'江苏|南通',
'1365132':'江苏|南通',
'1365140':'江苏|扬州',
'1365141':'江苏|扬州',
'1365150':'江苏|盐城',
'1365151':'江苏|盐城',
'1365160':'江苏|徐州',
'1365161':'江苏|徐州',
'1365162':'江苏|徐州',
'1365170':'江苏|淮安',
'1365171':'江苏|淮安',
'1365180':'江苏|连云港',
'1365181':'江苏|连云港',
'1365190':'江苏|常州',
'1365191':'江苏|常州',
'1365192':'江苏|常州',
'1365230':'江苏|泰州',
'1365231':'江苏|泰州',
'1365270':'江苏|宿迁',
'1365271':'江苏|宿迁',
'1365300':'山东|菏泽',
'1365301':'山东|菏泽',
'1365310':'山东|济南',
'1365311':'山东|济南',
'1365312':'山东|济南',
'1365313':'山东|济南',
'1365320':'山东|青岛',
'1365321':'山东|青岛',
'1365322':'山东|青岛',
'1365323':'山东|青岛',
'1365330':'山东|淄博',
'1365331':'山东|淄博',
'1365340':'山东|德州',
'1365341':'山东|德州',
'1365350':'山东|烟台',
'1365351':'山东|烟台',
'1365352':'山东|烟台',
'1365360':'山东|潍坊',
'1365361':'山东|潍坊',
'1365362':'山东|潍坊',
'1365370':'山东|济宁',
'1365371':'山东|济宁',
'1365380':'山东|泰安',
'1365381':'山东|泰安',
'1365390':'山东|临沂',
'1365391':'山东|临沂',
'1365430':'山东|滨州',
'1365431':'山东|滨州',
'1365460':'山东|东营',
'1365461':'山东|东营',
'1365500':'安徽|滁州',
'1365501':'安徽|滁州',
'1365510':'安徽|合肥',
'1365511':'安徽|合肥',
'1365512':'安徽|合肥',
'1365513':'安徽|合肥',
'1365514':'安徽|合肥',
'1365520':'安徽|蚌埠',
'1365521':'安徽|蚌埠',
'1365530':'安徽|芜湖',
'1365531':'安徽|芜湖',
'1365532':'安徽|芜湖',
'1365540':'安徽|淮南',
'1365541':'安徽|淮南',
'1365550':'安徽|马鞍山',
'1365551':'安徽|马鞍山',
'1365560':'安徽|安庆',
'1365561':'安徽|安庆',
'1365570':'安徽|宿州',
'1365571':'安徽|宿州',
'1365580':'安徽|阜阳',
'1365581':'安徽|阜阳',
'1365590':'安徽|黄山',
'1365591':'安徽|黄山',
'1365600':'安徽|合肥',
'1365601':'安徽|合肥',
'1365602':'安徽|合肥',
'1365603':'安徽|合肥',
'1365604':'安徽|合肥',
'1365610':'安徽|淮北',
'1365611':'安徽|淮北',
'1365620':'安徽|铜陵',
'1365621':'安徽|铜陵',
'1365630':'安徽|宣城',
'1365631':'安徽|宣城',
'1365640':'安徽|六安',
'1365641':'安徽|六安',
'1365660':'安徽|池州',
'1365661':'安徽|池州',
'1365700':'浙江|衢州',
'1365701':'浙江|衢州',
'1365710':'浙江|杭州',
'1365711':'浙江|杭州',
'1365712':'浙江|杭州',
'1365713':'浙江|杭州',
'1365720':'浙江|湖州',
'1365721':'浙江|湖州',
'1365730':'浙江|嘉兴',
'1365731':'浙江|嘉兴',
'1365740':'浙江|宁波',
'1365741':'浙江|宁波',
'1365742':'浙江|宁波',
'1365750':'浙江|绍兴',
'1365751':'浙江|绍兴',
'1365760':'浙江|台州',
'1365761':'浙江|台州',
'1365770':'浙江|温州',
'1365771':'浙江|温州',
'1365772':'浙江|温州',
'1365780':'浙江|丽水',
'1365781':'浙江|丽水',
'1365790':'浙江|金华',
'1365791':'浙江|金华',
'1365800':'浙江|舟山',
'1365801':'浙江|舟山',
'1365910':'福建|福州',
'1365911':'福建|福州',
'1365912':'福建|福州',
'1365913':'福建|福州',
'1365920':'福建|厦门',
'1365921':'福建|厦门',
'1365922':'福建|厦门',
'1365930':'福建|宁德',
'1365931':'福建|宁德',
'1365940':'福建|莆田',
'1365941':'福建|莆田',
'1365950':'福建|泉州',
'1365951':'福建|泉州',
'1365952':'福建|泉州',
'1365960':'福建|漳州',
'1365961':'福建|漳州',
'1365970':'福建|龙岩',
'1365971':'福建|龙岩',
'1365980':'福建|三明',
'1365981':'福建|三明',
'1365990':'福建|南平',
'1365991':'福建|南平',
'1366310':'山东|威海',
'1366311':'山东|威海',
'1366320':'山东|枣庄',
'1366321':'山东|枣庄',
'1366330':'山东|日照',
'1366331':'山东|日照',
'1366350':'山东|聊城',
'1366351':'山东|聊城',
'1366600':'广东|汕尾',
'1366601':'广东|汕尾',
'1366620':'广东|阳江',
'1366621':'广东|阳江',
'1366630':'广东|揭阳',
'1366631':'广东|揭阳',
'1366680':'广东|茂名',
'1366681':'广东|茂名',
'1367010':'江西|鹰潭',
'1367011':'江西|鹰潭',
'1367100':'湖北|襄阳',
'1367101':'湖北|襄阳',
'1367110':'湖北|鄂州',
'1367111':'湖北|鄂州',
'1367120':'湖北|孝感',
'1367121':'湖北|孝感',
'1367130':'湖北|黄冈',
'1367131':'湖北|黄冈',
'1367140':'湖北|黄石',
'1367141':'湖北|黄石',
'1367150':'湖北|咸宁',
'1367151':'湖北|咸宁',
'1367160':'湖北|荆州',
'1367161':'湖北|荆州',
'1367170':'湖北|宜昌',
'1367171':'湖北|宜昌',
'1367180':'湖北|恩施',
'1367181':'湖北|恩施',
'1367190':'湖北|十堰',
'1367191':'湖北|十堰',
'1367220':'湖北|随州',
'1367221':'湖北|随州',
'1367240':'湖北|荆门',
'1367241':'湖北|荆门',
'1367300':'湖南|岳阳',
'1367301':'湖南|岳阳',
'1367310':'湖南|长沙',
'1367311':'湖南|长沙',
'1367312':'湖南|长沙',
'1367313':'湖南|长沙',
'1367320':'湖南|湘潭',
'1367321':'湖南|湘潭',
'1367330':'湖南|株洲',
'1367331':'湖南|株洲',
'1367340':'湖南|衡阳',
'1367341':'湖南|衡阳',
'1367350':'湖南|郴州',
'1367351':'湖南|郴州',
'1367360':'湖南|常德',
'1367361':'湖南|常德',
'1367370':'湖南|益阳',
'1367371':'湖南|益阳',
'1367380':'湖南|娄底',
'1367381':'湖南|娄底',
'1367390':'湖南|邵阳',
'1367391':'湖南|邵阳',
'1367440':'湖南|张家界',
'1367441':'湖南|张家界',
'1367450':'湖南|怀化',
'1367451':'湖南|怀化',
'1367460':'湖南|永州',
'1367461':'湖南|永州',
'1367500':'广东|江门',
'1367501':'广东|江门',
'1367510':'广东|韶关',
'1367511':'广东|韶关',
'1367520':'广东|惠州',
'1367521':'广东|惠州',
'1367530':'广东|梅州',
'1367531':'广东|梅州',
'1367540':'广东|汕头',
'1367541':'广东|汕头',
'1367550':'广东|深圳',
'1367551':'广东|深圳',
'1367552':'广东|深圳',
'1367553':'广东|深圳',
'1367560':'广东|珠海',
'1367561':'广东|珠海',
'1367570':'广东|佛山',
'1367571':'广东|佛山',
'1367572':'广东|佛山',
'1367580':'广东|肇庆',
'1367581':'广东|肇庆',
'1367590':'广东|湛江',
'1367591':'广东|湛江',
'1367600':'广东|中山',
'1367601':'广东|中山',
'1367620':'广东|河源',
'1367621':'广东|河源',
'1367630':'广东|清远',
'1367631':'广东|清远',
'1367660':'广东|云浮',
'1367661':'广东|云浮',
'1367680':'广东|潮州',
'1367681':'广东|潮州',
'1367690':'广东|东莞',
'1367691':'广东|东莞',
'1367692':'广东|东莞',
'1367700':'广西|防城港',
'1367701':'广西|防城港',
'1367710':'广西|南宁',
'1367711':'广西|南宁',
'1367712':'广西|南宁',
'1367720':'广西|柳州',
'1367721':'广西|柳州',
'1367730':'广西|桂林',
'1367731':'广西|桂林',
'1367740':'广西|梧州',
'1367741':'广西|梧州',
'1367750':'广西|贵港',
'1367751':'广西|贵港',
'1367760':'广西|百色',
'1367761':'广西|百色',
'1367770':'广西|钦州',
'1367771':'广西|钦州',
'1367780':'广西|河池',
'1367781':'广西|河池',
'1367790':'广西|北海',
'1367791':'广西|北海',
'1367900':'江西|新余',
'1367901':'江西|新余',
'1367910':'江西|南昌',
'1367911':'江西|南昌',
'1367912':'江西|南昌',
'1367913':'江西|南昌',
'1367920':'江西|九江',
'1367921':'江西|九江',
'1367930':'江西|上饶',
'1367931':'江西|上饶',
'1367940':'江西|抚州',
'1367941':'江西|抚州',
'1367950':'江西|宜春',
'1367951':'江西|宜春',
'1367960':'江西|吉安',
'1367961':'江西|吉安',
'1367970':'江西|赣州',
'1367971':'江西|赣州',
'1367980':'江西|景德镇',
'1367981':'江西|景德镇',
'1367990':'江西|萍乡',
'1367991':'江西|萍乡',
'1368120':'四川|攀枝花',
'1368121':'四川|攀枝花',
'1368130':'四川|自贡',
'1368131':'四川|自贡',
'1368160':'四川|绵阳',
'1368161':'四川|绵阳',
'1368170':'四川|南充',
'1368171':'四川|南充',
'1368180':'四川|达州',
'1368181':'四川|达州',
'1368250':'四川|遂宁',
'1368251':'四川|遂宁',
'1368260':'四川|广安',
'1368261':'四川|广安',
'1368270':'四川|巴中',
'1368271':'四川|巴中',
'1368300':'重庆',
'1368301':'四川|泸州',
'1368310':'四川|宜宾',
'1368311':'四川|宜宾',
'1368320':'四川|内江',
'1368321':'四川|内江',
'1368330':'四川|乐山',
'1368331':'四川|乐山',
'1368350':'四川|雅安',
'1368351':'四川|雅安',
'1368380':'四川|德阳',
'1368381':'四川|德阳',
'1368390':'四川|广元',
'1368391':'四川|广元',
'1368400':'重庆',
'1368500':'重庆',
'1368510':'贵州|贵阳',
'1368511':'贵州|贵阳',
'1368512':'贵州|贵阳',
'1368520':'贵州|遵义',
'1368521':'贵州|遵义',
'1368530':'贵州|安顺',
'1368531':'贵州|安顺',
'1368560':'贵州|铜仁',
'1368561':'贵州|铜仁',
'1368570':'贵州|毕节',
'1368571':'贵州|毕节',
'1368580':'贵州|六盘水',
'1368581':'贵州|六盘水',
'1368700':'云南|昭通',
'1368701':'云南|昭通',
'1368710':'云南|昆明',
'1368711':'云南|昆明',
'1368712':'云南|昆明',
'1368713':'云南|昆明',
'1368720':'云南|大理',
'1368721':'云南|大理',
'1368740':'云南|曲靖',
'1368741':'云南|曲靖',
'1368750':'云南|保山',
'1368751':'云南|保山',
'1368770':'云南|玉溪',
'1368771':'云南|玉溪',
'1368790':'云南|普洱',
'1368791':'云南|普洱',
'1368880':'云南|丽江',
'1368881':'云南|丽江',
'1368910':'西藏|拉萨',
'1368911':'西藏|拉萨',
'1368920':'西藏|日喀则',
'1368921':'西藏|日喀则',
'1368980':'海南|海口',
'1368981':'海南|海口',
'1368982':'海南|海口',
'1368990':'海南|三亚',
'1368991':'海南|三亚',
'1369110':'陕西|延安',
'1369111':'陕西|延安',
'1369120':'陕西|榆林',
'1369121':'陕西|榆林',
'1369130':'陕西|渭南',
'1369131':'陕西|渭南',
'1369140':'陕西|商洛',
'1369141':'陕西|商洛',
'1369150':'陕西|安康',
'1369151':'陕西|安康',
'1369160':'陕西|汉中',
'1369161':'陕西|汉中',
'1369170':'陕西|宝鸡',
'1369171':'陕西|宝鸡',
'1369190':'陕西|铜川',
'1369191':'陕西|铜川',
'1369310':'甘肃|兰州',
'1369311':'甘肃|兰州',
'1369312':'甘肃|兰州',
'1369370':'甘肃|酒泉',
'1369371':'甘肃|酒泉',
'1369380':'甘肃|天水',
'1369381':'甘肃|天水',
'1369430':'甘肃|白银',
'1369431':'甘肃|白银',
'1369510':'宁夏|银川',
'1369511':'宁夏|银川',
'1369710':'青海|西宁',
'1369711':'青海|西宁',
'1369910':'新疆|乌鲁木齐',
'1369911':'新疆|乌鲁木齐',
'1369912':'新疆|乌鲁木齐',
'1371000':'北京',
'1371100':'北京',
'1371200':'北京',
'1371300':'北京',
'1371400':'北京',
'1371500':'北京',
'1371600':'北京',
'1371700':'北京',
'1371800':'北京',
'1371900':'北京',
'1372000':'广东|广州',
'1372001':'广东|广州',
'1372002':'广东|广州',
'1372003':'广东|广州',
'1372100':'上海',
'1372200':'上海',
'1372300':'上海',
'1372410':'辽宁|沈阳',
'1372411':'辽宁|沈阳',
'1372412':'辽宁|沈阳',
'1372413':'辽宁|沈阳',
'1372500':'江苏|南京',
'1372501':'江苏|南京',
'1372502':'江苏|南京',
'1372503':'江苏|南京',
'1372710':'湖北|武汉',
'1372711':'湖北|武汉',
'1372712':'湖北|武汉',
'1372713':'湖北|武汉',
'1372800':'四川|成都',
'1372801':'四川|成都',
'1372802':'四川|成都',
'1372803':'四川|成都',
'1372900':'陕西|咸阳',
'1372901':'陕西|咸阳',
'1372910':'陕西|西安',
'1372911':'陕西|西安',
'1372912':'陕西|西安',
'1372913':'陕西|西安',
'1373100':'河北|邯郸',
'1373101':'河北|邯郸',
'1373102':'河北|邯郸',
'1373110':'河北|石家庄',
'1373111':'河北|石家庄',
'1373112':'河北|石家庄',
'1373113':'河北|石家庄',
'1373120':'河北|保定',
'1373121':'河北|保定',
'1373122':'河北|保定',
'1373130':'河北|张家口',
'1373131':'河北|张家口',
'1373140':'河北|承德',
'1373141':'河北|承德',
'1373150':'河北|唐山',
'1373151':'河北|唐山',
'1373152':'河北|唐山',
'1373153':'河北|唐山',
'1373160':'河北|廊坊',
'1373161':'河北|廊坊',
'1373170':'河北|沧州',
'1373171':'河北|沧州',
'1373180':'河北|衡水',
'1373181':'河北|衡水',
'1373190':'河北|邢台',
'1373191':'河北|邢台',
'1373350':'河北|秦皇岛',
'1373351':'河北|秦皇岛',
'1373500':'山西|忻州',
'1373501':'山西|忻州',
'1373510':'山西|太原',
'1373511':'山西|太原',
'1373512':'山西|太原',
'1373513':'山西|太原',
'1373520':'山西|大同',
'1373521':'山西|大同',
'1373530':'山西|阳泉',
'1373531':'山西|阳泉',
'1373540':'山西|晋中',
'1373541':'山西|晋中',
'1373550':'山西|长治',
'1373551':'山西|长治',
'1373560':'山西|晋城',
'1373561':'山西|晋城',
'1373570':'山西|临汾',
'1373571':'山西|临汾',
'1373580':'山西|吕梁',
'1373581':'山西|吕梁',
'1373590':'山西|运城',
'1373591':'山西|运城',
'1373700':'河南|商丘',
'1373701':'河南|商丘',
'1373710':'河南|郑州',
'1373711':'河南|郑州',
'1373712':'河南|郑州',
'1373713':'河南|郑州',
'1373720':'河南|安阳',
'1373721':'河南|安阳',
'1373730':'河南|新乡',
'1373731':'河南|新乡',
'1373740':'河南|许昌',
'1373741':'河南|许昌',
'1373750':'河南|平顶山',
'1373751':'河南|平顶山',
'1373760':'河南|信阳',
'1373761':'河南|信阳',
'1373770':'河南|南阳',
'1373771':'河南|南阳',
'1373780':'河南|开封',
'1373781':'河南|开封',
'1373790':'河南|洛阳',
'1373791':'河南|洛阳',
'1373792':'河南|洛阳',
'1373910':'河南|焦作',
'1373911':'河南|焦作',
'1373920':'河南|鹤壁',
'1373921':'河南|鹤壁',
'1373930':'河南|濮阳',
'1373931':'河南|濮阳',
'1373940':'河南|周口',
'1373941':'河南|周口',
'1373950':'河南|漯河',
'1373951':'河南|漯河',
'1373960':'河南|驻马店',
'1373961':'河南|驻马店',
'1373980':'河南|三门峡',
'1373981':'河南|三门峡',
'1374100':'辽宁|铁岭',
'1374101':'辽宁|铁岭',
'1374110':'辽宁|大连',
'1374111':'辽宁|大连',
'1374112':'辽宁|大连',
'1374113':'辽宁|大连',
'1374120':'辽宁|鞍山',
'1374121':'辽宁|鞍山',
'1374130':'辽宁|抚顺',
'1374131':'辽宁|抚顺',
'1374140':'辽宁|本溪',
'1374141':'辽宁|本溪',
'1374150':'辽宁|丹东',
'1374151':'辽宁|丹东',
'1374160':'辽宁|锦州',
'1374161':'辽宁|锦州',
'1374170':'辽宁|营口',
'1374171':'辽宁|营口',
'1374180':'辽宁|阜新',
'1374181':'辽宁|阜新',
'1374190':'辽宁|辽阳',
'1374191':'辽宁|辽阳',
'1374210':'辽宁|朝阳',
'1374211':'辽宁|朝阳',
'1374270':'辽宁|盘锦',
'1374271':'辽宁|盘锦',
'1374290':'辽宁|葫芦岛',
'1374291':'辽宁|葫芦岛',
'1374310':'吉林|长春',
'1374311':'吉林|长春',
'1374312':'吉林|长春',
'1374313':'吉林|长春',
'1374320':'吉林|吉林市',
'1374321':'吉林|吉林市',
'1374340':'吉林|四平',
'1374341':'吉林|四平',
'1374350':'吉林|通化',
'1374351':'吉林|通化',
'1374360':'吉林|白城',
'1374361':'吉林|白城',
'1374370':'吉林|辽源',
'1374371':'吉林|辽源',
'1374380':'吉林|松原',
'1374381':'吉林|松原',
'1374390':'吉林|白山',
'1374391':'吉林|白山',
'1374510':'黑龙江|哈尔滨',
'1374511':'黑龙江|哈尔滨',
'1374512':'黑龙江|哈尔滨',
'1374513':'黑龙江|哈尔滨',
'1374520':'黑龙江|齐齐哈尔',
'1374521':'黑龙江|齐齐哈尔',
'1374530':'黑龙江|牡丹江',
'1374531':'黑龙江|牡丹江',
'1374540':'黑龙江|佳木斯',
'1374541':'黑龙江|佳木斯',
'1374550':'黑龙江|绥化',
'1374551':'黑龙江|绥化',
'1374580':'黑龙江|伊春',
'1374581':'黑龙江|伊春',
'1374590':'黑龙江|大庆',
'1374591':'黑龙江|大庆',
'1374670':'黑龙江|鸡西',
'1374671':'黑龙江|鸡西',
'1374710':'内蒙古|呼和浩特',
'1374711':'内蒙古|呼和浩特',
'1374712':'内蒙古|呼和浩特',
'1374720':'内蒙古|包头',
'1374721':'内蒙古|包头',
'1374730':'内蒙古|乌海',
'1374750':'内蒙古|通辽',
'1374751':'内蒙古|通辽',
'1374760':'内蒙古|赤峰',
'1374761':'内蒙古|赤峰',
'1374770':'内蒙古|鄂尔多斯',
'1374771':'内蒙古|鄂尔多斯',
'1375100':'江苏|无锡',
'1375101':'江苏|无锡',
'1375102':'江苏|无锡',
'1375110':'江苏|镇江',
'1375111':'江苏|镇江',
'1375120':'江苏|苏州',
'1375121':'江苏|苏州',
'1375122':'江苏|苏州',
'1375123':'江苏|苏州',
'1375130':'江苏|南通',
'1375131':'江苏|南通',
'1375132':'江苏|南通',
'1375140':'江苏|扬州',
'1375141':'江苏|扬州',
'1375150':'江苏|盐城',
'1375151':'江苏|盐城',
'1375160':'江苏|徐州',
'1375161':'江苏|徐州',
'1375162':'江苏|徐州',
'1375170':'江苏|淮安',
'1375171':'江苏|淮安',
'1375180':'江苏|连云港',
'1375181':'江苏|连云港',
'1375190':'江苏|常州',
'1375191':'江苏|常州',
'1375192':'江苏|常州',
'1375230':'江苏|泰州',
'1375231':'江苏|泰州',
'1375270':'江苏|宿迁',
'1375271':'江苏|宿迁',
'1375300':'山东|菏泽',
'1375301':'山东|菏泽',
'1375310':'山东|济南',
'1375311':'山东|济南',
'1375312':'山东|济南',
'1375313':'山东|济南',
'1375320':'山东|青岛',
'1375321':'山东|青岛',
'1375322':'山东|青岛',
'1375323':'山东|青岛',
'1375330':'山东|淄博',
'1375331':'山东|淄博',
'1375340':'山东|德州',
'1375341':'山东|德州',
'1375350':'山东|烟台',
'1375351':'山东|烟台',
'1375352':'山东|烟台',
'1375360':'山东|潍坊',
'1375361':'山东|潍坊',
'1375362':'山东|潍坊',
'1375370':'山东|济宁',
'1375371':'山东|济宁',
'1375380':'山东|泰安',
'1375381':'山东|泰安',
'1375390':'山东|临沂',
'1375391':'山东|临沂',
'1375430':'山东|滨州',
'1375431':'山东|滨州',
'1375460':'山东|东营',
'1375461':'山东|东营',
'1375500':'安徽|滁州',
'1375501':'安徽|滁州',
'1375510':'安徽|合肥',
'1375511':'安徽|合肥',
'1375512':'安徽|合肥',
'1375513':'安徽|合肥',
'1375514':'安徽|合肥',
'1375520':'安徽|蚌埠',
'1375521':'安徽|蚌埠',
'1375530':'安徽|芜湖',
'1375531':'安徽|芜湖',
'1375532':'安徽|芜湖',
'1375540':'安徽|淮南',
'1375541':'安徽|淮南',
'1375550':'安徽|马鞍山',
'1375551':'安徽|马鞍山',
'1375560':'安徽|安庆',
'1375561':'安徽|安庆',
'1375570':'安徽|宿州',
'1375571':'安徽|宿州',
'1375580':'安徽|阜阳',
'1375581':'安徽|阜阳',
'1375590':'安徽|黄山',
'1375591':'安徽|黄山',
'1375600':'安徽|合肥',
'1375601':'安徽|合肥',
'1375602':'安徽|合肥',
'1375603':'安徽|合肥',
'1375604':'安徽|合肥',
'1375610':'安徽|淮北',
'1375611':'安徽|淮北',
'1375620':'安徽|铜陵',
'1375621':'安徽|铜陵',
'1375630':'安徽|宣城',
'1375631':'安徽|宣城',
'1375640':'安徽|六安',
'1375641':'安徽|六安',
'1375660':'安徽|池州',
'1375661':'安徽|池州',
'1375700':'浙江|衢州',
'1375701':'浙江|衢州',
'1375710':'浙江|杭州',
'1375711':'浙江|杭州',
'1375712':'浙江|杭州',
'1375713':'浙江|杭州',
'1375720':'浙江|湖州',
'1375721':'浙江|湖州',
'1375730':'浙江|嘉兴',
'1375731':'浙江|嘉兴',
'1375740':'浙江|宁波',
'1375741':'浙江|宁波',
'1375742':'浙江|宁波',
'1375750':'浙江|绍兴',
'1375751':'浙江|绍兴',
'1375760':'浙江|台州',
'1375761':'浙江|台州',
'1375770':'浙江|温州',
'1375771':'浙江|温州',
'1375772':'浙江|温州',
'1375780':'浙江|丽水',
'1375781':'浙江|丽水',
'1375790':'浙江|金华',
'1375791':'浙江|金华',
'1375800':'浙江|舟山',
'1375801':'浙江|舟山',
'1375910':'福建|福州',
'1375911':'福建|福州',
'1375912':'福建|福州',
'1375913':'福建|福州',
'1375920':'福建|厦门',
'1375921':'福建|厦门',
'1375922':'福建|厦门',
'1375930':'福建|宁德',
'1375931':'福建|宁德',
'1375940':'福建|莆田',
'1375941':'福建|莆田',
'1375950':'福建|泉州',
'1375951':'福建|泉州',
'1375952':'福建|泉州',
'1375960':'福建|漳州',
'1375961':'福建|漳州',
'1375970':'福建|龙岩',
'1375971':'福建|龙岩',
'1375980':'福建|三明',
'1375981':'福建|三明',
'1375990':'福建|南平',
'1375991':'福建|南平',
'1376310':'山东|威海',
'1376311':'山东|威海',
'1376320':'山东|枣庄',
'1376321':'山东|枣庄',
'1376330':'山东|日照',
'1376331':'山东|日照',
'1376350':'山东|聊城',
'1376351':'山东|聊城',
'1376600':'广东|汕尾',
'1376601':'广东|汕尾',
'1376620':'广东|阳江',
'1376621':'广东|阳江',
'1376630':'广东|揭阳',
'1376631':'广东|揭阳',
'1376680':'广东|茂名',
'1376681':'广东|茂名',
'1377010':'江西|鹰潭',
'1377011':'江西|鹰潭',
'1377100':'湖北|襄阳',
'1377101':'湖北|襄阳',
'1377110':'湖北|鄂州',
'1377111':'湖北|鄂州',
'1377120':'湖北|孝感',
'1377121':'湖北|孝感',
'1377130':'湖北|黄冈',
'1377131':'湖北|黄冈',
'1377140':'湖北|黄石',
'1377141':'湖北|黄石',
'1377150':'湖北|咸宁',
'1377151':'湖北|咸宁',
'1377160':'湖北|荆州',
'1377161':'湖北|荆州',
'1377170':'湖北|宜昌',
'1377171':'湖北|宜昌',
'1377180':'湖北|恩施',
'1377181':'湖北|恩施',
'1377190':'湖北|十堰',
'1377191':'湖北|十堰',
'1377220':'湖北|随州',
'1377221':'湖北|随州',
'1377240':'湖北|荆门',
'1377241':'湖北|荆门',
'1377300':'湖南|岳阳',
'1377301':'湖南|岳阳',
'1377310':'湖南|长沙',
'1377311':'湖南|长沙',
'1377312':'湖南|长沙',
'1377313':'湖南|长沙',
'1377320':'湖南|湘潭',
'1377321':'湖南|湘潭',
'1377330':'湖南|株洲',
'1377331':'湖南|株洲',
'1377340':'湖南|衡阳',
'1377341':'湖南|衡阳',
'1377350':'湖南|郴州',
'1377351':'湖南|郴州',
'1377360':'湖南|常德',
'1377361':'湖南|常德',
'1377370':'湖南|益阳',
'1377371':'湖南|益阳',
'1377380':'湖南|娄底',
'1377381':'湖南|娄底',
'1377390':'湖南|邵阳',
'1377391':'湖南|邵阳',
'1377440':'湖南|张家界',
'1377441':'湖南|张家界',
'1377450':'湖南|怀化',
'1377451':'湖南|怀化',
'1377460':'湖南|永州',
'1377461':'湖南|永州',
'1377500':'广东|江门',
'1377501':'广东|江门',
'1377510':'广东|韶关',
'1377511':'广东|韶关',
'1377520':'广东|惠州',
'1377521':'广东|惠州',
'1377530':'广东|梅州',
'1377531':'广东|梅州',
'1377540':'广东|汕头',
'1377541':'广东|汕头',
'1377550':'广东|深圳',
'1377551':'广东|深圳',
'1377552':'广东|深圳',
'1377553':'广东|深圳',
'1377560':'广东|珠海',
'1377561':'广东|珠海',
'1377570':'广东|佛山',
'1377571':'广东|佛山',
'1377572':'广东|佛山',
'1377580':'广东|肇庆',
'1377581':'广东|肇庆',
'1377590':'广东|湛江',
'1377591':'广东|湛江',
'1377600':'广东|中山',
'1377601':'广东|中山',
'1377620':'广东|河源',
'1377621':'广东|河源',
'1377630':'广东|清远',
'1377631':'广东|清远',
'1377660':'广东|云浮',
'1377661':'广东|云浮',
'1377680':'广东|潮州',
'1377681':'广东|潮州',
'1377690':'广东|东莞',
'1377691':'广东|东莞',
'1377692':'广东|东莞',
'1377700':'广西|防城港',
'1377701':'广西|防城港',
'1377710':'广西|南宁',
'1377711':'广西|南宁',
'1377712':'广西|南宁',
'1377720':'广西|柳州',
'1377721':'广西|柳州',
'1377730':'广西|桂林',
'1377731':'广西|桂林',
'1377740':'广西|梧州',
'1377741':'广西|梧州',
'1377750':'广西|贵港',
'1377751':'广西|贵港',
'1377760':'广西|百色',
'1377761':'广西|百色',
'1377770':'广西|钦州',
'1377771':'广西|钦州',
'1377780':'广西|河池',
'1377781':'广西|河池',
'1377790':'广西|北海',
'1377791':'广西|北海',
'1377900':'江西|新余',
'1377901':'江西|新余',
'1377910':'江西|南昌',
'1377911':'江西|南昌',
'1377912':'江西|南昌',
'1377913':'江西|南昌',
'1377920':'江西|九江',
'1377921':'江西|九江',
'1377930':'江西|上饶',
'1377931':'江西|上饶',
'1377940':'江西|抚州',
'1377941':'江西|抚州',
'1377950':'江西|宜春',
'1377951':'江西|宜春',
'1377960':'江西|吉安',
'1377961':'江西|吉安',
'1377970':'江西|赣州',
'1377971':'江西|赣州',
'1377980':'江西|景德镇',
'1377981':'江西|景德镇',
'1377990':'江西|萍乡',
'1377991':'江西|萍乡',
'1378120':'四川|攀枝花',
'1378121':'四川|攀枝花',
'1378130':'四川|自贡',
'1378131':'四川|自贡',
'1378160':'四川|绵阳',
'1378161':'四川|绵阳',
'1378170':'四川|南充',
'1378171':'四川|南充',
'1378180':'四川|达州',
'1378181':'四川|达州',
'1378250':'四川|遂宁',
'1378251':'四川|遂宁',
'1378260':'四川|广安',
'1378261':'四川|广安',
'1378270':'四川|巴中',
'1378271':'四川|巴中',
'1378300':'重庆',
'1378301':'四川|泸州',
'1378310':'四川|宜宾',
'1378311':'四川|宜宾',
'1378320':'四川|内江',
'1378321':'四川|内江',
'1378330':'四川|乐山',
'1378331':'四川|乐山',
'1378350':'四川|雅安',
'1378351':'四川|雅安',
'1378380':'四川|德阳',
'1378381':'四川|德阳',
'1378390':'四川|广元',
'1378391':'四川|广元',
'1378400':'重庆',
'1378500':'重庆',
'1378510':'贵州|贵阳',
'1378511':'贵州|贵阳',
'1378512':'贵州|贵阳',
'1378520':'贵州|遵义',
'1378521':'贵州|遵义',
'1378530':'贵州|安顺',
'1378531':'贵州|安顺',
'1378560':'贵州|铜仁',
'1378561':'贵州|铜仁',
'1378570':'贵州|毕节',
'1378571':'贵州|毕节',
'1378580':'贵州|六盘水',
'1378581':'贵州|六盘水',
'1378700':'云南|昭通',
'1378701':'云南|昭通',
'1378710':'云南|昆明',
'1378711':'云南|昆明',
'1378712':'云南|昆明',
'1378713':'云南|昆明',
'1378720':'云南|大理',
'1378721':'云南|大理',
'1378740':'云南|曲靖',
'1378741':'云南|曲靖',
'1378750':'云南|保山',
'1378751':'云南|保山',
'1378770':'云南|玉溪',
'1378771':'云南|玉溪',
'1378790':'云南|普洱',
'1378791':'云南|普洱',
'1378880':'云南|丽江',
'1378881':'云南|丽江',
'1378910':'西藏|拉萨',
'1378911':'西藏|拉萨',
'1378920':'西藏|日喀则',
'1378921':'西藏|日喀则',
'1378980':'海南|海口',
'1378981':'海南|海口',
'1378982':'海南|海口',
'1378990':'海南|三亚',
'1378991':'海南|三亚',
'1379110':'陕西|延安',
'1379111':'陕西|延安',
'1379120':'陕西|榆林',
'1379121':'陕西|榆林',
'1379130':'陕西|渭南',
'1379131':'陕西|渭南',
'1379140':'陕西|商洛',
'1379141':'陕西|商洛',
'1379150':'陕西|安康',
'1379151':'陕西|安康',
'1379160':'陕西|汉中',
'1379161':'陕西|汉中',
'1379170':'陕西|宝鸡',
'1379171':'陕西|宝鸡',
'1379190':'陕西|铜川',
'1379191':'陕西|铜川',
'1379310':'甘肃|兰州',
'1379311':'甘肃|兰州',
'1379312':'甘肃|兰州',
'1379370':'甘肃|酒泉',
'1379371':'甘肃|酒泉',
'1379380':'甘肃|天水',
'1379381':'甘肃|天水',
'1379430':'甘肃|白银',
'1379431':'甘肃|白银',
'1379510':'宁夏|银川',
'1379511':'宁夏|银川',
'1379710':'青海|西宁',
'1379711':'青海|西宁',
'1379910':'新疆|乌鲁木齐',
'1379911':'新疆|乌鲁木齐',
'1379912':'新疆|乌鲁木齐',
'1381000':'北京',
'1381100':'北京',
'1381200':'北京',
'1381300':'北京',
'1381400':'北京',
'1381500':'北京',
'1381600':'北京',
'1381700':'北京',
'1381800':'北京',
'1381900':'北京',
'1382000':'广东|广州',
'1382001':'广东|广州',
'1382002':'广东|广州',
'1382003':'广东|广州',
'1382100':'上海',
'1382200':'上海',
'1382300':'上海',
'1382410':'辽宁|沈阳',
'1382411':'辽宁|沈阳',
'1382412':'辽宁|沈阳',
'1382413':'辽宁|沈阳',
'1382500':'江苏|南京',
'1382501':'江苏|南京',
'1382502':'江苏|南京',
'1382503':'江苏|南京',
'1382710':'湖北|武汉',
'1382711':'湖北|武汉',
'1382712':'湖北|武汉',
'1382713':'湖北|武汉',
'1382800':'四川|成都',
'1382801':'四川|成都',
'1382802':'四川|成都',
'1382803':'四川|成都',
'1382900':'陕西|咸阳',
'1382901':'陕西|咸阳',
'1382910':'陕西|西安',
'1382911':'陕西|西安',
'1382912':'陕西|西安',
'1382913':'陕西|西安',
'1383100':'河北|邯郸',
'1383101':'河北|邯郸',
'1383102':'河北|邯郸',
'1383110':'河北|石家庄',
'1383111':'河北|石家庄',
'1383112':'河北|石家庄',
'1383113':'河北|石家庄',
'1383120':'河北|保定',
'1383121':'河北|保定',
'1383122':'河北|保定',
'1383130':'河北|张家口',
'1383131':'河北|张家口',
'1383140':'河北|承德',
'1383141':'河北|承德',
'1383150':'河北|唐山',
'1383151':'河北|唐山',
'1383152':'河北|唐山',
'1383153':'河北|唐山',
'1383160':'河北|廊坊',
'1383161':'河北|廊坊',
'1383170':'河北|沧州',
'1383171':'河北|沧州',
'1383180':'河北|衡水',
'1383181':'河北|衡水',
'1383190':'河北|邢台',
'1383191':'河北|邢台',
'1383350':'河北|秦皇岛',
'1383351':'河北|秦皇岛',
'1383500':'山西|忻州',
'1383501':'山西|忻州',
'1383510':'山西|太原',
'1383511':'山西|太原',
'1383512':'山西|太原',
'1383513':'山西|太原',
'1383520':'山西|大同',
'1383521':'山西|大同',
'1383530':'山西|阳泉',
'1383531':'山西|阳泉',
'1383540':'山西|晋中',
'1383541':'山西|晋中',
'1383550':'山西|长治',
'1383551':'山西|长治',
'1383560':'山西|晋城',
'1383561':'山西|晋城',
'1383570':'山西|临汾',
'1383571':'山西|临汾',
'1383580':'山西|吕梁',
'1383581':'山西|吕梁',
'1383590':'山西|运城',
'1383591':'山西|运城',
'1383700':'河南|商丘',
'1383701':'河南|商丘',
'1383710':'河南|郑州',
'1383711':'河南|郑州',
'1383712':'河南|郑州',
'1383713':'河南|郑州',
'1383720':'河南|安阳',
'1383721':'河南|安阳',
'1383730':'河南|新乡',
'1383731':'河南|新乡',
'1383740':'河南|许昌',
'1383741':'河南|许昌',
'1383750':'河南|平顶山',
'1383751':'河南|平顶山',
'1383760':'河南|信阳',
'1383761':'河南|信阳',
'1383770':'河南|南阳',
'1383771':'河南|南阳',
'1383780':'河南|开封',
'1383781':'河南|开封',
'1383790':'河南|洛阳',
'1383791':'河南|洛阳',
'1383792':'河南|洛阳',
'1383910':'河南|焦作',
'1383911':'河南|焦作',
'1383920':'河南|鹤壁',
'1383921':'河南|鹤壁',
'1383930':'河南|濮阳',
'1383931':'河南|濮阳',
'1383940':'河南|周口',
'1383941':'河南|周口',
'1383950':'河南|漯河',
'1383951':'河南|漯河',
'1383960':'河南|驻马店',
'1383961':'河南|驻马店',
'1383980':'河南|三门峡',
'1383981':'河南|三门峡',
'1384100':'辽宁|铁岭',
'1384101':'辽宁|铁岭',
'1384110':'辽宁|大连',
'1384111':'辽宁|大连',
'1384112':'辽宁|大连',
'1384113':'辽宁|大连',
'1384120':'辽宁|鞍山',
'1384121':'辽宁|鞍山',
'1384130':'辽宁|抚顺',
'1384131':'辽宁|抚顺',
'1384140':'辽宁|本溪',
'1384141':'辽宁|本溪',
'1384150':'辽宁|丹东',
'1384151':'辽宁|丹东',
'1384160':'辽宁|锦州',
'1384161':'辽宁|锦州',
'1384170':'辽宁|营口',
'1384171':'辽宁|营口',
'1384180':'辽宁|阜新',
'1384181':'辽宁|阜新',
'1384190':'辽宁|辽阳',
'1384191':'辽宁|辽阳',
'1384210':'辽宁|朝阳',
'1384211':'辽宁|朝阳',
'1384270':'辽宁|盘锦',
'1384271':'辽宁|盘锦',
'1384290':'辽宁|葫芦岛',
'1384291':'辽宁|葫芦岛',
'1384310':'吉林|长春',
'1384311':'吉林|长春',
'1384312':'吉林|长春',
'1384313':'吉林|长春',
'1384320':'吉林|吉林市',
'1384321':'吉林|吉林市',
'1384340':'吉林|四平',
'1384341':'吉林|四平',
'1384350':'吉林|通化',
'1384351':'吉林|通化',
'1384360':'吉林|白城',
'1384361':'吉林|白城',
'1384370':'吉林|辽源',
'1384371':'吉林|辽源',
'1384380':'吉林|松原',
'1384381':'吉林|松原',
'1384390':'吉林|白山',
'1384391':'吉林|白山',
'1384510':'黑龙江|哈尔滨',
'1384511':'黑龙江|哈尔滨',
'1384512':'黑龙江|哈尔滨',
'1384513':'黑龙江|哈尔滨',
'1384520':'黑龙江|齐齐哈尔',
'1384521':'黑龙江|齐齐哈尔',
'1384530':'黑龙江|牡丹江',
'1384531':'黑龙江|牡丹江',
'1384540':'黑龙江|佳木斯',
'1384541':'黑龙江|佳木斯',
'1384550':'黑龙江|绥化',
'1384551':'黑龙江|绥化',
'1384580':'黑龙江|伊春',
'1384581':'黑龙江|伊春',
'1384590':'黑龙江|大庆',
'1384591':'黑龙江|大庆',
'1384670':'黑龙江|鸡西',
'1384671':'黑龙江|鸡西',
'1384710':'内蒙古|呼和浩特',
'1384711':'内蒙古|呼和浩特',
'1384712':'内蒙古|呼和浩特',
'1384720':'内蒙古|包头',
'1384721':'内蒙古|包头',
'1384730':'内蒙古|乌海',
'1384750':'内蒙古|通辽',
'1384751':'内蒙古|通辽',
'1384760':'内蒙古|赤峰',
'1384761':'内蒙古|赤峰',
'1384770':'内蒙古|鄂尔多斯',
'1384771':'内蒙古|鄂尔多斯',
'1385100':'江苏|无锡',
'1385101':'江苏|无锡',
'1385102':'江苏|无锡',
'1385110':'江苏|镇江',
'1385111':'江苏|镇江',
'1385120':'江苏|苏州',
'1385121':'江苏|苏州',
'1385122':'江苏|苏州',
'1385123':'江苏|苏州',
'1385130':'江苏|南通',
'1385131':'江苏|南通',
'1385132':'江苏|南通',
'1385140':'江苏|扬州',
'1385141':'江苏|扬州',
'1385150':'江苏|盐城',
'1385151':'江苏|盐城',
'1385160':'江苏|徐州',
'1385161':'江苏|徐州',
'1385162':'江苏|徐州',
'1385170':'江苏|淮安',
'1385171':'江苏|淮安',
'1385180':'江苏|连云港',
'1385181':'江苏|连云港',
'1385190':'江苏|常州',
'1385191':'江苏|常州',
'1385192':'江苏|常州',
'1385230':'江苏|泰州',
'1385231':'江苏|泰州',
'1385270':'江苏|宿迁',
'1385271':'江苏|宿迁',
'1385300':'山东|菏泽',
'1385301':'山东|菏泽',
'1385310':'山东|济南',
'1385311':'山东|济南',
'1385312':'山东|济南',
'1385313':'山东|济南',
'1385320':'山东|青岛',
'1385321':'山东|青岛',
'1385322':'山东|青岛',
'1385323':'山东|青岛',
'1385330':'山东|淄博',
'1385331':'山东|淄博',
'1385340':'山东|德州',
'1385341':'山东|德州',
'1385350':'山东|烟台',
'1385351':'山东|烟台',
'1385352':'山东|烟台',
'1385360':'山东|潍坊',
'1385361':'山东|潍坊',
'1385362':'山东|潍坊',
'1385370':'山东|济宁',
'1385371':'山东|济宁',
'1385380':'山东|泰安',
'1385381':'山东|泰安',
'1385390':'山东|临沂',
'1385391':'山东|临沂',
'1385430':'山东|滨州',
'1385431':'山东|滨州',
'1385460':'山东|东营',
'1385461':'山东|东营',
'1385500':'安徽|滁州',
'1385501':'安徽|滁州',
'1385510':'安徽|合肥',
'1385511':'安徽|合肥',
'1385512':'安徽|合肥',
'1385513':'安徽|合肥',
'1385514':'安徽|合肥',
'1385520':'安徽|蚌埠',
'1385521':'安徽|蚌埠',
'1385530':'安徽|芜湖',
'1385531':'安徽|芜湖',
'1385532':'安徽|芜湖',
'1385540':'安徽|淮南',
'1385541':'安徽|淮南',
'1385550':'安徽|马鞍山',
'1385551':'安徽|马鞍山',
'1385560':'安徽|安庆',
'1385561':'安徽|安庆',
'1385570':'安徽|宿州',
'1385571':'安徽|宿州',
'1385580':'安徽|阜阳',
'1385581':'安徽|阜阳',
'1385590':'安徽|黄山',
'1385591':'安徽|黄山',
'1385600':'安徽|合肥',
'1385601':'安徽|合肥',
'1385602':'安徽|合肥',
'1385603':'安徽|合肥',
'1385604':'安徽|合肥',
'1385610':'安徽|淮北',
'1385611':'安徽|淮北',
'1385620':'安徽|铜陵',
'1385621':'安徽|铜陵',
'1385630':'安徽|宣城',
'1385631':'安徽|宣城',
'1385640':'安徽|六安',
'1385641':'安徽|六安',
'1385660':'安徽|池州',
'1385661':'安徽|池州',
'1385700':'浙江|衢州',
'1385701':'浙江|衢州',
'1385710':'浙江|杭州',
'1385711':'浙江|杭州',
'1385712':'浙江|杭州',
'1385713':'浙江|杭州',
'1385720':'浙江|湖州',
'1385721':'浙江|湖州',
'1385730':'浙江|嘉兴',
'1385731':'浙江|嘉兴',
'1385740':'浙江|宁波',
'1385741':'浙江|宁波',
'1385742':'浙江|宁波',
'1385750':'浙江|绍兴',
'1385751':'浙江|绍兴',
'1385760':'浙江|台州',
'1385761':'浙江|台州',
'1385770':'浙江|温州',
'1385771':'浙江|温州',
'1385772':'浙江|温州',
'1385780':'浙江|丽水',
'1385781':'浙江|丽水',
'1385790':'浙江|金华',
'1385791':'浙江|金华',
'1385800':'浙江|舟山',
'1385801':'浙江|舟山',
'1385910':'福建|福州',
'1385911':'福建|福州',
'1385912':'福建|福州',
'1385913':'福建|福州',
'1385920':'福建|厦门',
'1385921':'福建|厦门',
'1385922':'福建|厦门',
'1385930':'福建|宁德',
'1385931':'福建|宁德',
'1385940':'福建|莆田',
'1385941':'福建|莆田',
'1385950':'福建|泉州',
'1385951':'福建|泉州',
'1385952':'福建|泉州',
'1385960':'福建|漳州',
'1385961':'福建|漳州',
'1385970':'福建|龙岩',
'1385971':'福建|龙岩',
'1385980':'福建|三明',
'1385981':'福建|三明',
'1385990':'福建|南平',
'1385991':'福建|南平',
'1386310':'山东|威海',
'1386311':'山东|威海',
'1386320':'山东|枣庄',
'1386321':'山东|枣庄',
'1386330':'山东|日照',
'1386331':'山东|日照',
'1386350':'山东|聊城',
'1386351':'山东|聊城',
'1386600':'广东|汕尾',
'1386601':'广东|汕尾',
'1386620':'广东|阳江',
'1386621':'广东|阳江',
'1386630':'广东|揭阳',
'1386631':'广东|揭阳',
'1386680':'广东|茂名',
'1386681':'广东|茂名',
'1387010':'江西|鹰潭',
'1387011':'江西|鹰潭',
'1387100':'湖北|襄阳',
'1387101':'湖北|襄阳',
'1387110':'湖北|鄂州',
'1387111':'湖北|鄂州',
'1387120':'湖北|孝感',
'1387121':'湖北|孝感',
'1387130':'湖北|黄冈',
'1387131':'湖北|黄冈',
'1387140':'湖北|黄石',
'1387141':'湖北|黄石',
'1387150':'湖北|咸宁',
'1387151':'湖北|咸宁',
'1387160':'湖北|荆州',
'1387161':'湖北|荆州',
'1387170':'湖北|宜昌',
'1387171':'湖北|宜昌',
'1387180':'湖北|恩施',
'1387181':'湖北|恩施',
'1387190':'湖北|十堰',
'1387191':'湖北|十堰',
'1387220':'湖北|随州',
'1387221':'湖北|随州',
'1387240':'湖北|荆门',
'1387241':'湖北|荆门',
'1387300':'湖南|岳阳',
'1387301':'湖南|岳阳',
'1387310':'湖南|长沙',
'1387311':'湖南|长沙',
'1387312':'湖南|长沙',
'1387313':'湖南|长沙',
'1387320':'湖南|湘潭',
'1387321':'湖南|湘潭',
'1387330':'湖南|株洲',
'1387331':'湖南|株洲',
'1387340':'湖南|衡阳',
'1387341':'湖南|衡阳',
'1387350':'湖南|郴州',
'1387351':'湖南|郴州',
'1387360':'湖南|常德',
'1387361':'湖南|常德',
'1387370':'湖南|益阳',
'1387371':'湖南|益阳',
'1387380':'湖南|娄底',
'1387381':'湖南|娄底',
'1387390':'湖南|邵阳',
'1387391':'湖南|邵阳',
'1387440':'湖南|张家界',
'1387441':'湖南|张家界',
'1387450':'湖南|怀化',
'1387451':'湖南|怀化',
'1387460':'湖南|永州',
'1387461':'湖南|永州',
'1387500':'广东|江门',
'1387501':'广东|江门',
'1387510':'广东|韶关',
'1387511':'广东|韶关',
'1387520':'广东|惠州',
'1387521':'广东|惠州',
'1387530':'广东|梅州',
'1387531':'广东|梅州',
'1387540':'广东|汕头',
'1387541':'广东|汕头',
'1387550':'广东|深圳',
'1387551':'广东|深圳',
'1387552':'广东|深圳',
'1387553':'广东|深圳',
'1387560':'广东|珠海',
'1387561':'广东|珠海',
'1387570':'广东|佛山',
'1387571':'广东|佛山',
'1387572':'广东|佛山',
'1387580':'广东|肇庆',
'1387581':'广东|肇庆',
'1387590':'广东|湛江',
'1387591':'广东|湛江',
'1387600':'广东|中山',
'1387601':'广东|中山',
'1387620':'广东|河源',
'1387621':'广东|河源',
'1387630':'广东|清远',
'1387631':'广东|清远',
'1387660':'广东|云浮',
'1387661':'广东|云浮',
'1387680':'广东|潮州',
'1387681':'广东|潮州',
'1387690':'广东|东莞',
'1387691':'广东|东莞',
'1387692':'广东|东莞',
'1387700':'广西|防城港',
'1387701':'广西|防城港',
'1387710':'广西|南宁',
'1387711':'广西|南宁',
'1387712':'广西|南宁',
'1387720':'广西|柳州',
'1387721':'广西|柳州',
'1387730':'广西|桂林',
'1387731':'广西|桂林',
'1387740':'广西|梧州',
'1387741':'广西|梧州',
'1387750':'广西|贵港',
'1387751':'广西|贵港',
'1387760':'广西|百色',
'1387761':'广西|百色',
'1387770':'广西|钦州',
'1387771':'广西|钦州',
'1387780':'广西|河池',
'1387781':'广西|河池',
'1387790':'广西|北海',
'1387791':'广西|北海',
'1387900':'江西|新余',
'1387901':'江西|新余',
'1387910':'江西|南昌',
'1387911':'江西|南昌',
'1387912':'江西|南昌',
'1387913':'江西|南昌',
'1387920':'江西|九江',
'1387921':'江西|九江',
'1387930':'江西|上饶',
'1387931':'江西|上饶',
'1387940':'江西|抚州',
'1387941':'江西|抚州',
'1387950':'江西|宜春',
'1387951':'江西|宜春',
'1387960':'江西|吉安',
'1387961':'江西|吉安',
'1387970':'江西|赣州',
'1387971':'江西|赣州',
'1387980':'江西|景德镇',
'1387981':'江西|景德镇',
'1387990':'江西|萍乡',
'1387991':'江西|萍乡',
'1388120':'四川|攀枝花',
'1388121':'四川|攀枝花',
'1388130':'四川|自贡',
'1388131':'四川|自贡',
'1388160':'四川|绵阳',
'1388161':'四川|绵阳',
'1388170':'四川|南充',
'1388171':'四川|南充',
'1388180':'四川|达州',
'1388181':'四川|达州',
'1388250':'四川|遂宁',
'1388251':'四川|遂宁',
'1388260':'四川|广安',
'1388261':'四川|广安',
'1388270':'四川|巴中',
'1388271':'四川|巴中',
'1388300':'重庆',
'1388301':'四川|泸州',
'1388310':'四川|宜宾',
'1388311':'四川|宜宾',
'1388320':'四川|内江',
'1388321':'四川|内江',
'1388330':'四川|乐山',
'1388331':'四川|乐山',
'1388350':'四川|雅安',
'1388351':'四川|雅安',
'1388380':'四川|德阳',
'1388381':'四川|德阳',
'1388390':'四川|广元',
'1388391':'四川|广元',
'1388400':'重庆',
'1388500':'重庆',
'1388510':'贵州|贵阳',
'1388511':'贵州|贵阳',
'1388512':'贵州|贵阳',
'1388520':'贵州|遵义',
'1388521':'贵州|遵义',
'1388530':'贵州|安顺',
'1388531':'贵州|安顺',
'1388560':'贵州|铜仁',
'1388561':'贵州|铜仁',
'1388570':'贵州|毕节',
'1388571':'贵州|毕节',
'1388580':'贵州|六盘水',
'1388581':'贵州|六盘水',
'1388700':'云南|昭通',
'1388701':'云南|昭通',
'1388710':'云南|昆明',
'1388711':'云南|昆明',
'1388712':'云南|昆明',
'1388713':'云南|昆明',
'1388720':'云南|大理',
'1388721':'云南|大理',
'1388740':'云南|曲靖',
'1388741':'云南|曲靖',
'1388750':'云南|保山',
'1388751':'云南|保山',
'1388770':'云南|玉溪',
'1388771':'云南|玉溪',
'1388790':'云南|普洱',
'1388791':'云南|普洱',
'1388880':'云南|丽江',
'1388881':'云南|丽江',
'1388910':'西藏|拉萨',
'1388911':'西藏|拉萨',
'1388920':'西藏|日喀则',
'1388921':'西藏|日喀则',
'1388980':'海南|海口',
'1388981':'海南|海口',
'1388982':'海南|海口',
'1388990':'海南|三亚',
'1388991':'海南|三亚',
'1389110':'陕西|延安',
'1389111':'陕西|延安',
'1389120':'陕西|榆林',
'1389121':'陕西|榆林',
'1389130':'陕西|渭南',
'1389131':'陕西|渭南',
'1389140':'陕西|商洛',
'1389141':'陕西|商洛',
'1389150':'陕西|安康',
'1389151':'陕西|安康',
'1389160':'陕西|汉中',
'1389161':'陕西|汉中',
'1389170':'陕西|宝鸡',
'1389171':'陕西|宝鸡',
'1389190':'陕西|铜川',
'1389191':'陕西|铜川',
'1389310':'甘肃|兰州',
'1389311':'甘肃|兰州',
'1389312':'甘肃|兰州',
'1389370':'甘肃|酒泉',
'1389371':'甘肃|酒泉',
'1389380':'甘肃|天水',
'1389381':'甘肃|天水',
'1389430':'甘肃|白银',
'1389431':'甘肃|白银',
'1389510':'宁夏|银川',
'1389511':'宁夏|银川',
'1389710':'青海|西宁',
'1389711':'青海|西宁',
'1389910':'新疆|乌鲁木齐',
'1389911':'新疆|乌鲁木齐',
'1389912':'新疆|乌鲁木齐',
'1391000':'北京',
'1391100':'北京',
'1391200':'北京',
'1391300':'北京',
'1391400':'北京',
'1391500':'北京',
'1391600':'北京',
'1391700':'北京',
'1391800':'北京',
'1391900':'北京',
'1392000':'广东|广州',
'1392001':'广东|广州',
'1392002':'广东|广州',
'1392003':'广东|广州',
'1392100':'上海',
'1392200':'上海',
'1392300':'上海',
'1392410':'辽宁|沈阳',
'1392411':'辽宁|沈阳',
'1392412':'辽宁|沈阳',
'1392413':'辽宁|沈阳',
'1392500':'江苏|南京',
'1392501':'江苏|南京',
'1392502':'江苏|南京',
'1392503':'江苏|南京',
'1392710':'湖北|武汉',
'1392711':'湖北|武汉',
'1392712':'湖北|武汉',
'1392713':'湖北|武汉',
'1392800':'四川|成都',
'1392801':'四川|成都',
'1392802':'四川|成都',
'1392803':'四川|成都',
'1392900':'陕西|咸阳',
'1392901':'陕西|咸阳',
'1392910':'陕西|西安',
'1392911':'陕西|西安',
'1392912':'陕西|西安',
'1392913':'陕西|西安',
'1393100':'河北|邯郸',
'1393101':'河北|邯郸',
'1393102':'河北|邯郸',
'1393110':'河北|石家庄',
'1393111':'河北|石家庄',
'1393112':'河北|石家庄',
'1393113':'河北|石家庄',
'1393120':'河北|保定',
'1393121':'河北|保定',
'1393122':'河北|保定',
'1393130':'河北|张家口',
'1393131':'河北|张家口',
'1393140':'河北|承德',
'1393141':'河北|承德',
'1393150':'河北|唐山',
'1393151':'河北|唐山',
'1393152':'河北|唐山',
'1393153':'河北|唐山',
'1393160':'河北|廊坊',
'1393161':'河北|廊坊',
'1393170':'河北|沧州',
'1393171':'河北|沧州',
'1393180':'河北|衡水',
'1393181':'河北|衡水',
'1393190':'河北|邢台',
'1393191':'河北|邢台',
'1393350':'河北|秦皇岛',
'1393351':'河北|秦皇岛',
'1393500':'山西|忻州',
'1393501':'山西|忻州',
'1393510':'山西|太原',
'1393511':'山西|太原',
'1393512':'山西|太原',
'1393513':'山西|太原',
'1393520':'山西|大同',
'1393521':'山西|大同',
'1393530':'山西|阳泉',
'1393531':'山西|阳泉',
'1393540':'山西|晋中',
'1393541':'山西|晋中',
'1393550':'山西|长治',
'1393551':'山西|长治',
'1393560':'山西|晋城',
'1393561':'山西|晋城',
'1393570':'山西|临汾',
'1393571':'山西|临汾',
'1393580':'山西|吕梁',
'1393581':'山西|吕梁',
'1393590':'山西|运城',
'1393591':'山西|运城',
'1393700':'河南|商丘',
'1393701':'河南|商丘',
'1393710':'河南|郑州',
'1393711':'河南|郑州',
'1393712':'河南|郑州',
'1393713':'河南|郑州',
'1393720':'河南|安阳',
'1393721':'河南|安阳',
'1393730':'河南|新乡',
'1393731':'河南|新乡',
'1393740':'河南|许昌',
'1393741':'河南|许昌',
'1393750':'河南|平顶山',
'1393751':'河南|平顶山',
'1393760':'河南|信阳',
'1393761':'河南|信阳',
'1393770':'河南|南阳',
'1393771':'河南|南阳',
'1393780':'河南|开封',
'1393781':'河南|开封',
'1393790':'河南|洛阳',
'1393791':'河南|洛阳',
'1393792':'河南|洛阳',
'1393910':'河南|焦作',
'1393911':'河南|焦作',
'1393920':'河南|鹤壁',
'1393921':'河南|鹤壁',
'1393930':'河南|濮阳',
'1393931':'河南|濮阳',
'1393940':'河南|周口',
'1393941':'河南|周口',
'1393950':'河南|漯河',
'1393951':'河南|漯河',
'1393960':'河南|驻马店',
'1393961':'河南|驻马店',
'1393980':'河南|三门峡',
'1393981':'河南|三门峡',
'1394100':'辽宁|铁岭',
'1394101':'辽宁|铁岭',
'1394110':'辽宁|大连',
'1394111':'辽宁|大连',
'1394112':'辽宁|大连',
'1394113':'辽宁|大连',
'1394120':'辽宁|鞍山',
'1394121':'辽宁|鞍山',
'1394130':'辽宁|抚顺',
'1394131':'辽宁|抚顺',
'1394140':'辽宁|本溪',
'1394141':'辽宁|本溪',
'1394150':'辽宁|丹东',
'1394151':'辽宁|丹东',
'1394160':'辽宁|锦州',
'1394161':'辽宁|锦州',
'1394170':'辽宁|营口',
'1394171':'辽宁|营口',
'1394180':'辽宁|阜新',
'1394181':'辽宁|阜新',
'1394190':'辽宁|辽阳',
'1394191':'辽宁|辽阳',
'1394210':'辽宁|朝阳',
'1394211':'辽宁|朝阳',
'1394270':'辽宁|盘锦',
'1394271':'辽宁|盘锦',
'1394290':'辽宁|葫芦岛',
'1394291':'辽宁|葫芦岛',
'1394310':'吉林|长春',
'1394311':'吉林|长春',
'1394312':'吉林|长春',
'1394313':'吉林|长春',
'1394320':'吉林|吉林市',
'1394321':'吉林|吉林市',
'1394340':'吉林|四平',
'1394341':'吉林|四平',
'1394350':'吉林|通化',
'1394351':'吉林|通化',
'1394360':'吉林|白城',
'1394361':'吉林|白城',
'1394370':'吉林|辽源',
'1394371':'吉林|辽源',
'1394380':'吉林|松原',
'1394381':'吉林|松原',
'1394390':'吉林|白山',
'1394391':'吉林|白山',
'1394510':'黑龙江|哈尔滨',
'1394511':'黑龙江|哈尔滨',
'1394512':'黑龙江|哈尔滨',
'1394513':'黑龙江|哈尔滨',
'1394520':'黑龙江|齐齐哈尔',
'1394521':'黑龙江|齐齐哈尔',
'1394530':'黑龙江|牡丹江',
'1394531':'黑龙江|牡丹江',
'1394540':'黑龙江|佳木斯',
'1394541':'黑龙江|佳木斯',
'1394550':'黑龙江|绥化',
'1394551':'黑龙江|绥化',
'1394580':'黑龙江|伊春',
'1394581':'黑龙江|伊春',
'1394590':'黑龙江|大庆',
'1394591':'黑龙江|大庆',
'1394670':'黑龙江|鸡西',
'1394671':'黑龙江|鸡西',
'1394710':'内蒙古|呼和浩特',
'1394711':'内蒙古|呼和浩特',
'1394712':'内蒙古|呼和浩特',
'1394720':'内蒙古|包头',
'1394721':'内蒙古|包头',
'1394730':'内蒙古|乌海',
'1394750':'内蒙古|通辽',
'1394751':'内蒙古|通辽',
'1394760':'内蒙古|赤峰',
'1394761':'内蒙古|赤峰',
'1394770':'内蒙古|鄂尔多斯',
'1394771':'内蒙古|鄂尔多斯',
'1395100':'江苏|无锡',
'1395101':'江苏|无锡',
'1395102':'江苏|无锡',
'1395110':'江苏|镇江',
'1395111':'江苏|镇江',
'1395120':'江苏|苏州',
'1395121':'江苏|苏州',
'1395122':'江苏|苏州',
'1395123':'江苏|苏州',
'1395130':'江苏|南通',
'1395131':'江苏|南通',
'1395132':'江苏|南通',
'1395140':'江苏|扬州',
'1395141':'江苏|扬州',
'1395150':'江苏|盐城',
'1395151':'江苏|盐城',
'1395160':'江苏|徐州',
'1395161':'江苏|徐州',
'1395162':'江苏|徐州',
'1395170':'江苏|淮安',
'1395171':'江苏|淮安',
'1395180':'江苏|连云港',
'1395181':'江苏|连云港',
'1395190':'江苏|常州',
'1395191':'江苏|常州',
'1395192':'江苏|常州',
'1395230':'江苏|泰州',
'1395231':'江苏|泰州',
'1395270':'江苏|宿迁',
'1395271':'江苏|宿迁',
'1395300':'山东|菏泽',
'1395301':'山东|菏泽',
'1395310':'山东|济南',
'1395311':'山东|济南',
'1395312':'山东|济南',
'1395313':'山东|济南',
'1395320':'山东|青岛',
'1395321':'山东|青岛',
'1395322':'山东|青岛',
'1395323':'山东|青岛',
'1395330':'山东|淄博',
'1395331':'山东|淄博',
'1395340':'山东|德州',
'1395341':'山东|德州',
'1395350':'山东|烟台',
'1395351':'山东|烟台',
'1395352':'山东|烟台',
'1395360':'山东|潍坊',
'1395361':'山东|潍坊',
'1395362':'山东|潍坊',
'1395370':'山东|济宁',
'1395371':'山东|济宁',
'1395380':'山东|泰安',
'1395381':'山东|泰安',
'1395390':'山东|临沂',
'1395391':'山东|临沂',
'1395430':'山东|滨州',
'1395431':'山东|滨州',
'1395460':'山东|东营',
'1395461':'山东|东营',
'1395500':'安徽|滁州',
'1395501':'安徽|滁州',
'1395510':'安徽|合肥',
'1395511':'安徽|合肥',
'1395512':'安徽|合肥',
'1395513':'安徽|合肥',
'1395514':'安徽|合肥',
'1395520':'安徽|蚌埠',
'1395521':'安徽|蚌埠',
'1395530':'安徽|芜湖',
'1395531':'安徽|芜湖',
'1395532':'安徽|芜湖',
'1395540':'安徽|淮南',
'1395541':'安徽|淮南',
'1395550':'安徽|马鞍山',
'1395551':'安徽|马鞍山',
'1395560':'安徽|安庆',
'1395561':'安徽|安庆',
'1395570':'安徽|宿州',
'1395571':'安徽|宿州',
'1395580':'安徽|阜阳',
'1395581':'安徽|阜阳',
'1395590':'安徽|黄山',
'1395591':'安徽|黄山',
'1395600':'安徽|合肥',
'1395601':'安徽|合肥',
'1395602':'安徽|合肥',
'1395603':'安徽|合肥',
'1395604':'安徽|合肥',
'1395610':'安徽|淮北',
'1395611':'安徽|淮北',
'1395620':'安徽|铜陵',
'1395621':'安徽|铜陵',
'1395630':'安徽|宣城',
'1395631':'安徽|宣城',
'1395640':'安徽|六安',
'1395641':'安徽|六安',
'1395660':'安徽|池州',
'1395661':'安徽|池州',
'1395700':'浙江|衢州',
'1395701':'浙江|衢州',
'1395710':'浙江|杭州',
'1395711':'浙江|杭州',
'1395712':'浙江|杭州',
'1395713':'浙江|杭州',
'1395720':'浙江|湖州',
'1395721':'浙江|湖州',
'1395730':'浙江|嘉兴',
'1395731':'浙江|嘉兴',
'1395740':'浙江|宁波',
'1395741':'浙江|宁波',
'1395742':'浙江|宁波',
'1395750':'浙江|绍兴',
'1395751':'浙江|绍兴',
'1395760':'浙江|台州',
'1395761':'浙江|台州',
'1395770':'浙江|温州',
'1395771':'浙江|温州',
'1395772':'浙江|温州',
'1395780':'浙江|丽水',
'1395781':'浙江|丽水',
'1395790':'浙江|金华',
'1395791':'浙江|金华',
'1395800':'浙江|舟山',
'1395801':'浙江|舟山',
'1395910':'福建|福州',
'1395911':'福建|福州',
'1395912':'福建|福州',
'1395913':'福建|福州',
'1395920':'福建|厦门',
'1395921':'福建|厦门',
'1395922':'福建|厦门',
'1395930':'福建|宁德',
'1395931':'福建|宁德',
'1395940':'福建|莆田',
'1395941':'福建|莆田',
'1395950':'福建|泉州',
'1395951':'福建|泉州',
'1395952':'福建|泉州',
'1395960':'福建|漳州',
'1395961':'福建|漳州',
'1395970':'福建|龙岩',
'1395971':'福建|龙岩',
'1395980':'福建|三明',
'1395981':'福建|三明',
'1395990':'福建|南平',
'1395991':'福建|南平',
'1396310':'山东|威海',
'1396311':'山东|威海',
'1396320':'山东|枣庄',
'1396321':'山东|枣庄',
'1396330':'山东|日照',
'1396331':'山东|日照',
'1396350':'山东|聊城',
'1396351':'山东|聊城',
'1396600':'广东|汕尾',
'1396601':'广东|汕尾',
'1396620':'广东|阳江',
'1396621':'广东|阳江',
'1396630':'广东|揭阳',
'1396631':'广东|揭阳',
'1396680':'广东|茂名',
'1396681':'广东|茂名',
'1397010':'江西|鹰潭',
'1397011':'江西|鹰潭',
'1397100':'湖北|襄阳',
'1397101':'湖北|襄阳',
'1397110':'湖北|鄂州',
'1397111':'湖北|鄂州',
'1397120':'湖北|孝感',
'1397121':'湖北|孝感',
'1397130':'湖北|黄冈',
'1397131':'湖北|黄冈',
'1397140':'湖北|黄石',
'1397141':'湖北|黄石',
'1397150':'湖北|咸宁',
'1397151':'湖北|咸宁',
'1397160':'湖北|荆州',
'1397161':'湖北|荆州',
'1397170':'湖北|宜昌',
'1397171':'湖北|宜昌',
'1397180':'湖北|恩施',
'1397181':'湖北|恩施',
'1397190':'湖北|十堰',
'1397191':'湖北|十堰',
'1397220':'湖北|随州',
'1397221':'湖北|随州',
'1397240':'湖北|荆门',
'1397241':'湖北|荆门',
'1397300':'湖南|岳阳',
'1397301':'湖南|岳阳',
'1397310':'湖南|长沙',
'1397311':'湖南|长沙',
'1397312':'湖南|长沙',
'1397313':'湖南|长沙',
'1397320':'湖南|湘潭',
'1397321':'湖南|湘潭',
'1397330':'湖南|株洲',
'1397331':'湖南|株洲',
'1397340':'湖南|衡阳',
'1397341':'湖南|衡阳',
'1397350':'湖南|郴州',
'1397351':'湖南|郴州',
'1397360':'湖南|常德',
'1397361':'湖南|常德',
'1397370':'湖南|益阳',
'1397371':'湖南|益阳',
'1397380':'湖南|娄底',
'1397381':'湖南|娄底',
'1397390':'湖南|邵阳',
'1397391':'湖南|邵阳',
'1397440':'湖南|张家界',
'1397441':'湖南|张家界',
'1397450':'湖南|怀化',
'1397451':'湖南|怀化',
'1397460':'湖南|永州',
'1397461':'湖南|永州',
'1397500':'广东|江门',
'1397501':'广东|江门',
'1397510':'广东|韶关',
'1397511':'广东|韶关',
'1397520':'广东|惠州',
'1397521':'广东|惠州',
'1397530':'广东|梅州',
'1397531':'广东|梅州',
'1397540':'广东|汕头',
'1397541':'广东|汕头',
'1397550':'广东|深圳',
'1397551':'广东|深圳',
'1397552':'广东|深圳',
'1397553':'广东|深圳',
'1397560':'广东|珠海',
'1397561':'广东|珠海',
'1397570':'广东|佛山',
'1397571':'广东|佛山',
'1397572':'广东|佛山',
'1397580':'广东|肇庆',
'1397581':'广东|肇庆',
'1397590':'广东|湛江',
'1397591':'广东|湛江',
'1397600':'广东|中山',
'1397601':'广东|中山',
'1397620':'广东|河源',
'1397621':'广东|河源',
'1397630':'广东|清远',
'1397631':'广东|清远',
'1397660':'广东|云浮',
'1397661':'广东|云浮',
'1397680':'广东|潮州',
'1397681':'广东|潮州',
'1397690':'广东|东莞',
'1397691':'广东|东莞',
'1397692':'广东|东莞',
'1397700':'广西|防城港',
'1397701':'广西|防城港',
'1397710':'广西|南宁',
'1397711':'广西|南宁',
'1397712':'广西|南宁',
'1397720':'广西|柳州',
'1397721':'广西|柳州',
'1397730':'广西|桂林',
'1397731':'广西|桂林',
'1397740':'广西|梧州',
'1397741':'广西|梧州',
'1397750':'广西|贵港',
'1397751':'广西|贵港',
'1397760':'广西|百色',
'1397761':'广西|百色',
'1397770':'广西|钦州',
'1397771':'广西|钦州',
'1397780':'广西|河池',
'1397781':'广西|河池',
'1397790':'广西|北海',
'1397791':'广西|北海',
'1397900':'江西|新余',
'1397901':'江西|新余',
'1397910':'江西|南昌',
'1397911':'江西|南昌',
'1397912':'江西|南昌',
'1397913':'江西|南昌',
'1397920':'江西|九江',
'1397921':'江西|九江',
'1397930':'江西|上饶',
'1397931':'江西|上饶',
'1397940':'江西|抚州',
'1397941':'江西|抚州',
'1397950':'江西|宜春',
'1397951':'江西|宜春',
'1397960':'江西|吉安',
'1397961':'江西|吉安',
'1397970':'江西|赣州',
'1397971':'江西|赣州',
'1397980':'江西|景德镇',
'1397981':'江西|景德镇',
'1397990':'江西|萍乡',
'1397991':'江西|萍乡',
'1398120':'四川|攀枝花',
'1398121':'四川|攀枝花',
'1398130':'四川|自贡',
'1398131':'四川|自贡',
'1398160':'四川|绵阳',
'1398161':'四川|绵阳',
'1398170':'四川|南充',
'1398171':'四川|南充',
'1398180':'四川|达州',
'1398181':'四川|达州',
'1398250':'四川|遂宁',
'1398251':'四川|遂宁',
'1398260':'四川|广安',
'1398261':'四川|广安',
'1398270':'四川|巴中',
'1398271':'四川|巴中',
'1398300':'重庆',
'1398301':'四川|泸州',
'1398310':'四川|宜宾',
'1398311':'四川|宜宾',
'1398320':'四川|内江',
'1398321':'四川|内江',
'1398330':'四川|乐山',
'1398331':'四川|乐山',
'1398350':'四川|雅安',
'1398351':'四川|雅安',
'1398380':'四川|德阳',
'1398381':'四川|德阳',
'1398390':'四川|广元',
'1398391':'四川|广元',
'1398400':'重庆',
'1398500':'重庆',
'1398510':'贵州|贵阳',
'1398511':'贵州|贵阳',
'1398512':'贵州|贵阳',
'1398520':'贵州|遵义',
'1398521':'贵州|遵义',
'1398530':'贵州|安顺',
'1398531':'贵州|安顺',
'1398560':'贵州|铜仁',
'1398561':'贵州|铜仁',
'1398570':'贵州|毕节',
'1398571':'贵州|毕节',
'1398580':'贵州|六盘水',
'1398581':'贵州|六盘水',
'1398700':'云南|昭通',
'1398701':'云南|昭通',
'1398710':'云南|昆明',
'1398711':'云南|昆明',
'1398712':'云南|昆明',
'1398713':'云南|昆明',
'1398720':'云南|大理',
'1398721':'云南|大理',
'1398740':'云南|曲靖',
'1398741':'云南|曲靖',
'1398750':'云南|保山',
'1398751':'云南|保山',
'1398770':'云南|玉溪',
'1398771':'云南|玉溪',
'1398790':'云南|普洱',
'1398791':'云南|普洱',
'1398880':'云南|丽江',
'1398881':'云南|丽江',
'1398910':'西藏|拉萨',
'1398911':'西藏|拉萨',
'1398920':'西藏|日喀则',
'1398921':'西藏|日喀则',
'1398980':'海南|海口',
'1398981':'海南|海口',
'1398982':'海南|海口',
'1398990':'海南|三亚',
'1398991':'海南|三亚',
'1399110':'陕西|延安',
'1399111':'陕西|延安',
'1399120':'陕西|榆林',
'1399121':'陕西|榆林',
'1399130':'陕西|渭南',
'1399131':'陕西|渭南',
'1399140':'陕西|商洛',
'1399141':'陕西|商洛',
'1399150':'陕西|安康',
'1399151':'陕西|安康',
'1399160':'陕西|汉中',
'1399161':'陕西|汉中',
'1399170':'陕西|宝鸡',
'1399171':'陕西|宝鸡',
'1399190':'陕西|铜川',
'1399191':'陕西|铜川',
'1399310':'甘肃|兰州',
'1399311':'甘肃|兰州',
'1399312':'甘肃|兰州',
'1399370':'甘肃|酒泉',
'1399371':'甘肃|酒泉',
'1399380':'甘肃|天水',
'1399381':'甘肃|天水',
'1399430':'甘肃|白银',
'1399431':'甘肃|白银',
'1399510':'宁夏|银川',
'1399511':'宁夏|银川',
'1399710':'青海|西宁',
'1399711':'青海|西宁',
'1399910':'新疆|乌鲁木齐',
'1399911':'新疆|乌鲁木齐',
'1399912':'新疆|乌鲁木齐',
'1501000':'北京',
'1501100':'北京',
'1501200':'北京',
'1501300':'北京',
'1501400':'北京',
'1501500':'北京',
'1501600':'北京',
'1501700':'北京',
'1501800':'北京',
'1501900':'北京',
'1502000':'广东|广州',
'1502001':'广东|广州',
'1502002':'广东|广州',
'1502003':'广东|广州',
'1502100':'上海',
'1502200':'上海',
'1502300':'上海',
'1502410':'辽宁|沈阳',
'1502411':'辽宁|沈阳',
'1502412':'辽宁|沈阳',
'1502413':'辽宁|沈阳',
'1502500':'江苏|南京',
'1502501':'江苏|南京',
'1502502':'江苏|南京',
'1502503':'江苏|南京',
'1502710':'湖北|武汉',
'1502711':'湖北|武汉',
'1502712':'湖北|武汉',
'1502713':'湖北|武汉',
'1502800':'四川|成都',
'1502801':'四川|成都',
'1502802':'四川|成都',
'1502803':'四川|成都',
'1502900':'陕西|咸阳',
'1502901':'陕西|咸阳',
'1502910':'陕西|西安',
'1502911':'陕西|西安',
'1502912':'陕西|西安',
'1502913':'陕西|西安',
'1503100':'河北|邯郸',
'1503101':'河北|邯郸',
'1503102':'河北|邯郸',
'1503110':'河北|石家庄',
'1503111':'河北|石家庄',
'1503112':'河北|石家庄',
'1503113':'河北|石家庄',
'1503120':'河北|保定',
'1503121':'河北|保定',
'1503122':'河北|保定',
'1503130':'河北|张家口',
'1503131':'河北|张家口',
'1503140':'河北|承德',
'1503141':'河北|承德',
'1503150':'河北|唐山',
'1503151':'河北|唐山',
'1503152':'河北|唐山',
'1503153':'河北|唐山',
'1503160':'河北|廊坊',
'1503161':'河北|廊坊',
'1503170':'河北|沧州',
'1503171':'河北|沧州',
'1503180':'河北|衡水',
'1503181':'河北|衡水',
'1503190':'河北|邢台',
'1503191':'河北|邢台',
'1503350':'河北|秦皇岛',
'1503351':'河北|秦皇岛',
'1503500':'山西|忻州',
'1503501':'山西|忻州',
'1503510':'山西|太原',
'1503511':'山西|太原',
'1503512':'山西|太原',
'1503513':'山西|太原',
'1503520':'山西|大同',
'1503521':'山西|大同',
'1503530':'山西|阳泉',
'1503531':'山西|阳泉',
'1503540':'山西|晋中',
'1503541':'山西|晋中',
'1503550':'山西|长治',
'1503551':'山西|长治',
'1503560':'山西|晋城',
'1503561':'山西|晋城',
'1503570':'山西|临汾',
'1503571':'山西|临汾',
'1503580':'山西|吕梁',
'1503581':'山西|吕梁',
'1503590':'山西|运城',
'1503591':'山西|运城',
'1503700':'河南|商丘',
'1503701':'河南|商丘',
'1503710':'河南|郑州',
'1503711':'河南|郑州',
'1503712':'河南|郑州',
'1503713':'河南|郑州',
'1503720':'河南|安阳',
'1503721':'河南|安阳',
'1503730':'河南|新乡',
'1503731':'河南|新乡',
'1503740':'河南|许昌',
'1503741':'河南|许昌',
'1503750':'河南|平顶山',
'1503751':'河南|平顶山',
'1503760':'河南|信阳',
'1503761':'河南|信阳',
'1503770':'河南|南阳',
'1503771':'河南|南阳',
'1503780':'河南|开封',
'1503781':'河南|开封',
'1503790':'河南|洛阳',
'1503791':'河南|洛阳',
'1503792':'河南|洛阳',
'1503910':'河南|焦作',
'1503911':'河南|焦作',
'1503920':'河南|鹤壁',
'1503921':'河南|鹤壁',
'1503930':'河南|濮阳',
'1503931':'河南|濮阳',
'1503940':'河南|周口',
'1503941':'河南|周口',
'1503950':'河南|漯河',
'1503951':'河南|漯河',
'1503960':'河南|驻马店',
'1503961':'河南|驻马店',
'1503980':'河南|三门峡',
'1503981':'河南|三门峡',
'1504100':'辽宁|铁岭',
'1504101':'辽宁|铁岭',
'1504110':'辽宁|大连',
'1504111':'辽宁|大连',
'1504112':'辽宁|大连',
'1504113':'辽宁|大连',
'1504120':'辽宁|鞍山',
'1504121':'辽宁|鞍山',
'1504130':'辽宁|抚顺',
'1504131':'辽宁|抚顺',
'1504140':'辽宁|本溪',
'1504141':'辽宁|本溪',
'1504150':'辽宁|丹东',
'1504151':'辽宁|丹东',
'1504160':'辽宁|锦州',
'1504161':'辽宁|锦州',
'1504170':'辽宁|营口',
'1504171':'辽宁|营口',
'1504180':'辽宁|阜新',
'1504181':'辽宁|阜新',
'1504190':'辽宁|辽阳',
'1504191':'辽宁|辽阳',
'1504210':'辽宁|朝阳',
'1504211':'辽宁|朝阳',
'1504270':'辽宁|盘锦',
'1504271':'辽宁|盘锦',
'1504290':'辽宁|葫芦岛',
'1504291':'辽宁|葫芦岛',
'1504310':'吉林|长春',
'1504311':'吉林|长春',
'1504312':'吉林|长春',
'1504313':'吉林|长春',
'1504320':'吉林|吉林市',
'1504321':'吉林|吉林市',
'1504340':'吉林|四平',
'1504341':'吉林|四平',
'1504350':'吉林|通化',
'1504351':'吉林|通化',
'1504360':'吉林|白城',
'1504361':'吉林|白城',
'1504370':'吉林|辽源',
'1504371':'吉林|辽源',
'1504380':'吉林|松原',
'1504381':'吉林|松原',
'1504390':'吉林|白山',
'1504391':'吉林|白山',
'1504510':'黑龙江|哈尔滨',
'1504511':'黑龙江|哈尔滨',
'1504512':'黑龙江|哈尔滨',
'1504513':'黑龙江|哈尔滨',
'1504520':'黑龙江|齐齐哈尔',
'1504521':'黑龙江|齐齐哈尔',
'1504530':'黑龙江|牡丹江',
'1504531':'黑龙江|牡丹江',
'1504540':'黑龙江|佳木斯',
'1504541':'黑龙江|佳木斯',
'1504550':'黑龙江|绥化',
'1504551':'黑龙江|绥化',
'1504580':'黑龙江|伊春',
'1504581':'黑龙江|伊春',
'1504590':'黑龙江|大庆',
'1504591':'黑龙江|大庆',
'1504670':'黑龙江|鸡西',
'1504671':'黑龙江|鸡西',
'1504710':'内蒙古|呼和浩特',
'1504711':'内蒙古|呼和浩特',
'1504712':'内蒙古|呼和浩特',
'1504720':'内蒙古|包头',
'1504721':'内蒙古|包头',
'1504730':'内蒙古|乌海',
'1504750':'内蒙古|通辽',
'1504751':'内蒙古|通辽',
'1504760':'内蒙古|赤峰',
'1504761':'内蒙古|赤峰',
'1504770':'内蒙古|鄂尔多斯',
'1504771':'内蒙古|鄂尔多斯',
'1505100':'江苏|无锡',
'1505101':'江苏|无锡',
'1505102':'江苏|无锡',
'1505110':'江苏|镇江',
'1505111':'江苏|镇江',
'1505120':'江苏|苏州',
'1505121':'江苏|苏州',
'1505122':'江苏|苏州',
'1505123':'江苏|苏州',
'1505130':'江苏|南通',
'1505131':'江苏|南通',
'1505132':'江苏|南通',
'1505140':'江苏|扬州',
'1505141':'江苏|扬州',
'1505150':'江苏|盐城',
'1505151':'江苏|盐城',
'1505160':'江苏|徐州',
'1505161':'江苏|徐州',
'1505162':'江苏|徐州',
'1505170':'江苏|淮安',
'1505171':'江苏|淮安',
'1505180':'江苏|连云港',
'1505181':'江苏|连云港',
'1505190':'江苏|常州',
'1505191':'江苏|常州',
'1505192':'江苏|常州',
'1505230':'江苏|泰州',
'1505231':'江苏|泰州',
'1505270':'江苏|宿迁',
'1505271':'江苏|宿迁',
'1505300':'山东|菏泽',
'1505301':'山东|菏泽',
'1505310':'山东|济南',
'1505311':'山东|济南',
'1505312':'山东|济南',
'1505313':'山东|济南',
'1505320':'山东|青岛',
'1505321':'山东|青岛',
'1505322':'山东|青岛',
'1505323':'山东|青岛',
'1505330':'山东|淄博',
'1505331':'山东|淄博',
'1505340':'山东|德州',
'1505341':'山东|德州',
'1505350':'山东|烟台',
'1505351':'山东|烟台',
'1505352':'山东|烟台',
'1505360':'山东|潍坊',
'1505361':'山东|潍坊',
'1505362':'山东|潍坊',
'1505370':'山东|济宁',
'1505371':'山东|济宁',
'1505380':'山东|泰安',
'1505381':'山东|泰安',
'1505390':'山东|临沂',
'1505391':'山东|临沂',
'1505430':'山东|滨州',
'1505431':'山东|滨州',
'1505460':'山东|东营',
'1505461':'山东|东营',
'1505500':'安徽|滁州',
'1505501':'安徽|滁州',
'1505510':'安徽|合肥',
'1505511':'安徽|合肥',
'1505512':'安徽|合肥',
'1505513':'安徽|合肥',
'1505514':'安徽|合肥',
'1505520':'安徽|蚌埠',
'1505521':'安徽|蚌埠',
'1505530':'安徽|芜湖',
'1505531':'安徽|芜湖',
'1505532':'安徽|芜湖',
'1505540':'安徽|淮南',
'1505541':'安徽|淮南',
'1505550':'安徽|马鞍山',
'1505551':'安徽|马鞍山',
'1505560':'安徽|安庆',
'1505561':'安徽|安庆',
'1505570':'安徽|宿州',
'1505571':'安徽|宿州',
'1505580':'安徽|阜阳',
'1505581':'安徽|阜阳',
'1505590':'安徽|黄山',
'1505591':'安徽|黄山',
'1505600':'安徽|合肥',
'1505601':'安徽|合肥',
'1505602':'安徽|合肥',
'1505603':'安徽|合肥',
'1505604':'安徽|合肥',
'1505610':'安徽|淮北',
'1505611':'安徽|淮北',
'1505620':'安徽|铜陵',
'1505621':'安徽|铜陵',
'1505630':'安徽|宣城',
'1505631':'安徽|宣城',
'1505640':'安徽|六安',
'1505641':'安徽|六安',
'1505660':'安徽|池州',
'1505661':'安徽|池州',
'1505700':'浙江|衢州',
'1505701':'浙江|衢州',
'1505710':'浙江|杭州',
'1505711':'浙江|杭州',
'1505712':'浙江|杭州',
'1505713':'浙江|杭州',
'1505720':'浙江|湖州',
'1505721':'浙江|湖州',
'1505730':'浙江|嘉兴',
'1505731':'浙江|嘉兴',
'1505740':'浙江|宁波',
'1505741':'浙江|宁波',
'1505742':'浙江|宁波',
'1505750':'浙江|绍兴',
'1505751':'浙江|绍兴',
'1505760':'浙江|台州',
'1505761':'浙江|台州',
'1505770':'浙江|温州',
'1505771':'浙江|温州',
'1505772':'浙江|温州',
'1505780':'浙江|丽水',
'1505781':'浙江|丽水',
'1505790':'浙江|金华',
'1505791':'浙江|金华',
'1505800':'浙江|舟山',
'1505801':'浙江|舟山',
'1505910':'福建|福州',
'1505911':'福建|福州',
'1505912':'福建|福州',
'1505913':'福建|福州',
'1505920':'福建|厦门',
'1505921':'福建|厦门',
'1505922':'福建|厦门',
'1505930':'福建|宁德',
'1505931':'福建|宁德',
'1505940':'福建|莆田',
'1505941':'福建|莆田',
'1505950':'福建|泉州',
'1505951':'福建|泉州',
'1505952':'福建|泉州',
'1505960':'福建|漳州',
'1505961':'福建|漳州',
'1505970':'福建|龙岩',
'1505971':'福建|龙岩',
'1505980':'福建|三明',
'1505981':'福建|三明',
'1505990':'福建|南平',
'1505991':'福建|南平',
'1506310':'山东|威海',
'1506311':'山东|威海',
'1506320':'山东|枣庄',
'1506321':'山东|枣庄',
'1506330':'山东|日照',
'1506331':'山东|日照',
'1506350':'山东|聊城',
'1506351':'山东|聊城',
'1506600':'广东|汕尾',
'1506601':'广东|汕尾',
'1506620':'广东|阳江',
'1506621':'广东|阳江',
'1506630':'广东|揭阳',
'1506631':'广东|揭阳',
'1506680':'广东|茂名',
'1506681':'广东|茂名',
'1507010':'江西|鹰潭',
'1507011':'江西|鹰潭',
'1507100':'湖北|襄阳',
'1507101':'湖北|襄阳',
'1507110':'湖北|鄂州',
'1507111':'湖北|鄂州',
'1507120':'湖北|孝感',
'1507121':'湖北|孝感',
'1507130':'湖北|黄冈',
'1507131':'湖北|黄冈',
'1507140':'湖北|黄石',
'1507141':'湖北|黄石',
'1507150':'湖北|咸宁',
'1507151':'湖北|咸宁',
'1507160':'湖北|荆州',
'1507161':'湖北|荆州',
'1507170':'湖北|宜昌',
'1507171':'湖北|宜昌',
'1507180':'湖北|恩施',
'1507181':'湖北|恩施',
'1507190':'湖北|十堰',
'1507191':'湖北|十堰',
'1507220':'湖北|随州',
'1507221':'湖北|随州',
'1507240':'湖北|荆门',
'1507241':'湖北|荆门',
'1507300':'湖南|岳阳',
'1507301':'湖南|岳阳',
'1507310':'湖南|长沙',
'1507311':'湖南|长沙',
'1507312':'湖南|长沙',
'1507313':'湖南|长沙',
'1507320':'湖南|湘潭',
'1507321':'湖南|湘潭',
'1507330':'湖南|株洲',
'1507331':'湖南|株洲',
'1507340':'湖南|衡阳',
'1507341':'湖南|衡阳',
'1507350':'湖南|郴州',
'1507351':'湖南|郴州',
'1507360':'湖南|常德',
'1507361':'湖南|常德',
'1507370':'湖南|益阳',
'1507371':'湖南|益阳',
'1507380':'湖南|娄底',
'1507381':'湖南|娄底',
'1507390':'湖南|邵阳',
'1507391':'湖南|邵阳',
'1507440':'湖南|张家界',
'1507441':'湖南|张家界',
'1507450':'湖南|怀化',
'1507451':'湖南|怀化',
'1507460':'湖南|永州',
'1507461':'湖南|永州',
'1507500':'广东|江门',
'1507501':'广东|江门',
'1507510':'广东|韶关',
'1507511':'广东|韶关',
'1507520':'广东|惠州',
'1507521':'广东|惠州',
'1507530':'广东|梅州',
'1507531':'广东|梅州',
'1507540':'广东|汕头',
'1507541':'广东|汕头',
'1507550':'广东|深圳',
'1507551':'广东|深圳',
'1507552':'广东|深圳',
'1507553':'广东|深圳',
'1507560':'广东|珠海',
'1507561':'广东|珠海',
'1507570':'广东|佛山',
'1507571':'广东|佛山',
'1507572':'广东|佛山',
'1507580':'广东|肇庆',
'1507581':'广东|肇庆',
'1507590':'广东|湛江',
'1507591':'广东|湛江',
'1507600':'广东|中山',
'1507601':'广东|中山',
'1507620':'广东|河源',
'1507621':'广东|河源',
'1507630':'广东|清远',
'1507631':'广东|清远',
'1507660':'广东|云浮',
'1507661':'广东|云浮',
'1507680':'广东|潮州',
'1507681':'广东|潮州',
'1507690':'广东|东莞',
'1507691':'广东|东莞',
'1507692':'广东|东莞',
'1507700':'广西|防城港',
'1507701':'广西|防城港',
'1507710':'广西|南宁',
'1507711':'广西|南宁',
'1507712':'广西|南宁',
'1507720':'广西|柳州',
'1507721':'广西|柳州',
'1507730':'广西|桂林',
'1507731':'广西|桂林',
'1507740':'广西|梧州',
'1507741':'广西|梧州',
'1507750':'广西|贵港',
'1507751':'广西|贵港',
'1507760':'广西|百色',
'1507761':'广西|百色',
'1507770':'广西|钦州',
'1507771':'广西|钦州',
'1507780':'广西|河池',
'1507781':'广西|河池',
'1507790':'广西|北海',
'1507791':'广西|北海',
'1507900':'江西|新余',
'1507901':'江西|新余',
'1507910':'江西|南昌',
'1507911':'江西|南昌',
'1507912':'江西|南昌',
'1507913':'江西|南昌',
'1507920':'江西|九江',
'1507921':'江西|九江',
'1507930':'江西|上饶',
'1507931':'江西|上饶',
'1507940':'江西|抚州',
'1507941':'江西|抚州',
'1507950':'江西|宜春',
'1507951':'江西|宜春',
'1507960':'江西|吉安',
'1507961':'江西|吉安',
'1507970':'江西|赣州',
'1507971':'江西|赣州',
'1507980':'江西|景德镇',
'1507981':'江西|景德镇',
'1507990':'江西|萍乡',
'1507991':'江西|萍乡',
'1508120':'四川|攀枝花',
'1508121':'四川|攀枝花',
'1508130':'四川|自贡',
'1508131':'四川|自贡',
'1508160':'四川|绵阳',
'1508161':'四川|绵阳',
'1508170':'四川|南充',
'1508171':'四川|南充',
'1508180':'四川|达州',
'1508181':'四川|达州',
'1508250':'四川|遂宁',
'1508251':'四川|遂宁',
'1508260':'四川|广安',
'1508261':'四川|广安',
'1508270':'四川|巴中',
'1508271':'四川|巴中',
'1508300':'重庆',
'1508301':'四川|泸州',
'1508310':'四川|宜宾',
'1508311':'四川|宜宾',
'1508320':'四川|内江',
'1508321':'四川|内江',
'1508330':'四川|乐山',
'1508331':'四川|乐山',
'1508350':'四川|雅安',
'1508351':'四川|雅安',
'1508380':'四川|德阳',
'1508381':'四川|德阳',
'1508390':'四川|广元',
'1508391':'四川|广元',
'1508400':'重庆',
'1508500':'重庆',
'1508510':'贵州|贵阳',
'1508511':'贵州|贵阳',
'1508512':'贵州|贵阳',
'1508520':'贵州|遵义',
'1508521':'贵州|遵义',
'1508530':'贵州|安顺',
'1508531':'贵州|安顺',
'1508560':'贵州|铜仁',
'1508561':'贵州|铜仁',
'1508570':'贵州|毕节',
'1508571':'贵州|毕节',
'1508580':'贵州|六盘水',
'1508581':'贵州|六盘水',
'1508700':'云南|昭通',
'1508701':'云南|昭通',
'1508710':'云南|昆明',
'1508711':'云南|昆明',
'1508712':'云南|昆明',
'1508713':'云南|昆明',
'1508720':'云南|大理',
'1508721':'云南|大理',
'1508740':'云南|曲靖',
'1508741':'云南|曲靖',
'1508750':'云南|保山',
'1508751':'云南|保山',
'1508770':'云南|玉溪',
'1508771':'云南|玉溪',
'1508790':'云南|普洱',
'1508791':'云南|普洱',
'1508880':'云南|丽江',
'1508881':'云南|丽江',
'1508910':'西藏|拉萨',
'1508911':'西藏|拉萨',
'1508920':'西藏|日喀则',
'1508921':'西藏|日喀则',
'1508980':'海南|海口',
'1508981':'海南|海口',
'1508982':'海南|海口',
'1508990':'海南|三亚',
'1508991':'海南|三亚',
'1509110':'陕西|延安',
'1509111':'陕西|延安',
'1509120':'陕西|榆林',
'1509121':'陕西|榆林',
'1509130':'陕西|渭南',
'1509131':'陕西|渭南',
'1509140':'陕西|商洛',
'1509141':'陕西|商洛',
'1509150':'陕西|安康',
'1509151':'陕西|安康',
'1509160':'陕西|汉中',
'1509161':'陕西|汉中',
'1509170':'陕西|宝鸡',
'1509171':'陕西|宝鸡',
'1509190':'陕西|铜川',
'1509191':'陕西|铜川',
'1509310':'甘肃|兰州',
'1509311':'甘肃|兰州',
'1509312':'甘肃|兰州',
'1509370':'甘肃|酒泉',
'1509371':'甘肃|酒泉',
'1509380':'甘肃|天水',
'1509381':'甘肃|天水',
'1509430':'甘肃|白银',
'1509431':'甘肃|白银',
'1509510':'宁夏|银川',
'1509511':'宁夏|银川',
'1509710':'青海|西宁',
'1509711':'青海|西宁',
'1509910':'新疆|乌鲁木齐',
'1509911':'新疆|乌鲁木齐',
'1509912':'新疆|乌鲁木齐',
'1511000':'北京',
'1511100':'北京',
'1511200':'北京',
'1511300':'北京',
'1511400':'北京',
'1511500':'北京',
'1511600':'北京',
'1511700':'北京',
'1511800':'北京',
'1511900':'北京',
'1512000':'广东|广州',
'1512001':'广东|广州',
'1512002':'广东|广州',
'1512003':'广东|广州',
'1512100':'上海',
'1512200':'上海',
'1512300':'上海',
'1512410':'辽宁|沈阳',
'1512411':'辽宁|沈阳',
'1512412':'辽宁|沈阳',
'1512413':'辽宁|沈阳',
'1512500':'江苏|南京',
'1512501':'江苏|南京',
'1512502':'江苏|南京',
'1512503':'江苏|南京',
'1512710':'湖北|武汉',
'1512711':'湖北|武汉',
'1512712':'湖北|武汉',
'1512713':'湖北|武汉',
'1512800':'四川|成都',
'1512801':'四川|成都',
'1512802':'四川|成都',
'1512803':'四川|成都',
'1512900':'陕西|咸阳',
'1512901':'陕西|咸阳',
'1512910':'陕西|西安',
'1512911':'陕西|西安',
'1512912':'陕西|西安',
'1512913':'陕西|西安',
'1513100':'河北|邯郸',
'1513101':'河北|邯郸',
'1513102':'河北|邯郸',
'1513110':'河北|石家庄',
'1513111':'河北|石家庄',
'1513112':'河北|石家庄',
'1513113':'河北|石家庄',
'1513120':'河北|保定',
'1513121':'河北|保定',
'1513122':'河北|保定',
'1513130':'河北|张家口',
'1513131':'河北|张家口',
'1513140':'河北|承德',
'1513141':'河北|承德',
'1513150':'河北|唐山',
'1513151':'河北|唐山',
'1513152':'河北|唐山',
'1513153':'河北|唐山',
'1513160':'河北|廊坊',
'1513161':'河北|廊坊',
'1513170':'河北|沧州',
'1513171':'河北|沧州',
'1513180':'河北|衡水',
'1513181':'河北|衡水',
'1513190':'河北|邢台',
'1513191':'河北|邢台',
'1513350':'河北|秦皇岛',
'1513351':'河北|秦皇岛',
'1513500':'山西|忻州',
'1513501':'山西|忻州',
'1513510':'山西|太原',
'1513511':'山西|太原',
'1513512':'山西|太原',
'1513513':'山西|太原',
'1513520':'山西|大同',
'1513521':'山西|大同',
'1513530':'山西|阳泉',
'1513531':'山西|阳泉',
'1513540':'山西|晋中',
'1513541':'山西|晋中',
'1513550':'山西|长治',
'1513551':'山西|长治',
'1513560':'山西|晋城',
'1513561':'山西|晋城',
'1513570':'山西|临汾',
'1513571':'山西|临汾',
'1513580':'山西|吕梁',
'1513581':'山西|吕梁',
'1513590':'山西|运城',
'1513591':'山西|运城',
'1513700':'河南|商丘',
'1513701':'河南|商丘',
'1513710':'河南|郑州',
'1513711':'河南|郑州',
'1513712':'河南|郑州',
'1513713':'河南|郑州',
'1513720':'河南|安阳',
'1513721':'河南|安阳',
'1513730':'河南|新乡',
'1513731':'河南|新乡',
'1513740':'河南|许昌',
'1513741':'河南|许昌',
'1513750':'河南|平顶山',
'1513751':'河南|平顶山',
'1513760':'河南|信阳',
'1513761':'河南|信阳',
'1513770':'河南|南阳',
'1513771':'河南|南阳',
'1513780':'河南|开封',
'1513781':'河南|开封',
'1513790':'河南|洛阳',
'1513791':'河南|洛阳',
'1513792':'河南|洛阳',
'1513910':'河南|焦作',
'1513911':'河南|焦作',
'1513920':'河南|鹤壁',
'1513921':'河南|鹤壁',
'1513930':'河南|濮阳',
'1513931':'河南|濮阳',
'1513940':'河南|周口',
'1513941':'河南|周口',
'1513950':'河南|漯河',
'1513951':'河南|漯河',
'1513960':'河南|驻马店',
'1513961':'河南|驻马店',
'1513980':'河南|三门峡',
'1513981':'河南|三门峡',
'1514100':'辽宁|铁岭',
'1514101':'辽宁|铁岭',
'1514110':'辽宁|大连',
'1514111':'辽宁|大连',
'1514112':'辽宁|大连',
'1514113':'辽宁|大连',
'1514120':'辽宁|鞍山',
'1514121':'辽宁|鞍山',
'1514130':'辽宁|抚顺',
'1514131':'辽宁|抚顺',
'1514140':'辽宁|本溪',
'1514141':'辽宁|本溪',
'1514150':'辽宁|丹东',
'1514151':'辽宁|丹东',
'1514160':'辽宁|锦州',
'1514161':'辽宁|锦州',
'1514170':'辽宁|营口',
'1514171':'辽宁|营口',
'1514180':'辽宁|阜新',
'1514181':'辽宁|阜新',
'1514190':'辽宁|辽阳',
'1514191':'辽宁|辽阳',
'1514210':'辽宁|朝阳',
'1514211':'辽宁|朝阳',
'1514270':'辽宁|盘锦',
'1514271':'辽宁|盘锦',
'1514290':'辽宁|葫芦岛',
'1514291':'辽宁|葫芦岛',
'1514310':'吉林|长春',
'1514311':'吉林|长春',
'1514312':'吉林|长春',
'1514313':'吉林|长春',
'1514320':'吉林|吉林市',
'1514321':'吉林|吉林市',
'1514340':'吉林|四平',
'1514341':'吉林|四平',
'1514350':'吉林|通化',
'1514351':'吉林|通化',
'1514360':'吉林|白城',
'1514361':'吉林|白城',
'1514370':'吉林|辽源',
'1514371':'吉林|辽源',
'1514380':'吉林|松原',
'1514381':'吉林|松原',
'1514390':'吉林|白山',
'1514391':'吉林|白山',
'1514510':'黑龙江|哈尔滨',
'1514511':'黑龙江|哈尔滨',
'1514512':'黑龙江|哈尔滨',
'1514513':'黑龙江|哈尔滨',
'1514520':'黑龙江|齐齐哈尔',
'1514521':'黑龙江|齐齐哈尔',
'1514530':'黑龙江|牡丹江',
'1514531':'黑龙江|牡丹江',
'1514540':'黑龙江|佳木斯',
'1514541':'黑龙江|佳木斯',
'1514550':'黑龙江|绥化',
'1514551':'黑龙江|绥化',
'1514580':'黑龙江|伊春',
'1514581':'黑龙江|伊春',
'1514590':'黑龙江|大庆',
'1514591':'黑龙江|大庆',
'1514670':'黑龙江|鸡西',
'1514671':'黑龙江|鸡西',
'1514710':'内蒙古|呼和浩特',
'1514711':'内蒙古|呼和浩特',
'1514712':'内蒙古|呼和浩特',
'1514720':'内蒙古|包头',
'1514721':'内蒙古|包头',
'1514730':'内蒙古|乌海',
'1514750':'内蒙古|通辽',
'1514751':'内蒙古|通辽',
'1514760':'内蒙古|赤峰',
'1514761':'内蒙古|赤峰',
'1514770':'内蒙古|鄂尔多斯',
'1514771':'内蒙古|鄂尔多斯',
'1515100':'江苏|无锡',
'1515101':'江苏|无锡',
'1515102':'江苏|无锡',
'1515110':'江苏|镇江',
'1515111':'江苏|镇江',
'1515120':'江苏|苏州',
'1515121':'江苏|苏州',
'1515122':'江苏|苏州',
'1515123':'江苏|苏州',
'1515130':'江苏|南通',
'1515131':'江苏|南通',
'1515132':'江苏|南通',
'1515140':'江苏|扬州',
'1515141':'江苏|扬州',
'1515150':'江苏|盐城',
'1515151':'江苏|盐城',
'1515160':'江苏|徐州',
'1515161':'江苏|徐州',
'1515162':'江苏|徐州',
'1515170':'江苏|淮安',
'1515171':'江苏|淮安',
'1515180':'江苏|连云港',
'1515181':'江苏|连云港',
'1515190':'江苏|常州',
'1515191':'江苏|常州',
'1515192':'江苏|常州',
'1515230':'江苏|泰州',
'1515231':'江苏|泰州',
'1515270':'江苏|宿迁',
'1515271':'江苏|宿迁',
'1515300':'山东|菏泽',
'1515301':'山东|菏泽',
'1515310':'山东|济南',
'1515311':'山东|济南',
'1515312':'山东|济南',
'1515313':'山东|济南',
'1515320':'山东|青岛',
'1515321':'山东|青岛',
'1515322':'山东|青岛',
'1515323':'山东|青岛',
'1515330':'山东|淄博',
'1515331':'山东|淄博',
'1515340':'山东|德州',
'1515341':'山东|德州',
'1515350':'山东|烟台',
'1515351':'山东|烟台',
'1515352':'山东|烟台',
'1515360':'山东|潍坊',
'1515361':'山东|潍坊',
'1515362':'山东|潍坊',
'1515370':'山东|济宁',
'1515371':'山东|济宁',
'1515380':'山东|泰安',
'1515381':'山东|泰安',
'1515390':'山东|临沂',
'1515391':'山东|临沂',
'1515430':'山东|滨州',
'1515431':'山东|滨州',
'1515460':'山东|东营',
'1515461':'山东|东营',
'1515500':'安徽|滁州',
'1515501':'安徽|滁州',
'1515510':'安徽|合肥',
'1515511':'安徽|合肥',
'1515512':'安徽|合肥',
'1515513':'安徽|合肥',
'1515514':'安徽|合肥',
'1515520':'安徽|蚌埠',
'1515521':'安徽|蚌埠',
'1515530':'安徽|芜湖',
'1515531':'安徽|芜湖',
'1515532':'安徽|芜湖',
'1515540':'安徽|淮南',
'1515541':'安徽|淮南',
'1515550':'安徽|马鞍山',
'1515551':'安徽|马鞍山',
'1515560':'安徽|安庆',
'1515561':'安徽|安庆',
'1515570':'安徽|宿州',
'1515571':'安徽|宿州',
'1515580':'安徽|阜阳',
'1515581':'安徽|阜阳',
'1515590':'安徽|黄山',
'1515591':'安徽|黄山',
'1515600':'安徽|合肥',
'1515601':'安徽|合肥',
'1515602':'安徽|合肥',
'1515603':'安徽|合肥',
'1515604':'安徽|合肥',
'1515610':'安徽|淮北',
'1515611':'安徽|淮北',
'1515620':'安徽|铜陵',
'1515621':'安徽|铜陵',
'1515630':'安徽|宣城',
'1515631':'安徽|宣城',
'1515640':'安徽|六安',
'1515641':'安徽|六安',
'1515660':'安徽|池州',
'1515661':'安徽|池州',
'1515700':'浙江|衢州',
'1515701':'浙江|衢州',
'1515710':'浙江|杭州',
'1515711':'浙江|杭州',
'1515712':'浙江|杭州',
'1515713':'浙江|杭州',
'1515720':'浙江|湖州',
'1515721':'浙江|湖州',
'1515730':'浙江|嘉兴',
'1515731':'浙江|嘉兴',
'1515740':'浙江|宁波',
'1515741':'浙江|宁波',
'1515742':'浙江|宁波',
'1515750':'浙江|绍兴',
'1515751':'浙江|绍兴',
'1515760':'浙江|台州',
'1515761':'浙江|台州',
'1515770':'浙江|温州',
'1515771':'浙江|温州',
'1515772':'浙江|温州',
'1515780':'浙江|丽水',
'1515781':'浙江|丽水',
'1515790':'浙江|金华',
'1515791':'浙江|金华',
'1515800':'浙江|舟山',
'1515801':'浙江|舟山',
'1515910':'福建|福州',
'1515911':'福建|福州',
'1515912':'福建|福州',
'1515913':'福建|福州',
'1515920':'福建|厦门',
'1515921':'福建|厦门',
'1515922':'福建|厦门',
'1515930':'福建|宁德',
'1515931':'福建|宁德',
'1515940':'福建|莆田',
'1515941':'福建|莆田',
'1515950':'福建|泉州',
'1515951':'福建|泉州',
'1515952':'福建|泉州',
'1515960':'福建|漳州',
'1515961':'福建|漳州',
'1515970':'福建|龙岩',
'1515971':'福建|龙岩',
'1515980':'福建|三明',
'1515981':'福建|三明',
'1515990':'福建|南平',
'1515991':'福建|南平',
'1516310':'山东|威海',
'1516311':'山东|威海',
'1516320':'山东|枣庄',
'1516321':'山东|枣庄',
'1516330':'山东|日照',
'1516331':'山东|日照',
'1516350':'山东|聊城',
'1516351':'山东|聊城',
'1516600':'广东|汕尾',
'1516601':'广东|汕尾',
'1516620':'广东|阳江',
'1516621':'广东|阳江',
'1516630':'广东|揭阳',
'1516631':'广东|揭阳',
'1516680':'广东|茂名',
'1516681':'广东|茂名',
'1517010':'江西|鹰潭',
'1517011':'江西|鹰潭',
'1517100':'湖北|襄阳',
'1517101':'湖北|襄阳',
'1517110':'湖北|鄂州',
'1517111':'湖北|鄂州',
'1517120':'湖北|孝感',
'1517121':'湖北|孝感',
'1517130':'湖北|黄冈',
'1517131':'湖北|黄冈',
'1517140':'湖北|黄石',
'1517141':'湖北|黄石',
'1517150':'湖北|咸宁',
'1517151':'湖北|咸宁',
'1517160':'湖北|荆州',
'1517161':'湖北|荆州',
'1517170':'湖北|宜昌',
'1517171':'湖北|宜昌',
'1517180':'湖北|恩施',
'1517181':'湖北|恩施',
'1517190':'湖北|十堰',
'1517191':'湖北|十堰',
'1517220':'湖北|随州',
'1517221':'湖北|随州',
'1517240':'湖北|荆门',
'1517241':'湖北|荆门',
'1517300':'湖南|岳阳',
'1517301':'湖南|岳阳',
'1517310':'湖南|长沙',
'1517311':'湖南|长沙',
'1517312':'湖南|长沙',
'1517313':'湖南|长沙',
'1517320':'湖南|湘潭',
'1517321':'湖南|湘潭',
'1517330':'湖南|株洲',
'1517331':'湖南|株洲',
'1517340':'湖南|衡阳',
'1517341':'湖南|衡阳',
'1517350':'湖南|郴州',
'1517351':'湖南|郴州',
'1517360':'湖南|常德',
'1517361':'湖南|常德',
'1517370':'湖南|益阳',
'1517371':'湖南|益阳',
'1517380':'湖南|娄底',
'1517381':'湖南|娄底',
'1517390':'湖南|邵阳',
'1517391':'湖南|邵阳',
'1517440':'湖南|张家界',
'1517441':'湖南|张家界',
'1517450':'湖南|怀化',
'1517451':'湖南|怀化',
'1517460':'湖南|永州',
'1517461':'湖南|永州',
'1517500':'广东|江门',
'1517501':'广东|江门',
'1517510':'广东|韶关',
'1517511':'广东|韶关',
'1517520':'广东|惠州',
'1517521':'广东|惠州',
'1517530':'广东|梅州',
'1517531':'广东|梅州',
'1517540':'广东|汕头',
'1517541':'广东|汕头',
'1517550':'广东|深圳',
'1517551':'广东|深圳',
'1517552':'广东|深圳',
'1517553':'广东|深圳',
'1517560':'广东|珠海',
'1517561':'广东|珠海',
'1517570':'广东|佛山',
'1517571':'广东|佛山',
'1517572':'广东|佛山',
'1517580':'广东|肇庆',
'1517581':'广东|肇庆',
'1517590':'广东|湛江',
'1517591':'广东|湛江',
'1517600':'广东|中山',
'1517601':'广东|中山',
'1517620':'广东|河源',
'1517621':'广东|河源',
'1517630':'广东|清远',
'1517631':'广东|清远',
'1517660':'广东|云浮',
'1517661':'广东|云浮',
'1517680':'广东|潮州',
'1517681':'广东|潮州',
'1517690':'广东|东莞',
'1517691':'广东|东莞',
'1517692':'广东|东莞',
'1517700':'广西|防城港',
'1517701':'广西|防城港',
'1517710':'广西|南宁',
'1517711':'广西|南宁',
'1517712':'广西|南宁',
'1517720':'广西|柳州',
'1517721':'广西|柳州',
'1517730':'广西|桂林',
'1517731':'广西|桂林',
'1517740':'广西|梧州',
'1517741':'广西|梧州',
'1517750':'广西|贵港',
'1517751':'广西|贵港',
'1517760':'广西|百色',
'1517761':'广西|百色',
'1517770':'广西|钦州',
'1517771':'广西|钦州',
'1517780':'广西|河池',
'1517781':'广西|河池',
'1517790':'广西|北海',
'1517791':'广西|北海',
'1517900':'江西|新余',
'1517901':'江西|新余',
'1517910':'江西|南昌',
'1517911':'江西|南昌',
'1517912':'江西|南昌',
'1517913':'江西|南昌',
'1517920':'江西|九江',
'1517921':'江西|九江',
'1517930':'江西|上饶',
'1517931':'江西|上饶',
'1517940':'江西|抚州',
'1517941':'江西|抚州',
'1517950':'江西|宜春',
'1517951':'江西|宜春',
'1517960':'江西|吉安',
'1517961':'江西|吉安',
'1517970':'江西|赣州',
'1517971':'江西|赣州',
'1517980':'江西|景德镇',
'1517981':'江西|景德镇',
'1517990':'江西|萍乡',
'1517991':'江西|萍乡',
'1518120':'四川|攀枝花',
'1518121':'四川|攀枝花',
'1518130':'四川|自贡',
'1518131':'四川|自贡',
'1518160':'四川|绵阳',
'1518161':'四川|绵阳',
'1518170':'四川|南充',
'1518171':'四川|南充',
'1518180':'四川|达州',
'1518181':'四川|达州',
'1518250':'四川|遂宁',
'1518251':'四川|遂宁',
'1518260':'四川|广安',
'1518261':'四川|广安',
'1518270':'四川|巴中',
'1518271':'四川|巴中',
'1518300':'重庆',
'1518301':'四川|泸州',
'1518310':'四川|宜宾',
'1518311':'四川|宜宾',
'1518320':'四川|内江',
'1518321':'四川|内江',
'1518330':'四川|乐山',
'1518331':'四川|乐山',
'1518350':'四川|雅安',
'1518351':'四川|雅安',
'1518380':'四川|德阳',
'1518381':'四川|德阳',
'1518390':'四川|广元',
'1518391':'四川|广元',
'1518400':'重庆',
'1518500':'重庆',
'1518510':'贵州|贵阳',
'1518511':'贵州|贵阳',
'1518512':'贵州|贵阳',
'1518520':'贵州|遵义',
'1518521':'贵州|遵义',
'1518530':'贵州|安顺',
'1518531':'贵州|安顺',
'1518560':'贵州|铜仁',
'1518561':'贵州|铜仁',
'1518570':'贵州|毕节',
'1518571':'贵州|毕节',
'1518580':'贵州|六盘水',
'1518581':'贵州|六盘水',
'1518700':'云南|昭通',
'1518701':'云南|昭通',
'1518710':'云南|昆明',
'1518711':'云南|昆明',
'1518712':'云南|昆明',
'1518713':'云南|昆明',
'1518720':'云南|大理',
'1518721':'云南|大理',
'1518740':'云南|曲靖',
'1518741':'云南|曲靖',
'1518750':'云南|保山',
'1518751':'云南|保山',
'1518770':'云南|玉溪',
'1518771':'云南|玉溪',
'1518790':'云南|普洱',
'1518791':'云南|普洱',
'1518880':'云南|丽江',
'1518881':'云南|丽江',
'1518910':'西藏|拉萨',
'1518911':'西藏|拉萨',
'1518920':'西藏|日喀则',
'1518921':'西藏|日喀则',
'1518980':'海南|海口',
'1518981':'海南|海口',
'1518982':'海南|海口',
'1518990':'海南|三亚',
'1518991':'海南|三亚',
'1519110':'陕西|延安',
'1519111':'陕西|延安',
'1519120':'陕西|榆林',
'1519121':'陕西|榆林',
'1519130':'陕西|渭南',
'1519131':'陕西|渭南',
'1519140':'陕西|商洛',
'1519141':'陕西|商洛',
'1519150':'陕西|安康',
'1519151':'陕西|安康',
'1519160':'陕西|汉中',
'1519161':'陕西|汉中',
'1519170':'陕西|宝鸡',
'1519171':'陕西|宝鸡',
'1519190':'陕西|铜川',
'1519191':'陕西|铜川',
'1519310':'甘肃|兰州',
'1519311':'甘肃|兰州',
'1519312':'甘肃|兰州',
'1519370':'甘肃|酒泉',
'1519371':'甘肃|酒泉',
'1519380':'甘肃|天水',
'1519381':'甘肃|天水',
'1519430':'甘肃|白银',
'1519431':'甘肃|白银',
'1519510':'宁夏|银川',
'1519511':'宁夏|银川',
'1519710':'青海|西宁',
'1519711':'青海|西宁',
'1519910':'新疆|乌鲁木齐',
'1519911':'新疆|乌鲁木齐',
'1519912':'新疆|乌鲁木齐',
'1521000':'北京',
'1521100':'北京',
'1521200':'北京',
'1521300':'北京',
'1521400':'北京',
'1521500':'北京',
'1521600':'北京',
'1521700':'北京',
'1521800':'北京',
'1521900':'北京',
'1522000':'广东|广州',
'1522001':'广东|广州',
'1522002':'广东|广州',
'1522003':'广东|广州',
'1522100':'上海',
'1522200':'上海',
'1522300':'上海',
'1522410':'辽宁|沈阳',
'1522411':'辽宁|沈阳',
'1522412':'辽宁|沈阳',
'1522413':'辽宁|沈阳',
'1522500':'江苏|南京',
'1522501':'江苏|南京',
'1522502':'江苏|南京',
'1522503':'江苏|南京',
'1522710':'湖北|武汉',
'1522711':'湖北|武汉',
'1522712':'湖北|武汉',
'1522713':'湖北|武汉',
'1522800':'四川|成都',
'1522801':'四川|成都',
'1522802':'四川|成都',
'1522803':'四川|成都',
'1522900':'陕西|咸阳',
'1522901':'陕西|咸阳',
'1522910':'陕西|西安',
'1522911':'陕西|西安',
'1522912':'陕西|西安',
'1522913':'陕西|西安',
'1523100':'河北|邯郸',
'1523101':'河北|邯郸',
'1523102':'河北|邯郸',
'1523110':'河北|石家庄',
'1523111':'河北|石家庄',
'1523112':'河北|石家庄',
'1523113':'河北|石家庄',
'1523120':'河北|保定',
'1523121':'河北|保定',
'1523122':'河北|保定',
'1523130':'河北|张家口',
'1523131':'河北|张家口',
'1523140':'河北|承德',
'1523141':'河北|承德',
'1523150':'河北|唐山',
'1523151':'河北|唐山',
'1523152':'河北|唐山',
'1523153':'河北|唐山',
'1523160':'河北|廊坊',
'1523161':'河北|廊坊',
'1523170':'河北|沧州',
'1523171':'河北|沧州',
'1523180':'河北|衡水',
'1523181':'河北|衡水',
'1523190':'河北|邢台',
'1523191':'河北|邢台',
'1523350':'河北|秦皇岛',
'1523351':'河北|秦皇岛',
'1523500':'山西|忻州',
'1523501':'山西|忻州',
'1523510':'山西|太原',
'1523511':'山西|太原',
'1523512':'山西|太原',
'1523513':'山西|太原',
'1523520':'山西|大同',
'1523521':'山西|大同',
'1523530':'山西|阳泉',
'1523531':'山西|阳泉',
'1523540':'山西|晋中',
'1523541':'山西|晋中',
'1523550':'山西|长治',
'1523551':'山西|长治',
'1523560':'山西|晋城',
'1523561':'山西|晋城',
'1523570':'山西|临汾',
'1523571':'山西|临汾',
'1523580':'山西|吕梁',
'1523581':'山西|吕梁',
'1523590':'山西|运城',
'1523591':'山西|运城',
'1523700':'河南|商丘',
'1523701':'河南|商丘',
'1523710':'河南|郑州',
'1523711':'河南|郑州',
'1523712':'河南|郑州',
'1523713':'河南|郑州',
'1523720':'河南|安阳',
'1523721':'河南|安阳',
'1523730':'河南|新乡',
'1523731':'河南|新乡',
'1523740':'河南|许昌',
'1523741':'河南|许昌',
'1523750':'河南|平顶山',
'1523751':'河南|平顶山',
'1523760':'河南|信阳',
'1523761':'河南|信阳',
'1523770':'河南|南阳',
'1523771':'河南|南阳',
'1523780':'河南|开封',
'1523781':'河南|开封',
'1523790':'河南|洛阳',
'1523791':'河南|洛阳',
'1523792':'河南|洛阳',
'1523910':'河南|焦作',
'1523911':'河南|焦作',
'1523920':'河南|鹤壁',
'1523921':'河南|鹤壁',
'1523930':'河南|濮阳',
'1523931':'河南|濮阳',
'1523940':'河南|周口',
'1523941':'河南|周口',
'1523950':'河南|漯河',
'1523951':'河南|漯河',
'1523960':'河南|驻马店',
'1523961':'河南|驻马店',
'1523980':'河南|三门峡',
'1523981':'河南|三门峡',
'1524100':'辽宁|铁岭',
'1524101':'辽宁|铁岭',
'1524110':'辽宁|大连',
'1524111':'辽宁|大连',
'1524112':'辽宁|大连',
'1524113':'辽宁|大连',
'1524120':'辽宁|鞍山',
'1524121':'辽宁|鞍山',
'1524130':'辽宁|抚顺',
'1524131':'辽宁|抚顺',
'1524140':'辽宁|本溪',
'1524141':'辽宁|本溪',
'1524150':'辽宁|丹东',
'1524151':'辽宁|丹东',
'1524160':'辽宁|锦州',
'1524161':'辽宁|锦州',
'1524170':'辽宁|营口',
'1524171':'辽宁|营口',
'1524180':'辽宁|阜新',
'1524181':'辽宁|阜新',
'1524190':'辽宁|辽阳',
'1524191':'辽宁|辽阳',
'1524210':'辽宁|朝阳',
'1524211':'辽宁|朝阳',
'1524270':'辽宁|盘锦',
'1524271':'辽宁|盘锦',
'1524290':'辽宁|葫芦岛',
'1524291':'辽宁|葫芦岛',
'1524310':'吉林|长春',
'1524311':'吉林|长春',
'1524312':'吉林|长春',
'1524313':'吉林|长春',
'1524320':'吉林|吉林市',
'1524321':'吉林|吉林市',
'1524340':'吉林|四平',
'1524341':'吉林|四平',
'1524350':'吉林|通化',
'1524351':'吉林|通化',
'1524360':'吉林|白城',
'1524361':'吉林|白城',
'1524370':'吉林|辽源',
'1524371':'吉林|辽源',
'1524380':'吉林|松原',
'1524381':'吉林|松原',
'1524390':'吉林|白山',
'1524391':'吉林|白山',
'1524510':'黑龙江|哈尔滨',
'1524511':'黑龙江|哈尔滨',
'1524512':'黑龙江|哈尔滨',
'1524513':'黑龙江|哈尔滨',
'1524520':'黑龙江|齐齐哈尔',
'1524521':'黑龙江|齐齐哈尔',
'1524530':'黑龙江|牡丹江',
'1524531':'黑龙江|牡丹江',
'1524540':'黑龙江|佳木斯',
'1524541':'黑龙江|佳木斯',
'1524550':'黑龙江|绥化',
'1524551':'黑龙江|绥化',
'1524580':'黑龙江|伊春',
'1524581':'黑龙江|伊春',
'1524590':'黑龙江|大庆',
'1524591':'黑龙江|大庆',
'1524670':'黑龙江|鸡西',
'1524671':'黑龙江|鸡西',
'1524710':'内蒙古|呼和浩特',
'1524711':'内蒙古|呼和浩特',
'1524712':'内蒙古|呼和浩特',
'1524720':'内蒙古|包头',
'1524721':'内蒙古|包头',
'1524730':'内蒙古|乌海',
'1524750':'内蒙古|通辽',
'1524751':'内蒙古|通辽',
'1524760':'内蒙古|赤峰',
'1524761':'内蒙古|赤峰',
'1524770':'内蒙古|鄂尔多斯',
'1524771':'内蒙古|鄂尔多斯',
'1525100':'江苏|无锡',
'1525101':'江苏|无锡',
'1525102':'江苏|无锡',
'1525110':'江苏|镇江',
'1525111':'江苏|镇江',
'1525120':'江苏|苏州',
'1525121':'江苏|苏州',
'1525122':'江苏|苏州',
'1525123':'江苏|苏州',
'1525130':'江苏|南通',
'1525131':'江苏|南通',
'1525132':'江苏|南通',
'1525140':'江苏|扬州',
'1525141':'江苏|扬州',
'1525150':'江苏|盐城',
'1525151':'江苏|盐城',
'1525160':'江苏|徐州',
'1525161':'江苏|徐州',
'1525162':'江苏|徐州',
'1525170':'江苏|淮安',
'1525171':'江苏|淮安',
'1525180':'江苏|连云港',
'1525181':'江苏|连云港',
'1525190':'江苏|常州',
'1525191':'江苏|常州',
'1525192':'江苏|常州',
'1525230':'江苏|泰州',
'1525231':'江苏|泰州',
'1525270':'江苏|宿迁',
'1525271':'江苏|宿迁',
'1525300':'山东|菏泽',
'1525301':'山东|菏泽',
'1525310':'山东|济南',
'1525311':'山东|济南',
'1525312':'山东|济南',
'1525313':'山东|济南',
'1525320':'山东|青岛',
'1525321':'山东|青岛',
'1525322':'山东|青岛',
'1525323':'山东|青岛',
'1525330':'山东|淄博',
'1525331':'山东|淄博',
'1525340':'山东|德州',
'1525341':'山东|德州',
'1525350':'山东|烟台',
'1525351':'山东|烟台',
'1525352':'山东|烟台',
'1525360':'山东|潍坊',
'1525361':'山东|潍坊',
'1525362':'山东|潍坊',
'1525370':'山东|济宁',
'1525371':'山东|济宁',
'1525380':'山东|泰安',
'1525381':'山东|泰安',
'1525390':'山东|临沂',
'1525391':'山东|临沂',
'1525430':'山东|滨州',
'1525431':'山东|滨州',
'1525460':'山东|东营',
'1525461':'山东|东营',
'1525500':'安徽|滁州',
'1525501':'安徽|滁州',
'1525510':'安徽|合肥',
'1525511':'安徽|合肥',
'1525512':'安徽|合肥',
'1525513':'安徽|合肥',
'1525514':'安徽|合肥',
'1525520':'安徽|蚌埠',
'1525521':'安徽|蚌埠',
'1525530':'安徽|芜湖',
'1525531':'安徽|芜湖',
'1525532':'安徽|芜湖',
'1525540':'安徽|淮南',
'1525541':'安徽|淮南',
'1525550':'安徽|马鞍山',
'1525551':'安徽|马鞍山',
'1525560':'安徽|安庆',
'1525561':'安徽|安庆',
'1525570':'安徽|宿州',
'1525571':'安徽|宿州',
'1525580':'安徽|阜阳',
'1525581':'安徽|阜阳',
'1525590':'安徽|黄山',
'1525591':'安徽|黄山',
'1525600':'安徽|合肥',
'1525601':'安徽|合肥',
'1525602':'安徽|合肥',
'1525603':'安徽|合肥',
'1525604':'安徽|合肥',
'1525610':'安徽|淮北',
'1525611':'安徽|淮北',
'1525620':'安徽|铜陵',
'1525621':'安徽|铜陵',
'1525630':'安徽|宣城',
'1525631':'安徽|宣城',
'1525640':'安徽|六安',
'1525641':'安徽|六安',
'1525660':'安徽|池州',
'1525661':'安徽|池州',
'1525700':'浙江|衢州',
'1525701':'浙江|衢州',
'1525710':'浙江|杭州',
'1525711':'浙江|杭州',
'1525712':'浙江|杭州',
'1525713':'浙江|杭州',
'1525720':'浙江|湖州',
'1525721':'浙江|湖州',
'1525730':'浙江|嘉兴',
'1525731':'浙江|嘉兴',
'1525740':'浙江|宁波',
'1525741':'浙江|宁波',
'1525742':'浙江|宁波',
'1525750':'浙江|绍兴',
'1525751':'浙江|绍兴',
'1525760':'浙江|台州',
'1525761':'浙江|台州',
'1525770':'浙江|温州',
'1525771':'浙江|温州',
'1525772':'浙江|温州',
'1525780':'浙江|丽水',
'1525781':'浙江|丽水',
'1525790':'浙江|金华',
'1525791':'浙江|金华',
'1525800':'浙江|舟山',
'1525801':'浙江|舟山',
'1525910':'福建|福州',
'1525911':'福建|福州',
'1525912':'福建|福州',
'1525913':'福建|福州',
'1525920':'福建|厦门',
'1525921':'福建|厦门',
'1525922':'福建|厦门',
'1525930':'福建|宁德',
'1525931':'福建|宁德',
'1525940':'福建|莆田',
'1525941':'福建|莆田',
'1525950':'福建|泉州',
'1525951':'福建|泉州',
'1525952':'福建|泉州',
'1525960':'福建|漳州',
'1525961':'福建|漳州',
'1525970':'福建|龙岩',
'1525971':'福建|龙岩',
'1525980':'福建|三明',
'1525981':'福建|三明',
'1525990':'福建|南平',
'1525991':'福建|南平',
'1526310':'山东|威海',
'1526311':'山东|威海',
'1526320':'山东|枣庄',
'1526321':'山东|枣庄',
'1526330':'山东|日照',
'1526331':'山东|日照',
'1526350':'山东|聊城',
'1526351':'山东|聊城',
'1526600':'广东|汕尾',
'1526601':'广东|汕尾',
'1526620':'广东|阳江',
'1526621':'广东|阳江',
'1526630':'广东|揭阳',
'1526631':'广东|揭阳',
'1526680':'广东|茂名',
'1526681':'广东|茂名',
'1527010':'江西|鹰潭',
'1527011':'江西|鹰潭',
'1527100':'湖北|襄阳',
'1527101':'湖北|襄阳',
'1527110':'湖北|鄂州',
'1527111':'湖北|鄂州',
'1527120':'湖北|孝感',
'1527121':'湖北|孝感',
'1527130':'湖北|黄冈',
'1527131':'湖北|黄冈',
'1527140':'湖北|黄石',
'1527141':'湖北|黄石',
'1527150':'湖北|咸宁',
'1527151':'湖北|咸宁',
'1527160':'湖北|荆州',
'1527161':'湖北|荆州',
'1527170':'湖北|宜昌',
'1527171':'湖北|宜昌',
'1527180':'湖北|恩施',
'1527181':'湖北|恩施',
'1527190':'湖北|十堰',
'1527191':'湖北|十堰',
'1527220':'湖北|随州',
'1527221':'湖北|随州',
'1527240':'湖北|荆门',
'1527241':'湖北|荆门',
'1527300':'湖南|岳阳',
'1527301':'湖南|岳阳',
'1527310':'湖南|长沙',
'1527311':'湖南|长沙',
'1527312':'湖南|长沙',
'1527313':'湖南|长沙',
'1527320':'湖南|湘潭',
'1527321':'湖南|湘潭',
'1527330':'湖南|株洲',
'1527331':'湖南|株洲',
'1527340':'湖南|衡阳',
'1527341':'湖南|衡阳',
'1527350':'湖南|郴州',
'1527351':'湖南|郴州',
'1527360':'湖南|常德',
'1527361':'湖南|常德',
'1527370':'湖南|益阳',
'1527371':'湖南|益阳',
'1527380':'湖南|娄底',
'1527381':'湖南|娄底',
'1527390':'湖南|邵阳',
'1527391':'湖南|邵阳',
'1527440':'湖南|张家界',
'1527441':'湖南|张家界',
'1527450':'湖南|怀化',
'1527451':'湖南|怀化',
'1527460':'湖南|永州',
'1527461':'湖南|永州',
'1527500':'广东|江门',
'1527501':'广东|江门',
'1527510':'广东|韶关',
'1527511':'广东|韶关',
'1527520':'广东|惠州',
'1527521':'广东|惠州',
'1527530':'广东|梅州',
'1527531':'广东|梅州',
'1527540':'广东|汕头',
'1527541':'广东|汕头',
'1527550':'广东|深圳',
'1527551':'广东|深圳',
'1527552':'广东|深圳',
'1527553':'广东|深圳',
'1527560':'广东|珠海',
'1527561':'广东|珠海',
'1527570':'广东|佛山',
'1527571':'广东|佛山',
'1527572':'广东|佛山',
'1527580':'广东|肇庆',
'1527581':'广东|肇庆',
'1527590':'广东|湛江',
'1527591':'广东|湛江',
'1527600':'广东|中山',
'1527601':'广东|中山',
'1527620':'广东|河源',
'1527621':'广东|河源',
'1527630':'广东|清远',
'1527631':'广东|清远',
'1527660':'广东|云浮',
'1527661':'广东|云浮',
'1527680':'广东|潮州',
'1527681':'广东|潮州',
'1527690':'广东|东莞',
'1527691':'广东|东莞',
'1527692':'广东|东莞',
'1527700':'广西|防城港',
'1527701':'广西|防城港',
'1527710':'广西|南宁',
'1527711':'广西|南宁',
'1527712':'广西|南宁',
'1527720':'广西|柳州',
'1527721':'广西|柳州',
'1527730':'广西|桂林',
'1527731':'广西|桂林',
'1527740':'广西|梧州',
'1527741':'广西|梧州',
'1527750':'广西|贵港',
'1527751':'广西|贵港',
'1527760':'广西|百色',
'1527761':'广西|百色',
'1527770':'广西|钦州',
'1527771':'广西|钦州',
'1527780':'广西|河池',
'1527781':'广西|河池',
'1527790':'广西|北海',
'1527791':'广西|北海',
'1527900':'江西|新余',
'1527901':'江西|新余',
'1527910':'江西|南昌',
'1527911':'江西|南昌',
'1527912':'江西|南昌',
'1527913':'江西|南昌',
'1527920':'江西|九江',
'1527921':'江西|九江',
'1527930':'江西|上饶',
'1527931':'江西|上饶',
'1527940':'江西|抚州',
'1527941':'江西|抚州',
'1527950':'江西|宜春',
'1527951':'江西|宜春',
'1527960':'江西|吉安',
'1527961':'江西|吉安',
'1527970':'江西|赣州',
'1527971':'江西|赣州',
'1527980':'江西|景德镇',
'1527981':'江西|景德镇',
'1527990':'江西|萍乡',
'1527991':'江西|萍乡',
'1528120':'四川|攀枝花',
'1528121':'四川|攀枝花',
'1528130':'四川|自贡',
'1528131':'四川|自贡',
'1528160':'四川|绵阳',
'1528161':'四川|绵阳',
'1528170':'四川|南充',
'1528171':'四川|南充',
'1528180':'四川|达州',
'1528181':'四川|达州',
'1528250':'四川|遂宁',
'1528251':'四川|遂宁',
'1528260':'四川|广安',
'1528261':'四川|广安',
'1528270':'四川|巴中',
'1528271':'四川|巴中',
'1528300':'重庆',
'1528301':'四川|泸州',
'1528310':'四川|宜宾',
'1528311':'四川|宜宾',
'1528320':'四川|内江',
'1528321':'四川|内江',
'1528330':'四川|乐山',
'1528331':'四川|乐山',
'1528350':'四川|雅安',
'1528351':'四川|雅安',
'1528380':'四川|德阳',
'1528381':'四川|德阳',
'1528390':'四川|广元',
'1528391':'四川|广元',
'1528400':'重庆',
'1528500':'重庆',
'1528510':'贵州|贵阳',
'1528511':'贵州|贵阳',
'1528512':'贵州|贵阳',
'1528520':'贵州|遵义',
'1528521':'贵州|遵义',
'1528530':'贵州|安顺',
'1528531':'贵州|安顺',
'1528560':'贵州|铜仁',
'1528561':'贵州|铜仁',
'1528570':'贵州|毕节',
'1528571':'贵州|毕节',
'1528580':'贵州|六盘水',
'1528581':'贵州|六盘水',
'1528700':'云南|昭通',
'1528701':'云南|昭通',
'1528710':'云南|昆明',
'1528711':'云南|昆明',
'1528712':'云南|昆明',
'1528713':'云南|昆明',
'1528720':'云南|大理',
'1528721':'云南|大理',
'1528740':'云南|曲靖',
'1528741':'云南|曲靖',
'1528750':'云南|保山',
'1528751':'云南|保山',
'1528770':'云南|玉溪',
'1528771':'云南|玉溪',
'1528790':'云南|普洱',
'1528791':'云南|普洱',
'1528880':'云南|丽江',
'1528881':'云南|丽江',
'1528910':'西藏|拉萨',
'1528911':'西藏|拉萨',
'1528920':'西藏|日喀则',
'1528921':'西藏|日喀则',
'1528980':'海南|海口',
'1528981':'海南|海口',
'1528982':'海南|海口',
'1528990':'海南|三亚',
'1528991':'海南|三亚',
'1529110':'陕西|延安',
'1529111':'陕西|延安',
'1529120':'陕西|榆林',
'1529121':'陕西|榆林',
'1529130':'陕西|渭南',
'1529131':'陕西|渭南',
'1529140':'陕西|商洛',
'1529141':'陕西|商洛',
'1529150':'陕西|安康',
'1529151':'陕西|安康',
'1529160':'陕西|汉中',
'1529161':'陕西|汉中',
'1529170':'陕西|宝鸡',
'1529171':'陕西|宝鸡',
'1529190':'陕西|铜川',
'1529191':'陕西|铜川',
'1529310':'甘肃|兰州',
'1529311':'甘肃|兰州',
'1529312':'甘肃|兰州',
'1529370':'甘肃|酒泉',
'1529371':'甘肃|酒泉',
'1529380':'甘肃|天水',
'1529381':'甘肃|天水',
'1529430':'甘肃|白银',
'1529431':'甘肃|白银',
'1529510':'宁夏|银川',
'1529511':'宁夏|银川',
'1529710':'青海|西宁',
'1529711':'青海|西宁',
'1529910':'新疆|乌鲁木齐',
'1529911':'新疆|乌鲁木齐',
'1529912':'新疆|乌鲁木齐',
'1531000':'北京',
'1531100':'北京',
'1531200':'北京',
'1531300':'北京',
'1531400':'北京',
'1531500':'北京',
'1531600':'北京',
'1531700':'北京',
'1531800':'北京',
'1531900':'北京',
'1532000':'广东|广州',
'1532001':'广东|广州',
'1532002':'广东|广州',
'1532003':'广东|广州',
'1532100':'上海',
'1532200':'上海',
'1532300':'上海',
'1532410':'辽宁|沈阳',
'1532411':'辽宁|沈阳',
'1532412':'辽宁|沈阳',
'1532413':'辽宁|沈阳',
'1532500':'江苏|南京',
'1532501':'江苏|南京',
'1532502':'江苏|南京',
'1532503':'江苏|南京',
'1532710':'湖北|武汉',
'1532711':'湖北|武汉',
'1532712':'湖北|武汉',
'1532713':'湖北|武汉',
'1532800':'四川|成都',
'1532801':'四川|成都',
'1532802':'四川|成都',
'1532803':'四川|成都',
'1532900':'陕西|咸阳',
'1532901':'陕西|咸阳',
'1532910':'陕西|西安',
'1532911':'陕西|西安',
'1532912':'陕西|西安',
'1532913':'陕西|西安',
'1533100':'河北|邯郸',
'1533101':'河北|邯郸',
'1533102':'河北|邯郸',
'1533110':'河北|石家庄',
'1533111':'河北|石家庄',
'1533112':'河北|石家庄',
'1533113':'河北|石家庄',
'1533120':'河北|保定',
'1533121':'河北|保定',
'1533122':'河北|保定',
'1533130':'河北|张家口',
'1533131':'河北|张家口',
'1533140':'河北|承德',
'1533141':'河北|承德',
'1533150':'河北|唐山',
'1533151':'河北|唐山',
'1533152':'河北|唐山',
'1533153':'河北|唐山',
'1533160':'河北|廊坊',
'1533161':'河北|廊坊',
'1533170':'河北|沧州',
'1533171':'河北|沧州',
'1533180':'河北|衡水',
'1533181':'河北|衡水',
'1533190':'河北|邢台',
'1533191':'河北|邢台',
'1533350':'河北|秦皇岛',
'1533351':'河北|秦皇岛',
'1533500':'山西|忻州',
'1533501':'山西|忻州',
'1533510':'山西|太原',
'1533511':'山西|太原',
'1533512':'山西|太原',
'1533513':'山西|太原',
'1533520':'山西|大同',
'1533521':'山西|大同',
'1533530':'山西|阳泉',
'1533531':'山西|阳泉',
'1533540':'山西|晋中',
'1533541':'山西|晋中',
'1533550':'山西|长治',
'1533551':'山西|长治',
'1533560':'山西|晋城',
'1533561':'山西|晋城',
'1533570':'山西|临汾',
'1533571':'山西|临汾',
'1533580':'山西|吕梁',
'1533581':'山西|吕梁',
'1533590':'山西|运城',
'1533591':'山西|运城',
'1533700':'河南|商丘',
'1533701':'河南|商丘',
'1533710':'河南|郑州',
'1533711':'河南|郑州',
'1533712':'河南|郑州',
'1533713':'河南|郑州',
'1533720':'河南|安阳',
'1533721':'河南|安阳',
'1533730':'河南|新乡',
'1533731':'河南|新乡',
'1533740':'河南|许昌',
'1533741':'河南|许昌',
'1533750':'河南|平顶山',
'1533751':'河南|平顶山',
'1533760':'河南|信阳',
'1533761':'河南|信阳',
'1533770':'河南|南阳',
'1533771':'河南|南阳',
'1533780':'河南|开封',
'1533781':'河南|开封',
'1533790':'河南|洛阳',
'1533791':'河南|洛阳',
'1533792':'河南|洛阳',
'1533910':'河南|焦作',
'1533911':'河南|焦作',
'1533920':'河南|鹤壁',
'1533921':'河南|鹤壁',
'1533930':'河南|濮阳',
'1533931':'河南|濮阳',
'1533940':'河南|周口',
'1533941':'河南|周口',
'1533950':'河南|漯河',
'1533951':'河南|漯河',
'1533960':'河南|驻马店',
'1533961':'河南|驻马店',
'1533980':'河南|三门峡',
'1533981':'河南|三门峡',
'1534100':'辽宁|铁岭',
'1534101':'辽宁|铁岭',
'1534110':'辽宁|大连',
'1534111':'辽宁|大连',
'1534112':'辽宁|大连',
'1534113':'辽宁|大连',
'1534120':'辽宁|鞍山',
'1534121':'辽宁|鞍山',
'1534130':'辽宁|抚顺',
'1534131':'辽宁|抚顺',
'1534140':'辽宁|本溪',
'1534141':'辽宁|本溪',
'1534150':'辽宁|丹东',
'1534151':'辽宁|丹东',
'1534160':'辽宁|锦州',
'1534161':'辽宁|锦州',
'1534170':'辽宁|营口',
'1534171':'辽宁|营口',
'1534180':'辽宁|阜新',
'1534181':'辽宁|阜新',
'1534190':'辽宁|辽阳',
'1534191':'辽宁|辽阳',
'1534210':'辽宁|朝阳',
'1534211':'辽宁|朝阳',
'1534270':'辽宁|盘锦',
'1534271':'辽宁|盘锦',
'1534290':'辽宁|葫芦岛',
'1534291':'辽宁|葫芦岛',
'1534310':'吉林|长春',
'1534311':'吉林|长春',
'1534312':'吉林|长春',
'1534313':'吉林|长春',
'1534320':'吉林|吉林市',
'1534321':'吉林|吉林市',
'1534340':'吉林|四平',
'1534341':'吉林|四平',
'1534350':'吉林|通化',
'1534351':'吉林|通化',
'1534360':'吉林|白城',
'1534361':'吉林|白城',
'1534370':'吉林|辽源',
'1534371':'吉林|辽源',
'1534380':'吉林|松原',
'1534381':'吉林|松原',
'1534390':'吉林|白山',
'1534391':'吉林|白山',
'1534510':'黑龙江|哈尔滨',
'1534511':'黑龙江|哈尔滨',
'1534512':'黑龙江|哈尔滨',
'1534513':'黑龙江|哈尔滨',
'1534520':'黑龙江|齐齐哈尔',
'1534521':'黑龙江|齐齐哈尔',
'1534530':'黑龙江|牡丹江',
'1534531':'黑龙江|牡丹江',
'1534540':'黑龙江|佳木斯',
'1534541':'黑龙江|佳木斯',
'1534550':'黑龙江|绥化',
'1534551':'黑龙江|绥化',
'1534580':'黑龙江|伊春',
'1534581':'黑龙江|伊春',
'1534590':'黑龙江|大庆',
'1534591':'黑龙江|大庆',
'1534670':'黑龙江|鸡西',
'1534671':'黑龙江|鸡西',
'1534710':'内蒙古|呼和浩特',
'1534711':'内蒙古|呼和浩特',
'1534712':'内蒙古|呼和浩特',
'1534720':'内蒙古|包头',
'1534721':'内蒙古|包头',
'1534730':'内蒙古|乌海',
'1534750':'内蒙古|通辽',
'1534751':'内蒙古|通辽',
'1534760':'内蒙古|赤峰',
'1534761':'内蒙古|赤峰',
'1534770':'内蒙古|鄂尔多斯',
'1534771':'内蒙古|鄂尔多斯',
'1535100':'江苏|无锡',
'1535101':'江苏|无锡',
'1535102':'江苏|无锡',
'1535110':'江苏|镇江',
'1535111':'江苏|镇江',
'1535120':'江苏|苏州',
'1535121':'江苏|苏州',
'1535122':'江苏|苏州',
'1535123':'江苏|苏州',
'1535130':'江苏|南通',
'1535131':'江苏|南通',
'1535132':'江苏|南通',
'1535140':'江苏|扬州',
'1535141':'江苏|扬州',
'1535150':'江苏|盐城',
'1535151':'江苏|盐城',
'1535160':'江苏|徐州',
'1535161':'江苏|徐州',
'1535162':'江苏|徐州',
'1535170':'江苏|淮安',
'1535171':'江苏|淮安',
'1535180':'江苏|连云港',
'1535181':'江苏|连云港',
'1535190':'江苏|常州',
'1535191':'江苏|常州',
'1535192':'江苏|常州',
'1535230':'江苏|泰州',
'1535231':'江苏|泰州',
'1535270':'江苏|宿迁',
'1535271':'江苏|宿迁',
'1535300':'山东|菏泽',
'1535301':'山东|菏泽',
'1535310':'山东|济南',
'1535311':'山东|济南',
'1535312':'山东|济南',
'1535313':'山东|济南',
'1535320':'山东|青岛',
'1535321':'山东|青岛',
'1535322':'山东|青岛',
'1535323':'山东|青岛',
'1535330':'山东|淄博',
'1535331':'山东|淄博',
'1535340':'山东|德州',
'1535341':'山东|德州',
'1535350':'山东|烟台',
'1535351':'山东|烟台',
'1535352':'山东|烟台',
'1535360':'山东|潍坊',
'1535361':'山东|潍坊',
'1535362':'山东|潍坊',
'1535370':'山东|济宁',
'1535371':'山东|济宁',
'1535380':'山东|泰安',
'1535381':'山东|泰安',
'1535390':'山东|临沂',
'1535391':'山东|临沂',
'1535430':'山东|滨州',
'1535431':'山东|滨州',
'1535460':'山东|东营',
'1535461':'山东|东营',
'1535500':'安徽|滁州',
'1535501':'安徽|滁州',
'1535510':'安徽|合肥',
'1535511':'安徽|合肥',
'1535512':'安徽|合肥',
'1535513':'安徽|合肥',
'1535514':'安徽|合肥',
'1535520':'安徽|蚌埠',
'1535521':'安徽|蚌埠',
'1535530':'安徽|芜湖',
'1535531':'安徽|芜湖',
'1535532':'安徽|芜湖',
'1535540':'安徽|淮南',
'1535541':'安徽|淮南',
'1535550':'安徽|马鞍山',
'1535551':'安徽|马鞍山',
'1535560':'安徽|安庆',
'1535561':'安徽|安庆',
'1535570':'安徽|宿州',
'1535571':'安徽|宿州',
'1535580':'安徽|阜阳',
'1535581':'安徽|阜阳',
'1535590':'安徽|黄山',
'1535591':'安徽|黄山',
'1535600':'安徽|合肥',
'1535601':'安徽|合肥',
'1535602':'安徽|合肥',
'1535603':'安徽|合肥',
'1535604':'安徽|合肥',
'1535610':'安徽|淮北',
'1535611':'安徽|淮北',
'1535620':'安徽|铜陵',
'1535621':'安徽|铜陵',
'1535630':'安徽|宣城',
'1535631':'安徽|宣城',
'1535640':'安徽|六安',
'1535641':'安徽|六安',
'1535660':'安徽|池州',
'1535661':'安徽|池州',
'1535700':'浙江|衢州',
'1535701':'浙江|衢州',
'1535710':'浙江|杭州',
'1535711':'浙江|杭州',
'1535712':'浙江|杭州',
'1535713':'浙江|杭州',
'1535720':'浙江|湖州',
'1535721':'浙江|湖州',
'1535730':'浙江|嘉兴',
'1535731':'浙江|嘉兴',
'1535740':'浙江|宁波',
'1535741':'浙江|宁波',
'1535742':'浙江|宁波',
'1535750':'浙江|绍兴',
'1535751':'浙江|绍兴',
'1535760':'浙江|台州',
'1535761':'浙江|台州',
'1535770':'浙江|温州',
'1535771':'浙江|温州',
'1535772':'浙江|温州',
'1535780':'浙江|丽水',
'1535781':'浙江|丽水',
'1535790':'浙江|金华',
'1535791':'浙江|金华',
'1535800':'浙江|舟山',
'1535801':'浙江|舟山',
'1535910':'福建|福州',
'1535911':'福建|福州',
'1535912':'福建|福州',
'1535913':'福建|福州',
'1535920':'福建|厦门',
'1535921':'福建|厦门',
'1535922':'福建|厦门',
'1535930':'福建|宁德',
'1535931':'福建|宁德',
'1535940':'福建|莆田',
'1535941':'福建|莆田',
'1535950':'福建|泉州',
'1535951':'福建|泉州',
'1535952':'福建|泉州',
'1535960':'福建|漳州',
'1535961':'福建|漳州',
'1535970':'福建|龙岩',
'1535971':'福建|龙岩',
'1535980':'福建|三明',
'1535981':'福建|三明',
'1535990':'福建|南平',
'1535991':'福建|南平',
'1536310':'山东|威海',
'1536311':'山东|威海',
'1536320':'山东|枣庄',
'1536321':'山东|枣庄',
'1536330':'山东|日照',
'1536331':'山东|日照',
'1536350':'山东|聊城',
'1536351':'山东|聊城',
'1536600':'广东|汕尾',
'1536601':'广东|汕尾',
'1536620':'广东|阳江',
'1536621':'广东|阳江',
'1536630':'广东|揭阳',
'1536631':'广东|揭阳',
'1536680':'广东|茂名',
'1536681':'广东|茂名',
'1537010':'江西|鹰潭',
'1537011':'江西|鹰潭',
'1537100':'湖北|襄阳',
'1537101':'湖北|襄阳',
'1537110':'湖北|鄂州',
'1537111':'湖北|鄂州',
'1537120':'湖北|孝感',
'1537121':'湖北|孝感',
'1537130':'湖北|黄冈',
'1537131':'湖北|黄冈',
'1537140':'湖北|黄石',
'1537141':'湖北|黄石',
'1537150':'湖北|咸宁',
'1537151':'湖北|咸宁',
'1537160':'湖北|荆州',
'1537161':'湖北|荆州',
'1537170':'湖北|宜昌',
'1537171':'湖北|宜昌',
'1537180':'湖北|恩施',
'1537181':'湖北|恩施',
'1537190':'湖北|十堰',
'1537191':'湖北|十堰',
'1537220':'湖北|随州',
'1537221':'湖北|随州',
'1537240':'湖北|荆门',
'1537241':'湖北|荆门',
'1537300':'湖南|岳阳',
'1537301':'湖南|岳阳',
'1537310':'湖南|长沙',
'1537311':'湖南|长沙',
'1537312':'湖南|长沙',
'1537313':'湖南|长沙',
'1537320':'湖南|湘潭',
'1537321':'湖南|湘潭',
'1537330':'湖南|株洲',
'1537331':'湖南|株洲',
'1537340':'湖南|衡阳',
'1537341':'湖南|衡阳',
'1537350':'湖南|郴州',
'1537351':'湖南|郴州',
'1537360':'湖南|常德',
'1537361':'湖南|常德',
'1537370':'湖南|益阳',
'1537371':'湖南|益阳',
'1537380':'湖南|娄底',
'1537381':'湖南|娄底',
'1537390':'湖南|邵阳',
'1537391':'湖南|邵阳',
'1537440':'湖南|张家界',
'1537441':'湖南|张家界',
'1537450':'湖南|怀化',
'1537451':'湖南|怀化',
'1537460':'湖南|永州',
'1537461':'湖南|永州',
'1537500':'广东|江门',
'1537501':'广东|江门',
'1537510':'广东|韶关',
'1537511':'广东|韶关',
'1537520':'广东|惠州',
'1537521':'广东|惠州',
'1537530':'广东|梅州',
'1537531':'广东|梅州',
'1537540':'广东|汕头',
'1537541':'广东|汕头',
'1537550':'广东|深圳',
'1537551':'广东|深圳',
'1537552':'广东|深圳',
'1537553':'广东|深圳',
'1537560':'广东|珠海',
'1537561':'广东|珠海',
'1537570':'广东|佛山',
'1537571':'广东|佛山',
'1537572':'广东|佛山',
'1537580':'广东|肇庆',
'1537581':'广东|肇庆',
'1537590':'广东|湛江',
'1537591':'广东|湛江',
'1537600':'广东|中山',
'1537601':'广东|中山',
'1537620':'广东|河源',
'1537621':'广东|河源',
'1537630':'广东|清远',
'1537631':'广东|清远',
'1537660':'广东|云浮',
'1537661':'广东|云浮',
'1537680':'广东|潮州',
'1537681':'广东|潮州',
'1537690':'广东|东莞',
'1537691':'广东|东莞',
'1537692':'广东|东莞',
'1537700':'广西|防城港',
'1537701':'广西|防城港',
'1537710':'广西|南宁',
'1537711':'广西|南宁',
'1537712':'广西|南宁',
'1537720':'广西|柳州',
'1537721':'广西|柳州',
'1537730':'广西|桂林',
'1537731':'广西|桂林',
'1537740':'广西|梧州',
'1537741':'广西|梧州',
'1537750':'广西|贵港',
'1537751':'广西|贵港',
'1537760':'广西|百色',
'1537761':'广西|百色',
'1537770':'广西|钦州',
'1537771':'广西|钦州',
'1537780':'广西|河池',
'1537781':'广西|河池',
'1537790':'广西|北海',
'1537791':'广西|北海',
'1537900':'江西|新余',
'1537901':'江西|新余',
'1537910':'江西|南昌',
'1537911':'江西|南昌',
'1537912':'江西|南昌',
'1537913':'江西|南昌',
'1537920':'江西|九江',
'1537921':'江西|九江',
'1537930':'江西|上饶',
'1537931':'江西|上饶',
'1537940':'江西|抚州',
'1537941':'江西|抚州',
'1537950':'江西|宜春',
'1537951':'江西|宜春',
'1537960':'江西|吉安',
'1537961':'江西|吉安',
'1537970':'江西|赣州',
'1537971':'江西|赣州',
'1537980':'江西|景德镇',
'1537981':'江西|景德镇',
'1537990':'江西|萍乡',
'1537991':'江西|萍乡',
'1538120':'四川|攀枝花',
'1538121':'四川|攀枝花',
'1538130':'四川|自贡',
'1538131':'四川|自贡',
'1538160':'四川|绵阳',
'1538161':'四川|绵阳',
'1538170':'四川|南充',
'1538171':'四川|南充',
'1538180':'四川|达州',
'1538181':'四川|达州',
'1538250':'四川|遂宁',
'1538251':'四川|遂宁',
'1538260':'四川|广安',
'1538261':'四川|广安',
'1538270':'四川|巴中',
'1538271':'四川|巴中',
'1538300':'重庆',
'1538301':'四川|泸州',
'1538310':'四川|宜宾',
'1538311':'四川|宜宾',
'1538320':'四川|内江',
'1538321':'四川|内江',
'1538330':'四川|乐山',
'1538331':'四川|乐山',
'1538350':'四川|雅安',
'1538351':'四川|雅安',
'1538380':'四川|德阳',
'1538381':'四川|德阳',
'1538390':'四川|广元',
'1538391':'四川|广元',
'1538400':'重庆',
'1538500':'重庆',
'1538510':'贵州|贵阳',
'1538511':'贵州|贵阳',
'1538512':'贵州|贵阳',
'1538520':'贵州|遵义',
'1538521':'贵州|遵义',
'1538530':'贵州|安顺',
'1538531':'贵州|安顺',
'1538560':'贵州|铜仁',
'1538561':'贵州|铜仁',
'1538570':'贵州|毕节',
'1538571':'贵州|毕节',
'1538580':'贵州|六盘水',
'1538581':'贵州|六盘水',
'1538700':'云南|昭通',
'1538701':'云南|昭通',
'1538710':'云南|昆明',
'1538711':'云南|昆明',
'1538712':'云南|昆明',
'1538713':'云南|昆明',
'1538720':'云南|大理',
'1538721':'云南|大理',
'1538740':'云南|曲靖',
'1538741':'云南|曲靖',
'1538750':'云南|保山',
'1538751':'云南|保山',
'1538770':'云南|玉溪',
'1538771':'云南|玉溪',
'1538790':'云南|普洱',
'1538791':'云南|普洱',
'1538880':'云南|丽江',
'1538881':'云南|丽江',
'1538910':'西藏|拉萨',
'1538911':'西藏|拉萨',
'1538920':'西藏|日喀则',
'1538921':'西藏|日喀则',
'1538980':'海南|海口',
'1538981':'海南|海口',
'1538982':'海南|海口',
'1538990':'海南|三亚',
'1538991':'海南|三亚',
'1539110':'陕西|延安',
'1539111':'陕西|延安',
'1539120':'陕西|榆林',
'1539121':'陕西|榆林',
'1539130':'陕西|渭南',
'1539131':'陕西|渭南',
'1539140':'陕西|商洛',
'1539141':'陕西|商洛',
'1539150':'陕西|安康',
'1539151':'陕西|安康',
'1539160':'陕西|汉中',
'1539161':'陕西|汉中',
'1539170':'陕西|宝鸡',
'1539171':'陕西|宝鸡',
'1539190':'陕西|铜川',
'1539191':'陕西|铜川',
'1539310':'甘肃|兰州',
'1539311':'甘肃|兰州',
'1539312':'甘肃|兰州',
'1539370':'甘肃|酒泉',
'1539371':'甘肃|酒泉',
'1539380':'甘肃|天水',
'1539381':'甘肃|天水',
'1539430':'甘肃|白银',
'1539431':'甘肃|白银',
'1539510':'宁夏|银川',
'1539511':'宁夏|银川',
'1539710':'青海|西宁',
'1539711':'青海|西宁',
'1539910':'新疆|乌鲁木齐',
'1539911':'新疆|乌鲁木齐',
'1539912':'新疆|乌鲁木齐',
'1551000':'北京',
'1551100':'北京',
'1551200':'北京',
'1551300':'北京',
'1551400':'北京',
'1551500':'北京',
'1551600':'北京',
'1551700':'北京',
'1551800':'北京',
'1551900':'北京',
'1552000':'广东|广州',
'1552001':'广东|广州',
'1552002':'广东|广州',
'1552003':'广东|广州',
'1552100':'上海',
'1552200':'上海',
'1552300':'上海',
'1552410':'辽宁|沈阳',
'1552411':'辽宁|沈阳',
'1552412':'辽宁|沈阳',
'1552413':'辽宁|沈阳',
'1552500':'江苏|南京',
'1552501':'江苏|南京',
'1552502':'江苏|南京',
'1552503':'江苏|南京',
'1552710':'湖北|武汉',
'1552711':'湖北|武汉',
'1552712':'湖北|武汉',
'1552713':'湖北|武汉',
'1552800':'四川|成都',
'1552801':'四川|成都',
'1552802':'四川|成都',
'1552803':'四川|成都',
'1552900':'陕西|咸阳',
'1552901':'陕西|咸阳',
'1552910':'陕西|西安',
'1552911':'陕西|西安',
'1552912':'陕西|西安',
'1552913':'陕西|西安',
'1553100':'河北|邯郸',
'1553101':'河北|邯郸',
'1553102':'河北|邯郸',
'1553110':'河北|石家庄',
'1553111':'河北|石家庄',
'1553112':'河北|石家庄',
'1553113':'河北|石家庄',
'1553120':'河北|保定',
'1553121':'河北|保定',
'1553122':'河北|保定',
'1553130':'河北|张家口',
'1553131':'河北|张家口',
'1553140':'河北|承德',
'1553141':'河北|承德',
'1553150':'河北|唐山',
'1553151':'河北|唐山',
'1553152':'河北|唐山',
'1553153':'河北|唐山',
'1553160':'河北|廊坊',
'1553161':'河北|廊坊',
'1553170':'河北|沧州',
'1553171':'河北|沧州',
'1553180':'河北|衡水',
'1553181':'河北|衡水',
'1553190':'河北|邢台',
'1553191':'河北|邢台',
'1553350':'河北|秦皇岛',
'1553351':'河北|秦皇岛',
'1553500':'山西|忻州',
'1553501':'山西|忻州',
'1553510':'山西|太原',
'1553511':'山西|太原',
'1553512':'山西|太原',
'1553513':'山西|太原',
'1553520':'山西|大同',
'1553521':'山西|大同',
'1553530':'山西|阳泉',
'1553531':'山西|阳泉',
'1553540':'山西|晋中',
'1553541':'山西|晋中',
'1553550':'山西|长治',
'1553551':'山西|长治',
'1553560':'山西|晋城',
'1553561':'山西|晋城',
'1553570':'山西|临汾',
'1553571':'山西|临汾',
'1553580':'山西|吕梁',
'1553581':'山西|吕梁',
'1553590':'山西|运城',
'1553591':'山西|运城',
'1553700':'河南|商丘',
'1553701':'河南|商丘',
'1553710':'河南|郑州',
'1553711':'河南|郑州',
'1553712':'河南|郑州',
'1553713':'河南|郑州',
'1553720':'河南|安阳',
'1553721':'河南|安阳',
'1553730':'河南|新乡',
'1553731':'河南|新乡',
'1553740':'河南|许昌',
'1553741':'河南|许昌',
'1553750':'河南|平顶山',
'1553751':'河南|平顶山',
'1553760':'河南|信阳',
'1553761':'河南|信阳',
'1553770':'河南|南阳',
'1553771':'河南|南阳',
'1553780':'河南|开封',
'1553781':'河南|开封',
'1553790':'河南|洛阳',
'1553791':'河南|洛阳',
'1553792':'河南|洛阳',
'1553910':'河南|焦作',
'1553911':'河南|焦作',
'1553920':'河南|鹤壁',
'1553921':'河南|鹤壁',
'1553930':'河南|濮阳',
'1553931':'河南|濮阳',
'1553940':'河南|周口',
'1553941':'河南|周口',
'1553950':'河南|漯河',
'1553951':'河南|漯河',
'1553960':'河南|驻马店',
'1553961':'河南|驻马店',
'1553980':'河南|三门峡',
'1553981':'河南|三门峡',
'1554100':'辽宁|铁岭',
'1554101':'辽宁|铁岭',
'1554110':'辽宁|大连',
'1554111':'辽宁|大连',
'1554112':'辽宁|大连',
'1554113':'辽宁|大连',
'1554120':'辽宁|鞍山',
'1554121':'辽宁|鞍山',
'1554130':'辽宁|抚顺',
'1554131':'辽宁|抚顺',
'1554140':'辽宁|本溪',
'1554141':'辽宁|本溪',
'1554150':'辽宁|丹东',
'1554151':'辽宁|丹东',
'1554160':'辽宁|锦州',
'1554161':'辽宁|锦州',
'1554170':'辽宁|营口',
'1554171':'辽宁|营口',
'1554180':'辽宁|阜新',
'1554181':'辽宁|阜新',
'1554190':'辽宁|辽阳',
'1554191':'辽宁|辽阳',
'1554210':'辽宁|朝阳',
'1554211':'辽宁|朝阳',
'1554270':'辽宁|盘锦',
'1554271':'辽宁|盘锦',
'1554290':'辽宁|葫芦岛',
'1554291':'辽宁|葫芦岛',
'1554310':'吉林|长春',
'1554311':'吉林|长春',
'1554312':'吉林|长春',
'1554313':'吉林|长春',
'1554320':'吉林|吉林市',
'1554321':'吉林|吉林市',
'1554340':'吉林|四平',
'1554341':'吉林|四平',
'1554350':'吉林|通化',
'1554351':'吉林|通化',
'1554360':'吉林|白城',
'1554361':'吉林|白城',
'1554370':'吉林|辽源',
'1554371':'吉林|辽源',
'1554380':'吉林|松原',
'1554381':'吉林|松原',
'1554390':'吉林|白山',
'1554391':'吉林|白山',
'1554510':'黑龙江|哈尔滨',
'1554511':'黑龙江|哈尔滨',
'1554512':'黑龙江|哈尔滨',
'1554513':'黑龙江|哈尔滨',
'1554520':'黑龙江|齐齐哈尔',
'1554521':'黑龙江|齐齐哈尔',
'1554530':'黑龙江|牡丹江',
'1554531':'黑龙江|牡丹江',
'1554540':'黑龙江|佳木斯',
'1554541':'黑龙江|佳木斯',
'1554550':'黑龙江|绥化',
'1554551':'黑龙江|绥化',
'1554580':'黑龙江|伊春',
'1554581':'黑龙江|伊春',
'1554590':'黑龙江|大庆',
'1554591':'黑龙江|大庆',
'1554670':'黑龙江|鸡西',
'1554671':'黑龙江|鸡西',
'1554710':'内蒙古|呼和浩特',
'1554711':'内蒙古|呼和浩特',
'1554712':'内蒙古|呼和浩特',
'1554720':'内蒙古|包头',
'1554721':'内蒙古|包头',
'1554730':'内蒙古|乌海',
'1554750':'内蒙古|通辽',
'1554751':'内蒙古|通辽',
'1554760':'内蒙古|赤峰',
'1554761':'内蒙古|赤峰',
'1554770':'内蒙古|鄂尔多斯',
'1554771':'内蒙古|鄂尔多斯',
'1555100':'江苏|无锡',
'1555101':'江苏|无锡',
'1555102':'江苏|无锡',
'1555110':'江苏|镇江',
'1555111':'江苏|镇江',
'1555120':'江苏|苏州',
'1555121':'江苏|苏州',
'1555122':'江苏|苏州',
'1555123':'江苏|苏州',
'1555130':'江苏|南通',
'1555131':'江苏|南通',
'1555132':'江苏|南通',
'1555140':'江苏|扬州',
'1555141':'江苏|扬州',
'1555150':'江苏|盐城',
'1555151':'江苏|盐城',
'1555160':'江苏|徐州',
'1555161':'江苏|徐州',
'1555162':'江苏|徐州',
'1555170':'江苏|淮安',
'1555171':'江苏|淮安',
'1555180':'江苏|连云港',
'1555181':'江苏|连云港',
'1555190':'江苏|常州',
'1555191':'江苏|常州',
'1555192':'江苏|常州',
'1555230':'江苏|泰州',
'1555231':'江苏|泰州',
'1555270':'江苏|宿迁',
'1555271':'江苏|宿迁',
'1555300':'山东|菏泽',
'1555301':'山东|菏泽',
'1555310':'山东|济南',
'1555311':'山东|济南',
'1555312':'山东|济南',
'1555313':'山东|济南',
'1555320':'山东|青岛',
'1555321':'山东|青岛',
'1555322':'山东|青岛',
'1555323':'山东|青岛',
'1555330':'山东|淄博',
'1555331':'山东|淄博',
'1555340':'山东|德州',
'1555341':'山东|德州',
'1555350':'山东|烟台',
'1555351':'山东|烟台',
'1555352':'山东|烟台',
'1555360':'山东|潍坊',
'1555361':'山东|潍坊',
'1555362':'山东|潍坊',
'1555370':'山东|济宁',
'1555371':'山东|济宁',
'1555380':'山东|泰安',
'1555381':'山东|泰安',
'1555390':'山东|临沂',
'1555391':'山东|临沂',
'1555430':'山东|滨州',
'1555431':'山东|滨州',
'1555460':'山东|东营',
'1555461':'山东|东营',
'1555500':'安徽|滁州',
'1555501':'安徽|滁州',
'1555510':'安徽|合肥',
'1555511':'安徽|合肥',
'1555512':'安徽|合肥',
'1555513':'安徽|合肥',
'1555514':'安徽|合肥',
'1555520':'安徽|蚌埠',
'1555521':'安徽|蚌埠',
'1555530':'安徽|芜湖',
'1555531':'安徽|芜湖',
'1555532':'安徽|芜湖',
'1555540':'安徽|淮南',
'1555541':'安徽|淮南',
'1555550':'安徽|马鞍山',
'1555551':'安徽|马鞍山',
'1555560':'安徽|安庆',
'1555561':'安徽|安庆',
'1555570':'安徽|宿州',
'1555571':'安徽|宿州',
'1555580':'安徽|阜阳',
'1555581':'安徽|阜阳',
'1555590':'安徽|黄山',
'1555591':'安徽|黄山',
'1555600':'安徽|合肥',
'1555601':'安徽|合肥',
'1555602':'安徽|合肥',
'1555603':'安徽|合肥',
'1555604':'安徽|合肥',
'1555610':'安徽|淮北',
'1555611':'安徽|淮北',
'1555620':'安徽|铜陵',
'1555621':'安徽|铜陵',
'1555630':'安徽|宣城',
'1555631':'安徽|宣城',
'1555640':'安徽|六安',
'1555641':'安徽|六安',
'1555660':'安徽|池州',
'1555661':'安徽|池州',
'1555700':'浙江|衢州',
'1555701':'浙江|衢州',
'1555710':'浙江|杭州',
'1555711':'浙江|杭州',
'1555712':'浙江|杭州',
'1555713':'浙江|杭州',
'1555720':'浙江|湖州',
'1555721':'浙江|湖州',
'1555730':'浙江|嘉兴',
'1555731':'浙江|嘉兴',
'1555740':'浙江|宁波',
'1555741':'浙江|宁波',
'1555742':'浙江|宁波',
'1555750':'浙江|绍兴',
'1555751':'浙江|绍兴',
'1555760':'浙江|台州',
'1555761':'浙江|台州',
'1555770':'浙江|温州',
'1555771':'浙江|温州',
'1555772':'浙江|温州',
'1555780':'浙江|丽水',
'1555781':'浙江|丽水',
'1555790':'浙江|金华',
'1555791':'浙江|金华',
'1555800':'浙江|舟山',
'1555801':'浙江|舟山',
'1555910':'福建|福州',
'1555911':'福建|福州',
'1555912':'福建|福州',
'1555913':'福建|福州',
'1555920':'福建|厦门',
'1555921':'福建|厦门',
'1555922':'福建|厦门',
'1555930':'福建|宁德',
'1555931':'福建|宁德',
'1555940':'福建|莆田',
'1555941':'福建|莆田',
'1555950':'福建|泉州',
'1555951':'福建|泉州',
'1555952':'福建|泉州',
'1555960':'福建|漳州',
'1555961':'福建|漳州',
'1555970':'福建|龙岩',
'1555971':'福建|龙岩',
'1555980':'福建|三明',
'1555981':'福建|三明',
'1555990':'福建|南平',
'1555991':'福建|南平',
'1556310':'山东|威海',
'1556311':'山东|威海',
'1556320':'山东|枣庄',
'1556321':'山东|枣庄',
'1556330':'山东|日照',
'1556331':'山东|日照',
'1556350':'山东|聊城',
'1556351':'山东|聊城',
'1556600':'广东|汕尾',
'1556601':'广东|汕尾',
'1556620':'广东|阳江',
'1556621':'广东|阳江',
'1556630':'广东|揭阳',
'1556631':'广东|揭阳',
'1556680':'广东|茂名',
'1556681':'广东|茂名',
'1557010':'江西|鹰潭',
'1557011':'江西|鹰潭',
'1557100':'湖北|襄阳',
'1557101':'湖北|襄阳',
'1557110':'湖北|鄂州',
'1557111':'湖北|鄂州',
'1557120':'湖北|孝感',
'1557121':'湖北|孝感',
'1557130':'湖北|黄冈',
'1557131':'湖北|黄冈',
'1557140':'湖北|黄石',
'1557141':'湖北|黄石',
'1557150':'湖北|咸宁',
'1557151':'湖北|咸宁',
'1557160':'湖北|荆州',
'1557161':'湖北|荆州',
'1557170':'湖北|宜昌',
'1557171':'湖北|宜昌',
'1557180':'湖北|恩施',
'1557181':'湖北|恩施',
'1557190':'湖北|十堰',
'1557191':'湖北|十堰',
'1557220':'湖北|随州',
'1557221':'湖北|随州',
'1557240':'湖北|荆门',
'1557241':'湖北|荆门',
'1557300':'湖南|岳阳',
'1557301':'湖南|岳阳',
'1557310':'湖南|长沙',
'1557311':'湖南|长沙',
'1557312':'湖南|长沙',
'1557313':'湖南|长沙',
'1557320':'湖南|湘潭',
'1557321':'湖南|湘潭',
'1557330':'湖南|株洲',
'1557331':'湖南|株洲',
'1557340':'湖南|衡阳',
'1557341':'湖南|衡阳',
'1557350':'湖南|郴州',
'1557351':'湖南|郴州',
'1557360':'湖南|常德',
'1557361':'湖南|常德',
'1557370':'湖南|益阳',
'1557371':'湖南|益阳',
'1557380':'湖南|娄底',
'1557381':'湖南|娄底',
'1557390':'湖南|邵阳',
'1557391':'湖南|邵阳',
'1557440':'湖南|张家界',
'1557441':'湖南|张家界',
'1557450':'湖南|怀化',
'1557451':'湖南|怀化',
'1557460':'湖南|永州',
'1557461':'湖南|永州',
'1557500':'广东|江门',
'1557501':'广东|江门',
'1557510':'广东|韶关',
'1557511':'广东|韶关',
'1557520':'广东|惠州',
'1557521':'广东|惠州',
'1557530':'广东|梅州',
'1557531':'广东|梅州',
'1557540':'广东|汕头',
'1557541':'广东|汕头',
'1557550':'广东|深圳',
'1557551':'广东|深圳',
'1557552':'广东|深圳',
'1557553':'广东|深圳',
'1557560':'广东|珠海',
'1557561':'广东|珠海',
'1557570':'广东|佛山',
'1557571':'广东|佛山',
'1557572':'广东|佛山',
'1557580':'广东|肇庆',
'1557581':'广东|肇庆',
'1557590':'广东|湛江',
'1557591':'广东|湛江',
'1557600':'广东|中山',
'1557601':'广东|中山',
'1557620':'广东|河源',
'1557621':'广东|河源',
'1557630':'广东|清远',
'1557631':'广东|清远',
'1557660':'广东|云浮',
'1557661':'广东|云浮',
'1557680':'广东|潮州',
'1557681':'广东|潮州',
'1557690':'广东|东莞',
'1557691':'广东|东莞',
'1557692':'广东|东莞',
'1557700':'广西|防城港',
'1557701':'广西|防城港',
'1557710':'广西|南宁',
'1557711':'广西|南宁',
'1557712':'广西|南宁',
'1557720':'广西|柳州',
'1557721':'广西|柳州',
'1557730':'广西|桂林',
'1557731':'广西|桂林',
'1557740':'广西|梧州',
'1557741':'广西|梧州',
'1557750':'广西|贵港',
'1557751':'广西|贵港',
'1557760':'广西|百色',
'1557761':'广西|百色',
'1557770':'广西|钦州',
'1557771':'广西|钦州',
'1557780':'广西|河池',
'1557781':'广西|河池',
'1557790':'广西|北海',
'1557791':'广西|北海',
'1557900':'江西|新余',
'1557901':'江西|新余',
'1557910':'江西|南昌',
'1557911':'江西|南昌',
'1557912':'江西|南昌',
'1557913':'江西|南昌',
'1557920':'江西|九江',
'1557921':'江西|九江',
'1557930':'江西|上饶',
'1557931':'江西|上饶',
'1557940':'江西|抚州',
'1557941':'江西|抚州',
'1557950':'江西|宜春',
'1557951':'江西|宜春',
'1557960':'江西|吉安',
'1557961':'江西|吉安',
'1557970':'江西|赣州',
'1557971':'江西|赣州',
'1557980':'江西|景德镇',
'1557981':'江西|景德镇',
'1557990':'江西|萍乡',
'1557991':'江西|萍乡',
'1558120':'四川|攀枝花',
'1558121':'四川|攀枝花',
'1558130':'四川|自贡',
'1558131':'四川|自贡',
'1558160':'四川|绵阳',
'1558161':'四川|绵阳',
'1558170':'四川|南充',
'1558171':'四川|南充',
'1558180':'四川|达州',
'1558181':'四川|达州',
'1558250':'四川|遂宁',
'1558251':'四川|遂宁',
'1558260':'四川|广安',
'1558261':'四川|广安',
'1558270':'四川|巴中',
'1558271':'四川|巴中',
'1558300':'重庆',
'1558301':'四川|泸州',
'1558310':'四川|宜宾',
'1558311':'四川|宜宾',
'1558320':'四川|内江',
'1558321':'四川|内江',
'1558330':'四川|乐山',
'1558331':'四川|乐山',
'1558350':'四川|雅安',
'1558351':'四川|雅安',
'1558380':'四川|德阳',
'1558381':'四川|德阳',
'1558390':'四川|广元',
'1558391':'四川|广元',
'1558400':'重庆',
'1558500':'重庆',
'1558510':'贵州|贵阳',
'1558511':'贵州|贵阳',
'1558512':'贵州|贵阳',
'1558520':'贵州|遵义',
'1558521':'贵州|遵义',
'1558530':'贵州|安顺',
'1558531':'贵州|安顺',
'1558560':'贵州|铜仁',
'1558561':'贵州|铜仁',
'1558570':'贵州|毕节',
'1558571':'贵州|毕节',
'1558580':'贵州|六盘水',
'1558581':'贵州|六盘水',
'1558700':'云南|昭通',
'1558701':'云南|昭通',
'1558710':'云南|昆明',
'1558711':'云南|昆明',
'1558712':'云南|昆明',
'1558713':'云南|昆明',
'1558720':'云南|大理',
'1558721':'云南|大理',
'1558740':'云南|曲靖',
'1558741':'云南|曲靖',
'1558750':'云南|保山',
'1558751':'云南|保山',
'1558770':'云南|玉溪',
'1558771':'云南|玉溪',
'1558790':'云南|普洱',
'1558791':'云南|普洱',
'1558880':'云南|丽江',
'1558881':'云南|丽江',
'1558910':'西藏|拉萨',
'1558911':'西藏|拉萨',
'1558920':'西藏|日喀则',
'1558921':'西藏|日喀则',
'1558980':'海南|海口',
'1558981':'海南|海口',
'1558982':'海南|海口',
'1558990':'海南|三亚',
'1558991':'海南|三亚',
'1559110':'陕西|延安',
'1559111':'陕西|延安',
'1559120':'陕西|榆林',
'1559121':'陕西|榆林',
'1559130':'陕西|渭南',
'1559131':'陕西|渭南',
'1559140':'陕西|商洛',
'1559141':'陕西|商洛',
'1559150':'陕西|安康',
'1559151':'陕西|安康',
'1559160':'陕西|汉中',
'1559161':'陕西|汉中',
'1559170':'陕西|宝鸡',
'1559171':'陕西|宝鸡',
'1559190':'陕西|铜川',
'1559191':'陕西|铜川',
'1559310':'甘肃|兰州',
'1559311':'甘肃|兰州',
'1559312':'甘肃|兰州',
'1559370':'甘肃|酒泉',
'1559371':'甘肃|酒泉',
'1559380':'甘肃|天水',
'1559381':'甘肃|天水',
'1559430':'甘肃|白银',
'1559431':'甘肃|白银',
'1559510':'宁夏|银川',
'1559511':'宁夏|银川',
'1559710':'青海|西宁',
'1559711':'青海|西宁',
'1559910':'新疆|乌鲁木齐',
'1559911':'新疆|乌鲁木齐',
'1559912':'新疆|乌鲁木齐',
'1561000':'北京',
'1561100':'北京',
'1561200':'北京',
'1561300':'北京',
'1561400':'北京',
'1561500':'北京',
'1561600':'北京',
'1561700':'北京',
'1561800':'北京',
'1561900':'北京',
'1562000':'广东|广州',
'1562001':'广东|广州',
'1562002':'广东|广州',
'1562003':'广东|广州',
'1562100':'上海',
'1562200':'上海',
'1562300':'上海',
'1562410':'辽宁|沈阳',
'1562411':'辽宁|沈阳',
'1562412':'辽宁|沈阳',
'1562413':'辽宁|沈阳',
'1562500':'江苏|南京',
'1562501':'江苏|南京',
'1562502':'江苏|南京',
'1562503':'江苏|南京',
'1562710':'湖北|武汉',
'1562711':'湖北|武汉',
'1562712':'湖北|武汉',
'1562713':'湖北|武汉',
'1562800':'四川|成都',
'1562801':'四川|成都',
'1562802':'四川|成都',
'1562803':'四川|成都',
'1562900':'陕西|咸阳',
'1562901':'陕西|咸阳',
'1562910':'陕西|西安',
'1562911':'陕西|西安',
'1562912':'陕西|西安',
'1562913':'陕西|西安',
'1563100':'河北|邯郸',
'1563101':'河北|邯郸',
'1563102':'河北|邯郸',
'1563110':'河北|石家庄',
'1563111':'河北|石家庄',
'1563112':'河北|石家庄',
'1563113':'河北|石家庄',
'1563120':'河北|保定',
'1563121':'河北|保定',
'1563122':'河北|保定',
'1563130':'河北|张家口',
'1563131':'河北|张家口',
'1563140':'河北|承德',
'1563141':'河北|承德',
'1563150':'河北|唐山',
'1563151':'河北|唐山',
'1563152':'河北|唐山',
'1563153':'河北|唐山',
'1563160':'河北|廊坊',
'1563161':'河北|廊坊',
'1563170':'河北|沧州',
'1563171':'河北|沧州',
'1563180':'河北|衡水',
'1563181':'河北|衡水',
'1563190':'河北|邢台',
'1563191':'河北|邢台',
'1563350':'河北|秦皇岛',
'1563351':'河北|秦皇岛',
'1563500':'山西|忻州',
'1563501':'山西|忻州',
'1563510':'山西|太原',
'1563511':'山西|太原',
'1563512':'山西|太原',
'1563513':'山西|太原',
'1563520':'山西|大同',
'1563521':'山西|大同',
'1563530':'山西|阳泉',
'1563531':'山西|阳泉',
'1563540':'山西|晋中',
'1563541':'山西|晋中',
'1563550':'山西|长治',
'1563551':'山西|长治',
'1563560':'山西|晋城',
'1563561':'山西|晋城',
'1563570':'山西|临汾',
'1563571':'山西|临汾',
'1563580':'山西|吕梁',
'1563581':'山西|吕梁',
'1563590':'山西|运城',
'1563591':'山西|运城',
'1563700':'河南|商丘',
'1563701':'河南|商丘',
'1563710':'河南|郑州',
'1563711':'河南|郑州',
'1563712':'河南|郑州',
'1563713':'河南|郑州',
'1563720':'河南|安阳',
'1563721':'河南|安阳',
'1563730':'河南|新乡',
'1563731':'河南|新乡',
'1563740':'河南|许昌',
'1563741':'河南|许昌',
'1563750':'河南|平顶山',
'1563751':'河南|平顶山',
'1563760':'河南|信阳',
'1563761':'河南|信阳',
'1563770':'河南|南阳',
'1563771':'河南|南阳',
'1563780':'河南|开封',
'1563781':'河南|开封',
'1563790':'河南|洛阳',
'1563791':'河南|洛阳',
'1563792':'河南|洛阳',
'1563910':'河南|焦作',
'1563911':'河南|焦作',
'1563920':'河南|鹤壁',
'1563921':'河南|鹤壁',
'1563930':'河南|濮阳',
'1563931':'河南|濮阳',
'1563940':'河南|周口',
'1563941':'河南|周口',
'1563950':'河南|漯河',
'1563951':'河南|漯河',
'1563960':'河南|驻马店',
'1563961':'河南|驻马店',
'1563980':'河南|三门峡',
'1563981':'河南|三门峡',
'1564100':'辽宁|铁岭',
'1564101':'辽宁|铁岭',
'1564110':'辽宁|大连',
'1564111':'辽宁|大连',
'1564112':'辽宁|大连',
'1564113':'辽宁|大连',
'1564120':'辽宁|鞍山',
'1564121':'辽宁|鞍山',
'1564130':'辽宁|抚顺',
'1564131':'辽宁|抚顺',
'1564140':'辽宁|本溪',
'1564141':'辽宁|本溪',
'1564150':'辽宁|丹东',
'1564151':'辽宁|丹东',
'1564160':'辽宁|锦州',
'1564161':'辽宁|锦州',
'1564170':'辽宁|营口',
'1564171':'辽宁|营口',
'1564180':'辽宁|阜新',
'1564181':'辽宁|阜新',
'1564190':'辽宁|辽阳',
'1564191':'辽宁|辽阳',
'1564210':'辽宁|朝阳',
'1564211':'辽宁|朝阳',
'1564270':'辽宁|盘锦',
'1564271':'辽宁|盘锦',
'1564290':'辽宁|葫芦岛',
'1564291':'辽宁|葫芦岛',
'1564310':'吉林|长春',
'1564311':'吉林|长春',
'1564312':'吉林|长春',
'1564313':'吉林|长春',
'1564320':'吉林|吉林市',
'1564321':'吉林|吉林市',
'1564340':'吉林|四平',
'1564341':'吉林|四平',
'1564350':'吉林|通化',
'1564351':'吉林|通化',
'1564360':'吉林|白城',
'1564361':'吉林|白城',
'1564370':'吉林|辽源',
'1564371':'吉林|辽源',
'1564380':'吉林|松原',
'1564381':'吉林|松原',
'1564390':'吉林|白山',
'1564391':'吉林|白山',
'1564510':'黑龙江|哈尔滨',
'1564511':'黑龙江|哈尔滨',
'1564512':'黑龙江|哈尔滨',
'1564513':'黑龙江|哈尔滨',
'1564520':'黑龙江|齐齐哈尔',
'1564521':'黑龙江|齐齐哈尔',
'1564530':'黑龙江|牡丹江',
'1564531':'黑龙江|牡丹江',
'1564540':'黑龙江|佳木斯',
'1564541':'黑龙江|佳木斯',
'1564550':'黑龙江|绥化',
'1564551':'黑龙江|绥化',
'1564580':'黑龙江|伊春',
'1564581':'黑龙江|伊春',
'1564590':'黑龙江|大庆',
'1564591':'黑龙江|大庆',
'1564670':'黑龙江|鸡西',
'1564671':'黑龙江|鸡西',
'1564710':'内蒙古|呼和浩特',
'1564711':'内蒙古|呼和浩特',
'1564712':'内蒙古|呼和浩特',
'1564720':'内蒙古|包头',
'1564721':'内蒙古|包头',
'1564730':'内蒙古|乌海',
'1564750':'内蒙古|通辽',
'1564751':'内蒙古|通辽',
'1564760':'内蒙古|赤峰',
'1564761':'内蒙古|赤峰',
'1564770':'内蒙古|鄂尔多斯',
'1564771':'内蒙古|鄂尔多斯',
'1565100':'江苏|无锡',
'1565101':'江苏|无锡',
'1565102':'江苏|无锡',
'1565110':'江苏|镇江',
'1565111':'江苏|镇江',
'1565120':'江苏|苏州',
'1565121':'江苏|苏州',
'1565122':'江苏|苏州',
'1565123':'江苏|苏州',
'1565130':'江苏|南通',
'1565131':'江苏|南通',
'1565132':'江苏|南通',
'1565140':'江苏|扬州',
'1565141':'江苏|扬州',
'1565150':'江苏|盐城',
'1565151':'江苏|盐城',
'1565160':'江苏|徐州',
'1565161':'江苏|徐州',
'1565162':'江苏|徐州',
'1565170':'江苏|淮安',
'1565171':'江苏|淮安',
'1565180':'江苏|连云港',
'1565181':'江苏|连云港',
'1565190':'江苏|常州',
'1565191':'江苏|常州',
'1565192':'江苏|常州',
'1565230':'江苏|泰州',
'1565231':'江苏|泰州',
'1565270':'江苏|宿迁',
'1565271':'江苏|宿迁',
'1565300':'山东|菏泽',
'1565301':'山东|菏泽',
'1565310':'山东|济南',
'1565311':'山东|济南',
'1565312':'山东|济南',
'1565313':'山东|济南',
'1565320':'山东|青岛',
'1565321':'山东|青岛',
'1565322':'山东|青岛',
'1565323':'山东|青岛',
'1565330':'山东|淄博',
'1565331':'山东|淄博',
'1565340':'山东|德州',
'1565341':'山东|德州',
'1565350':'山东|烟台',
'1565351':'山东|烟台',
'1565352':'山东|烟台',
'1565360':'山东|潍坊',
'1565361':'山东|潍坊',
'1565362':'山东|潍坊',
'1565370':'山东|济宁',
'1565371':'山东|济宁',
'1565380':'山东|泰安',
'1565381':'山东|泰安',
'1565390':'山东|临沂',
'1565391':'山东|临沂',
'1565430':'山东|滨州',
'1565431':'山东|滨州',
'1565460':'山东|东营',
'1565461':'山东|东营',
'1565500':'安徽|滁州',
'1565501':'安徽|滁州',
'1565510':'安徽|合肥',
'1565511':'安徽|合肥',
'1565512':'安徽|合肥',
'1565513':'安徽|合肥',
'1565514':'安徽|合肥',
'1565520':'安徽|蚌埠',
'1565521':'安徽|蚌埠',
'1565530':'安徽|芜湖',
'1565531':'安徽|芜湖',
'1565532':'安徽|芜湖',
'1565540':'安徽|淮南',
'1565541':'安徽|淮南',
'1565550':'安徽|马鞍山',
'1565551':'安徽|马鞍山',
'1565560':'安徽|安庆',
'1565561':'安徽|安庆',
'1565570':'安徽|宿州',
'1565571':'安徽|宿州',
'1565580':'安徽|阜阳',
'1565581':'安徽|阜阳',
'1565590':'安徽|黄山',
'1565591':'安徽|黄山',
'1565600':'安徽|合肥',
'1565601':'安徽|合肥',
'1565602':'安徽|合肥',
'1565603':'安徽|合肥',
'1565604':'安徽|合肥',
'1565610':'安徽|淮北',
'1565611':'安徽|淮北',
'1565620':'安徽|铜陵',
'1565621':'安徽|铜陵',
'1565630':'安徽|宣城',
'1565631':'安徽|宣城',
'1565640':'安徽|六安',
'1565641':'安徽|六安',
'1565660':'安徽|池州',
'1565661':'安徽|池州',
'1565700':'浙江|衢州',
'1565701':'浙江|衢州',
'1565710':'浙江|杭州',
'1565711':'浙江|杭州',
'1565712':'浙江|杭州',
'1565713':'浙江|杭州',
'1565720':'浙江|湖州',
'1565721':'浙江|湖州',
'1565730':'浙江|嘉兴',
'1565731':'浙江|嘉兴',
'1565740':'浙江|宁波',
'1565741':'浙江|宁波',
'1565742':'浙江|宁波',
'1565750':'浙江|绍兴',
'1565751':'浙江|绍兴',
'1565760':'浙江|台州',
'1565761':'浙江|台州',
'1565770':'浙江|温州',
'1565771':'浙江|温州',
'1565772':'浙江|温州',
'1565780':'浙江|丽水',
'1565781':'浙江|丽水',
'1565790':'浙江|金华',
'1565791':'浙江|金华',
'1565800':'浙江|舟山',
'1565801':'浙江|舟山',
'1565910':'福建|福州',
'1565911':'福建|福州',
'1565912':'福建|福州',
'1565913':'福建|福州',
'1565920':'福建|厦门',
'1565921':'福建|厦门',
'1565922':'福建|厦门',
'1565930':'福建|宁德',
'1565931':'福建|宁德',
'1565940':'福建|莆田',
'1565941':'福建|莆田',
'1565950':'福建|泉州',
'1565951':'福建|泉州',
'1565952':'福建|泉州',
'1565960':'福建|漳州',
'1565961':'福建|漳州',
'1565970':'福建|龙岩',
'1565971':'福建|龙岩',
'1565980':'福建|三明',
'1565981':'福建|三明',
'1565990':'福建|南平',
'1565991':'福建|南平',
'1566310':'山东|威海',
'1566311':'山东|威海',
'1566320':'山东|枣庄',
'1566321':'山东|枣庄',
'1566330':'山东|日照',
'1566331':'山东|日照',
'1566350':'山东|聊城',
'1566351':'山东|聊城',
'1566600':'广东|汕尾',
'1566601':'广东|汕尾',
'1566620':'广东|阳江',
'1566621':'广东|阳江',
'1566630':'广东|揭阳',
'1566631':'广东|揭阳',
'1566680':'广东|茂名',
'1566681':'广东|茂名',
'1567010':'江西|鹰潭',
'1567011':'江西|鹰潭',
'1567100':'湖北|襄阳',
'1567101':'湖北|襄阳',
'1567110':'湖北|鄂州',
'1567111':'湖北|鄂州',
'1567120':'湖北|孝感',
'1567121':'湖北|孝感',
'1567130':'湖北|黄冈',
'1567131':'湖北|黄冈',
'1567140':'湖北|黄石',
'1567141':'湖北|黄石',
'1567150':'湖北|咸宁',
'1567151':'湖北|咸宁',
'1567160':'湖北|荆州',
'1567161':'湖北|荆州',
'1567170':'湖北|宜昌',
'1567171':'湖北|宜昌',
'1567180':'湖北|恩施',
'1567181':'湖北|恩施',
'1567190':'湖北|十堰',
'1567191':'湖北|十堰',
'1567220':'湖北|随州',
'1567221':'湖北|随州',
'1567240':'湖北|荆门',
'1567241':'湖北|荆门',
'1567300':'湖南|岳阳',
'1567301':'湖南|岳阳',
'1567310':'湖南|长沙',
'1567311':'湖南|长沙',
'1567312':'湖南|长沙',
'1567313':'湖南|长沙',
'1567320':'湖南|湘潭',
'1567321':'湖南|湘潭',
'1567330':'湖南|株洲',
'1567331':'湖南|株洲',
'1567340':'湖南|衡阳',
'1567341':'湖南|衡阳',
'1567350':'湖南|郴州',
'1567351':'湖南|郴州',
'1567360':'湖南|常德',
'1567361':'湖南|常德',
'1567370':'湖南|益阳',
'1567371':'湖南|益阳',
'1567380':'湖南|娄底',
'1567381':'湖南|娄底',
'1567390':'湖南|邵阳',
'1567391':'湖南|邵阳',
'1567440':'湖南|张家界',
'1567441':'湖南|张家界',
'1567450':'湖南|怀化',
'1567451':'湖南|怀化',
'1567460':'湖南|永州',
'1567461':'湖南|永州',
'1567500':'广东|江门',
'1567501':'广东|江门',
'1567510':'广东|韶关',
'1567511':'广东|韶关',
'1567520':'广东|惠州',
'1567521':'广东|惠州',
'1567530':'广东|梅州',
'1567531':'广东|梅州',
'1567540':'广东|汕头',
'1567541':'广东|汕头',
'1567550':'广东|深圳',
'1567551':'广东|深圳',
'1567552':'广东|深圳',
'1567553':'广东|深圳',
'1567560':'广东|珠海',
'1567561':'广东|珠海',
'1567570':'广东|佛山',
'1567571':'广东|佛山',
'1567572':'广东|佛山',
'1567580':'广东|肇庆',
'1567581':'广东|肇庆',
'1567590':'广东|湛江',
'1567591':'广东|湛江',
'1567600':'广东|中山',
'1567601':'广东|中山',
'1567620':'广东|河源',
'1567621':'广东|河源',
'1567630':'广东|清远',
'1567631':'广东|清远',
'1567660':'广东|云浮',
'1567661':'广东|云浮',
'1567680':'广东|潮州',
'1567681':'广东|潮州',
'1567690':'广东|东莞',
'1567691':'广东|东莞',
'1567692':'广东|东莞',
'1567700':'广西|防城港',
'1567701':'广西|防城港',
'1567710':'广西|南宁',
'1567711':'广西|南宁',
'1567712':'广西|南宁',
'1567720':'广西|柳州',
'1567721':'广西|柳州',
'1567730':'广西|桂林',
'1567731':'广西|桂林',
'1567740':'广西|梧州',
'1567741':'广西|梧州',
'1567750':'广西|贵港',
'1567751':'广西|贵港',
'1567760':'广西|百色',
'1567761':'广西|百色',
'1567770':'广西|钦州',
'1567771':'广西|钦州',
'1567780':'广西|河池',
'1567781':'广西|河池',
'1567790':'广西|北海',
'1567791':'广西|北海',
'1567900':'江西|新余',
'1567901':'江西|新余',
'1567910':'江西|南昌',
'1567911':'江西|南昌',
'1567912':'江西|南昌',
'1567913':'江西|南昌',
'1567920':'江西|九江',
'1567921':'江西|九江',
'1567930':'江西|上饶',
'1567931':'江西|上饶',
'1567940':'江西|抚州',
'1567941':'江西|抚州',
'1567950':'江西|宜春',
'1567951':'江西|宜春',
'1567960':'江西|吉安',
'1567961':'江西|吉安',
'1567970':'江西|赣州',
'1567971':'江西|赣州',
'1567980':'江西|景德镇',
'1567981':'江西|景德镇',
'1567990':'江西|萍乡',
'1567991':'江西|萍乡',
'1568120':'四川|攀枝花',
'1568121':'四川|攀枝花',
'1568130':'四川|自贡',
'1568131':'四川|自贡',
'1568160':'四川|绵阳',
'1568161':'四川|绵阳',
'1568170':'四川|南充',
'1568171':'四川|南充',
'1568180':'四川|达州',
'1568181':'四川|达州',
'1568250':'四川|遂宁',
'1568251':'四川|遂宁',
'1568260':'四川|广安',
'1568261':'四川|广安',
'1568270':'四川|巴中',
'1568271':'四川|巴中',
'1568300':'重庆',
'1568301':'四川|泸州',
'1568310':'四川|宜宾',
'1568311':'四川|宜宾',
'1568320':'四川|内江',
'1568321':'四川|内江',
'1568330':'四川|乐山',
'1568331':'四川|乐山',
'1568350':'四川|雅安',
'1568351':'四川|雅安',
'1568380':'四川|德阳',
'1568381':'四川|德阳',
'1568390':'四川|广元',
'1568391':'四川|广元',
'1568400':'重庆',
'1568500':'重庆',
'1568510':'贵州|贵阳',
'1568511':'贵州|贵阳',
'1568512':'贵州|贵阳',
'1568520':'贵州|遵义',
'1568521':'贵州|遵义',
'1568530':'贵州|安顺',
'1568531':'贵州|安顺',
'1568560':'贵州|铜仁',
'1568561':'贵州|铜仁',
'1568570':'贵州|毕节',
'1568571':'贵州|毕节',
'1568580':'贵州|六盘水',
'1568581':'贵州|六盘水',
'1568700':'云南|昭通',
'1568701':'云南|昭通',
'1568710':'云南|昆明',
'1568711':'云南|昆明',
'1568712':'云南|昆明',
'1568713':'云南|昆明',
'1568720':'云南|大理',
'1568721':'云南|大理',
'1568740':'云南|曲靖',
'1568741':'云南|曲靖',
'1568750':'云南|保山',
'1568751':'云南|保山',
'1568770':'云南|玉溪',
'1568771':'云南|玉溪',
'1568790':'云南|普洱',
'1568791':'云南|普洱',
'1568880':'云南|丽江',
'1568881':'云南|丽江',
'1568910':'西藏|拉萨',
'1568911':'西藏|拉萨',
'1568920':'西藏|日喀则',
'1568921':'西藏|日喀则',
'1568980':'海南|海口',
'1568981':'海南|海口',
'1568982':'海南|海口',
'1568990':'海南|三亚',
'1568991':'海南|三亚',
'1569110':'陕西|延安',
'1569111':'陕西|延安',
'1569120':'陕西|榆林',
'1569121':'陕西|榆林',
'1569130':'陕西|渭南',
'1569131':'陕西|渭南',
'1569140':'陕西|商洛',
'1569141':'陕西|商洛',
'1569150':'陕西|安康',
'1569151':'陕西|安康',
'1569160':'陕西|汉中',
'1569161':'陕西|汉中',
'1569170':'陕西|宝鸡',
'1569171':'陕西|宝鸡',
'1569190':'陕西|铜川',
'1569191':'陕西|铜川',
'1569310':'甘肃|兰州',
'1569311':'甘肃|兰州',
'1569312':'甘肃|兰州',
'1569370':'甘肃|酒泉',
'1569371':'甘肃|酒泉',
'1569380':'甘肃|天水',
'1569381':'甘肃|天水',
'1569430':'甘肃|白银',
'1569431':'甘肃|白银',
'1569510':'宁夏|银川',
'1569511':'宁夏|银川',
'1569710':'青海|西宁',
'1569711':'青海|西宁',
'1569910':'新疆|乌鲁木齐',
'1569911':'新疆|乌鲁木齐',
'1569912':'新疆|乌鲁木齐',
'1571000':'北京',
'1571100':'北京',
'1571200':'北京',
'1571300':'北京',
'1571400':'北京',
'1571500':'北京',
'1571600':'北京',
'1571700':'北京',
'1571800':'北京',
'1571900':'北京',
'1572000':'广东|广州',
'1572001':'广东|广州',
'1572002':'广东|广州',
'1572003':'广东|广州',
'1572100':'上海',
'1572200':'上海',
'1572300':'上海',
'1572410':'辽宁|沈阳',
'1572411':'辽宁|沈阳',
'1572412':'辽宁|沈阳',
'1572413':'辽宁|沈阳',
'1572500':'江苏|南京',
'1572501':'江苏|南京',
'1572502':'江苏|南京',
'1572503':'江苏|南京',
'1572710':'湖北|武汉',
'1572711':'湖北|武汉',
'1572712':'湖北|武汉',
'1572713':'湖北|武汉',
'1572800':'四川|成都',
'1572801':'四川|成都',
'1572802':'四川|成都',
'1572803':'四川|成都',
'1572900':'陕西|咸阳',
'1572901':'陕西|咸阳',
'1572910':'陕西|西安',
'1572911':'陕西|西安',
'1572912':'陕西|西安',
'1572913':'陕西|西安',
'1573100':'河北|邯郸',
'1573101':'河北|邯郸',
'1573102':'河北|邯郸',
'1573110':'河北|石家庄',
'1573111':'河北|石家庄',
'1573112':'河北|石家庄',
'1573113':'河北|石家庄',
'1573120':'河北|保定',
'1573121':'河北|保定',
'1573122':'河北|保定',
'1573130':'河北|张家口',
'1573131':'河北|张家口',
'1573140':'河北|承德',
'1573141':'河北|承德',
'1573150':'河北|唐山',
'1573151':'河北|唐山',
'1573152':'河北|唐山',
'1573153':'河北|唐山',
'1573160':'河北|廊坊',
'1573161':'河北|廊坊',
'1573170':'河北|沧州',
'1573171':'河北|沧州',
'1573180':'河北|衡水',
'1573181':'河北|衡水',
'1573190':'河北|邢台',
'1573191':'河北|邢台',
'1573350':'河北|秦皇岛',
'1573351':'河北|秦皇岛',
'1573500':'山西|忻州',
'1573501':'山西|忻州',
'1573510':'山西|太原',
'1573511':'山西|太原',
'1573512':'山西|太原',
'1573513':'山西|太原',
'1573520':'山西|大同',
'1573521':'山西|大同',
'1573530':'山西|阳泉',
'1573531':'山西|阳泉',
'1573540':'山西|晋中',
'1573541':'山西|晋中',
'1573550':'山西|长治',
'1573551':'山西|长治',
'1573560':'山西|晋城',
'1573561':'山西|晋城',
'1573570':'山西|临汾',
'1573571':'山西|临汾',
'1573580':'山西|吕梁',
'1573581':'山西|吕梁',
'1573590':'山西|运城',
'1573591':'山西|运城',
'1573700':'河南|商丘',
'1573701':'河南|商丘',
'1573710':'河南|郑州',
'1573711':'河南|郑州',
'1573712':'河南|郑州',
'1573713':'河南|郑州',
'1573720':'河南|安阳',
'1573721':'河南|安阳',
'1573730':'河南|新乡',
'1573731':'河南|新乡',
'1573740':'河南|许昌',
'1573741':'河南|许昌',
'1573750':'河南|平顶山',
'1573751':'河南|平顶山',
'1573760':'河南|信阳',
'1573761':'河南|信阳',
'1573770':'河南|南阳',
'1573771':'河南|南阳',
'1573780':'河南|开封',
'1573781':'河南|开封',
'1573790':'河南|洛阳',
'1573791':'河南|洛阳',
'1573792':'河南|洛阳',
'1573910':'河南|焦作',
'1573911':'河南|焦作',
'1573920':'河南|鹤壁',
'1573921':'河南|鹤壁',
'1573930':'河南|濮阳',
'1573931':'河南|濮阳',
'1573940':'河南|周口',
'1573941':'河南|周口',
'1573950':'河南|漯河',
'1573951':'河南|漯河',
'1573960':'河南|驻马店',
'1573961':'河南|驻马店',
'1573980':'河南|三门峡',
'1573981':'河南|三门峡',
'1574100':'辽宁|铁岭',
'1574101':'辽宁|铁岭',
'1574110':'辽宁|大连',
'1574111':'辽宁|大连',
'1574112':'辽宁|大连',
'1574113':'辽宁|大连',
'1574120':'辽宁|鞍山',
'1574121':'辽宁|鞍山',
'1574130':'辽宁|抚顺',
'1574131':'辽宁|抚顺',
'1574140':'辽宁|本溪',
'1574141':'辽宁|本溪',
'1574150':'辽宁|丹东',
'1574151':'辽宁|丹东',
'1574160':'辽宁|锦州',
'1574161':'辽宁|锦州',
'1574170':'辽宁|营口',
'1574171':'辽宁|营口',
'1574180':'辽宁|阜新',
'1574181':'辽宁|阜新',
'1574190':'辽宁|辽阳',
'1574191':'辽宁|辽阳',
'1574210':'辽宁|朝阳',
'1574211':'辽宁|朝阳',
'1574270':'辽宁|盘锦',
'1574271':'辽宁|盘锦',
'1574290':'辽宁|葫芦岛',
'1574291':'辽宁|葫芦岛',
'1574310':'吉林|长春',
'1574311':'吉林|长春',
'1574312':'吉林|长春',
'1574313':'吉林|长春',
'1574320':'吉林|吉林市',
'1574321':'吉林|吉林市',
'1574340':'吉林|四平',
'1574341':'吉林|四平',
'1574350':'吉林|通化',
'1574351':'吉林|通化',
'1574360':'吉林|白城',
'1574361':'吉林|白城',
'1574370':'吉林|辽源',
'1574371':'吉林|辽源',
'1574380':'吉林|松原',
'1574381':'吉林|松原',
'1574390':'吉林|白山',
'1574391':'吉林|白山',
'1574510':'黑龙江|哈尔滨',
'1574511':'黑龙江|哈尔滨',
'1574512':'黑龙江|哈尔滨',
'1574513':'黑龙江|哈尔滨',
'1574520':'黑龙江|齐齐哈尔',
'1574521':'黑龙江|齐齐哈尔',
'1574530':'黑龙江|牡丹江',
'1574531':'黑龙江|牡丹江',
'1574540':'黑龙江|佳木斯',
'1574541':'黑龙江|佳木斯',
'1574550':'黑龙江|绥化',
'1574551':'黑龙江|绥化',
'1574580':'黑龙江|伊春',
'1574581':'黑龙江|伊春',
'1574590':'黑龙江|大庆',
'1574591':'黑龙江|大庆',
'1574670':'黑龙江|鸡西',
'1574671':'黑龙江|鸡西',
'1574710':'内蒙古|呼和浩特',
'1574711':'内蒙古|呼和浩特',
'1574712':'内蒙古|呼和浩特',
'1574720':'内蒙古|包头',
'1574721':'内蒙古|包头',
'1574730':'内蒙古|乌海',
'1574750':'内蒙古|通辽',
'1574751':'内蒙古|通辽',
'1574760':'内蒙古|赤峰',
'1574761':'内蒙古|赤峰',
'1574770':'内蒙古|鄂尔多斯',
'1574771':'内蒙古|鄂尔多斯',
'1575100':'江苏|无锡',
'1575101':'江苏|无锡',
'1575102':'江苏|无锡',
'1575110':'江苏|镇江',
'1575111':'江苏|镇江',
'1575120':'江苏|苏州',
'1575121':'江苏|苏州',
'1575122':'江苏|苏州',
'1575123':'江苏|苏州',
'1575130':'江苏|南通',
'1575131':'江苏|南通',
'1575132':'江苏|南通',
'1575140':'江苏|扬州',
'1575141':'江苏|扬州',
'1575150':'江苏|盐城',
'1575151':'江苏|盐城',
'1575160':'江苏|徐州',
'1575161':'江苏|徐州',
'1575162':'江苏|徐州',
'1575170':'江苏|淮安',
'1575171':'江苏|淮安',
'1575180':'江苏|连云港',
'1575181':'江苏|连云港',
'1575190':'江苏|常州',
'1575191':'江苏|常州',
'1575192':'江苏|常州',
'1575230':'江苏|泰州',
'1575231':'江苏|泰州',
'1575270':'江苏|宿迁',
'1575271':'江苏|宿迁',
'1575300':'山东|菏泽',
'1575301':'山东|菏泽',
'1575310':'山东|济南',
'1575311':'山东|济南',
'1575312':'山东|济南',
'1575313':'山东|济南',
'1575320':'山东|青岛',
'1575321':'山东|青岛',
'1575322':'山东|青岛',
'1575323':'山东|青岛',
'1575330':'山东|淄博',
'1575331':'山东|淄博',
'1575340':'山东|德州',
'1575341':'山东|德州',
'1575350':'山东|烟台',
'1575351':'山东|烟台',
'1575352':'山东|烟台',
'1575360':'山东|潍坊',
'1575361':'山东|潍坊',
'1575362':'山东|潍坊',
'1575370':'山东|济宁',
'1575371':'山东|济宁',
'1575380':'山东|泰安',
'1575381':'山东|泰安',
'1575390':'山东|临沂',
'1575391':'山东|临沂',
'1575430':'山东|滨州',
'1575431':'山东|滨州',
'1575460':'山东|东营',
'1575461':'山东|东营',
'1575500':'安徽|滁州',
'1575501':'安徽|滁州',
'1575510':'安徽|合肥',
'1575511':'安徽|合肥',
'1575512':'安徽|合肥',
'1575513':'安徽|合肥',
'1575514':'安徽|合肥',
'1575520':'安徽|蚌埠',
'1575521':'安徽|蚌埠',
'1575530':'安徽|芜湖',
'1575531':'安徽|芜湖',
'1575532':'安徽|芜湖',
'1575540':'安徽|淮南',
'1575541':'安徽|淮南',
'1575550':'安徽|马鞍山',
'1575551':'安徽|马鞍山',
'1575560':'安徽|安庆',
'1575561':'安徽|安庆',
'1575570':'安徽|宿州',
'1575571':'安徽|宿州',
'1575580':'安徽|阜阳',
'1575581':'安徽|阜阳',
'1575590':'安徽|黄山',
'1575591':'安徽|黄山',
'1575600':'安徽|合肥',
'1575601':'安徽|合肥',
'1575602':'安徽|合肥',
'1575603':'安徽|合肥',
'1575604':'安徽|合肥',
'1575610':'安徽|淮北',
'1575611':'安徽|淮北',
'1575620':'安徽|铜陵',
'1575621':'安徽|铜陵',
'1575630':'安徽|宣城',
'1575631':'安徽|宣城',
'1575640':'安徽|六安',
'1575641':'安徽|六安',
'1575660':'安徽|池州',
'1575661':'安徽|池州',
'1575700':'浙江|衢州',
'1575701':'浙江|衢州',
'1575710':'浙江|杭州',
'1575711':'浙江|杭州',
'1575712':'浙江|杭州',
'1575713':'浙江|杭州',
'1575720':'浙江|湖州',
'1575721':'浙江|湖州',
'1575730':'浙江|嘉兴',
'1575731':'浙江|嘉兴',
'1575740':'浙江|宁波',
'1575741':'浙江|宁波',
'1575742':'浙江|宁波',
'1575750':'浙江|绍兴',
'1575751':'浙江|绍兴',
'1575760':'浙江|台州',
'1575761':'浙江|台州',
'1575770':'浙江|温州',
'1575771':'浙江|温州',
'1575772':'浙江|温州',
'1575780':'浙江|丽水',
'1575781':'浙江|丽水',
'1575790':'浙江|金华',
'1575791':'浙江|金华',
'1575800':'浙江|舟山',
'1575801':'浙江|舟山',
'1575910':'福建|福州',
'1575911':'福建|福州',
'1575912':'福建|福州',
'1575913':'福建|福州',
'1575920':'福建|厦门',
'1575921':'福建|厦门',
'1575922':'福建|厦门',
'1575930':'福建|宁德',
'1575931':'福建|宁德',
'1575940':'福建|莆田',
'1575941':'福建|莆田',
'1575950':'福建|泉州',
'1575951':'福建|泉州',
'1575952':'福建|泉州',
'1575960':'福建|漳州',
'1575961':'福建|漳州',
'1575970':'福建|龙岩',
'1575971':'福建|龙岩',
'1575980':'福建|三明',
'1575981':'福建|三明',
'1575990':'福建|南平',
'1575991':'福建|南平',
'1576310':'山东|威海',
'1576311':'山东|威海',
'1576320':'山东|枣庄',
'1576321':'山东|枣庄',
'1576330':'山东|日照',
'1576331':'山东|日照',
'1576350':'山东|聊城',
'1576351':'山东|聊城',
'1576600':'广东|汕尾',
'1576601':'广东|汕尾',
'1576620':'广东|阳江',
'1576621':'广东|阳江',
'1576630':'广东|揭阳',
'1576631':'广东|揭阳',
'1576680':'广东|茂名',
'1576681':'广东|茂名',
'1577010':'江西|鹰潭',
'1577011':'江西|鹰潭',
'1577100':'湖北|襄阳',
'1577101':'湖北|襄阳',
'1577110':'湖北|鄂州',
'1577111':'湖北|鄂州',
'1577120':'湖北|孝感',
'1577121':'湖北|孝感',
'1577130':'湖北|黄冈',
'1577131':'湖北|黄冈',
'1577140':'湖北|黄石',
'1577141':'湖北|黄石',
'1577150':'湖北|咸宁',
'1577151':'湖北|咸宁',
'1577160':'湖北|荆州',
'1577161':'湖北|荆州',
'1577170':'湖北|宜昌',
'1577171':'湖北|宜昌',
'1577180':'湖北|恩施',
'1577181':'湖北|恩施',
'1577190':'湖北|十堰',
'1577191':'湖北|十堰',
'1577220':'湖北|随州',
'1577221':'湖北|随州',
'1577240':'湖北|荆门',
'1577241':'湖北|荆门',
'1577300':'湖南|岳阳',
'1577301':'湖南|岳阳',
'1577310':'湖南|长沙',
'1577311':'湖南|长沙',
'1577312':'湖南|长沙',
'1577313':'湖南|长沙',
'1577320':'湖南|湘潭',
'1577321':'湖南|湘潭',
'1577330':'湖南|株洲',
'1577331':'湖南|株洲',
'1577340':'湖南|衡阳',
'1577341':'湖南|衡阳',
'1577350':'湖南|郴州',
'1577351':'湖南|郴州',
'1577360':'湖南|常德',
'1577361':'湖南|常德',
'1577370':'湖南|益阳',
'1577371':'湖南|益阳',
'1577380':'湖南|娄底',
'1577381':'湖南|娄底',
'1577390':'湖南|邵阳',
'1577391':'湖南|邵阳',
'1577440':'湖南|张家界',
'1577441':'湖南|张家界',
'1577450':'湖南|怀化',
'1577451':'湖南|怀化',
'1577460':'湖南|永州',
'1577461':'湖南|永州',
'1577500':'广东|江门',
'1577501':'广东|江门',
'1577510':'广东|韶关',
'1577511':'广东|韶关',
'1577520':'广东|惠州',
'1577521':'广东|惠州',
'1577530':'广东|梅州',
'1577531':'广东|梅州',
'1577540':'广东|汕头',
'1577541':'广东|汕头',
'1577550':'广东|深圳',
'1577551':'广东|深圳',
'1577552':'广东|深圳',
'1577553':'广东|深圳',
'1577560':'广东|珠海',
'1577561':'广东|珠海',
'1577570':'广东|佛山',
'1577571':'广东|佛山',
'1577572':'广东|佛山',
'1577580':'广东|肇庆',
'1577581':'广东|肇庆',
'1577590':'广东|湛江',
'1577591':'广东|湛江',
'1577600':'广东|中山',
'1577601':'广东|中山',
'1577620':'广东|河源',
'1577621':'广东|河源',
'1577630':'广东|清远',
'1577631':'广东|清远',
'1577660':'广东|云浮',
'1577661':'广东|云浮',
'1577680':'广东|潮州',
'1577681':'广东|潮州',
'1577690':'广东|东莞',
'1577691':'广东|东莞',
'1577692':'广东|东莞',
'1577700':'广西|防城港',
'1577701':'广西|防城港',
'1577710':'广西|南宁',
'1577711':'广西|南宁',
'1577712':'广西|南宁',
'1577720':'广西|柳州',
'1577721':'广西|柳州',
'1577730':'广西|桂林',
'1577731':'广西|桂林',
'1577740':'广西|梧州',
'1577741':'广西|梧州',
'1577750':'广西|贵港',
'1577751':'广西|贵港',
'1577760':'广西|百色',
'1577761':'广西|百色',
'1577770':'广西|钦州',
'1577771':'广西|钦州',
'1577780':'广西|河池',
'1577781':'广西|河池',
'1577790':'广西|北海',
'1577791':'广西|北海',
'1577900':'江西|新余',
'1577901':'江西|新余',
'1577910':'江西|南昌',
'1577911':'江西|南昌',
'1577912':'江西|南昌',
'1577913':'江西|南昌',
'1577920':'江西|九江',
'1577921':'江西|九江',
'1577930':'江西|上饶',
'1577931':'江西|上饶',
'1577940':'江西|抚州',
'1577941':'江西|抚州',
'1577950':'江西|宜春',
'1577951':'江西|宜春',
'1577960':'江西|吉安',
'1577961':'江西|吉安',
'1577970':'江西|赣州',
'1577971':'江西|赣州',
'1577980':'江西|景德镇',
'1577981':'江西|景德镇',
'1577990':'江西|萍乡',
'1577991':'江西|萍乡',
'1578120':'四川|攀枝花',
'1578121':'四川|攀枝花',
'1578130':'四川|自贡',
'1578131':'四川|自贡',
'1578160':'四川|绵阳',
'1578161':'四川|绵阳',
'1578170':'四川|南充',
'1578171':'四川|南充',
'1578180':'四川|达州',
'1578181':'四川|达州',
'1578250':'四川|遂宁',
'1578251':'四川|遂宁',
'1578260':'四川|广安',
'1578261':'四川|广安',
'1578270':'四川|巴中',
'1578271':'四川|巴中',
'1578300':'重庆',
'1578301':'四川|泸州',
'1578310':'四川|宜宾',
'1578311':'四川|宜宾',
'1578320':'四川|内江',
'1578321':'四川|内江',
'1578330':'四川|乐山',
'1578331':'四川|乐山',
'1578350':'四川|雅安',
'1578351':'四川|雅安',
'1578380':'四川|德阳',
'1578381':'四川|德阳',
'1578390':'四川|广元',
'1578391':'四川|广元',
'1578400':'重庆',
'1578500':'重庆',
'1578510':'贵州|贵阳',
'1578511':'贵州|贵阳',
'1578512':'贵州|贵阳',
'1578520':'贵州|遵义',
'1578521':'贵州|遵义',
'1578530':'贵州|安顺',
'1578531':'贵州|安顺',
'1578560':'贵州|铜仁',
'1578561':'贵州|铜仁',
'1578570':'贵州|毕节',
'1578571':'贵州|毕节',
'1578580':'贵州|六盘水',
'1578581':'贵州|六盘水',
'1578700':'云南|昭通',
'1578701':'云南|昭通',
'1578710':'云南|昆明',
'1578711':'云南|昆明',
'1578712':'云南|昆明',
'1578713':'云南|昆明',
'1578720':'云南|大理',
'1578721':'云南|大理',
'1578740':'云南|曲靖',
'1578741':'云南|曲靖',
'1578750':'云南|保山',
'1578751':'云南|保山',
'1578770':'云南|玉溪',
'1578771':'云南|玉溪',
'1578790':'云南|普洱',
'1578791':'云南|普洱',
'1578880':'云南|丽江',
'1578881':'云南|丽江',
'1578910':'西藏|拉萨',
'1578911':'西藏|拉萨',
'1578920':'西藏|日喀则',
'1578921':'西藏|日喀则',
'1578980':'海南|海口',
'1578981':'海南|海口',
'1578982':'海南|海口',
'1578990':'海南|三亚',
'1578991':'海南|三亚',
'1579110':'陕西|延安',
'1579111':'陕西|延安',
'1579120':'陕西|榆林',
'1579121':'陕西|榆林',
'1579130':'陕西|渭南',
'1579131':'陕西|渭南',
'1579140':'陕西|商洛',
'1579141':'陕西|商洛',
'1579150':'陕西|安康',
'1579151':'陕西|安康',
'1579160':'陕西|汉中',
'1579161':'陕西|汉中',
'1579170':'陕西|宝鸡',
'1579171':'陕西|宝鸡',
'1579190':'陕西|铜川',
'1579191':'陕西|铜川',
'1579310':'甘肃|兰州',
'1579311':'甘肃|兰州',
'1579312':'甘肃|兰州',
'1579370':'甘肃|酒泉',
'1579371':'甘肃|酒泉',
'1579380':'甘肃|天水',
'1579381':'甘肃|天水',
'1579430':'甘肃|白银',
'1579431':'甘肃|白银',
'1579510':'宁夏|银川',
'1579511':'宁夏|银川',
'1579710':'青海|西宁',
'1579711':'青海|西宁',
'1579910':'新疆|乌鲁木齐',
'1579911':'新疆|乌鲁木齐',
'1579912':'新疆|乌鲁木齐',
'1581000':'北京',
'1581100':'北京',
'1581200':'北京',
'1581300':'北京',
'1581400':'北京',
'1581500':'北京',
'1581600':'北京',
'1581700':'北京',
'1581800':'北京',
'1581900':'北京',
'1582000':'广东|广州',
'1582001':'广东|广州',
'1582002':'广东|广州',
'1582003':'广东|广州',
'1582100':'上海',
'1582200':'上海',
'1582300':'上海',
'1582410':'辽宁|沈阳',
'1582411':'辽宁|沈阳',
'1582412':'辽宁|沈阳',
'1582413':'辽宁|沈阳',
'1582500':'江苏|南京',
'1582501':'江苏|南京',
'1582502':'江苏|南京',
'1582503':'江苏|南京',
'1582710':'湖北|武汉',
'1582711':'湖北|武汉',
'1582712':'湖北|武汉',
'1582713':'湖北|武汉',
'1582800':'四川|成都',
'1582801':'四川|成都',
'1582802':'四川|成都',
'1582803':'四川|成都',
'1582900':'陕西|咸阳',
'1582901':'陕西|咸阳',
'1582910':'陕西|西安',
'1582911':'陕西|西安',
'1582912':'陕西|西安',
'1582913':'陕西|西安',
'1583100':'河北|邯郸',
'1583101':'河北|邯郸',
'1583102':'河北|邯郸',
'1583110':'河北|石家庄',
'1583111':'河北|石家庄',
'1583112':'河北|石家庄',
'1583113':'河北|石家庄',
'1583120':'河北|保定',
'1583121':'河北|保定',
'1583122':'河北|保定',
'1583130':'河北|张家口',
'1583131':'河北|张家口',
'1583140':'河北|承德',
'1583141':'河北|承德',
'1583150':'河北|唐山',
'1583151':'河北|唐山',
'1583152':'河北|唐山',
'1583153':'河北|唐山',
'1583160':'河北|廊坊',
'1583161':'河北|廊坊',
'1583170':'河北|沧州',
'1583171':'河北|沧州',
'1583180':'河北|衡水',
'1583181':'河北|衡水',
'1583190':'河北|邢台',
'1583191':'河北|邢台',
'1583350':'河北|秦皇岛',
'1583351':'河北|秦皇岛',
'1583500':'山西|忻州',
'1583501':'山西|忻州',
'1583510':'山西|太原',
'1583511':'山西|太原',
'1583512':'山西|太原',
'1583513':'山西|太原',
'1583520':'山西|大同',
'1583521':'山西|大同',
'1583530':'山西|阳泉',
'1583531':'山西|阳泉',
'1583540':'山西|晋中',
'1583541':'山西|晋中',
'1583550':'山西|长治',
'1583551':'山西|长治',
'1583560':'山西|晋城',
'1583561':'山西|晋城',
'1583570':'山西|临汾',
'1583571':'山西|临汾',
'1583580':'山西|吕梁',
'1583581':'山西|吕梁',
'1583590':'山西|运城',
'1583591':'山西|运城',
'1583700':'河南|商丘',
'1583701':'河南|商丘',
'1583710':'河南|郑州',
'1583711':'河南|郑州',
'1583712':'河南|郑州',
'1583713':'河南|郑州',
'1583720':'河南|安阳',
'1583721':'河南|安阳',
'1583730':'河南|新乡',
'1583731':'河南|新乡',
'1583740':'河南|许昌',
'1583741':'河南|许昌',
'1583750':'河南|平顶山',
'1583751':'河南|平顶山',
'1583760':'河南|信阳',
'1583761':'河南|信阳',
'1583770':'河南|南阳',
'1583771':'河南|南阳',
'1583780':'河南|开封',
'1583781':'河南|开封',
'1583790':'河南|洛阳',
'1583791':'河南|洛阳',
'1583792':'河南|洛阳',
'1583910':'河南|焦作',
'1583911':'河南|焦作',
'1583920':'河南|鹤壁',
'1583921':'河南|鹤壁',
'1583930':'河南|濮阳',
'1583931':'河南|濮阳',
'1583940':'河南|周口',
'1583941':'河南|周口',
'1583950':'河南|漯河',
'1583951':'河南|漯河',
'1583960':'河南|驻马店',
'1583961':'河南|驻马店',
'1583980':'河南|三门峡',
'1583981':'河南|三门峡',
'1584100':'辽宁|铁岭',
'1584101':'辽宁|铁岭',
'1584110':'辽宁|大连',
'1584111':'辽宁|大连',
'1584112':'辽宁|大连',
'1584113':'辽宁|大连',
'1584120':'辽宁|鞍山',
'1584121':'辽宁|鞍山',
'1584130':'辽宁|抚顺',
'1584131':'辽宁|抚顺',
'1584140':'辽宁|本溪',
'1584141':'辽宁|本溪',
'1584150':'辽宁|丹东',
'1584151':'辽宁|丹东',
'1584160':'辽宁|锦州',
'1584161':'辽宁|锦州',
'1584170':'辽宁|营口',
'1584171':'辽宁|营口',
'1584180':'辽宁|阜新',
'1584181':'辽宁|阜新',
'1584190':'辽宁|辽阳',
'1584191':'辽宁|辽阳',
'1584210':'辽宁|朝阳',
'1584211':'辽宁|朝阳',
'1584270':'辽宁|盘锦',
'1584271':'辽宁|盘锦',
'1584290':'辽宁|葫芦岛',
'1584291':'辽宁|葫芦岛',
'1584310':'吉林|长春',
'1584311':'吉林|长春',
'1584312':'吉林|长春',
'1584313':'吉林|长春',
'1584320':'吉林|吉林市',
'1584321':'吉林|吉林市',
'1584340':'吉林|四平',
'1584341':'吉林|四平',
'1584350':'吉林|通化',
'1584351':'吉林|通化',
'1584360':'吉林|白城',
'1584361':'吉林|白城',
'1584370':'吉林|辽源',
'1584371':'吉林|辽源',
'1584380':'吉林|松原',
'1584381':'吉林|松原',
'1584390':'吉林|白山',
'1584391':'吉林|白山',
'1584510':'黑龙江|哈尔滨',
'1584511':'黑龙江|哈尔滨',
'1584512':'黑龙江|哈尔滨',
'1584513':'黑龙江|哈尔滨',
'1584520':'黑龙江|齐齐哈尔',
'1584521':'黑龙江|齐齐哈尔',
'1584530':'黑龙江|牡丹江',
'1584531':'黑龙江|牡丹江',
'1584540':'黑龙江|佳木斯',
'1584541':'黑龙江|佳木斯',
'1584550':'黑龙江|绥化',
'1584551':'黑龙江|绥化',
'1584580':'黑龙江|伊春',
'1584581':'黑龙江|伊春',
'1584590':'黑龙江|大庆',
'1584591':'黑龙江|大庆',
'1584670':'黑龙江|鸡西',
'1584671':'黑龙江|鸡西',
'1584710':'内蒙古|呼和浩特',
'1584711':'内蒙古|呼和浩特',
'1584712':'内蒙古|呼和浩特',
'1584720':'内蒙古|包头',
'1584721':'内蒙古|包头',
'1584730':'内蒙古|乌海',
'1584750':'内蒙古|通辽',
'1584751':'内蒙古|通辽',
'1584760':'内蒙古|赤峰',
'1584761':'内蒙古|赤峰',
'1584770':'内蒙古|鄂尔多斯',
'1584771':'内蒙古|鄂尔多斯',
'1585100':'江苏|无锡',
'1585101':'江苏|无锡',
'1585102':'江苏|无锡',
'1585110':'江苏|镇江',
'1585111':'江苏|镇江',
'1585120':'江苏|苏州',
'1585121':'江苏|苏州',
'1585122':'江苏|苏州',
'1585123':'江苏|苏州',
'1585130':'江苏|南通',
'1585131':'江苏|南通',
'1585132':'江苏|南通',
'1585140':'江苏|扬州',
'1585141':'江苏|扬州',
'1585150':'江苏|盐城',
'1585151':'江苏|盐城',
'1585160':'江苏|徐州',
'1585161':'江苏|徐州',
'1585162':'江苏|徐州',
'1585170':'江苏|淮安',
'1585171':'江苏|淮安',
'1585180':'江苏|连云港',
'1585181':'江苏|连云港',
'1585190':'江苏|常州',
'1585191':'江苏|常州',
'1585192':'江苏|常州',
'1585230':'江苏|泰州',
'1585231':'江苏|泰州',
'1585270':'江苏|宿迁',
'1585271':'江苏|宿迁',
'1585300':'山东|菏泽',
'1585301':'山东|菏泽',
'1585310':'山东|济南',
'1585311':'山东|济南',
'1585312':'山东|济南',
'1585313':'山东|济南',
'1585320':'山东|青岛',
'1585321':'山东|青岛',
'1585322':'山东|青岛',
'1585323':'山东|青岛',
'1585330':'山东|淄博',
'1585331':'山东|淄博',
'1585340':'山东|德州',
'1585341':'山东|德州',
'1585350':'山东|烟台',
'1585351':'山东|烟台',
'1585352':'山东|烟台',
'1585360':'山东|潍坊',
'1585361':'山东|潍坊',
'1585362':'山东|潍坊',
'1585370':'山东|济宁',
'1585371':'山东|济宁',
'1585380':'山东|泰安',
'1585381':'山东|泰安',
'1585390':'山东|临沂',
'1585391':'山东|临沂',
'1585430':'山东|滨州',
'1585431':'山东|滨州',
'1585460':'山东|东营',
'1585461':'山东|东营',
'1585500':'安徽|滁州',
'1585501':'安徽|滁州',
'1585510':'安徽|合肥',
'1585511':'安徽|合肥',
'1585512':'安徽|合肥',
'1585513':'安徽|合肥',
'1585514':'安徽|合肥',
'1585520':'安徽|蚌埠',
'1585521':'安徽|蚌埠',
'1585530':'安徽|芜湖',
'1585531':'安徽|芜湖',
'1585532':'安徽|芜湖',
'1585540':'安徽|淮南',
'1585541':'安徽|淮南',
'1585550':'安徽|马鞍山',
'1585551':'安徽|马鞍山',
'1585560':'安徽|安庆',
'1585561':'安徽|安庆',
'1585570':'安徽|宿州',
'1585571':'安徽|宿州',
'1585580':'安徽|阜阳',
'1585581':'安徽|阜阳',
'1585590':'安徽|黄山',
'1585591':'安徽|黄山',
'1585600':'安徽|合肥',
'1585601':'安徽|合肥',
'1585602':'安徽|合肥',
'1585603':'安徽|合肥',
'1585604':'安徽|合肥',
'1585610':'安徽|淮北',
'1585611':'安徽|淮北',
'1585620':'安徽|铜陵',
'1585621':'安徽|铜陵',
'1585630':'安徽|宣城',
'1585631':'安徽|宣城',
'1585640':'安徽|六安',
'1585641':'安徽|六安',
'1585660':'安徽|池州',
'1585661':'安徽|池州',
'1585700':'浙江|衢州',
'1585701':'浙江|衢州',
'1585710':'浙江|杭州',
'1585711':'浙江|杭州',
'1585712':'浙江|杭州',
'1585713':'浙江|杭州',
'1585720':'浙江|湖州',
'1585721':'浙江|湖州',
'1585730':'浙江|嘉兴',
'1585731':'浙江|嘉兴',
'1585740':'浙江|宁波',
'1585741':'浙江|宁波',
'1585742':'浙江|宁波',
'1585750':'浙江|绍兴',
'1585751':'浙江|绍兴',
'1585760':'浙江|台州',
'1585761':'浙江|台州',
'1585770':'浙江|温州',
'1585771':'浙江|温州',
'1585772':'浙江|温州',
'1585780':'浙江|丽水',
'1585781':'浙江|丽水',
'1585790':'浙江|金华',
'1585791':'浙江|金华',
'1585800':'浙江|舟山',
'1585801':'浙江|舟山',
'1585910':'福建|福州',
'1585911':'福建|福州',
'1585912':'福建|福州',
'1585913':'福建|福州',
'1585920':'福建|厦门',
'1585921':'福建|厦门',
'1585922':'福建|厦门',
'1585930':'福建|宁德',
'1585931':'福建|宁德',
'1585940':'福建|莆田',
'1585941':'福建|莆田',
'1585950':'福建|泉州',
'1585951':'福建|泉州',
'1585952':'福建|泉州',
'1585960':'福建|漳州',
'1585961':'福建|漳州',
'1585970':'福建|龙岩',
'1585971':'福建|龙岩',
'1585980':'福建|三明',
'1585981':'福建|三明',
'1585990':'福建|南平',
'1585991':'福建|南平',
'1586310':'山东|威海',
'1586311':'山东|威海',
'1586320':'山东|枣庄',
'1586321':'山东|枣庄',
'1586330':'山东|日照',
'1586331':'山东|日照',
'1586350':'山东|聊城',
'1586351':'山东|聊城',
'1586600':'广东|汕尾',
'1586601':'广东|汕尾',
'1586620':'广东|阳江',
'1586621':'广东|阳江',
'1586630':'广东|揭阳',
'1586631':'广东|揭阳',
'1586680':'广东|茂名',
'1586681':'广东|茂名',
'1587010':'江西|鹰潭',
'1587011':'江西|鹰潭',
'1587100':'湖北|襄阳',
'1587101':'湖北|襄阳',
'1587110':'湖北|鄂州',
'1587111':'湖北|鄂州',
'1587120':'湖北|孝感',
'1587121':'湖北|孝感',
'1587130':'湖北|黄冈',
'1587131':'湖北|黄冈',
'1587140':'湖北|黄石',
'1587141':'湖北|黄石',
'1587150':'湖北|咸宁',
'1587151':'湖北|咸宁',
'1587160':'湖北|荆州',
'1587161':'湖北|荆州',
'1587170':'湖北|宜昌',
'1587171':'湖北|宜昌',
'1587180':'湖北|恩施',
'1587181':'湖北|恩施',
'1587190':'湖北|十堰',
'1587191':'湖北|十堰',
'1587220':'湖北|随州',
'1587221':'湖北|随州',
'1587240':'湖北|荆门',
'1587241':'湖北|荆门',
'1587300':'湖南|岳阳',
'1587301':'湖南|岳阳',
'1587310':'湖南|长沙',
'1587311':'湖南|长沙',
'1587312':'湖南|长沙',
'1587313':'湖南|长沙',
'1587320':'湖南|湘潭',
'1587321':'湖南|湘潭',
'1587330':'湖南|株洲',
'1587331':'湖南|株洲',
'1587340':'湖南|衡阳',
'1587341':'湖南|衡阳',
'1587350':'湖南|郴州',
'1587351':'湖南|郴州',
'1587360':'湖南|常德',
'1587361':'湖南|常德',
'1587370':'湖南|益阳',
'1587371':'湖南|益阳',
'1587380':'湖南|娄底',
'1587381':'湖南|娄底',
'1587390':'湖南|邵阳',
'1587391':'湖南|邵阳',
'1587440':'湖南|张家界',
'1587441':'湖南|张家界',
'1587450':'湖南|怀化',
'1587451':'湖南|怀化',
'1587460':'湖南|永州',
'1587461':'湖南|永州',
'1587500':'广东|江门',
'1587501':'广东|江门',
'1587510':'广东|韶关',
'1587511':'广东|韶关',
'1587520':'广东|惠州',
'1587521':'广东|惠州',
'1587530':'广东|梅州',
'1587531':'广东|梅州',
'1587540':'广东|汕头',
'1587541':'广东|汕头',
'1587550':'广东|深圳',
'1587551':'广东|深圳',
'1587552':'广东|深圳',
'1587553':'广东|深圳',
'1587560':'广东|珠海',
'1587561':'广东|珠海',
'1587570':'广东|佛山',
'1587571':'广东|佛山',
'1587572':'广东|佛山',
'1587580':'广东|肇庆',
'1587581':'广东|肇庆',
'1587590':'广东|湛江',
'1587591':'广东|湛江',
'1587600':'广东|中山',
'1587601':'广东|中山',
'1587620':'广东|河源',
'1587621':'广东|河源',
'1587630':'广东|清远',
'1587631':'广东|清远',
'1587660':'广东|云浮',
'1587661':'广东|云浮',
'1587680':'广东|潮州',
'1587681':'广东|潮州',
'1587690':'广东|东莞',
'1587691':'广东|东莞',
'1587692':'广东|东莞',
'1587700':'广西|防城港',
'1587701':'广西|防城港',
'1587710':'广西|南宁',
'1587711':'广西|南宁',
'1587712':'广西|南宁',
'1587720':'广西|柳州',
'1587721':'广西|柳州',
'1587730':'广西|桂林',
'1587731':'广西|桂林',
'1587740':'广西|梧州',
'1587741':'广西|梧州',
'1587750':'广西|贵港',
'1587751':'广西|贵港',
'1587760':'广西|百色',
'1587761':'广西|百色',
'1587770':'广西|钦州',
'1587771':'广西|钦州',
'1587780':'广西|河池',
'1587781':'广西|河池',
'1587790':'广西|北海',
'1587791':'广西|北海',
'1587900':'江西|新余',
'1587901':'江西|新余',
'1587910':'江西|南昌',
'1587911':'江西|南昌',
'1587912':'江西|南昌',
'1587913':'江西|南昌',
'1587920':'江西|九江',
'1587921':'江西|九江',
'1587930':'江西|上饶',
'1587931':'江西|上饶',
'1587940':'江西|抚州',
'1587941':'江西|抚州',
'1587950':'江西|宜春',
'1587951':'江西|宜春',
'1587960':'江西|吉安',
'1587961':'江西|吉安',
'1587970':'江西|赣州',
'1587971':'江西|赣州',
'1587980':'江西|景德镇',
'1587981':'江西|景德镇',
'1587990':'江西|萍乡',
'1587991':'江西|萍乡',
'1588120':'四川|攀枝花',
'1588121':'四川|攀枝花',
'1588130':'四川|自贡',
'1588131':'四川|自贡',
'1588160':'四川|绵阳',
'1588161':'四川|绵阳',
'1588170':'四川|南充',
'1588171':'四川|南充',
'1588180':'四川|达州',
'1588181':'四川|达州',
'1588250':'四川|遂宁',
'1588251':'四川|遂宁',
'1588260':'四川|广安',
'1588261':'四川|广安',
'1588270':'四川|巴中',
'1588271':'四川|巴中',
'1588300':'重庆',
'1588301':'四川|泸州',
'1588310':'四川|宜宾',
'1588311':'四川|宜宾',
'1588320':'四川|内江',
'1588321':'四川|内江',
'1588330':'四川|乐山',
'1588331':'四川|乐山',
'1588350':'四川|雅安',
'1588351':'四川|雅安',
'1588380':'四川|德阳',
'1588381':'四川|德阳',
'1588390':'四川|广元',
'1588391':'四川|广元',
'1588400':'重庆',
'1588500':'重庆',
'1588510':'贵州|贵阳',
'1588511':'贵州|贵阳',
'1588512':'贵州|贵阳',
'1588520':'贵州|遵义',
'1588521':'贵州|遵义',
'1588530':'贵州|安顺',
'1588531':'贵州|安顺',
'1588560':'贵州|铜仁',
'1588561':'贵州|铜仁',
'1588570':'贵州|毕节',
'1588571':'贵州|毕节',
'1588580':'贵州|六盘水',
'1588581':'贵州|六盘水',
'1588700':'云南|昭通',
'1588701':'云南|昭通',
'1588710':'云南|昆明',
'1588711':'云南|昆明',
'1588712':'云南|昆明',
'1588713':'云南|昆明',
'1588720':'云南|大理',
'1588721':'云南|大理',
'1588740':'云南|曲靖',
'1588741':'云南|曲靖',
'1588750':'云南|保山',
'1588751':'云南|保山',
'1588770':'云南|玉溪',
'1588771':'云南|玉溪',
'1588790':'云南|普洱',
'1588791':'云南|普洱',
'1588880':'云南|丽江',
'1588881':'云南|丽江',
'1588910':'西藏|拉萨',
'1588911':'西藏|拉萨',
'1588920':'西藏|日喀则',
'1588921':'西藏|日喀则',
'1588980':'海南|海口',
'1588981':'海南|海口',
'1588982':'海南|海口',
'1588990':'海南|三亚',
'1588991':'海南|三亚',
'1589110':'陕西|延安',
'1589111':'陕西|延安',
'1589120':'陕西|榆林',
'1589121':'陕西|榆林',
'1589130':'陕西|渭南',
'1589131':'陕西|渭南',
'1589140':'陕西|商洛',
'1589141':'陕西|商洛',
'1589150':'陕西|安康',
'1589151':'陕西|安康',
'1589160':'陕西|汉中',
'1589161':'陕西|汉中',
'1589170':'陕西|宝鸡',
'1589171':'陕西|宝鸡',
'1589190':'陕西|铜川',
'1589191':'陕西|铜川',
'1589310':'甘肃|兰州',
'1589311':'甘肃|兰州',
'1589312':'甘肃|兰州',
'1589370':'甘肃|酒泉',
'1589371':'甘肃|酒泉',
'1589380':'甘肃|天水',
'1589381':'甘肃|天水',
'1589430':'甘肃|白银',
'1589431':'甘肃|白银',
'1589510':'宁夏|银川',
'1589511':'宁夏|银川',
'1589710':'青海|西宁',
'1589711':'青海|西宁',
'1589910':'新疆|乌鲁木齐',
'1589911':'新疆|乌鲁木齐',
'1589912':'新疆|乌鲁木齐',
'1591000':'北京',
'1591100':'北京',
'1591200':'北京',
'1591300':'北京',
'1591400':'北京',
'1591500':'北京',
'1591600':'北京',
'1591700':'北京',
'1591800':'北京',
'1591900':'北京',
'1592000':'广东|广州',
'1592001':'广东|广州',
'1592002':'广东|广州',
'1592003':'广东|广州',
'1592100':'上海',
'1592200':'上海',
'1592300':'上海',
'1592410':'辽宁|沈阳',
'1592411':'辽宁|沈阳',
'1592412':'辽宁|沈阳',
'1592413':'辽宁|沈阳',
'1592500':'江苏|南京',
'1592501':'江苏|南京',
'1592502':'江苏|南京',
'1592503':'江苏|南京',
'1592710':'湖北|武汉',
'1592711':'湖北|武汉',
'1592712':'湖北|武汉',
'1592713':'湖北|武汉',
'1592800':'四川|成都',
'1592801':'四川|成都',
'1592802':'四川|成都',
'1592803':'四川|成都',
'1592900':'陕西|咸阳',
'1592901':'陕西|咸阳',
'1592910':'陕西|西安',
'1592911':'陕西|西安',
'1592912':'陕西|西安',
'1592913':'陕西|西安',
'1593100':'河北|邯郸',
'1593101':'河北|邯郸',
'1593102':'河北|邯郸',
'1593110':'河北|石家庄',
'1593111':'河北|石家庄',
'1593112':'河北|石家庄',
'1593113':'河北|石家庄',
'1593120':'河北|保定',
'1593121':'河北|保定',
'1593122':'河北|保定',
'1593130':'河北|张家口',
'1593131':'河北|张家口',
'1593140':'河北|承德',
'1593141':'河北|承德',
'1593150':'河北|唐山',
'1593151':'河北|唐山',
'1593152':'河北|唐山',
'1593153':'河北|唐山',
'1593160':'河北|廊坊',
'1593161':'河北|廊坊',
'1593170':'河北|沧州',
'1593171':'河北|沧州',
'1593180':'河北|衡水',
'1593181':'河北|衡水',
'1593190':'河北|邢台',
'1593191':'河北|邢台',
'1593350':'河北|秦皇岛',
'1593351':'河北|秦皇岛',
'1593500':'山西|忻州',
'1593501':'山西|忻州',
'1593510':'山西|太原',
'1593511':'山西|太原',
'1593512':'山西|太原',
'1593513':'山西|太原',
'1593520':'山西|大同',
'1593521':'山西|大同',
'1593530':'山西|阳泉',
'1593531':'山西|阳泉',
'1593540':'山西|晋中',
'1593541':'山西|晋中',
'1593550':'山西|长治',
'1593551':'山西|长治',
'1593560':'山西|晋城',
'1593561':'山西|晋城',
'1593570':'山西|临汾',
'1593571':'山西|临汾',
'1593580':'山西|吕梁',
'1593581':'山西|吕梁',
'1593590':'山西|运城',
'1593591':'山西|运城',
'1593700':'河南|商丘',
'1593701':'河南|商丘',
'1593710':'河南|郑州',
'1593711':'河南|郑州',
'1593712':'河南|郑州',
'1593713':'河南|郑州',
'1593720':'河南|安阳',
'1593721':'河南|安阳',
'1593730':'河南|新乡',
'1593731':'河南|新乡',
'1593740':'河南|许昌',
'1593741':'河南|许昌',
'1593750':'河南|平顶山',
'1593751':'河南|平顶山',
'1593760':'河南|信阳',
'1593761':'河南|信阳',
'1593770':'河南|南阳',
'1593771':'河南|南阳',
'1593780':'河南|开封',
'1593781':'河南|开封',
'1593790':'河南|洛阳',
'1593791':'河南|洛阳',
'1593792':'河南|洛阳',
'1593910':'河南|焦作',
'1593911':'河南|焦作',
'1593920':'河南|鹤壁',
'1593921':'河南|鹤壁',
'1593930':'河南|濮阳',
'1593931':'河南|濮阳',
'1593940':'河南|周口',
'1593941':'河南|周口',
'1593950':'河南|漯河',
'1593951':'河南|漯河',
'1593960':'河南|驻马店',
'1593961':'河南|驻马店',
'1593980':'河南|三门峡',
'1593981':'河南|三门峡',
'1594100':'辽宁|铁岭',
'1594101':'辽宁|铁岭',
'1594110':'辽宁|大连',
'1594111':'辽宁|大连',
'1594112':'辽宁|大连',
'1594113':'辽宁|大连',
'1594120':'辽宁|鞍山',
'1594121':'辽宁|鞍山',
'1594130':'辽宁|抚顺',
'1594131':'辽宁|抚顺',
'1594140':'辽宁|本溪',
'1594141':'辽宁|本溪',
'1594150':'辽宁|丹东',
'1594151':'辽宁|丹东',
'1594160':'辽宁|锦州',
'1594161':'辽宁|锦州',
'1594170':'辽宁|营口',
'1594171':'辽宁|营口',
'1594180':'辽宁|阜新',
'1594181':'辽宁|阜新',
'1594190':'辽宁|辽阳',
'1594191':'辽宁|辽阳',
'1594210':'辽宁|朝阳',
'1594211':'辽宁|朝阳',
'1594270':'辽宁|盘锦',
'1594271':'辽宁|盘锦',
'1594290':'辽宁|葫芦岛',
'1594291':'辽宁|葫芦岛',
'1594310':'吉林|长春',
'1594311':'吉林|长春',
'1594312':'吉林|长春',
'1594313':'吉林|长春',
'1594320':'吉林|吉林市',
'1594321':'吉林|吉林市',
'1594340':'吉林|四平',
'1594341':'吉林|四平',
'1594350':'吉林|通化',
'1594351':'吉林|通化',
'1594360':'吉林|白城',
'1594361':'吉林|白城',
'1594370':'吉林|辽源',
'1594371':'吉林|辽源',
'1594380':'吉林|松原',
'1594381':'吉林|松原',
'1594390':'吉林|白山',
'1594391':'吉林|白山',
'1594510':'黑龙江|哈尔滨',
'1594511':'黑龙江|哈尔滨',
'1594512':'黑龙江|哈尔滨',
'1594513':'黑龙江|哈尔滨',
'1594520':'黑龙江|齐齐哈尔',
'1594521':'黑龙江|齐齐哈尔',
'1594530':'黑龙江|牡丹江',
'1594531':'黑龙江|牡丹江',
'1594540':'黑龙江|佳木斯',
'1594541':'黑龙江|佳木斯',
'1594550':'黑龙江|绥化',
'1594551':'黑龙江|绥化',
'1594580':'黑龙江|伊春',
'1594581':'黑龙江|伊春',
'1594590':'黑龙江|大庆',
'1594591':'黑龙江|大庆',
'1594670':'黑龙江|鸡西',
'1594671':'黑龙江|鸡西',
'1594710':'内蒙古|呼和浩特',
'1594711':'内蒙古|呼和浩特',
'1594712':'内蒙古|呼和浩特',
'1594720':'内蒙古|包头',
'1594721':'内蒙古|包头',
'1594730':'内蒙古|乌海',
'1594750':'内蒙古|通辽',
'1594751':'内蒙古|通辽',
'1594760':'内蒙古|赤峰',
'1594761':'内蒙古|赤峰',
'1594770':'内蒙古|鄂尔多斯',
'1594771':'内蒙古|鄂尔多斯',
'1595100':'江苏|无锡',
'1595101':'江苏|无锡',
'1595102':'江苏|无锡',
'1595110':'江苏|镇江',
'1595111':'江苏|镇江',
'1595120':'江苏|苏州',
'1595121':'江苏|苏州',
'1595122':'江苏|苏州',
'1595123':'江苏|苏州',
'1595130':'江苏|南通',
'1595131':'江苏|南通',
'1595132':'江苏|南通',
'1595140':'江苏|扬州',
'1595141':'江苏|扬州',
'1595150':'江苏|盐城',
'1595151':'江苏|盐城',
'1595160':'江苏|徐州',
'1595161':'江苏|徐州',
'1595162':'江苏|徐州',
'1595170':'江苏|淮安',
'1595171':'江苏|淮安',
'1595180':'江苏|连云港',
'1595181':'江苏|连云港',
'1595190':'江苏|常州',
'1595191':'江苏|常州',
'1595192':'江苏|常州',
'1595230':'江苏|泰州',
'1595231':'江苏|泰州',
'1595270':'江苏|宿迁',
'1595271':'江苏|宿迁',
'1595300':'山东|菏泽',
'1595301':'山东|菏泽',
'1595310':'山东|济南',
'1595311':'山东|济南',
'1595312':'山东|济南',
'1595313':'山东|济南',
'1595320':'山东|青岛',
'1595321':'山东|青岛',
'1595322':'山东|青岛',
'1595323':'山东|青岛',
'1595330':'山东|淄博',
'1595331':'山东|淄博',
'1595340':'山东|德州',
'1595341':'山东|德州',
'1595350':'山东|烟台',
'1595351':'山东|烟台',
'1595352':'山东|烟台',
'1595360':'山东|潍坊',
'1595361':'山东|潍坊',
'1595362':'山东|潍坊',
'1595370':'山东|济宁',
'1595371':'山东|济宁',
'1595380':'山东|泰安',
'1595381':'山东|泰安',
'1595390':'山东|临沂',
'1595391':'山东|临沂',
'1595430':'山东|滨州',
'1595431':'山东|滨州',
'1595460':'山东|东营',
'1595461':'山东|东营',
'1595500':'安徽|滁州',
'1595501':'安徽|滁州',
'1595510':'安徽|合肥',
'1595511':'安徽|合肥',
'1595512':'安徽|合肥',
'1595513':'安徽|合肥',
'1595514':'安徽|合肥',
'1595520':'安徽|蚌埠',
'1595521':'安徽|蚌埠',
'1595530':'安徽|芜湖',
'1595531':'安徽|芜湖',
'1595532':'安徽|芜湖',
'1595540':'安徽|淮南',
'1595541':'安徽|淮南',
'1595550':'安徽|马鞍山',
'1595551':'安徽|马鞍山',
'1595560':'安徽|安庆',
'1595561':'安徽|安庆',
'1595570':'安徽|宿州',
'1595571':'安徽|宿州',
'1595580':'安徽|阜阳',
'1595581':'安徽|阜阳',
'1595590':'安徽|黄山',
'1595591':'安徽|黄山',
'1595600':'安徽|合肥',
'1595601':'安徽|合肥',
'1595602':'安徽|合肥',
'1595603':'安徽|合肥',
'1595604':'安徽|合肥',
'1595610':'安徽|淮北',
'1595611':'安徽|淮北',
'1595620':'安徽|铜陵',
'1595621':'安徽|铜陵',
'1595630':'安徽|宣城',
'1595631':'安徽|宣城',
'1595640':'安徽|六安',
'1595641':'安徽|六安',
'1595660':'安徽|池州',
'1595661':'安徽|池州',
'1595700':'浙江|衢州',
'1595701':'浙江|衢州',
'1595710':'浙江|杭州',
'1595711':'浙江|杭州',
'1595712':'浙江|杭州',
'1595713':'浙江|杭州',
'1595720':'浙江|湖州',
'1595721':'浙江|湖州',
'1595730':'浙江|嘉兴',
'1595731':'浙江|嘉兴',
'1595740':'浙江|宁波',
'1595741':'浙江|宁波',
'1595742':'浙江|宁波',
'1595750':'浙江|绍兴',
'1595751':'浙江|绍兴',
'1595760':'浙江|台州',
'1595761':'浙江|台州',
'1595770':'浙江|温州',
'1595771':'浙江|温州',
'1595772':'浙江|温州',
'1595780':'浙江|丽水',
'1595781':'浙江|丽水',
'1595790':'浙江|金华',
'1595791':'浙江|金华',
'1595800':'浙江|舟山',
'1595801':'浙江|舟山',
'1595910':'福建|福州',
'1595911':'福建|福州',
'1595912':'福建|福州',
'1595913':'福建|福州',
'1595920':'福建|厦门',
'1595921':'福建|厦门',
'1595922':'福建|厦门',
'1595930':'福建|宁德',
'1595931':'福建|宁德',
'1595940':'福建|莆田',
'1595941':'福建|莆田',
'1595950':'福建|泉州',
'1595951':'福建|泉州',
'1595952':'福建|泉州',
'1595960':'福建|漳州',
'1595961':'福建|漳州',
'1595970':'福建|龙岩',
'1595971':'福建|龙岩',
'1595980':'福建|三明',
'1595981':'福建|三明',
'1595990':'福建|南平',
'1595991':'福建|南平',
'1596310':'山东|威海',
'1596311':'山东|威海',
'1596320':'山东|枣庄',
'1596321':'山东|枣庄',
'1596330':'山东|日照',
'1596331':'山东|日照',
'1596350':'山东|聊城',
'1596351':'山东|聊城',
'1596600':'广东|汕尾',
'1596601':'广东|汕尾',
'1596620':'广东|阳江',
'1596621':'广东|阳江',
'1596630':'广东|揭阳',
'1596631':'广东|揭阳',
'1596680':'广东|茂名',
'1596681':'广东|茂名',
'1597010':'江西|鹰潭',
'1597011':'江西|鹰潭',
'1597100':'湖北|襄阳',
'1597101':'湖北|襄阳',
'1597110':'湖北|鄂州',
'1597111':'湖北|鄂州',
'1597120':'湖北|孝感',
'1597121':'湖北|孝感',
'1597130':'湖北|黄冈',
'1597131':'湖北|黄冈',
'1597140':'湖北|黄石',
'1597141':'湖北|黄石',
'1597150':'湖北|咸宁',
'1597151':'湖北|咸宁',
'1597160':'湖北|荆州',
'1597161':'湖北|荆州',
'1597170':'湖北|宜昌',
'1597171':'湖北|宜昌',
'1597180':'湖北|恩施',
'1597181':'湖北|恩施',
'1597190':'湖北|十堰',
'1597191':'湖北|十堰',
'1597220':'湖北|随州',
'1597221':'湖北|随州',
'1597240':'湖北|荆门',
'1597241':'湖北|荆门',
'1597300':'湖南|岳阳',
'1597301':'湖南|岳阳',
'1597310':'湖南|长沙',
'1597311':'湖南|长沙',
'1597312':'湖南|长沙',
'1597313':'湖南|长沙',
'1597320':'湖南|湘潭',
'1597321':'湖南|湘潭',
'1597330':'湖南|株洲',
'1597331':'湖南|株洲',
'1597340':'湖南|衡阳',
'1597341':'湖南|衡阳',
'1597350':'湖南|郴州',
'1597351':'湖南|郴州',
'1597360':'湖南|常德',
'1597361':'湖南|常德',
'1597370':'湖南|益阳',
'1597371':'湖南|益阳',
'1597380':'湖南|娄底',
'1597381':'湖南|娄底',
'1597390':'湖南|邵阳',
'1597391':'湖南|邵阳',
'1597440':'湖南|张家界',
'1597441':'湖南|张家界',
'1597450':'湖南|怀化',
'1597451':'湖南|怀化',
'1597460':'湖南|永州',
'1597461':'湖南|永州',
'1597500':'广东|江门',
'1597501':'广东|江门',
'1597510':'广东|韶关',
'1597511':'广东|韶关',
'1597520':'广东|惠州',
'1597521':'广东|惠州',
'1597530':'广东|梅州',
'1597531':'广东|梅州',
'1597540':'广东|汕头',
'1597541':'广东|汕头',
'1597550':'广东|深圳',
'1597551':'广东|深圳',
'1597552':'广东|深圳',
'1597553':'广东|深圳',
'1597560':'广东|珠海',
'1597561':'广东|珠海',
'1597570':'广东|佛山',
'1597571':'广东|佛山',
'1597572':'广东|佛山',
'1597580':'广东|肇庆',
'1597581':'广东|肇庆',
'1597590':'广东|湛江',
'1597591':'广东|湛江',
'1597600':'广东|中山',
'1597601':'广东|中山',
'1597620':'广东|河源',
'1597621':'广东|河源',
'1597630':'广东|清远',
'1597631':'广东|清远',
'1597660':'广东|云浮',
'1597661':'广东|云浮',
'1597680':'广东|潮州',
'1597681':'广东|潮州',
'1597690':'广东|东莞',
'1597691':'广东|东莞',
'1597692':'广东|东莞',
'1597700':'广西|防城港',
'1597701':'广西|防城港',
'1597710':'广西|南宁',
'1597711':'广西|南宁',
'1597712':'广西|南宁',
'1597720':'广西|柳州',
'1597721':'广西|柳州',
'1597730':'广西|桂林',
'1597731':'广西|桂林',
'1597740':'广西|梧州',
'1597741':'广西|梧州',
'1597750':'广西|贵港',
'1597751':'广西|贵港',
'1597760':'广西|百色',
'1597761':'广西|百色',
'1597770':'广西|钦州',
'1597771':'广西|钦州',
'1597780':'广西|河池',
'1597781':'广西|河池',
'1597790':'广西|北海',
'1597791':'广西|北海',
'1597900':'江西|新余',
'1597901':'江西|新余',
'1597910':'江西|南昌',
'1597911':'江西|南昌',
'1597912':'江西|南昌',
'1597913':'江西|南昌',
'1597920':'江西|九江',
'1597921':'江西|九江',
'1597930':'江西|上饶',
'1597931':'江西|上饶',
'1597940':'江西|抚州',
'1597941':'江西|抚州',
'1597950':'江西|宜春',
'1597951':'江西|宜春',
'1597960':'江西|吉安',
'1597961':'江西|吉安',
'1597970':'江西|赣州',
'1597971':'江西|赣州',
'1597980':'江西|景德镇',
'1597981':'江西|景德镇',
'1597990':'江西|萍乡',
'1597991':'江西|萍乡',
'1598120':'四川|攀枝花',
'1598121':'四川|攀枝花',
'1598130':'四川|自贡',
'1598131':'四川|自贡',
'1598160':'四川|绵阳',
'1598161':'四川|绵阳',
'1598170':'四川|南充',
'1598171':'四川|南充',
'1598180':'四川|达州',
'1598181':'四川|达州',
'1598250':'四川|遂宁',
'1598251':'四川|遂宁',
'1598260':'四川|广安',
'1598261':'四川|广安',
'1598270':'四川|巴中',
'1598271':'四川|巴中',
'1598300':'重庆',
'1598301':'四川|泸州',
'1598310':'四川|宜宾',
'1598311':'四川|宜宾',
'1598320':'四川|内江',
'1598321':'四川|内江',
'1598330':'四川|乐山',
'1598331':'四川|乐山',
'1598350':'四川|雅安',
'1598351':'四川|雅安',
'1598380':'四川|德阳',
'1598381':'四川|德阳',
'1598390':'四川|广元',
'1598391':'四川|广元',
'1598400':'重庆',
'1598500':'重庆',
'1598510':'贵州|贵阳',
'1598511':'贵州|贵阳',
'1598512':'贵州|贵阳',
'1598520':'贵州|遵义',
'1598521':'贵州|遵义',
'1598530':'贵州|安顺',
'1598531':'贵州|安顺',
'1598560':'贵州|铜仁',
'1598561':'贵州|铜仁',
'1598570':'贵州|毕节',
'1598571':'贵州|毕节',
'1598580':'贵州|六盘水',
'1598581':'贵州|六盘水',
'1598700':'云南|昭通',
'1598701':'云南|昭通',
'1598710':'云南|昆明',
'1598711':'云南|昆明',
'1598712':'云南|昆明',
'1598713':'云南|昆明',
'1598720':'云南|大理',
'1598721':'云南|大理',
'1598740':'云南|曲靖',
'1598741':'云南|曲靖',
'1598750':'云南|保山',
'1598751':'云南|保山',
'1598770':'云南|玉溪',
'1598771':'云南|玉溪',
'1598790':'云南|普洱',
'1598791':'云南|普洱',
'1598880':'云南|丽江',
'1598881':'云南|丽江',
'1598910':'西藏|拉萨',
'1598911':'西藏|拉萨',
'1598920':'西藏|日喀则',
'1598921':'西藏|日喀则',
'1598980':'海南|海口',
'1598981':'海南|海口',
'1598982':'海南|海口',
'1598990':'海南|三亚',
'1598991':'海南|三亚',
'1599110':'陕西|延安',
'1599111':'陕西|延安',
'1599120':'陕西|榆林',
'1599121':'陕西|榆林',
'1599130':'陕西|渭南',
'1599131':'陕西|渭南',
'1599140':'陕西|商洛',
'1599141':'陕西|商洛',
'1599150':'陕西|安康',
'1599151':'陕西|安康',
'1599160':'陕西|汉中',
'1599161':'陕西|汉中',
'1599170':'陕西|宝鸡',
'1599171':'陕西|宝鸡',
'1599190':'陕西|铜川',
'1599191':'陕西|铜川',
'1599310':'甘肃|兰州',
'1599311':'甘肃|兰州',
'1599312':'甘肃|兰州',
'1599370':'甘肃|酒泉',
'1599371':'甘肃|酒泉',
'1599380':'甘肃|天水',
'1599381':'甘肃|天水',
'1599430':'甘肃|白银',
'1599431':'甘肃|白银',
'1599510':'宁夏|银川',
'1599511':'宁夏|银川',
'1599710':'青海|西宁',
'1599711':'青海|西宁',
'1599910':'新疆|乌鲁木齐',
'1599911':'新疆|乌鲁木齐',
'1599912':'新疆|乌鲁木齐',
'1821000':'北京',
'1821100':'北京',
'1821200':'北京',
'1821300':'北京',
'1821400':'北京',
'1821500':'北京',
'1821600':'北京',
'1821700':'北京',
'1821800':'北京',
'1821900':'北京',
'1822000':'广东|广州',
'1822001':'广东|广州',
'1822002':'广东|广州',
'1822003':'广东|广州',
'1822100':'上海',
'1822200':'上海',
'1822300':'上海',
'1822410':'辽宁|沈阳',
'1822411':'辽宁|沈阳',
'1822412':'辽宁|沈阳',
'1822413':'辽宁|沈阳',
'1822500':'江苏|南京',
'1822501':'江苏|南京',
'1822502':'江苏|南京',
'1822503':'江苏|南京',
'1822710':'湖北|武汉',
'1822711':'湖北|武汉',
'1822712':'湖北|武汉',
'1822713':'湖北|武汉',
'1822800':'四川|成都',
'1822801':'四川|成都',
'1822802':'四川|成都',
'1822803':'四川|成都',
'1822900':'陕西|咸阳',
'1822901':'陕西|咸阳',
'1822910':'陕西|西安',
'1822911':'陕西|西安',
'1822912':'陕西|西安',
'1822913':'陕西|西安',
'1823100':'河北|邯郸',
'1823101':'河北|邯郸',
'1823102':'河北|邯郸',
'1823110':'河北|石家庄',
'1823111':'河北|石家庄',
'1823112':'河北|石家庄',
'1823113':'河北|石家庄',
'1823120':'河北|保定',
'1823121':'河北|保定',
'1823122':'河北|保定',
'1823130':'河北|张家口',
'1823131':'河北|张家口',
'1823140':'河北|承德',
'1823141':'河北|承德',
'1823150':'河北|唐山',
'1823151':'河北|唐山',
'1823152':'河北|唐山',
'1823153':'河北|唐山',
'1823160':'河北|廊坊',
'1823161':'河北|廊坊',
'1823170':'河北|沧州',
'1823171':'河北|沧州',
'1823180':'河北|衡水',
'1823181':'河北|衡水',
'1823190':'河北|邢台',
'1823191':'河北|邢台',
'1823350':'河北|秦皇岛',
'1823351':'河北|秦皇岛',
'1823500':'山西|忻州',
'1823501':'山西|忻州',
'1823510':'山西|太原',
'1823511':'山西|太原',
'1823512':'山西|太原',
'1823513':'山西|太原',
'1823520':'山西|大同',
'1823521':'山西|大同',
'1823530':'山西|阳泉',
'1823531':'山西|阳泉',
'1823540':'山西|晋中',
'1823541':'山西|晋中',
'1823550':'山西|长治',
'1823551':'山西|长治',
'1823560':'山西|晋城',
'1823561':'山西|晋城',
'1823570':'山西|临汾',
'1823571':'山西|临汾',
'1823580':'山西|吕梁',
'1823581':'山西|吕梁',
'1823590':'山西|运城',
'1823591':'山西|运城',
'1823700':'河南|商丘',
'1823701':'河南|商丘',
'1823710':'河南|郑州',
'1823711':'河南|郑州',
'1823712':'河南|郑州',
'1823713':'河南|郑州',
'1823720':'河南|安阳',
'1823721':'河南|安阳',
'1823730':'河南|新乡',
'1823731':'河南|新乡',
'1823740':'河南|许昌',
'1823741':'河南|许昌',
'1823750':'河南|平顶山',
'1823751':'河南|平顶山',
'1823760':'河南|信阳',
'1823761':'河南|信阳',
'1823770':'河南|南阳',
'1823771':'河南|南阳',
'1823780':'河南|开封',
'1823781':'河南|开封',
'1823790':'河南|洛阳',
'1823791':'河南|洛阳',
'1823792':'河南|洛阳',
'1823910':'河南|焦作',
'1823911':'河南|焦作',
'1823920':'河南|鹤壁',
'1823921':'河南|鹤壁',
'1823930':'河南|濮阳',
'1823931':'河南|濮阳',
'1823940':'河南|周口',
'1823941':'河南|周口',
'1823950':'河南|漯河',
'1823951':'河南|漯河',
'1823960':'河南|驻马店',
'1823961':'河南|驻马店',
'1823980':'河南|三门峡',
'1823981':'河南|三门峡',
'1824100':'辽宁|铁岭',
'1824101':'辽宁|铁岭',
'1824110':'辽宁|大连',
'1824111':'辽宁|大连',
'1824112':'辽宁|大连',
'1824113':'辽宁|大连',
'1824120':'辽宁|鞍山',
'1824121':'辽宁|鞍山',
'1824130':'辽宁|抚顺',
'1824131':'辽宁|抚顺',
'1824140':'辽宁|本溪',
'1824141':'辽宁|本溪',
'1824150':'辽宁|丹东',
'1824151':'辽宁|丹东',
'1824160':'辽宁|锦州',
'1824161':'辽宁|锦州',
'1824170':'辽宁|营口',
'1824171':'辽宁|营口',
'1824180':'辽宁|阜新',
'1824181':'辽宁|阜新',
'1824190':'辽宁|辽阳',
'1824191':'辽宁|辽阳',
'1824210':'辽宁|朝阳',
'1824211':'辽宁|朝阳',
'1824270':'辽宁|盘锦',
'1824271':'辽宁|盘锦',
'1824290':'辽宁|葫芦岛',
'1824291':'辽宁|葫芦岛',
'1824310':'吉林|长春',
'1824311':'吉林|长春',
'1824312':'吉林|长春',
'1824313':'吉林|长春',
'1824320':'吉林|吉林市',
'1824321':'吉林|吉林市',
'1824340':'吉林|四平',
'1824341':'吉林|四平',
'1824350':'吉林|通化',
'1824351':'吉林|通化',
'1824360':'吉林|白城',
'1824361':'吉林|白城',
'1824370':'吉林|辽源',
'1824371':'吉林|辽源',
'1824380':'吉林|松原',
'1824381':'吉林|松原',
'1824390':'吉林|白山',
'1824391':'吉林|白山',
'1824510':'黑龙江|哈尔滨',
'1824511':'黑龙江|哈尔滨',
'1824512':'黑龙江|哈尔滨',
'1824513':'黑龙江|哈尔滨',
'1824520':'黑龙江|齐齐哈尔',
'1824521':'黑龙江|齐齐哈尔',
'1824530':'黑龙江|牡丹江',
'1824531':'黑龙江|牡丹江',
'1824540':'黑龙江|佳木斯',
'1824541':'黑龙江|佳木斯',
'1824550':'黑龙江|绥化',
'1824551':'黑龙江|绥化',
'1824580':'黑龙江|伊春',
'1824581':'黑龙江|伊春',
'1824590':'黑龙江|大庆',
'1824591':'黑龙江|大庆',
'1824670':'黑龙江|鸡西',
'1824671':'黑龙江|鸡西',
'1824710':'内蒙古|呼和浩特',
'1824711':'内蒙古|呼和浩特',
'1824712':'内蒙古|呼和浩特',
'1824720':'内蒙古|包头',
'1824721':'内蒙古|包头',
'1824730':'内蒙古|乌海',
'1824750':'内蒙古|通辽',
'1824751':'内蒙古|通辽',
'1824760':'内蒙古|赤峰',
'1824761':'内蒙古|赤峰',
'1824770':'内蒙古|鄂尔多斯',
'1824771':'内蒙古|鄂尔多斯',
'1825100':'江苏|无锡',
'1825101':'江苏|无锡',
'1825102':'江苏|无锡',
'1825110':'江苏|镇江',
'1825111':'江苏|镇江',
'1825120':'江苏|苏州',
'1825121':'江苏|苏州',
'1825122':'江苏|苏州',
'1825123':'江苏|苏州',
'1825130':'江苏|南通',
'1825131':'江苏|南通',
'1825132':'江苏|南通',
'1825140':'江苏|扬州',
'1825141':'江苏|扬州',
'1825150':'江苏|盐城',
'1825151':'江苏|盐城',
'1825160':'江苏|徐州',
'1825161':'江苏|徐州',
'1825162':'江苏|徐州',
'1825170':'江苏|淮安',
'1825171':'江苏|淮安',
'1825180':'江苏|连云港',
'1825181':'江苏|连云港',
'1825190':'江苏|常州',
'1825191':'江苏|常州',
'1825192':'江苏|常州',
'1825230':'江苏|泰州',
'1825231':'江苏|泰州',
'1825270':'江苏|宿迁',
'1825271':'江苏|宿迁',
'1825300':'山东|菏泽',
'1825301':'山东|菏泽',
'1825310':'山东|济南',
'1825311':'山东|济南',
'1825312':'山东|济南',
'1825313':'山东|济南',
'1825320':'山东|青岛',
'1825321':'山东|青岛',
'1825322':'山东|青岛',
'1825323':'山东|青岛',
'1825330':'山东|淄博',
'1825331':'山东|淄博',
'1825340':'山东|德州',
'1825341':'山东|德州',
'1825350':'山东|烟台',
'1825351':'山东|烟台',
'1825352':'山东|烟台',
'1825360':'山东|潍坊',
'1825361':'山东|潍坊',
'1825362':'山东|潍坊',
'1825370':'山东|济宁',
'1825371':'山东|济宁',
'1825380':'山东|泰安',
'1825381':'山东|泰安',
'1825390':'山东|临沂',
'1825391':'山东|临沂',
'1825430':'山东|滨州',
'1825431':'山东|滨州',
'1825460':'山东|东营',
'1825461':'山东|东营',
'1825500':'安徽|滁州',
'1825501':'安徽|滁州',
'1825510':'安徽|合肥',
'1825511':'安徽|合肥',
'1825512':'安徽|合肥',
'1825513':'安徽|合肥',
'1825514':'安徽|合肥',
'1825520':'安徽|蚌埠',
'1825521':'安徽|蚌埠',
'1825530':'安徽|芜湖',
'1825531':'安徽|芜湖',
'1825532':'安徽|芜湖',
'1825540':'安徽|淮南',
'1825541':'安徽|淮南',
'1825550':'安徽|马鞍山',
'1825551':'安徽|马鞍山',
'1825560':'安徽|安庆',
'1825561':'安徽|安庆',
'1825570':'安徽|宿州',
'1825571':'安徽|宿州',
'1825580':'安徽|阜阳',
'1825581':'安徽|阜阳',
'1825590':'安徽|黄山',
'1825591':'安徽|黄山',
'1825600':'安徽|合肥',
'1825601':'安徽|合肥',
'1825602':'安徽|合肥',
'1825603':'安徽|合肥',
'1825604':'安徽|合肥',
'1825610':'安徽|淮北',
'1825611':'安徽|淮北',
'1825620':'安徽|铜陵',
'1825621':'安徽|铜陵',
'1825630':'安徽|宣城',
'1825631':'安徽|宣城',
'1825640':'安徽|六安',
'1825641':'安徽|六安',
'1825660':'安徽|池州',
'1825661':'安徽|池州',
'1825700':'浙江|衢州',
'1825701':'浙江|衢州',
'1825710':'浙江|杭州',
'1825711':'浙江|杭州',
'1825712':'浙江|杭州',
'1825713':'浙江|杭州',
'1825720':'浙江|湖州',
'1825721':'浙江|湖州',
'1825730':'浙江|嘉兴',
'1825731':'浙江|嘉兴',
'1825740':'浙江|宁波',
'1825741':'浙江|宁波',
'1825742':'浙江|宁波',
'1825750':'浙江|绍兴',
'1825751':'浙江|绍兴',
'1825760':'浙江|台州',
'1825761':'浙江|台州',
'1825770':'浙江|温州',
'1825771':'浙江|温州',
'1825772':'浙江|温州',
'1825780':'浙江|丽水',
'1825781':'浙江|丽水',
'1825790':'浙江|金华',
'1825791':'浙江|金华',
'1825800':'浙江|舟山',
'1825801':'浙江|舟山',
'1825910':'福建|福州',
'1825911':'福建|福州',
'1825912':'福建|福州',
'1825913':'福建|福州',
'1825920':'福建|厦门',
'1825921':'福建|厦门',
'1825922':'福建|厦门',
'1825930':'福建|宁德',
'1825931':'福建|宁德',
'1825940':'福建|莆田',
'1825941':'福建|莆田',
'1825950':'福建|泉州',
'1825951':'福建|泉州',
'1825952':'福建|泉州',
'1825960':'福建|漳州',
'1825961':'福建|漳州',
'1825970':'福建|龙岩',
'1825971':'福建|龙岩',
'1825980':'福建|三明',
'1825981':'福建|三明',
'1825990':'福建|南平',
'1825991':'福建|南平',
'1826310':'山东|威海',
'1826311':'山东|威海',
'1826320':'山东|枣庄',
'1826321':'山东|枣庄',
'1826330':'山东|日照',
'1826331':'山东|日照',
'1826350':'山东|聊城',
'1826351':'山东|聊城',
'1826600':'广东|汕尾',
'1826601':'广东|汕尾',
'1826620':'广东|阳江',
'1826621':'广东|阳江',
'1826630':'广东|揭阳',
'1826631':'广东|揭阳',
'1826680':'广东|茂名',
'1826681':'广东|茂名',
'1827010':'江西|鹰潭',
'1827011':'江西|鹰潭',
'1827100':'湖北|襄阳',
'1827101':'湖北|襄阳',
'1827110':'湖北|鄂州',
'1827111':'湖北|鄂州',
'1827120':'湖北|孝感',
'1827121':'湖北|孝感',
'1827130':'湖北|黄冈',
'1827131':'湖北|黄冈',
'1827140':'湖北|黄石',
'1827141':'湖北|黄石',
'1827150':'湖北|咸宁',
'1827151':'湖北|咸宁',
'1827160':'湖北|荆州',
'1827161':'湖北|荆州',
'1827170':'湖北|宜昌',
'1827171':'湖北|宜昌',
'1827180':'湖北|恩施',
'1827181':'湖北|恩施',
'1827190':'湖北|十堰',
'1827191':'湖北|十堰',
'1827220':'湖北|随州',
'1827221':'湖北|随州',
'1827240':'湖北|荆门',
'1827241':'湖北|荆门',
'1827300':'湖南|岳阳',
'1827301':'湖南|岳阳',
'1827310':'湖南|长沙',
'1827311':'湖南|长沙',
'1827312':'湖南|长沙',
'1827313':'湖南|长沙',
'1827320':'湖南|湘潭',
'1827321':'湖南|湘潭',
'1827330':'湖南|株洲',
'1827331':'湖南|株洲',
'1827340':'湖南|衡阳',
'1827341':'湖南|衡阳',
'1827350':'湖南|郴州',
'1827351':'湖南|郴州',
'1827360':'湖南|常德',
'1827361':'湖南|常德',
'1827370':'湖南|益阳',
'1827371':'湖南|益阳',
'1827380':'湖南|娄底',
'1827381':'湖南|娄底',
'1827390':'湖南|邵阳',
'1827391':'湖南|邵阳',
'1827440':'湖南|张家界',
'1827441':'湖南|张家界',
'1827450':'湖南|怀化',
'1827451':'湖南|怀化',
'1827460':'湖南|永州',
'1827461':'湖南|永州',
'1827500':'广东|江门',
'1827501':'广东|江门',
'1827510':'广东|韶关',
'1827511':'广东|韶关',
'1827520':'广东|惠州',
'1827521':'广东|惠州',
'1827530':'广东|梅州',
'1827531':'广东|梅州',
'1827540':'广东|汕头',
'1827541':'广东|汕头',
'1827550':'广东|深圳',
'1827551':'广东|深圳',
'1827552':'广东|深圳',
'1827553':'广东|深圳',
'1827560':'广东|珠海',
'1827561':'广东|珠海',
'1827570':'广东|佛山',
'1827571':'广东|佛山',
'1827572':'广东|佛山',
'1827580':'广东|肇庆',
'1827581':'广东|肇庆',
'1827590':'广东|湛江',
'1827591':'广东|湛江',
'1827600':'广东|中山',
'1827601':'广东|中山',
'1827620':'广东|河源',
'1827621':'广东|河源',
'1827630':'广东|清远',
'1827631':'广东|清远',
'1827660':'广东|云浮',
'1827661':'广东|云浮',
'1827680':'广东|潮州',
'1827681':'广东|潮州',
'1827690':'广东|东莞',
'1827691':'广东|东莞',
'1827692':'广东|东莞',
'1827700':'广西|防城港',
'1827701':'广西|防城港',
'1827710':'广西|南宁',
'1827711':'广西|南宁',
'1827712':'广西|南宁',
'1827720':'广西|柳州',
'1827721':'广西|柳州',
'1827730':'广西|桂林',
'1827731':'广西|桂林',
'1827740':'广西|梧州',
'1827741':'广西|梧州',
'1827750':'广西|贵港',
'1827751':'广西|贵港',
'1827760':'广西|百色',
'1827761':'广西|百色',
'1827770':'广西|钦州',
'1827771':'广西|钦州',
'1827780':'广西|河池',
'1827781':'广西|河池',
'1827790':'广西|北海',
'1827791':'广西|北海',
'1827900':'江西|新余',
'1827901':'江西|新余',
'1827910':'江西|南昌',
'1827911':'江西|南昌',
'1827912':'江西|南昌',
'1827913':'江西|南昌',
'1827920':'江西|九江',
'1827921':'江西|九江',
'1827930':'江西|上饶',
'1827931':'江西|上饶',
'1827940':'江西|抚州',
'1827941':'江西|抚州',
'1827950':'江西|宜春',
'1827951':'江西|宜春',
'1827960':'江西|吉安',
'1827961':'江西|吉安',
'1827970':'江西|赣州',
'1827971':'江西|赣州',
'1827980':'江西|景德镇',
'1827981':'江西|景德镇',
'1827990':'江西|萍乡',
'1827991':'江西|萍乡',
'1828120':'四川|攀枝花',
'1828121':'四川|攀枝花',
'1828130':'四川|自贡',
'1828131':'四川|自贡',
'1828160':'四川|绵阳',
'1828161':'四川|绵阳',
'1828170':'四川|南充',
'1828171':'四川|南充',
'1828180':'四川|达州',
'1828181':'四川|达州',
'1828250':'四川|遂宁',
'1828251':'四川|遂宁',
'1828260':'四川|广安',
'1828261':'四川|广安',
'1828270':'四川|巴中',
'1828271':'四川|巴中',
'1828300':'重庆',
'1828301':'四川|泸州',
'1828310':'四川|宜宾',
'1828311':'四川|宜宾',
'1828320':'四川|内江',
'1828321':'四川|内江',
'1828330':'四川|乐山',
'1828331':'四川|乐山',
'1828350':'四川|雅安',
'1828351':'四川|雅安',
'1828380':'四川|德阳',
'1828381':'四川|德阳',
'1828390':'四川|广元',
'1828391':'四川|广元',
'1828400':'重庆',
'1828500':'重庆',
'1828510':'贵州|贵阳',
'1828511':'贵州|贵阳',
'1828512':'贵州|贵阳',
'1828520':'贵州|遵义',
'1828521':'贵州|遵义',
'1828530':'贵州|安顺',
'1828531':'贵州|安顺',
'1828560':'贵州|铜仁',
'1828561':'贵州|铜仁',
'1828570':'贵州|毕节',
'1828571':'贵州|毕节',
'1828580':'贵州|六盘水',
'1828581':'贵州|六盘水',
'1828700':'云南|昭通',
'1828701':'云南|昭通',
'1828710':'云南|昆明',
'1828711':'云南|昆明',
'1828712':'云南|昆明',
'1828713':'云南|昆明',
'1828720':'云南|大理',
'1828721':'云南|大理',
'1828740':'云南|曲靖',
'1828741':'云南|曲靖',
'1828750':'云南|保山',
'1828751':'云南|保山',
'1828770':'云南|玉溪',
'1828771':'云南|玉溪',
'1828790':'云南|普洱',
'1828791':'云南|普洱',
'1828880':'云南|丽江',
'1828881':'云南|丽江',
'1828910':'西藏|拉萨',
'1828911':'西藏|拉萨',
'1828920':'西藏|日喀则',
'1828921':'西藏|日喀则',
'1828980':'海南|海口',
'1828981':'海南|海口',
'1828982':'海南|海口',
'1828990':'海南|三亚',
'1828991':'海南|三亚',
'1829110':'陕西|延安',
'1829111':'陕西|延安',
'1829120':'陕西|榆林',
'1829121':'陕西|榆林',
'1829130':'陕西|渭南',
'1829131':'陕西|渭南',
'1829140':'陕西|商洛',
'1829141':'陕西|商洛',
'1829150':'陕西|安康',
'1829151':'陕西|安康',
'1829160':'陕西|汉中',
'1829161':'陕西|汉中',
'1829170':'陕西|宝鸡',
'1829171':'陕西|宝鸡',
'1829190':'陕西|铜川',
'1829191':'陕西|铜川',
'1829310':'甘肃|兰州',
'1829311':'甘肃|兰州',
'1829312':'甘肃|兰州',
'1829370':'甘肃|酒泉',
'1829371':'甘肃|酒泉',
'1829380':'甘肃|天水',
'1829381':'甘肃|天水',
'1829430':'甘肃|白银',
'1829431':'甘肃|白银',
'1829510':'宁夏|银川',
'1829511':'宁夏|银川',
'1829710':'青海|西宁',
'1829711':'青海|西宁',
'1829910':'新疆|乌鲁木齐',
'1829911':'新疆|乌鲁木齐',
'1829912':'新疆|乌鲁木齐',
'1831000':'北京',
'1831100':'北京',
'1831200':'北京',
'1831300':'北京',
'1831400':'北京',
'1831500':'北京',
'1831600':'北京',
'1831700':'北京',
'1831800':'北京',
'1831900':'北京',
'1832000':'广东|广州',
'1832001':'广东|广州',
'1832002':'广东|广州',
'1832003':'广东|广州',
'1832100':'上海',
'1832200':'上海',
'1832300':'上海',
'1832410':'辽宁|沈阳',
'1832411':'辽宁|沈阳',
'1832412':'辽宁|沈阳',
'1832413':'辽宁|沈阳',
'1832500':'江苏|南京',
'1832501':'江苏|南京',
'1832502':'江苏|南京',
'1832503':'江苏|南京',
'1832710':'湖北|武汉',
'1832711':'湖北|武汉',
'1832712':'湖北|武汉',
'1832713':'湖北|武汉',
'1832800':'四川|成都',
'1832801':'四川|成都',
'1832802':'四川|成都',
'1832803':'四川|成都',
'1832900':'陕西|咸阳',
'1832901':'陕西|咸阳',
'1832910':'陕西|西安',
'1832911':'陕西|西安',
'1832912':'陕西|西安',
'1832913':'陕西|西安',
'1833100':'河北|邯郸',
'1833101':'河北|邯郸',
'1833102':'河北|邯郸',
'1833110':'河北|石家庄',
'1833111':'河北|石家庄',
'1833112':'河北|石家庄',
'1833113':'河北|石家庄',
'1833120':'河北|保定',
'1833121':'河北|保定',
'1833122':'河北|保定',
'1833130':'河北|张家口',
'1833131':'河北|张家口',
'1833140':'河北|承德',
'1833141':'河北|承德',
'1833150':'河北|唐山',
'1833151':'河北|唐山',
'1833152':'河北|唐山',
'1833153':'河北|唐山',
'1833160':'河北|廊坊',
'1833161':'河北|廊坊',
'1833170':'河北|沧州',
'1833171':'河北|沧州',
'1833180':'河北|衡水',
'1833181':'河北|衡水',
'1833190':'河北|邢台',
'1833191':'河北|邢台',
'1833350':'河北|秦皇岛',
'1833351':'河北|秦皇岛',
'1833500':'山西|忻州',
'1833501':'山西|忻州',
'1833510':'山西|太原',
'1833511':'山西|太原',
'1833512':'山西|太原',
'1833513':'山西|太原',
'1833520':'山西|大同',
'1833521':'山西|大同',
'1833530':'山西|阳泉',
'1833531':'山西|阳泉',
'1833540':'山西|晋中',
'1833541':'山西|晋中',
'1833550':'山西|长治',
'1833551':'山西|长治',
'1833560':'山西|晋城',
'1833561':'山西|晋城',
'1833570':'山西|临汾',
'1833571':'山西|临汾',
'1833580':'山西|吕梁',
'1833581':'山西|吕梁',
'1833590':'山西|运城',
'1833591':'山西|运城',
'1833700':'河南|商丘',
'1833701':'河南|商丘',
'1833710':'河南|郑州',
'1833711':'河南|郑州',
'1833712':'河南|郑州',
'1833713':'河南|郑州',
'1833720':'河南|安阳',
'1833721':'河南|安阳',
'1833730':'河南|新乡',
'1833731':'河南|新乡',
'1833740':'河南|许昌',
'1833741':'河南|许昌',
'1833750':'河南|平顶山',
'1833751':'河南|平顶山',
'1833760':'河南|信阳',
'1833761':'河南|信阳',
'1833770':'河南|南阳',
'1833771':'河南|南阳',
'1833780':'河南|开封',
'1833781':'河南|开封',
'1833790':'河南|洛阳',
'1833791':'河南|洛阳',
'1833792':'河南|洛阳',
'1833910':'河南|焦作',
'1833911':'河南|焦作',
'1833920':'河南|鹤壁',
'1833921':'河南|鹤壁',
'1833930':'河南|濮阳',
'1833931':'河南|濮阳',
'1833940':'河南|周口',
'1833941':'河南|周口',
'1833950':'河南|漯河',
'1833951':'河南|漯河',
'1833960':'河南|驻马店',
'1833961':'河南|驻马店',
'1833980':'河南|三门峡',
'1833981':'河南|三门峡',
'1834100':'辽宁|铁岭',
'1834101':'辽宁|铁岭',
'1834110':'辽宁|大连',
'1834111':'辽宁|大连',
'1834112':'辽宁|大连',
'1834113':'辽宁|大连',
'1834120':'辽宁|鞍山',
'1834121':'辽宁|鞍山',
'1834130':'辽宁|抚顺',
'1834131':'辽宁|抚顺',
'1834140':'辽宁|本溪',
'1834141':'辽宁|本溪',
'1834150':'辽宁|丹东',
'1834151':'辽宁|丹东',
'1834160':'辽宁|锦州',
'1834161':'辽宁|锦州',
'1834170':'辽宁|营口',
'1834171':'辽宁|营口',
'1834180':'辽宁|阜新',
'1834181':'辽宁|阜新',
'1834190':'辽宁|辽阳',
'1834191':'辽宁|辽阳',
'1834210':'辽宁|朝阳',
'1834211':'辽宁|朝阳',
'1834270':'辽宁|盘锦',
'1834271':'辽宁|盘锦',
'1834290':'辽宁|葫芦岛',
'1834291':'辽宁|葫芦岛',
'1834310':'吉林|长春',
'1834311':'吉林|长春',
'1834312':'吉林|长春',
'1834313':'吉林|长春',
'1834320':'吉林|吉林市',
'1834321':'吉林|吉林市',
'1834340':'吉林|四平',
'1834341':'吉林|四平',
'1834350':'吉林|通化',
'1834351':'吉林|通化',
'1834360':'吉林|白城',
'1834361':'吉林|白城',
'1834370':'吉林|辽源',
'1834371':'吉林|辽源',
'1834380':'吉林|松原',
'1834381':'吉林|松原',
'1834390':'吉林|白山',
'1834391':'吉林|白山',
'1834510':'黑龙江|哈尔滨',
'1834511':'黑龙江|哈尔滨',
'1834512':'黑龙江|哈尔滨',
'1834513':'黑龙江|哈尔滨',
'1834520':'黑龙江|齐齐哈尔',
'1834521':'黑龙江|齐齐哈尔',
'1834530':'黑龙江|牡丹江',
'1834531':'黑龙江|牡丹江',
'1834540':'黑龙江|佳木斯',
'1834541':'黑龙江|佳木斯',
'1834550':'黑龙江|绥化',
'1834551':'黑龙江|绥化',
'1834580':'黑龙江|伊春',
'1834581':'黑龙江|伊春',
'1834590':'黑龙江|大庆',
'1834591':'黑龙江|大庆',
'1834670':'黑龙江|鸡西',
'1834671':'黑龙江|鸡西',
'1834710':'内蒙古|呼和浩特',
'1834711':'内蒙古|呼和浩特',
'1834712':'内蒙古|呼和浩特',
'1834720':'内蒙古|包头',
'1834721':'内蒙古|包头',
'1834730':'内蒙古|乌海',
'1834750':'内蒙古|通辽',
'1834751':'内蒙古|通辽',
'1834760':'内蒙古|赤峰',
'1834761':'内蒙古|赤峰',
'1834770':'内蒙古|鄂尔多斯',
'1834771':'内蒙古|鄂尔多斯',
'1835100':'江苏|无锡',
'1835101':'江苏|无锡',
'1835102':'江苏|无锡',
'1835110':'江苏|镇江',
'1835111':'江苏|镇江',
'1835120':'江苏|苏州',
'1835121':'江苏|苏州',
'1835122':'江苏|苏州',
'1835123':'江苏|苏州',
'1835130':'江苏|南通',
'1835131':'江苏|南通',
'1835132':'江苏|南通',
'1835140':'江苏|扬州',
'1835141':'江苏|扬州',
'1835150':'江苏|盐城',
'1835151':'江苏|盐城',
'1835160':'江苏|徐州',
'1835161':'江苏|徐州',
'1835162':'江苏|徐州',
'1835170':'江苏|淮安',
'1835171':'江苏|淮安',
'1835180':'江苏|连云港',
'1835181':'江苏|连云港',
'1835190':'江苏|常州',
'1835191':'江苏|常州',
'1835192':'江苏|常州',
'1835230':'江苏|泰州',
'1835231':'江苏|泰州',
'1835270':'江苏|宿迁',
'1835271':'江苏|宿迁',
'1835300':'山东|菏泽',
'1835301':'山东|菏泽',
'1835310':'山东|济南',
'1835311':'山东|济南',
'1835312':'山东|济南',
'1835313':'山东|济南',
'1835320':'山东|青岛',
'1835321':'山东|青岛',
'1835322':'山东|青岛',
'1835323':'山东|青岛',
'1835330':'山东|淄博',
'1835331':'山东|淄博',
'1835340':'山东|德州',
'1835341':'山东|德州',
'1835350':'山东|烟台',
'1835351':'山东|烟台',
'1835352':'山东|烟台',
'1835360':'山东|潍坊',
'1835361':'山东|潍坊',
'1835362':'山东|潍坊',
'1835370':'山东|济宁',
'1835371':'山东|济宁',
'1835380':'山东|泰安',
'1835381':'山东|泰安',
'1835390':'山东|临沂',
'1835391':'山东|临沂',
'1835430':'山东|滨州',
'1835431':'山东|滨州',
'1835460':'山东|东营',
'1835461':'山东|东营',
'1835500':'安徽|滁州',
'1835501':'安徽|滁州',
'1835510':'安徽|合肥',
'1835511':'安徽|合肥',
'1835512':'安徽|合肥',
'1835513':'安徽|合肥',
'1835514':'安徽|合肥',
'1835520':'安徽|蚌埠',
'1835521':'安徽|蚌埠',
'1835530':'安徽|芜湖',
'1835531':'安徽|芜湖',
'1835532':'安徽|芜湖',
'1835540':'安徽|淮南',
'1835541':'安徽|淮南',
'1835550':'安徽|马鞍山',
'1835551':'安徽|马鞍山',
'1835560':'安徽|安庆',
'1835561':'安徽|安庆',
'1835570':'安徽|宿州',
'1835571':'安徽|宿州',
'1835580':'安徽|阜阳',
'1835581':'安徽|阜阳',
'1835590':'安徽|黄山',
'1835591':'安徽|黄山',
'1835600':'安徽|合肥',
'1835601':'安徽|合肥',
'1835602':'安徽|合肥',
'1835603':'安徽|合肥',
'1835604':'安徽|合肥',
'1835610':'安徽|淮北',
'1835611':'安徽|淮北',
'1835620':'安徽|铜陵',
'1835621':'安徽|铜陵',
'1835630':'安徽|宣城',
'1835631':'安徽|宣城',
'1835640':'安徽|六安',
'1835641':'安徽|六安',
'1835660':'安徽|池州',
'1835661':'安徽|池州',
'1835700':'浙江|衢州',
'1835701':'浙江|衢州',
'1835710':'浙江|杭州',
'1835711':'浙江|杭州',
'1835712':'浙江|杭州',
'1835713':'浙江|杭州',
'1835720':'浙江|湖州',
'1835721':'浙江|湖州',
'1835730':'浙江|嘉兴',
'1835731':'浙江|嘉兴',
'1835740':'浙江|宁波',
'1835741':'浙江|宁波',
'1835742':'浙江|宁波',
'1835750':'浙江|绍兴',
'1835751':'浙江|绍兴',
'1835760':'浙江|台州',
'1835761':'浙江|台州',
'1835770':'浙江|温州',
'1835771':'浙江|温州',
'1835772':'浙江|温州',
'1835780':'浙江|丽水',
'1835781':'浙江|丽水',
'1835790':'浙江|金华',
'1835791':'浙江|金华',
'1835800':'浙江|舟山',
'1835801':'浙江|舟山',
'1835910':'福建|福州',
'1835911':'福建|福州',
'1835912':'福建|福州',
'1835913':'福建|福州',
'1835920':'福建|厦门',
'1835921':'福建|厦门',
'1835922':'福建|厦门',
'1835930':'福建|宁德',
'1835931':'福建|宁德',
'1835940':'福建|莆田',
'1835941':'福建|莆田',
'1835950':'福建|泉州',
'1835951':'福建|泉州',
'1835952':'福建|泉州',
'1835960':'福建|漳州',
'1835961':'福建|漳州',
'1835970':'福建|龙岩',
'1835971':'福建|龙岩',
'1835980':'福建|三明',
'1835981':'福建|三明',
'1835990':'福建|南平',
'1835991':'福建|南平',
'1836310':'山东|威海',
'1836311':'山东|威海',
'1836320':'山东|枣庄',
'1836321':'山东|枣庄',
'1836330':'山东|日照',
'1836331':'山东|日照',
'1836350':'山东|聊城',
'1836351':'山东|聊城',
'1836600':'广东|汕尾',
'1836601':'广东|汕尾',
'1836620':'广东|阳江',
'1836621':'广东|阳江',
'1836630':'广东|揭阳',
'1836631':'广东|揭阳',
'1836680':'广东|茂名',
'1836681':'广东|茂名',
'1837010':'江西|鹰潭',
'1837011':'江西|鹰潭',
'1837100':'湖北|襄阳',
'1837101':'湖北|襄阳',
'1837110':'湖北|鄂州',
'1837111':'湖北|鄂州',
'1837120':'湖北|孝感',
'1837121':'湖北|孝感',
'1837130':'湖北|黄冈',
'1837131':'湖北|黄冈',
'1837140':'湖北|黄石',
'1837141':'湖北|黄石',
'1837150':'湖北|咸宁',
'1837151':'湖北|咸宁',
'1837160':'湖北|荆州',
'1837161':'湖北|荆州',
'1837170':'湖北|宜昌',
'1837171':'湖北|宜昌',
'1837180':'湖北|恩施',
'1837181':'湖北|恩施',
'1837190':'湖北|十堰',
'1837191':'湖北|十堰',
'1837220':'湖北|随州',
'1837221':'湖北|随州',
'1837240':'湖北|荆门',
'1837241':'湖北|荆门',
'1837300':'湖南|岳阳',
'1837301':'湖南|岳阳',
'1837310':'湖南|长沙',
'1837311':'湖南|长沙',
'1837312':'湖南|长沙',
'1837313':'湖南|长沙',
'1837320':'湖南|湘潭',
'1837321':'湖南|湘潭',
'1837330':'湖南|株洲',
'1837331':'湖南|株洲',
'1837340':'湖南|衡阳',
'1837341':'湖南|衡阳',
'1837350':'湖南|郴州',
'1837351':'湖南|郴州',
'1837360':'湖南|常德',
'1837361':'湖南|常德',
'1837370':'湖南|益阳',
'1837371':'湖南|益阳',
'1837380':'湖南|娄底',
'1837381':'湖南|娄底',
'1837390':'湖南|邵阳',
'1837391':'湖南|邵阳',
'1837440':'湖南|张家界',
'1837441':'湖南|张家界',
'1837450':'湖南|怀化',
'1837451':'湖南|怀化',
'1837460':'湖南|永州',
'1837461':'湖南|永州',
'1837500':'广东|江门',
'1837501':'广东|江门',
'1837510':'广东|韶关',
'1837511':'广东|韶关',
'1837520':'广东|惠州',
'1837521':'广东|惠州',
'1837530':'广东|梅州',
'1837531':'广东|梅州',
'1837540':'广东|汕头',
'1837541':'广东|汕头',
'1837550':'广东|深圳',
'1837551':'广东|深圳',
'1837552':'广东|深圳',
'1837553':'广东|深圳',
'1837560':'广东|珠海',
'1837561':'广东|珠海',
'1837570':'广东|佛山',
'1837571':'广东|佛山',
'1837572':'广东|佛山',
'1837580':'广东|肇庆',
'1837581':'广东|肇庆',
'1837590':'广东|湛江',
'1837591':'广东|湛江',
'1837600':'广东|中山',
'1837601':'广东|中山',
'1837620':'广东|河源',
'1837621':'广东|河源',
'1837630':'广东|清远',
'1837631':'广东|清远',
'1837660':'广东|云浮',
'1837661':'广东|云浮',
'1837680':'广东|潮州',
'1837681':'广东|潮州',
'1837690':'广东|东莞',
'1837691':'广东|东莞',
'1837692':'广东|东莞',
'1837700':'广西|防城港',
'1837701':'广西|防城港',
'1837710':'广西|南宁',
'1837711':'广西|南宁',
'1837712':'广西|南宁',
'1837720':'广西|柳州',
'1837721':'广西|柳州',
'1837730':'广西|桂林',
'1837731':'广西|桂林',
'1837740':'广西|梧州',
'1837741':'广西|梧州',
'1837750':'广西|贵港',
'1837751':'广西|贵港',
'1837760':'广西|百色',
'1837761':'广西|百色',
'1837770':'广西|钦州',
'1837771':'广西|钦州',
'1837780':'广西|河池',
'1837781':'广西|河池',
'1837790':'广西|北海',
'1837791':'广西|北海',
'1837900':'江西|新余',
'1837901':'江西|新余',
'1837910':'江西|南昌',
'1837911':'江西|南昌',
'1837912':'江西|南昌',
'1837913':'江西|南昌',
'1837920':'江西|九江',
'1837921':'江西|九江',
'1837930':'江西|上饶',
'1837931':'江西|上饶',
'1837940':'江西|抚州',
'1837941':'江西|抚州',
'1837950':'江西|宜春',
'1837951':'江西|宜春',
'1837960':'江西|吉安',
'1837961':'江西|吉安',
'1837970':'江西|赣州',
'1837971':'江西|赣州',
'1837980':'江西|景德镇',
'1837981':'江西|景德镇',
'1837990':'江西|萍乡',
'1837991':'江西|萍乡',
'1838120':'四川|攀枝花',
'1838121':'四川|攀枝花',
'1838130':'四川|自贡',
'1838131':'四川|自贡',
'1838160':'四川|绵阳',
'1838161':'四川|绵阳',
'1838170':'四川|南充',
'1838171':'四川|南充',
'1838180':'四川|达州',
'1838181':'四川|达州',
'1838250':'四川|遂宁',
'1838251':'四川|遂宁',
'1838260':'四川|广安',
'1838261':'四川|广安',
'1838270':'四川|巴中',
'1838271':'四川|巴中',
'1838300':'重庆',
'1838301':'四川|泸州',
'1838310':'四川|宜宾',
'1838311':'四川|宜宾',
'1838320':'四川|内江',
'1838321':'四川|内江',
'1838330':'四川|乐山',
'1838331':'四川|乐山',
'1838350':'四川|雅安',
'1838351':'四川|雅安',
'1838380':'四川|德阳',
'1838381':'四川|德阳',
'1838390':'四川|广元',
'1838391':'四川|广元',
'1838400':'重庆',
'1838500':'重庆',
'1838510':'贵州|贵阳',
'1838511':'贵州|贵阳',
'1838512':'贵州|贵阳',
'1838520':'贵州|遵义',
'1838521':'贵州|遵义',
'1838530':'贵州|安顺',
'1838531':'贵州|安顺',
'1838560':'贵州|铜仁',
'1838561':'贵州|铜仁',
'1838570':'贵州|毕节',
'1838571':'贵州|毕节',
'1838580':'贵州|六盘水',
'1838581':'贵州|六盘水',
'1838700':'云南|昭通',
'1838701':'云南|昭通',
'1838710':'云南|昆明',
'1838711':'云南|昆明',
'1838712':'云南|昆明',
'1838713':'云南|昆明',
'1838720':'云南|大理',
'1838721':'云南|大理',
'1838740':'云南|曲靖',
'1838741':'云南|曲靖',
'1838750':'云南|保山',
'1838751':'云南|保山',
'1838770':'云南|玉溪',
'1838771':'云南|玉溪',
'1838790':'云南|普洱',
'1838791':'云南|普洱',
'1838880':'云南|丽江',
'1838881':'云南|丽江',
'1838910':'西藏|拉萨',
'1838911':'西藏|拉萨',
'1838920':'西藏|日喀则',
'1838921':'西藏|日喀则',
'1838980':'海南|海口',
'1838981':'海南|海口',
'1838982':'海南|海口',
'1838990':'海南|三亚',
'1838991':'海南|三亚',
'1839110':'陕西|延安',
'1839111':'陕西|延安',
'1839120':'陕西|榆林',
'1839121':'陕西|榆林',
'1839130':'陕西|渭南',
'1839131':'陕西|渭南',
'1839140':'陕西|商洛',
'1839141':'陕西|商洛',
'1839150':'陕西|安康',
'1839151':'陕西|安康',
'1839160':'陕西|汉中',
'1839161':'陕西|汉中',
'1839170':'陕西|宝鸡',
'1839171':'陕西|宝鸡',
'1839190':'陕西|铜川',
'1839191':'陕西|铜川',
'1839310':'甘肃|兰州',
'1839311':'甘肃|兰州',
'1839312':'甘肃|兰州',
'1839370':'甘肃|酒泉',
'1839371':'甘肃|酒泉',
'1839380':'甘肃|天水',
'1839381':'甘肃|天水',
'1839430':'甘肃|白银',
'1839431':'甘肃|白银',
'1839510':'宁夏|银川',
'1839511':'宁夏|银川',
'1839710':'青海|西宁',
'1839711':'青海|西宁',
'1839910':'新疆|乌鲁木齐',
'1839911':'新疆|乌鲁木齐',
'1839912':'新疆|乌鲁木齐',
'1841000':'北京',
'1841100':'北京',
'1841200':'北京',
'1841300':'北京',
'1841400':'北京',
'1841500':'北京',
'1841600':'北京',
'1841700':'北京',
'1841800':'北京',
'1841900':'北京',
'1842000':'广东|广州',
'1842001':'广东|广州',
'1842002':'广东|广州',
'1842003':'广东|广州',
'1842100':'上海',
'1842200':'上海',
'1842300':'上海',
'1842410':'辽宁|沈阳',
'1842411':'辽宁|沈阳',
'1842412':'辽宁|沈阳',
'1842413':'辽宁|沈阳',
'1842500':'江苏|南京',
'1842501':'江苏|南京',
'1842502':'江苏|南京',
'1842503':'江苏|南京',
'1842710':'湖北|武汉',
'1842711':'湖北|武汉',
'1842712':'湖北|武汉',
'1842713':'湖北|武汉',
'1842800':'四川|成都',
'1842801':'四川|成都',
'1842802':'四川|成都',
'1842803':'四川|成都',
'1842900':'陕西|咸阳',
'1842901':'陕西|咸阳',
'1842910':'陕西|西安',
'1842911':'陕西|西安',
'1842912':'陕西|西安',
'1842913':'陕西|西安',
'1843100':'河北|邯郸',
'1843101':'河北|邯郸',
'1843102':'河北|邯郸',
'1843110':'河北|石家庄',
'1843111':'河北|石家庄',
'1843112':'河北|石家庄',
'1843113':'河北|石家庄',
'1843120':'河北|保定',
'1843121':'河北|保定',
'1843122':'河北|保定',
'1843130':'河北|张家口',
'1843131':'河北|张家口',
'1843140':'河北|承德',
'1843141':'河北|承德',
'1843150':'河北|唐山',
'1843151':'河北|唐山',
'1843152':'河北|唐山',
'1843153':'河北|唐山',
'1843160':'河北|廊坊',
'1843161':'河北|廊坊',
'1843170':'河北|沧州',
'1843171':'河北|沧州',
'1843180':'河北|衡水',
'1843181':'河北|衡水',
'1843190':'河北|邢台',
'1843191':'河北|邢台',
'1843350':'河北|秦皇岛',
'1843351':'河北|秦皇岛',
'1843500':'山西|忻州',
'1843501':'山西|忻州',
'1843510':'山西|太原',
'1843511':'山西|太原',
'1843512':'山西|太原',
'1843513':'山西|太原',
'1843520':'山西|大同',
'1843521':'山西|大同',
'1843530':'山西|阳泉',
'1843531':'山西|阳泉',
'1843540':'山西|晋中',
'1843541':'山西|晋中',
'1843550':'山西|长治',
'1843551':'山西|长治',
'1843560':'山西|晋城',
'1843561':'山西|晋城',
'1843570':'山西|临汾',
'1843571':'山西|临汾',
'1843580':'山西|吕梁',
'1843581':'山西|吕梁',
'1843590':'山西|运城',
'1843591':'山西|运城',
'1843700':'河南|商丘',
'1843701':'河南|商丘',
'1843710':'河南|郑州',
'1843711':'河南|郑州',
'1843712':'河南|郑州',
'1843713':'河南|郑州',
'1843720':'河南|安阳',
'1843721':'河南|安阳',
'1843730':'河南|新乡',
'1843731':'河南|新乡',
'1843740':'河南|许昌',
'1843741':'河南|许昌',
'1843750':'河南|平顶山',
'1843751':'河南|平顶山',
'1843760':'河南|信阳',
'1843761':'河南|信阳',
'1843770':'河南|南阳',
'1843771':'河南|南阳',
'1843780':'河南|开封',
'1843781':'河南|开封',
'1843790':'河南|洛阳',
'1843791':'河南|洛阳',
'1843792':'河南|洛阳',
'1843910':'河南|焦作',
'1843911':'河南|焦作',
'1843920':'河南|鹤壁',
'1843921':'河南|鹤壁',
'1843930':'河南|濮阳',
'1843931':'河南|濮阳',
'1843940':'河南|周口',
'1843941':'河南|周口',
'1843950':'河南|漯河',
'1843951':'河南|漯河',
'1843960':'河南|驻马店',
'1843961':'河南|驻马店',
'1843980':'河南|三门峡',
'1843981':'河南|三门峡',
'1844100':'辽宁|铁岭',
'1844101':'辽宁|铁岭',
'1844110':'辽宁|大连',
'1844111':'辽宁|大连',
'1844112':'辽宁|大连',
'1844113':'辽宁|大连',
'1844120':'辽宁|鞍山',
'1844121':'辽宁|鞍山',
'1844130':'辽宁|抚顺',
'1844131':'辽宁|抚顺',
'1844140':'辽宁|本溪',
'1844141':'辽宁|本溪',
'1844150':'辽宁|丹东',
'1844151':'辽宁|丹东',
'1844160':'辽宁|锦州',
'1844161':'辽宁|锦州',
'1844170':'辽宁|营口',
'1844171':'辽宁|营口',
'1844180':'辽宁|阜新',
'1844181':'辽宁|阜新',
'1844190':'辽宁|辽阳',
'1844191':'辽宁|辽阳',
'1844210':'辽宁|朝阳',
'1844211':'辽宁|朝阳',
'1844270':'辽宁|盘锦',
'1844271':'辽宁|盘锦',
'1844290':'辽宁|葫芦岛',
'1844291':'辽宁|葫芦岛',
'1844310':'吉林|长春',
'1844311':'吉林|长春',
'1844312':'吉林|长春',
'1844313':'吉林|长春',
'1844320':'吉林|吉林市',
'1844321':'吉林|吉林市',
'1844340':'吉林|四平',
'1844341':'吉林|四平',
'1844350':'吉林|通化',
'1844351':'吉林|通化',
'1844360':'吉林|白城',
'1844361':'吉林|白城',
'1844370':'吉林|辽源',
'1844371':'吉林|辽源',
'1844380':'吉林|松原',
'1844381':'吉林|松原',
'1844390':'吉林|白山',
'1844391':'吉林|白山',
'1844510':'黑龙江|哈尔滨',
'1844511':'黑龙江|哈尔滨',
'1844512':'黑龙江|哈尔滨',
'1844513':'黑龙江|哈尔滨',
'1844520':'黑龙江|齐齐哈尔',
'1844521':'黑龙江|齐齐哈尔',
'1844530':'黑龙江|牡丹江',
'1844531':'黑龙江|牡丹江',
'1844540':'黑龙江|佳木斯',
'1844541':'黑龙江|佳木斯',
'1844550':'黑龙江|绥化',
'1844551':'黑龙江|绥化',
'1844580':'黑龙江|伊春',
'1844581':'黑龙江|伊春',
'1844590':'黑龙江|大庆',
'1844591':'黑龙江|大庆',
'1844670':'黑龙江|鸡西',
'1844671':'黑龙江|鸡西',
'1844710':'内蒙古|呼和浩特',
'1844711':'内蒙古|呼和浩特',
'1844712':'内蒙古|呼和浩特',
'1844720':'内蒙古|包头',
'1844721':'内蒙古|包头',
'1844730':'内蒙古|乌海',
'1844750':'内蒙古|通辽',
'1844751':'内蒙古|通辽',
'1844760':'内蒙古|赤峰',
'1844761':'内蒙古|赤峰',
'1844770':'内蒙古|鄂尔多斯',
'1844771':'内蒙古|鄂尔多斯',
'1845100':'江苏|无锡',
'1845101':'江苏|无锡',
'1845102':'江苏|无锡',
'1845110':'江苏|镇江',
'1845111':'江苏|镇江',
'1845120':'江苏|苏州',
'1845121':'江苏|苏州',
'1845122':'江苏|苏州',
'1845123':'江苏|苏州',
'1845130':'江苏|南通',
'1845131':'江苏|南通',
'1845132':'江苏|南通',
'1845140':'江苏|扬州',
'1845141':'江苏|扬州',
'1845150':'江苏|盐城',
'1845151':'江苏|盐城',
'1845160':'江苏|徐州',
'1845161':'江苏|徐州',
'1845162':'江苏|徐州',
'1845170':'江苏|淮安',
'1845171':'江苏|淮安',
'1845180':'江苏|连云港',
'1845181':'江苏|连云港',
'1845190':'江苏|常州',
'1845191':'江苏|常州',
'1845192':'江苏|常州',
'1845230':'江苏|泰州',
'1845231':'江苏|泰州',
'1845270':'江苏|宿迁',
'1845271':'江苏|宿迁',
'1845300':'山东|菏泽',
'1845301':'山东|菏泽',
'1845310':'山东|济南',
'1845311':'山东|济南',
'1845312':'山东|济南',
'1845313':'山东|济南',
'1845320':'山东|青岛',
'1845321':'山东|青岛',
'1845322':'山东|青岛',
'1845323':'山东|青岛',
'1845330':'山东|淄博',
'1845331':'山东|淄博',
'1845340':'山东|德州',
'1845341':'山东|德州',
'1845350':'山东|烟台',
'1845351':'山东|烟台',
'1845352':'山东|烟台',
'1845360':'山东|潍坊',
'1845361':'山东|潍坊',
'1845362':'山东|潍坊',
'1845370':'山东|济宁',
'1845371':'山东|济宁',
'1845380':'山东|泰安',
'1845381':'山东|泰安',
'1845390':'山东|临沂',
'1845391':'山东|临沂',
'1845430':'山东|滨州',
'1845431':'山东|滨州',
'1845460':'山东|东营',
'1845461':'山东|东营',
'1845500':'安徽|滁州',
'1845501':'安徽|滁州',
'1845510':'安徽|合肥',
'1845511':'安徽|合肥',
'1845512':'安徽|合肥',
'1845513':'安徽|合肥',
'1845514':'安徽|合肥',
'1845520':'安徽|蚌埠',
'1845521':'安徽|蚌埠',
'1845530':'安徽|芜湖',
'1845531':'安徽|芜湖',
'1845532':'安徽|芜湖',
'1845540':'安徽|淮南',
'1845541':'安徽|淮南',
'1845550':'安徽|马鞍山',
'1845551':'安徽|马鞍山',
'1845560':'安徽|安庆',
'1845561':'安徽|安庆',
'1845570':'安徽|宿州',
'1845571':'安徽|宿州',
'1845580':'安徽|阜阳',
'1845581':'安徽|阜阳',
'1845590':'安徽|黄山',
'1845591':'安徽|黄山',
'1845600':'安徽|合肥',
'1845601':'安徽|合肥',
'1845602':'安徽|合肥',
'1845603':'安徽|合肥',
'1845604':'安徽|合肥',
'1845610':'安徽|淮北',
'1845611':'安徽|淮北',
'1845620':'安徽|铜陵',
'1845621':'安徽|铜陵',
'1845630':'安徽|宣城',
'1845631':'安徽|宣城',
'1845640':'安徽|六安',
'1845641':'安徽|六安',
'1845660':'安徽|池州',
'1845661':'安徽|池州',
'1845700':'浙江|衢州',
'1845701':'浙江|衢州',
'1845710':'浙江|杭州',
'1845711':'浙江|杭州',
'1845712':'浙江|杭州',
'1845713':'浙江|杭州',
'1845720':'浙江|湖州',
'1845721':'浙江|湖州',
'1845730':'浙江|嘉兴',
'1845731':'浙江|嘉兴',
'1845740':'浙江|宁波',
'1845741':'浙江|宁波',
'1845742':'浙江|宁波',
'1845750':'浙江|绍兴',
'1845751':'浙江|绍兴',
'1845760':'浙江|台州',
'1845761':'浙江|台州',
'1845770':'浙江|温州',
'1845771':'浙江|温州',
'1845772':'浙江|温州',
'1845780':'浙江|丽水',
'1845781':'浙江|丽水',
'1845790':'浙江|金华',
'1845791':'浙江|金华',
'1845800':'浙江|舟山',
'1845801':'浙江|舟山',
'1845910':'福建|福州',
'1845911':'福建|福州',
'1845912':'福建|福州',
'1845913':'福建|福州',
'1845920':'福建|厦门',
'1845921':'福建|厦门',
'1845922':'福建|厦门',
'1845930':'福建|宁德',
'1845931':'福建|宁德',
'1845940':'福建|莆田',
'1845941':'福建|莆田',
'1845950':'福建|泉州',
'1845951':'福建|泉州',
'1845952':'福建|泉州',
'1845960':'福建|漳州',
'1845961':'福建|漳州',
'1845970':'福建|龙岩',
'1845971':'福建|龙岩',
'1845980':'福建|三明',
'1845981':'福建|三明',
'1845990':'福建|南平',
'1845991':'福建|南平',
'1846310':'山东|威海',
'1846311':'山东|威海',
'1846320':'山东|枣庄',
'1846321':'山东|枣庄',
'1846330':'山东|日照',
'1846331':'山东|日照',
'1846350':'山东|聊城',
'1846351':'山东|聊城',
'1846600':'广东|汕尾',
'1846601':'广东|汕尾',
'1846620':'广东|阳江',
'1846621':'广东|阳江',
'1846630':'广东|揭阳',
'1846631':'广东|揭阳',
'1846680':'广东|茂名',
'1846681':'广东|茂名',
'1847010':'江西|鹰潭',
'1847011':'江西|鹰潭',
'1847100':'湖北|襄阳',
'1847101':'湖北|襄阳',
'1847110':'湖北|鄂州',
'1847111':'湖北|鄂州',
'1847120':'湖北|孝感',
'1847121':'湖北|孝感',
'1847130':'湖北|黄冈',
'1847131':'湖北|黄冈',
'1847140':'湖北|黄石',
'1847141':'湖北|黄石',
'1847150':'湖北|咸宁',
'1847151':'湖北|咸宁',
'1847160':'湖北|荆州',
'1847161':'湖北|荆州',
'1847170':'湖北|宜昌',
'1847171':'湖北|宜昌',
'1847180':'湖北|恩施',
'1847181':'湖北|恩施',
'1847190':'湖北|十堰',
'1847191':'湖北|十堰',
'1847220':'湖北|随州',
'1847221':'湖北|随州',
'1847240':'湖北|荆门',
'1847241':'湖北|荆门',
'1847300':'湖南|岳阳',
'1847301':'湖南|岳阳',
'1847310':'湖南|长沙',
'1847311':'湖南|长沙',
'1847312':'湖南|长沙',
'1847313':'湖南|长沙',
'1847320':'湖南|湘潭',
'1847321':'湖南|湘潭',
'1847330':'湖南|株洲',
'1847331':'湖南|株洲',
'1847340':'湖南|衡阳',
'1847341':'湖南|衡阳',
'1847350':'湖南|郴州',
'1847351':'湖南|郴州',
'1847360':'湖南|常德',
'1847361':'湖南|常德',
'1847370':'湖南|益阳',
'1847371':'湖南|益阳',
'1847380':'湖南|娄底',
'1847381':'湖南|娄底',
'1847390':'湖南|邵阳',
'1847391':'湖南|邵阳',
'1847440':'湖南|张家界',
'1847441':'湖南|张家界',
'1847450':'湖南|怀化',
'1847451':'湖南|怀化',
'1847460':'湖南|永州',
'1847461':'湖南|永州',
'1847500':'广东|江门',
'1847501':'广东|江门',
'1847510':'广东|韶关',
'1847511':'广东|韶关',
'1847520':'广东|惠州',
'1847521':'广东|惠州',
'1847530':'广东|梅州',
'1847531':'广东|梅州',
'1847540':'广东|汕头',
'1847541':'广东|汕头',
'1847550':'广东|深圳',
'1847551':'广东|深圳',
'1847552':'广东|深圳',
'1847553':'广东|深圳',
'1847560':'广东|珠海',
'1847561':'广东|珠海',
'1847570':'广东|佛山',
'1847571':'广东|佛山',
'1847572':'广东|佛山',
'1847580':'广东|肇庆',
'1847581':'广东|肇庆',
'1847590':'广东|湛江',
'1847591':'广东|湛江',
'1847600':'广东|中山',
'1847601':'广东|中山',
'1847620':'广东|河源',
'1847621':'广东|河源',
'1847630':'广东|清远',
'1847631':'广东|清远',
'1847660':'广东|云浮',
'1847661':'广东|云浮',
'1847680':'广东|潮州',
'1847681':'广东|潮州',
'1847690':'广东|东莞',
'1847691':'广东|东莞',
'1847692':'广东|东莞',
'1847700':'广西|防城港',
'1847701':'广西|防城港',
'1847710':'广西|南宁',
'1847711':'广西|南宁',
'1847712':'广西|南宁',
'1847720':'广西|柳州',
'1847721':'广西|柳州',
'1847730':'广西|桂林',
'1847731':'广西|桂林',
'1847740':'广西|梧州',
'1847741':'广西|梧州',
'1847750':'广西|贵港',
'1847751':'广西|贵港',
'1847760':'广西|百色',
'1847761':'广西|百色',
'1847770':'广西|钦州',
'1847771':'广西|钦州',
'1847780':'广西|河池',
'1847781':'广西|河池',
'1847790':'广西|北海',
'1847791':'广西|北海',
'1847900':'江西|新余',
'1847901':'江西|新余',
'1847910':'江西|南昌',
'1847911':'江西|南昌',
'1847912':'江西|南昌',
'1847913':'江西|南昌',
'1847920':'江西|九江',
'1847921':'江西|九江',
'1847930':'江西|上饶',
'1847931':'江西|上饶',
'1847940':'江西|抚州',
'1847941':'江西|抚州',
'1847950':'江西|宜春',
'1847951':'江西|宜春',
'1847960':'江西|吉安',
'1847961':'江西|吉安',
'1847970':'江西|赣州',
'1847971':'江西|赣州',
'1847980':'江西|景德镇',
'1847981':'江西|景德镇',
'1847990':'江西|萍乡',
'1847991':'江西|萍乡',
'1848120':'四川|攀枝花',
'1848121':'四川|攀枝花',
'1848130':'四川|自贡',
'1848131':'四川|自贡',
'1848160':'四川|绵阳',
'1848161':'四川|绵阳',
'1848170':'四川|南充',
'1848171':'四川|南充',
'1848180':'四川|达州',
'1848181':'四川|达州',
'1848250':'四川|遂宁',
'1848251':'四川|遂宁',
'1848260':'四川|广安',
'1848261':'四川|广安',
'1848270':'四川|巴中',
'1848271':'四川|巴中',
'1848300':'重庆',
'1848301':'四川|泸州',
'1848310':'四川|宜宾',
'1848311':'四川|宜宾',
'1848320':'四川|内江',
'1848321':'四川|内江',
'1848330':'四川|乐山',
'1848331':'四川|乐山',
'1848350':'四川|雅安',
'1848351':'四川|雅安',
'1848380':'四川|德阳',
'1848381':'四川|德阳',
'1848390':'四川|广元',
'1848391':'四川|广元',
'1848400':'重庆',
'1848500':'重庆',
'1848510':'贵州|贵阳',
'1848511':'贵州|贵阳',
'1848512':'贵州|贵阳',
'1848520':'贵州|遵义',
'1848521':'贵州|遵义',
'1848530':'贵州|安顺',
'1848531':'贵州|安顺',
'1848560':'贵州|铜仁',
'1848561':'贵州|铜仁',
'1848570':'贵州|毕节',
'1848571':'贵州|毕节',
'1848580':'贵州|六盘水',
'1848581':'贵州|六盘水',
'1848700':'云南|昭通',
'1848701':'云南|昭通',
'1848710':'云南|昆明',
'1848711':'云南|昆明',
'1848712':'云南|昆明',
'1848713':'云南|昆明',
'1848720':'云南|大理',
'1848721':'云南|大理',
'1848740':'云南|曲靖',
'1848741':'云南|曲靖',
'1848750':'云南|保山',
'1848751':'云南|保山',
'1848770':'云南|玉溪',
'1848771':'云南|玉溪',
'1848790':'云南|普洱',
'1848791':'云南|普洱',
'1848880':'云南|丽江',
'1848881':'云南|丽江',
'1848910':'西藏|拉萨',
'1848911':'西藏|拉萨',
'1848920':'西藏|日喀则',
'1848921':'西藏|日喀则',
'1848980':'海南|海口',
'1848981':'海南|海口',
'1848982':'海南|海口',
'1848990':'海南|三亚',
'1848991':'海南|三亚',
'1849110':'陕西|延安',
'1849111':'陕西|延安',
'1849120':'陕西|榆林',
'1849121':'陕西|榆林',
'1849130':'陕西|渭南',
'1849131':'陕西|渭南',
'1849140':'陕西|商洛',
'1849141':'陕西|商洛',
'1849150':'陕西|安康',
'1849151':'陕西|安康',
'1849160':'陕西|汉中',
'1849161':'陕西|汉中',
'1849170':'陕西|宝鸡',
'1849171':'陕西|宝鸡',
'1849190':'陕西|铜川',
'1849191':'陕西|铜川',
'1849310':'甘肃|兰州',
'1849311':'甘肃|兰州',
'1849312':'甘肃|兰州',
'1849370':'甘肃|酒泉',
'1849371':'甘肃|酒泉',
'1849380':'甘肃|天水',
'1849381':'甘肃|天水',
'1849430':'甘肃|白银',
'1849431':'甘肃|白银',
'1849510':'宁夏|银川',
'1849511':'宁夏|银川',
'1849710':'青海|西宁',
'1849711':'青海|西宁',
'1849910':'新疆|乌鲁木齐',
'1849911':'新疆|乌鲁木齐',
'1849912':'新疆|乌鲁木齐',
'1871000':'北京',
'1871100':'北京',
'1871200':'北京',
'1871300':'北京',
'1871400':'北京',
'1871500':'北京',
'1871600':'北京',
'1871700':'北京',
'1871800':'北京',
'1871900':'北京',
'1872000':'广东|广州',
'1872001':'广东|广州',
'1872002':'广东|广州',
'1872003':'广东|广州',
'1872100':'上海',
'1872200':'上海',
'1872300':'上海',
'1872410':'辽宁|沈阳',
'1872411':'辽宁|沈阳',
'1872412':'辽宁|沈阳',
'1872413':'辽宁|沈阳',
'1872500':'江苏|南京',
'1872501':'江苏|南京',
'1872502':'江苏|南京',
'1872503':'江苏|南京',
'1872710':'湖北|武汉',
'1872711':'湖北|武汉',
'1872712':'湖北|武汉',
'1872713':'湖北|武汉',
'1872800':'四川|成都',
'1872801':'四川|成都',
'1872802':'四川|成都',
'1872803':'四川|成都',
'1872900':'陕西|咸阳',
'1872901':'陕西|咸阳',
'1872910':'陕西|西安',
'1872911':'陕西|西安',
'1872912':'陕西|西安',
'1872913':'陕西|西安',
'1873100':'河北|邯郸',
'1873101':'河北|邯郸',
'1873102':'河北|邯郸',
'1873110':'河北|石家庄',
'1873111':'河北|石家庄',
'1873112':'河北|石家庄',
'1873113':'河北|石家庄',
'1873120':'河北|保定',
'1873121':'河北|保定',
'1873122':'河北|保定',
'1873130':'河北|张家口',
'1873131':'河北|张家口',
'1873140':'河北|承德',
'1873141':'河北|承德',
'1873150':'河北|唐山',
'1873151':'河北|唐山',
'1873152':'河北|唐山',
'1873153':'河北|唐山',
'1873160':'河北|廊坊',
'1873161':'河北|廊坊',
'1873170':'河北|沧州',
'1873171':'河北|沧州',
'1873180':'河北|衡水',
'1873181':'河北|衡水',
'1873190':'河北|邢台',
'1873191':'河北|邢台',
'1873350':'河北|秦皇岛',
'1873351':'河北|秦皇岛',
'1873500':'山西|忻州',
'1873501':'山西|忻州',
'1873510':'山西|太原',
'1873511':'山西|太原',
'1873512':'山西|太原',
'1873513':'山西|太原',
'1873520':'山西|大同',
'1873521':'山西|大同',
'1873530':'山西|阳泉',
'1873531':'山西|阳泉',
'1873540':'山西|晋中',
'1873541':'山西|晋中',
'1873550':'山西|长治',
'1873551':'山西|长治',
'1873560':'山西|晋城',
'1873561':'山西|晋城',
'1873570':'山西|临汾',
'1873571':'山西|临汾',
'1873580':'山西|吕梁',
'1873581':'山西|吕梁',
'1873590':'山西|运城',
'1873591':'山西|运城',
'1873700':'河南|商丘',
'1873701':'河南|商丘',
'1873710':'河南|郑州',
'1873711':'河南|郑州',
'1873712':'河南|郑州',
'1873713':'河南|郑州',
'1873720':'河南|安阳',
'1873721':'河南|安阳',
'1873730':'河南|新乡',
'1873731':'河南|新乡',
'1873740':'河南|许昌',
'1873741':'河南|许昌',
'1873750':'河南|平顶山',
'1873751':'河南|平顶山',
'1873760':'河南|信阳',
'1873761':'河南|信阳',
'1873770':'河南|南阳',
'1873771':'河南|南阳',
'1873780':'河南|开封',
'1873781':'河南|开封',
'1873790':'河南|洛阳',
'1873791':'河南|洛阳',
'1873792':'河南|洛阳',
'1873910':'河南|焦作',
'1873911':'河南|焦作',
'1873920':'河南|鹤壁',
'1873921':'河南|鹤壁',
'1873930':'河南|濮阳',
'1873931':'河南|濮阳',
'1873940':'河南|周口',
'1873941':'河南|周口',
'1873950':'河南|漯河',
'1873951':'河南|漯河',
'1873960':'河南|驻马店',
'1873961':'河南|驻马店',
'1873980':'河南|三门峡',
'1873981':'河南|三门峡',
'1874100':'辽宁|铁岭',
'1874101':'辽宁|铁岭',
'1874110':'辽宁|大连',
'1874111':'辽宁|大连',
'1874112':'辽宁|大连',
'1874113':'辽宁|大连',
'1874120':'辽宁|鞍山',
'1874121':'辽宁|鞍山',
'1874130':'辽宁|抚顺',
'1874131':'辽宁|抚顺',
'1874140':'辽宁|本溪',
'1874141':'辽宁|本溪',
'1874150':'辽宁|丹东',
'1874151':'辽宁|丹东',
'1874160':'辽宁|锦州',
'1874161':'辽宁|锦州',
'1874170':'辽宁|营口',
'1874171':'辽宁|营口',
'1874180':'辽宁|阜新',
'1874181':'辽宁|阜新',
'1874190':'辽宁|辽阳',
'1874191':'辽宁|辽阳',
'1874210':'辽宁|朝阳',
'1874211':'辽宁|朝阳',
'1874270':'辽宁|盘锦',
'1874271':'辽宁|盘锦',
'1874290':'辽宁|葫芦岛',
'1874291':'辽宁|葫芦岛',
'1874310':'吉林|长春',
'1874311':'吉林|长春',
'1874312':'吉林|长春',
'1874313':'吉林|长春',
'1874320':'吉林|吉林市',
'1874321':'吉林|吉林市',
'1874340':'吉林|四平',
'1874341':'吉林|四平',
'1874350':'吉林|通化',
'1874351':'吉林|通化',
'1874360':'吉林|白城',
'1874361':'吉林|白城',
'1874370':'吉林|辽源',
'1874371':'吉林|辽源',
'1874380':'吉林|松原',
'1874381':'吉林|松原',
'1874390':'吉林|白山',
'1874391':'吉林|白山',
'1874510':'黑龙江|哈尔滨',
'1874511':'黑龙江|哈尔滨',
'1874512':'黑龙江|哈尔滨',
'1874513':'黑龙江|哈尔滨',
'1874520':'黑龙江|齐齐哈尔',
'1874521':'黑龙江|齐齐哈尔',
'1874530':'黑龙江|牡丹江',
'1874531':'黑龙江|牡丹江',
'1874540':'黑龙江|佳木斯',
'1874541':'黑龙江|佳木斯',
'1874550':'黑龙江|绥化',
'1874551':'黑龙江|绥化',
'1874580':'黑龙江|伊春',
'1874581':'黑龙江|伊春',
'1874590':'黑龙江|大庆',
'1874591':'黑龙江|大庆',
'1874670':'黑龙江|鸡西',
'1874671':'黑龙江|鸡西',
'1874710':'内蒙古|呼和浩特',
'1874711':'内蒙古|呼和浩特',
'1874712':'内蒙古|呼和浩特',
'1874720':'内蒙古|包头',
'1874721':'内蒙古|包头',
'1874730':'内蒙古|乌海',
'1874750':'内蒙古|通辽',
'1874751':'内蒙古|通辽',
'1874760':'内蒙古|赤峰',
'1874761':'内蒙古|赤峰',
'1874770':'内蒙古|鄂尔多斯',
'1874771':'内蒙古|鄂尔多斯',
'1875100':'江苏|无锡',
'1875101':'江苏|无锡',
'1875102':'江苏|无锡',
'1875110':'江苏|镇江',
'1875111':'江苏|镇江',
'1875120':'江苏|苏州',
'1875121':'江苏|苏州',
'1875122':'江苏|苏州',
'1875123':'江苏|苏州',
'1875130':'江苏|南通',
'1875131':'江苏|南通',
'1875132':'江苏|南通',
'1875140':'江苏|扬州',
'1875141':'江苏|扬州',
'1875150':'江苏|盐城',
'1875151':'江苏|盐城',
'1875160':'江苏|徐州',
'1875161':'江苏|徐州',
'1875162':'江苏|徐州',
'1875170':'江苏|淮安',
'1875171':'江苏|淮安',
'1875180':'江苏|连云港',
'1875181':'江苏|连云港',
'1875190':'江苏|常州',
'1875191':'江苏|常州',
'1875192':'江苏|常州',
'1875230':'江苏|泰州',
'1875231':'江苏|泰州',
'1875270':'江苏|宿迁',
'1875271':'江苏|宿迁',
'1875300':'山东|菏泽',
'1875301':'山东|菏泽',
'1875310':'山东|济南',
'1875311':'山东|济南',
'1875312':'山东|济南',
'1875313':'山东|济南',
'1875320':'山东|青岛',
'1875321':'山东|青岛',
'1875322':'山东|青岛',
'1875323':'山东|青岛',
'1875330':'山东|淄博',
'1875331':'山东|淄博',
'1875340':'山东|德州',
'1875341':'山东|德州',
'1875350':'山东|烟台',
'1875351':'山东|烟台',
'1875352':'山东|烟台',
'1875360':'山东|潍坊',
'1875361':'山东|潍坊',
'1875362':'山东|潍坊',
'1875370':'山东|济宁',
'1875371':'山东|济宁',
'1875380':'山东|泰安',
'1875381':'山东|泰安',
'1875390':'山东|临沂',
'1875391':'山东|临沂',
'1875430':'山东|滨州',
'1875431':'山东|滨州',
'1875460':'山东|东营',
'1875461':'山东|东营',
'1875500':'安徽|滁州',
'1875501':'安徽|滁州',
'1875510':'安徽|合肥',
'1875511':'安徽|合肥',
'1875512':'安徽|合肥',
'1875513':'安徽|合肥',
'1875514':'安徽|合肥',
'1875520':'安徽|蚌埠',
'1875521':'安徽|蚌埠',
'1875530':'安徽|芜湖',
'1875531':'安徽|芜湖',
'1875532':'安徽|芜湖',
'1875540':'安徽|淮南',
'1875541':'安徽|淮南',
'1875550':'安徽|马鞍山',
'1875551':'安徽|马鞍山',
'1875560':'安徽|安庆',
'1875561':'安徽|安庆',
'1875570':'安徽|宿州',
'1875571':'安徽|宿州',
'1875580':'安徽|阜阳',
'1875581':'安徽|阜阳',
'1875590':'安徽|黄山',
'1875591':'安徽|黄山',
'1875600':'安徽|合肥',
'1875601':'安徽|合肥',
'1875602':'安徽|合肥',
'1875603':'安徽|合肥',
'1875604':'安徽|合肥',
'1875610':'安徽|淮北',
'1875611':'安徽|淮北',
'1875620':'安徽|铜陵',
'1875621':'安徽|铜陵',
'1875630':'安徽|宣城',
'1875631':'安徽|宣城',
'1875640':'安徽|六安',
'1875641':'安徽|六安',
'1875660':'安徽|池州',
'1875661':'安徽|池州',
'1875700':'浙江|衢州',
'1875701':'浙江|衢州',
'1875710':'浙江|杭州',
'1875711':'浙江|杭州',
'1875712':'浙江|杭州',
'1875713':'浙江|杭州',
'1875720':'浙江|湖州',
'1875721':'浙江|湖州',
'1875730':'浙江|嘉兴',
'1875731':'浙江|嘉兴',
'1875740':'浙江|宁波',
'1875741':'浙江|宁波',
'1875742':'浙江|宁波',
'1875750':'浙江|绍兴',
'1875751':'浙江|绍兴',
'1875760':'浙江|台州',
'1875761':'浙江|台州',
'1875770':'浙江|温州',
'1875771':'浙江|温州',
'1875772':'浙江|温州',
'1875780':'浙江|丽水',
'1875781':'浙江|丽水',
'1875790':'浙江|金华',
'1875791':'浙江|金华',
'1875800':'浙江|舟山',
'1875801':'浙江|舟山',
'1875910':'福建|福州',
'1875911':'福建|福州',
'1875912':'福建|福州',
'1875913':'福建|福州',
'1875920':'福建|厦门',
'1875921':'福建|厦门',
'1875922':'福建|厦门',
'1875930':'福建|宁德',
'1875931':'福建|宁德',
'1875940':'福建|莆田',
'1875941':'福建|莆田',
'1875950':'福建|泉州',
'1875951':'福建|泉州',
'1875952':'福建|泉州',
'1875960':'福建|漳州',
'1875961':'福建|漳州',
'1875970':'福建|龙岩',
'1875971':'福建|龙岩',
'1875980':'福建|三明',
'1875981':'福建|三明',
'1875990':'福建|南平',
'1875991':'福建|南平',
'1876310':'山东|威海',
'1876311':'山东|威海',
'1876320':'山东|枣庄',
'1876321':'山东|枣庄',
'1876330':'山东|日照',
'1876331':'山东|日照',
'1876350':'山东|聊城',
'1876351':'山东|聊城',
'1876600':'广东|汕尾',
'1876601':'广东|汕尾',
'1876620':'广东|阳江',
'1876621':'广东|阳江',
'1876630':'广东|揭阳',
'1876631':'广东|揭阳',
'1876680':'广东|茂名',
'1876681':'广东|茂名',
'1877010':'江西|鹰潭',
'1877011':'江西|鹰潭',
'1877100':'湖北|襄阳',
'1877101':'湖北|襄阳',
'1877110':'湖北|鄂州',
'1877111':'湖北|鄂州',
'1877120':'湖北|孝感',
'1877121':'湖北|孝感',
'1877130':'湖北|黄冈',
'1877131':'湖北|黄冈',
'1877140':'湖北|黄石',
'1877141':'湖北|黄石',
'1877150':'湖北|咸宁',
'1877151':'湖北|咸宁',
'1877160':'湖北|荆州',
'1877161':'湖北|荆州',
'1877170':'湖北|宜昌',
'1877171':'湖北|宜昌',
'1877180':'湖北|恩施',
'1877181':'湖北|恩施',
'1877190':'湖北|十堰',
'1877191':'湖北|十堰',
'1877220':'湖北|随州',
'1877221':'湖北|随州',
'1877240':'湖北|荆门',
'1877241':'湖北|荆门',
'1877300':'湖南|岳阳',
'1877301':'湖南|岳阳',
'1877310':'湖南|长沙',
'1877311':'湖南|长沙',
'1877312':'湖南|长沙',
'1877313':'湖南|长沙',
'1877320':'湖南|湘潭',
'1877321':'湖南|湘潭',
'1877330':'湖南|株洲',
'1877331':'湖南|株洲',
'1877340':'湖南|衡阳',
'1877341':'湖南|衡阳',
'1877350':'湖南|郴州',
'1877351':'湖南|郴州',
'1877360':'湖南|常德',
'1877361':'湖南|常德',
'1877370':'湖南|益阳',
'1877371':'湖南|益阳',
'1877380':'湖南|娄底',
'1877381':'湖南|娄底',
'1877390':'湖南|邵阳',
'1877391':'湖南|邵阳',
'1877440':'湖南|张家界',
'1877441':'湖南|张家界',
'1877450':'湖南|怀化',
'1877451':'湖南|怀化',
'1877460':'湖南|永州',
'1877461':'湖南|永州',
'1877500':'广东|江门',
'1877501':'广东|江门',
'1877510':'广东|韶关',
'1877511':'广东|韶关',
'1877520':'广东|惠州',
'1877521':'广东|惠州',
'1877530':'广东|梅州',
'1877531':'广东|梅州',
'1877540':'广东|汕头',
'1877541':'广东|汕头',
'1877550':'广东|深圳',
'1877551':'广东|深圳',
'1877552':'广东|深圳',
'1877553':'广东|深圳',
'1877560':'广东|珠海',
'1877561':'广东|珠海',
'1877570':'广东|佛山',
'1877571':'广东|佛山',
'1877572':'广东|佛山',
'1877580':'广东|肇庆',
'1877581':'广东|肇庆',
'1877590':'广东|湛江',
'1877591':'广东|湛江',
'1877600':'广东|中山',
'1877601':'广东|中山',
'1877620':'广东|河源',
'1877621':'广东|河源',
'1877630':'广东|清远',
'1877631':'广东|清远',
'1877660':'广东|云浮',
'1877661':'广东|云浮',
'1877680':'广东|潮州',
'1877681':'广东|潮州',
'1877690':'广东|东莞',
'1877691':'广东|东莞',
'1877692':'广东|东莞',
'1877700':'广西|防城港',
'1877701':'广西|防城港',
'1877710':'广西|南宁',
'1877711':'广西|南宁',
'1877712':'广西|南宁',
'1877720':'广西|柳州',
'1877721':'广西|柳州',
'1877730':'广西|桂林',
'1877731':'广西|桂林',
'1877740':'广西|梧州',
'1877741':'广西|梧州',
'1877750':'广西|贵港',
'1877751':'广西|贵港',
'1877760':'广西|百色',
'1877761':'广西|百色',
'1877770':'广西|钦州',
'1877771':'广西|钦州',
'1877780':'广西|河池',
'1877781':'广西|河池',
'1877790':'广西|北海',
'1877791':'广西|北海',
'1877900':'江西|新余',
'1877901':'江西|新余',
'1877910':'江西|南昌',
'1877911':'江西|南昌',
'1877912':'江西|南昌',
'1877913':'江西|南昌',
'1877920':'江西|九江',
'1877921':'江西|九江',
'1877930':'江西|上饶',
'1877931':'江西|上饶',
'1877940':'江西|抚州',
'1877941':'江西|抚州',
'1877950':'江西|宜春',
'1877951':'江西|宜春',
'1877960':'江西|吉安',
'1877961':'江西|吉安',
'1877970':'江西|赣州',
'1877971':'江西|赣州',
'1877980':'江西|景德镇',
'1877981':'江西|景德镇',
'1877990':'江西|萍乡',
'1877991':'江西|萍乡',
'1878120':'四川|攀枝花',
'1878121':'四川|攀枝花',
'1878130':'四川|自贡',
'1878131':'四川|自贡',
'1878160':'四川|绵阳',
'1878161':'四川|绵阳',
'1878170':'四川|南充',
'1878171':'四川|南充',
'1878180':'四川|达州',
'1878181':'四川|达州',
'1878250':'四川|遂宁',
'1878251':'四川|遂宁',
'1878260':'四川|广安',
'1878261':'四川|广安',
'1878270':'四川|巴中',
'1878271':'四川|巴中',
'1878300':'重庆',
'1878301':'四川|泸州',
'1878310':'四川|宜宾',
'1878311':'四川|宜宾',
'1878320':'四川|内江',
'1878321':'四川|内江',
'1878330':'四川|乐山',
'1878331':'四川|乐山',
'1878350':'四川|雅安',
'1878351':'四川|雅安',
'1878380':'四川|德阳',
'1878381':'四川|德阳',
'1878390':'四川|广元',
'1878391':'四川|广元',
'1878400':'重庆',
'1878500':'重庆',
'1878510':'贵州|贵阳',
'1878511':'贵州|贵阳',
'1878512':'贵州|贵阳',
'1878520':'贵州|遵义',
'1878521':'贵州|遵义',
'1878530':'贵州|安顺',
'1878531':'贵州|安顺',
'1878560':'贵州|铜仁',
'1878561':'贵州|铜仁',
'1878570':'贵州|毕节',
'1878571':'贵州|毕节',
'1878580':'贵州|六盘水',
'1878581':'贵州|六盘水',
'1878700':'云南|昭通',
'1878701':'云南|昭通',
'1878710':'云南|昆明',
'1878711':'云南|昆明',
'1878712':'云南|昆明',
'1878713':'云南|昆明',
'1878720':'云南|大理',
'1878721':'云南|大理',
'1878740':'云南|曲靖',
'1878741':'云南|曲靖',
'1878750':'云南|保山',
'1878751':'云南|保山',
'1878770':'云南|玉溪',
'1878771':'云南|玉溪',
'1878790':'云南|普洱',
'1878791':'云南|普洱',
'1878880':'云南|丽江',
'1878881':'云南|丽江',
'1878910':'西藏|拉萨',
'1878911':'西藏|拉萨',
'1878920':'西藏|日喀则',
'1878921':'西藏|日喀则',
'1878980':'海南|海口',
'1878981':'海南|海口',
'1878982':'海南|海口',
'1878990':'海南|三亚',
'1878991':'海南|三亚',
'1879110':'陕西|延安',
'1879111':'陕西|延安',
'1879120':'陕西|榆林',
'1879121':'陕西|榆林',
'1879130':'陕西|渭南',
'1879131':'陕西|渭南',
'1879140':'陕西|商洛',
'1879141':'陕西|商洛',
'1879150':'陕西|安康',
'1879151':'陕西|安康',
'1879160':'陕西|汉中',
'1879161':'陕西|汉中',
'1879170':'陕西|宝鸡',
'1879171':'陕西|宝鸡',
'1879190':'陕西|铜川',
'1879191':'陕西|铜川',
'1879310':'甘肃|兰州',
'1879311':'甘肃|兰州',
'1879312':'甘肃|兰州',
'1879370':'甘肃|酒泉',
'1879371':'甘肃|酒泉',
'1879380':'甘肃|天水',
'1879381':'甘肃|天水',
'1879430':'甘肃|白银',
'1879431':'甘肃|白银',
'1879510':'宁夏|银川',
'1879511':'宁夏|银川',
'1879710':'青海|西宁',
'1879711':'青海|西宁',
'1879910':'新疆|乌鲁木齐',
'1879911':'新疆|乌鲁木齐',
'1879912':'新疆|乌鲁木齐',
'1881000':'北京',
'1881100':'北京',
'1881200':'北京',
'1881300':'北京',
'1881400':'北京',
'1881500':'北京',
'1881600':'北京',
'1881700':'北京',
'1881800':'北京',
'1881900':'北京',
'1882000':'广东|广州',
'1882001':'广东|广州',
'1882002':'广东|广州',
'1882003':'广东|广州',
'1882100':'上海',
'1882200':'上海',
'1882300':'上海',
'1882410':'辽宁|沈阳',
'1882411':'辽宁|沈阳',
'1882412':'辽宁|沈阳',
'1882413':'辽宁|沈阳',
'1882500':'江苏|南京',
'1882501':'江苏|南京',
'1882502':'江苏|南京',
'1882503':'江苏|南京',
'1882710':'湖北|武汉',
'1882711':'湖北|武汉',
'1882712':'湖北|武汉',
'1882713':'湖北|武汉',
'1882800':'四川|成都',
'1882801':'四川|成都',
'1882802':'四川|成都',
'1882803':'四川|成都',
'1882900':'陕西|咸阳',
'1882901':'陕西|咸阳',
'1882910':'陕西|西安',
'1882911':'陕西|西安',
'1882912':'陕西|西安',
'1882913':'陕西|西安',
'1883100':'河北|邯郸',
'1883101':'河北|邯郸',
'1883102':'河北|邯郸',
'1883110':'河北|石家庄',
'1883111':'河北|石家庄',
'1883112':'河北|石家庄',
'1883113':'河北|石家庄',
'1883120':'河北|保定',
'1883121':'河北|保定',
'1883122':'河北|保定',
'1883130':'河北|张家口',
'1883131':'河北|张家口',
'1883140':'河北|承德',
'1883141':'河北|承德',
'1883150':'河北|唐山',
'1883151':'河北|唐山',
'1883152':'河北|唐山',
'1883153':'河北|唐山',
'1883160':'河北|廊坊',
'1883161':'河北|廊坊',
'1883170':'河北|沧州',
'1883171':'河北|沧州',
'1883180':'河北|衡水',
'1883181':'河北|衡水',
'1883190':'河北|邢台',
'1883191':'河北|邢台',
'1883350':'河北|秦皇岛',
'1883351':'河北|秦皇岛',
'1883500':'山西|忻州',
'1883501':'山西|忻州',
'1883510':'山西|太原',
'1883511':'山西|太原',
'1883512':'山西|太原',
'1883513':'山西|太原',
'1883520':'山西|大同',
'1883521':'山西|大同',
'1883530':'山西|阳泉',
'1883531':'山西|阳泉',
'1883540':'山西|晋中',
'1883541':'山西|晋中',
'1883550':'山西|长治',
'1883551':'山西|长治',
'1883560':'山西|晋城',
'1883561':'山西|晋城',
'1883570':'山西|临汾',
'1883571':'山西|临汾',
'1883580':'山西|吕梁',
'1883581':'山西|吕梁',
'1883590':'山西|运城',
'1883591':'山西|运城',
'1883700':'河南|商丘',
'1883701':'河南|商丘',
'1883710':'河南|郑州',
'1883711':'河南|郑州',
'1883712':'河南|郑州',
'1883713':'河南|郑州',
'1883720':'河南|安阳',
'1883721':'河南|安阳',
'1883730':'河南|新乡',
'1883731':'河南|新乡',
'1883740':'河南|许昌',
'1883741':'河南|许昌',
'1883750':'河南|平顶山',
'1883751':'河南|平顶山',
'1883760':'河南|信阳',
'1883761':'河南|信阳',
'1883770':'河南|南阳',
'1883771':'河南|南阳',
'1883780':'河南|开封',
'1883781':'河南|开封',
'1883790':'河南|洛阳',
'1883791':'河南|洛阳',
'1883792':'河南|洛阳',
'1883910':'河南|焦作',
'1883911':'河南|焦作',
'1883920':'河南|鹤壁',
'1883921':'河南|鹤壁',
'1883930':'河南|濮阳',
'1883931':'河南|濮阳',
'1883940':'河南|周口',
'1883941':'河南|周口',
'1883950':'河南|漯河',
'1883951':'河南|漯河',
'1883960':'河南|驻马店',
'1883961':'河南|驻马店',
'1883980':'河南|三门峡',
'1883981':'河南|三门峡',
'1884100':'辽宁|铁岭',
'1884101':'辽宁|铁岭',
'1884110':'辽宁|大连',
'1884111':'辽宁|大连',
'1884112':'辽宁|大连',
'1884113':'辽宁|大连',
'1884120':'辽宁|鞍山',
'1884121':'辽宁|鞍山',
'1884130':'辽宁|抚顺',
'1884131':'辽宁|抚顺',
'1884140':'辽宁|本溪',
'1884141':'辽宁|本溪',
'1884150':'辽宁|丹东',
'1884151':'辽宁|丹东',
'1884160':'辽宁|锦州',
'1884161':'辽宁|锦州',
'1884170':'辽宁|营口',
'1884171':'辽宁|营口',
'1884180':'辽宁|阜新',
'1884181':'辽宁|阜新',
'1884190':'辽宁|辽阳',
'1884191':'辽宁|辽阳',
'1884210':'辽宁|朝阳',
'1884211':'辽宁|朝阳',
'1884270':'辽宁|盘锦',
'1884271':'辽宁|盘锦',
'1884290':'辽宁|葫芦岛',
'1884291':'辽宁|葫芦岛',
'1884310':'吉林|长春',
'1884311':'吉林|长春',
'1884312':'吉林|长春',
'1884313':'吉林|长春',
'1884320':'吉林|吉林市',
'1884321':'吉林|吉林市',
'1884340':'吉林|四平',
'1884341':'吉林|四平',
'1884350':'吉林|通化',
'1884351':'吉林|通化',
'1884360':'吉林|白城',
'1884361':'吉林|白城',
'1884370':'吉林|辽源',
'1884371':'吉林|辽源',
'1884380':'吉林|松原',
'1884381':'吉林|松原',
'1884390':'吉林|白山',
'1884391':'吉林|白山',
'1884510':'黑龙江|哈尔滨',
'1884511':'黑龙江|哈尔滨',
'1884512':'黑龙江|哈尔滨',
'1884513':'黑龙江|哈尔滨',
'1884520':'黑龙江|齐齐哈尔',
'1884521':'黑龙江|齐齐哈尔',
'1884530':'黑龙江|牡丹江',
'1884531':'黑龙江|牡丹江',
'1884540':'黑龙江|佳木斯',
'1884541':'黑龙江|佳木斯',
'1884550':'黑龙江|绥化',
'1884551':'黑龙江|绥化',
'1884580':'黑龙江|伊春',
'1884581':'黑龙江|伊春',
'1884590':'黑龙江|大庆',
'1884591':'黑龙江|大庆',
'1884670':'黑龙江|鸡西',
'1884671':'黑龙江|鸡西',
'1884710':'内蒙古|呼和浩特',
'1884711':'内蒙古|呼和浩特',
'1884712':'内蒙古|呼和浩特',
'1884720':'内蒙古|包头',
'1884721':'内蒙古|包头',
'1884730':'内蒙古|乌海',
'1884750':'内蒙古|通辽',
'1884751':'内蒙古|通辽',
'1884760':'内蒙古|赤峰',
'1884761':'内蒙古|赤峰',
'1884770':'内蒙古|鄂尔多斯',
'1884771':'内蒙古|鄂尔多斯',
'1885100':'江苏|无锡',
'1885101':'江苏|无锡',
'1885102':'江苏|无锡',
'1885110':'江苏|镇江',
'1885111':'江苏|镇江',
'1885120':'江苏|苏州',
'1885121':'江苏|苏州',
'1885122':'江苏|苏州',
'1885123':'江苏|苏州',
'1885130':'江苏|南通',
'1885131':'江苏|南通',
'1885132':'江苏|南通',
'1885140':'江苏|扬州',
'1885141':'江苏|扬州',
'1885150':'江苏|盐城',
'1885151':'江苏|盐城',
'1885160':'江苏|徐州',
'1885161':'江苏|徐州',
'1885162':'江苏|徐州',
'1885170':'江苏|淮安',
'1885171':'江苏|淮安',
'1885180':'江苏|连云港',
'1885181':'江苏|连云港',
'1885190':'江苏|常州',
'1885191':'江苏|常州',
'1885192':'江苏|常州',
'1885230':'江苏|泰州',
'1885231':'江苏|泰州',
'1885270':'江苏|宿迁',
'1885271':'江苏|宿迁',
'1885300':'山东|菏泽',
'1885301':'山东|菏泽',
'1885310':'山东|济南',
'1885311':'山东|济南',
'1885312':'山东|济南',
'1885313':'山东|济南',
'1885320':'山东|青岛',
'1885321':'山东|青岛',
'1885322':'山东|青岛',
'1885323':'山东|青岛',
'1885330':'山东|淄博',
'1885331':'山东|淄博',
'1885340':'山东|德州',
'1885341':'山东|德州',
'1885350':'山东|烟台',
'1885351':'山东|烟台',
'1885352':'山东|烟台',
'1885360':'山东|潍坊',
'1885361':'山东|潍坊',
'1885362':'山东|潍坊',
'1885370':'山东|济宁',
'1885371':'山东|济宁',
'1885380':'山东|泰安',
'1885381':'山东|泰安',
'1885390':'山东|临沂',
'1885391':'山东|临沂',
'1885430':'山东|滨州',
'1885431':'山东|滨州',
'1885460':'山东|东营',
'1885461':'山东|东营',
'1885500':'安徽|滁州',
'1885501':'安徽|滁州',
'1885510':'安徽|合肥',
'1885511':'安徽|合肥',
'1885512':'安徽|合肥',
'1885513':'安徽|合肥',
'1885514':'安徽|合肥',
'1885520':'安徽|蚌埠',
'1885521':'安徽|蚌埠',
'1885530':'安徽|芜湖',
'1885531':'安徽|芜湖',
'1885532':'安徽|芜湖',
'1885540':'安徽|淮南',
'1885541':'安徽|淮南',
'1885550':'安徽|马鞍山',
'1885551':'安徽|马鞍山',
'1885560':'安徽|安庆',
'1885561':'安徽|安庆',
'1885570':'安徽|宿州',
'1885571':'安徽|宿州',
'1885580':'安徽|阜阳',
'1885581':'安徽|阜阳',
'1885590':'安徽|黄山',
'1885591':'安徽|黄山',
'1885600':'安徽|合肥',
'1885601':'安徽|合肥',
'1885602':'安徽|合肥',
'1885603':'安徽|合肥',
'1885604':'安徽|合肥',
'1885610':'安徽|淮北',
'1885611':'安徽|淮北',
'1885620':'安徽|铜陵',
'1885621':'安徽|铜陵',
'1885630':'安徽|宣城',
'1885631':'安徽|宣城',
'1885640':'安徽|六安',
'1885641':'安徽|六安',
'1885660':'安徽|池州',
'1885661':'安徽|池州',
'1885700':'浙江|衢州',
'1885701':'浙江|衢州',
'1885710':'浙江|杭州',
'1885711':'浙江|杭州',
'1885712':'浙江|杭州',
'1885713':'浙江|杭州',
'1885720':'浙江|湖州',
'1885721':'浙江|湖州',
'1885730':'浙江|嘉兴',
'1885731':'浙江|嘉兴',
'1885740':'浙江|宁波',
'1885741':'浙江|宁波',
'1885742':'浙江|宁波',
'1885750':'浙江|绍兴',
'1885751':'浙江|绍兴',
'1885760':'浙江|台州',
'1885761':'浙江|台州',
'1885770':'浙江|温州',
'1885771':'浙江|温州',
'1885772':'浙江|温州',
'1885780':'浙江|丽水',
'1885781':'浙江|丽水',
'1885790':'浙江|金华',
'1885791':'浙江|金华',
'1885800':'浙江|舟山',
'1885801':'浙江|舟山',
'1885910':'福建|福州',
'1885911':'福建|福州',
'1885912':'福建|福州',
'1885913':'福建|福州',
'1885920':'福建|厦门',
'1885921':'福建|厦门',
'1885922':'福建|厦门',
'1885930':'福建|宁德',
'1885931':'福建|宁德',
'1885940':'福建|莆田',
'1885941':'福建|莆田',
'1885950':'福建|泉州',
'1885951':'福建|泉州',
'1885952':'福建|泉州',
'1885960':'福建|漳州',
'1885961':'福建|漳州',
'1885970':'福建|龙岩',
'1885971':'福建|龙岩',
'1885980':'福建|三明',
'1885981':'福建|三明',
'1885990':'福建|南平',
'1885991':'福建|南平',
'1886310':'山东|威海',
'1886311':'山东|威海',
'1886320':'山东|枣庄',
'1886321':'山东|枣庄',
'1886330':'山东|日照',
'1886331':'山东|日照',
'1886350':'山东|聊城',
'1886351':'山东|聊城',
'1886600':'广东|汕尾',
'1886601':'广东|汕尾',
'1886620':'广东|阳江',
'1886621':'广东|阳江',
'1886630':'广东|揭阳',
'1886631':'广东|揭阳',
'1886680':'广东|茂名',
'1886681':'广东|茂名',
'1887010':'江西|鹰潭',
'1887011':'江西|鹰潭',
'1887100':'湖北|襄阳',
'1887101':'湖北|襄阳',
'1887110':'湖北|鄂州',
'1887111':'湖北|鄂州',
'1887120':'湖北|孝感',
'1887121':'湖北|孝感',
'1887130':'湖北|黄冈',
'1887131':'湖北|黄冈',
'1887140':'湖北|黄石',
'1887141':'湖北|黄石',
'1887150':'湖北|咸宁',
'1887151':'湖北|咸宁',
'1887160':'湖北|荆州',
'1887161':'湖北|荆州',
'1887170':'湖北|宜昌',
'1887171':'湖北|宜昌',
'1887180':'湖北|恩施',
'1887181':'湖北|恩施',
'1887190':'湖北|十堰',
'1887191':'湖北|十堰',
'1887220':'湖北|随州',
'1887221':'湖北|随州',
'1887240':'湖北|荆门',
'1887241':'湖北|荆门',
'1887300':'湖南|岳阳',
'1887301':'湖南|岳阳',
'1887310':'湖南|长沙',
'1887311':'湖南|长沙',
'1887312':'湖南|长沙',
'1887313':'湖南|长沙',
'1887320':'湖南|湘潭',
'1887321':'湖南|湘潭',
'1887330':'湖南|株洲',
'1887331':'湖南|株洲',
'1887340':'湖南|衡阳',
'1887341':'湖南|衡阳',
'1887350':'湖南|郴州',
'1887351':'湖南|郴州',
'1887360':'湖南|常德',
'1887361':'湖南|常德',
'1887370':'湖南|益阳',
'1887371':'湖南|益阳',
'1887380':'湖南|娄底',
'1887381':'湖南|娄底',
'1887390':'湖南|邵阳',
'1887391':'湖南|邵阳',
'1887440':'湖南|张家界',
'1887441':'湖南|张家界',
'1887450':'湖南|怀化',
'1887451':'湖南|怀化',
'1887460':'湖南|永州',
'1887461':'湖南|永州',
'1887500':'广东|江门',
'1887501':'广东|江门',
'1887510':'广东|韶关',
'1887511':'广东|韶关',
'1887520':'广东|惠州',
'1887521':'广东|惠州',
'1887530':'广东|梅州',
'1887531':'广东|梅州',
'1887540':'广东|汕头',
'1887541':'广东|汕头',
'1887550':'广东|深圳',
'1887551':'广东|深圳',
'1887552':'广东|深圳',
'1887553':'广东|深圳',
'1887560':'广东|珠海',
'1887561':'广东|珠海',
'1887570':'广东|佛山',
'1887571':'广东|佛山',
'1887572':'广东|佛山',
'1887580':'广东|肇庆',
'1887581':'广东|肇庆',
'1887590':'广东|湛江',
'1887591':'广东|湛江',
'1887600':'广东|中山',
'1887601':'广东|中山',
'1887620':'广东|河源',
'1887621':'广东|河源',
'1887630':'广东|清远',
'1887631':'广东|清远',
'1887660':'广东|云浮',
'1887661':'广东|云浮',
'1887680':'广东|潮州',
'1887681':'广东|潮州',
'1887690':'广东|东莞',
'1887691':'广东|东莞',
'1887692':'广东|东莞',
'1887700':'广西|防城港',
'1887701':'广西|防城港',
'1887710':'广西|南宁',
'1887711':'广西|南宁',
'1887712':'广西|南宁',
'1887720':'广西|柳州',
'1887721':'广西|柳州',
'1887730':'广西|桂林',
'1887731':'广西|桂林',
'1887740':'广西|梧州',
'1887741':'广西|梧州',
'1887750':'广西|贵港',
'1887751':'广西|贵港',
'1887760':'广西|百色',
'1887761':'广西|百色',
'1887770':'广西|钦州',
'1887771':'广西|钦州',
'1887780':'广西|河池',
'1887781':'广西|河池',
'1887790':'广西|北海',
'1887791':'广西|北海',
'1887900':'江西|新余',
'1887901':'江西|新余',
'1887910':'江西|南昌',
'1887911':'江西|南昌',
'1887912':'江西|南昌',
'1887913':'江西|南昌',
'1887920':'江西|九江',
'1887921':'江西|九江',
'1887930':'江西|上饶',
'1887931':'江西|上饶',
'1887940':'江西|抚州',
'1887941':'江西|抚州',
'1887950':'江西|宜春',
'1887951':'江西|宜春',
'1887960':'江西|吉安',
'1887961':'江西|吉安',
'1887970':'江西|赣州',
'1887971':'江西|赣州',
'1887980':'江西|景德镇',
'1887981':'江西|景德镇',
'1887990':'江西|萍乡',
'1887991':'江西|萍乡',
'1888120':'四川|攀枝花',
'1888121':'四川|攀枝花',
'1888130':'四川|自贡',
'1888131':'四川|自贡',
'1888160':'四川|绵阳',
'1888161':'四川|绵阳',
'1888170':'四川|南充',
'1888171':'四川|南充',
'1888180':'四川|达州',
'1888181':'四川|达州',
'1888250':'四川|遂宁',
'1888251':'四川|遂宁',
'1888260':'四川|广安',
'1888261':'四川|广安',
'1888270':'四川|巴中',
'1888271':'四川|巴中',
'1888300':'重庆',
'1888301':'四川|泸州',
'1888310':'四川|宜宾',
'1888311':'四川|宜宾',
'1888320':'四川|内江',
'1888321':'四川|内江',
'1888330':'四川|乐山',
'1888331':'四川|乐山',
'1888350':'四川|雅安',
'1888351':'四川|雅安',
'1888380':'四川|德阳',
'1888381':'四川|德阳',
'1888390':'四川|广元',
'1888391':'四川|广元',
'1888400':'重庆',
'1888500':'重庆',
'1888510':'贵州|贵阳',
'1888511':'贵州|贵阳',
'1888512':'贵州|贵阳',
'1888520':'贵州|遵义',
'1888521':'贵州|遵义',
'1888530':'贵州|安顺',
'1888531':'贵州|安顺',
'1888560':'贵州|铜仁',
'1888561':'贵州|铜仁',
'1888570':'贵州|毕节',
'1888571':'贵州|毕节',
'1888580':'贵州|六盘水',
'1888581':'贵州|六盘水',
'1888700':'云南|昭通',
'1888701':'云南|昭通',
'1888710':'云南|昆明',
'1888711':'云南|昆明',
'1888712':'云南|昆明',
'1888713':'云南|昆明',
'1888720':'云南|大理',
'1888721':'云南|大理',
'1888740':'云南|曲靖',
'1888741':'云南|曲靖',
'1888750':'云南|保山',
'1888751':'云南|保山',
'1888770':'云南|玉溪',
'1888771':'云南|玉溪',
'1888790':'云南|普洱',
'1888791':'云南|普洱',
'1888880':'云南|丽江',
'1888881':'云南|丽江',
'1888910':'西藏|拉萨',
'1888911':'西藏|拉萨',
'1888920':'西藏|日喀则',
'1888921':'西藏|日喀则',
'1888980':'海南|海口',
'1888981':'海南|海口',
'1888982':'海南|海口',
'1888990':'海南|三亚',
'1888991':'海南|三亚',
'1889110':'陕西|延安',
'1889111':'陕西|延安',
'1889120':'陕西|榆林',
'1889121':'陕西|榆林',
'1889130':'陕西|渭南',
'1889131':'陕西|渭南',
'1889140':'陕西|商洛',
'1889141':'陕西|商洛',
'1889150':'陕西|安康',
'1889151':'陕西|安康',
'1889160':'陕西|汉中',
'1889161':'陕西|汉中',
'1889170':'陕西|宝鸡',
'1889171':'陕西|宝鸡',
'1889190':'陕西|铜川',
'1889191':'陕西|铜川',
'1889310':'甘肃|兰州',
'1889311':'甘肃|兰州',
'1889312':'甘肃|兰州',
'1889370':'甘肃|酒泉',
'1889371':'甘肃|酒泉',
'1889380':'甘肃|天水',
'1889381':'甘肃|天水',
'1889430':'甘肃|白银',
'1889431':'甘肃|白银',
'1889510':'宁夏|银川',
'1889511':'宁夏|银川',
'1889710':'青海|西宁',
'1889711':'青海|西宁',
'1889910':'新疆|乌鲁木齐',
'1889911':'新疆|乌鲁木齐',
'1889912':'新疆|乌鲁木齐',
'1891000':'北京',
'1891100':'北京',
'1891200':'北京',
'1891300':'北京',
'1891400':'北京',
'1891500':'北京',
'1891600':'北京',
'1891700':'北京',
'1891800':'北京',
'1891900':'北京',
'1892000':'广东|广州',
'1892001':'广东|广州',
'1892002':'广东|广州',
'1892003':'广东|广州',
'1892100':'上海',
'1892200':'上海',
'1892300':'上海',
'1892410':'辽宁|沈阳',
'1892411':'辽宁|沈阳',
'1892412':'辽宁|沈阳',
'1892413':'辽宁|沈阳',
'1892500':'江苏|南京',
'1892501':'江苏|南京',
'1892502':'江苏|南京',
'1892503':'江苏|南京',
'1892710':'湖北|武汉',
'1892711':'湖北|武汉',
'1892712':'湖北|武汉',
'1892713':'湖北|武汉',
'1892800':'四川|成都',
'1892801':'四川|成都',
'1892802':'四川|成都',
'1892803':'四川|成都',
'1892900':'陕西|咸阳',
'1892901':'陕西|咸阳',
'1892910':'陕西|西安',
'1892911':'陕西|西安',
'1892912':'陕西|西安',
'1892913':'陕西|西安',
'1893100':'河北|邯郸',
'1893101':'河北|邯郸',
'1893102':'河北|邯郸',
'1893110':'河北|石家庄',
'1893111':'河北|石家庄',
'1893112':'河北|石家庄',
'1893113':'河北|石家庄',
'1893120':'河北|保定',
'1893121':'河北|保定',
'1893122':'河北|保定',
'1893130':'河北|张家口',
'1893131':'河北|张家口',
'1893140':'河北|承德',
'1893141':'河北|承德',
'1893150':'河北|唐山',
'1893151':'河北|唐山',
'1893152':'河北|唐山',
'1893153':'河北|唐山',
'1893160':'河北|廊坊',
'1893161':'河北|廊坊',
'1893170':'河北|沧州',
'1893171':'河北|沧州',
'1893180':'河北|衡水',
'1893181':'河北|衡水',
'1893190':'河北|邢台',
'1893191':'河北|邢台',
'1893350':'河北|秦皇岛',
'1893351':'河北|秦皇岛',
'1893500':'山西|忻州',
'1893501':'山西|忻州',
'1893510':'山西|太原',
'1893511':'山西|太原',
'1893512':'山西|太原',
'1893513':'山西|太原',
'1893520':'山西|大同',
'1893521':'山西|大同',
'1893530':'山西|阳泉',
'1893531':'山西|阳泉',
'1893540':'山西|晋中',
'1893541':'山西|晋中',
'1893550':'山西|长治',
'1893551':'山西|长治',
'1893560':'山西|晋城',
'1893561':'山西|晋城',
'1893570':'山西|临汾',
'1893571':'山西|临汾',
'1893580':'山西|吕梁',
'1893581':'山西|吕梁',
'1893590':'山西|运城',
'1893591':'山西|运城',
'1893700':'河南|商丘',
'1893701':'河南|商丘',
'1893710':'河南|郑州',
'1893711':'河南|郑州',
'1893712':'河南|郑州',
'1893713':'河南|郑州',
'1893720':'河南|安阳',
'1893721':'河南|安阳',
'1893730':'河南|新乡',
'1893731':'河南|新乡',
'1893740':'河南|许昌',
'1893741':'河南|许昌',
'1893750':'河南|平顶山',
'1893751':'河南|平顶山',
'1893760':'河南|信阳',
'1893761':'河南|信阳',
'1893770':'河南|南阳',
'1893771':'河南|南阳',
'1893780':'河南|开封',
'1893781':'河南|开封',
'1893790':'河南|洛阳',
'1893791':'河南|洛阳',
'1893792':'河南|洛阳',
'1893910':'河南|焦作',
'1893911':'河南|焦作',
'1893920':'河南|鹤壁',
'1893921':'河南|鹤壁',
'1893930':'河南|濮阳',
'1893931':'河南|濮阳',
'1893940':'河南|周口',
'1893941':'河南|周口',
'1893950':'河南|漯河',
'1893951':'河南|漯河',
'1893960':'河南|驻马店',
'1893961':'河南|驻马店',
'1893980':'河南|三门峡',
'1893981':'河南|三门峡',
'1894100':'辽宁|铁岭',
'1894101':'辽宁|铁岭',
'1894110':'辽宁|大连',
'1894111':'辽宁|大连',
'1894112':'辽宁|大连',
'1894113':'辽宁|大连',
'1894120':'辽宁|鞍山',
'1894121':'辽宁|鞍山',
'1894130':'辽宁|抚顺',
'1894131':'辽宁|抚顺',
'1894140':'辽宁|本溪',
'1894141':'辽宁|本溪',
'1894150':'辽宁|丹东',
'1894151':'辽宁|丹东',
'1894160':'辽宁|锦州',
'1894161':'辽宁|锦州',
'1894170':'辽宁|营口',
'1894171':'辽宁|营口',
'1894180':'辽宁|阜新',
'1894181':'辽宁|阜新',
'1894190':'辽宁|辽阳',
'1894191':'辽宁|辽阳',
'1894210':'辽宁|朝阳',
'1894211':'辽宁|朝阳',
'1894270':'辽宁|盘锦',
'1894271':'辽宁|盘锦',
'1894290':'辽宁|葫芦岛',
'1894291':'辽宁|葫芦岛',
'1894310':'吉林|长春',
'1894311':'吉林|长春',
'1894312':'吉林|长春',
'1894313':'吉林|长春',
'1894320':'吉林|吉林市',
'1894321':'吉林|吉林市',
'1894340':'吉林|四平',
'1894341':'吉林|四平',
'1894350':'吉林|通化',
'1894351':'吉林|通化',
'1894360':'吉林|白城',
'1894361':'吉林|白城',
'1894370':'吉林|辽源',
'1894371':'吉林|辽源',
'1894380':'吉林|松原',
'1894381':'吉林|松原',
'1894390':'吉林|白山',
'1894391':'吉林|白山',
'1894510':'黑龙江|哈尔滨',
'1894511':'黑龙江|哈尔滨',
'1894512':'黑龙江|哈尔滨',
'1894513':'黑龙江|哈尔滨',
'1894520':'黑龙江|齐齐哈尔',
'1894521':'黑龙江|齐齐哈尔',
'1894530':'黑龙江|牡丹江',
'1894531':'黑龙江|牡丹江',
'1894540':'黑龙江|佳木斯',
'1894541':'黑龙江|佳木斯',
'1894550':'黑龙江|绥化',
'1894551':'黑龙江|绥化',
'1894580':'黑龙江|伊春',
'1894581':'黑龙江|伊春',
'1894590':'黑龙江|大庆',
'1894591':'黑龙江|大庆',
'1894670':'黑龙江|鸡西',
'1894671':'黑龙江|鸡西',
'1894710':'内蒙古|呼和浩特',
'1894711':'内蒙古|呼和浩特',
'1894712':'内蒙古|呼和浩特',
'1894720':'内蒙古|包头',
'1894721':'内蒙古|包头',
'1894730':'内蒙古|乌海',
'1894750':'内蒙古|通辽',
'1894751':'内蒙古|通辽',
'1894760':'内蒙古|赤峰',
'1894761':'内蒙古|赤峰',
'1894770':'内蒙古|鄂尔多斯',
'1894771':'内蒙古|鄂尔多斯',
'1895100':'江苏|无锡',
'1895101':'江苏|无锡',
'1895102':'江苏|无锡',
'1895110':'江苏|镇江',
'1895111':'江苏|镇江',
'1895120':'江苏|苏州',
'1895121':'江苏|苏州',
'1895122':'江苏|苏州',
'1895123':'江苏|苏州',
'1895130':'江苏|南通',
'1895131':'江苏|南通',
'1895132':'江苏|南通',
'1895140':'江苏|扬州',
'1895141':'江苏|扬州',
'1895150':'江苏|盐城',
'1895151':'江苏|盐城',
'1895160':'江苏|徐州',
'1895161':'江苏|徐州',
'1895162':'江苏|徐州',
'1895170':'江苏|淮安',
'1895171':'江苏|淮安',
'1895180':'江苏|连云港',
'1895181':'江苏|连云港',
'1895190':'江苏|常州',
'1895191':'江苏|常州',
'1895192':'江苏|常州',
'1895230':'江苏|泰州',
'1895231':'江苏|泰州',
'1895270':'江苏|宿迁',
'1895271':'江苏|宿迁',
'1895300':'山东|菏泽',
'1895301':'山东|菏泽',
'1895310':'山东|济南',
'1895311':'山东|济南',
'1895312':'山东|济南',
'1895313':'山东|济南',
'1895320':'山东|青岛',
'1895321':'山东|青岛',
'1895322':'山东|青岛',
'1895323':'山东|青岛',
'1895330':'山东|淄博',
'1895331':'山东|淄博',
'1895340':'山东|德州',
'1895341':'山东|德州',
'1895350':'山东|烟台',
'1895351':'山东|烟台',
'1895352':'山东|烟台',
'1895360':'山东|潍坊',
'1895361':'山东|潍坊',
'1895362':'山东|潍坊',
'1895370':'山东|济宁',
'1895371':'山东|济宁',
'1895380':'山东|泰安',
'1895381':'山东|泰安',
'1895390':'山东|临沂',
'1895391':'山东|临沂',
'1895430':'山东|滨州',
'1895431':'山东|滨州',
'1895460':'山东|东营',
'1895461':'山东|东营',
'1895500':'安徽|滁州',
'1895501':'安徽|滁州',
'1895510':'安徽|合肥',
'1895511':'安徽|合肥',
'1895512':'安徽|合肥',
'1895513':'安徽|合肥',
'1895514':'安徽|合肥',
'1895520':'安徽|蚌埠',
'1895521':'安徽|蚌埠',
'1895530':'安徽|芜湖',
'1895531':'安徽|芜湖',
'1895532':'安徽|芜湖',
'1895540':'安徽|淮南',
'1895541':'安徽|淮南',
'1895550':'安徽|马鞍山',
'1895551':'安徽|马鞍山',
'1895560':'安徽|安庆',
'1895561':'安徽|安庆',
'1895570':'安徽|宿州',
'1895571':'安徽|宿州',
'1895580':'安徽|阜阳',
'1895581':'安徽|阜阳',
'1895590':'安徽|黄山',
'1895591':'安徽|黄山',
'1895600':'安徽|合肥',
'1895601':'安徽|合肥',
'1895602':'安徽|合肥',
'1895603':'安徽|合肥',
'1895604':'安徽|合肥',
'1895610':'安徽|淮北',
'1895611':'安徽|淮北',
'1895620':'安徽|铜陵',
'1895621':'安徽|铜陵',
'1895630':'安徽|宣城',
'1895631':'安徽|宣城',
'1895640':'安徽|六安',
'1895641':'安徽|六安',
'1895660':'安徽|池州',
'1895661':'安徽|池州',
'1895700':'浙江|衢州',
'1895701':'浙江|衢州',
'1895710':'浙江|杭州',
'1895711':'浙江|杭州',
'1895712':'浙江|杭州',
'1895713':'浙江|杭州',
'1895720':'浙江|湖州',
'1895721':'浙江|湖州',
'1895730':'浙江|嘉兴',
'1895731':'浙江|嘉兴',
'1895740':'浙江|宁波',
'1895741':'浙江|宁波',
'1895742':'浙江|宁波',
'1895750':'浙江|绍兴',
'1895751':'浙江|绍兴',
'1895760':'浙江|台州',
'1895761':'浙江|台州',
'1895770':'浙江|温州',
'1895771':'浙江|温州',
'1895772':'浙江|温州',
'1895780':'浙江|丽水',
'1895781':'浙江|丽水',
'1895790':'浙江|金华',
'1895791':'浙江|金华',
'1895800':'浙江|舟山',
'1895801':'浙江|舟山',
'1895910':'福建|福州',
'1895911':'福建|福州',
'1895912':'福建|福州',
'1895913':'福建|福州',
'1895920':'福建|厦门',
'1895921':'福建|厦门',
'1895922':'福建|厦门',
'1895930':'福建|宁德',
'1895931':'福建|宁德',
'1895940':'福建|莆田',
'1895941':'福建|莆田',
'1895950':'福建|泉州',
'1895951':'福建|泉州',
'1895952':'福建|泉州',
'1895960':'福建|漳州',
'1895961':'福建|漳州',
'1895970':'福建|龙岩',
'1895971':'福建|龙岩',
'1895980':'福建|三明',
'1895981':'福建|三明',
'1895990':'福建|南平',
'1895991':'福建|南平',
'1896310':'山东|威海',
'1896311':'山东|威海',
'1896320':'山东|枣庄',
'1896321':'山东|枣庄',
'1896330':'山东|日照',
'1896331':'山东|日照',
'1896350':'山东|聊城',
'1896351':'山东|聊城',
'1896600':'广东|汕尾',
'1896601':'广东|汕尾',
'1896620':'广东|阳江',
'1896621':'广东|阳江',
'1896630':'广东|揭阳',
'1896631':'广东|揭阳',
'1896680':'广东|茂名',
'1896681':'广东|茂名',
'1897010':'江西|鹰潭',
'1897011':'江西|鹰潭',
'1897100':'湖北|襄阳',
'1897101':'湖北|襄阳',
'1897110':'湖北|鄂州',
'1897111':'湖北|鄂州',
'1897120':'湖北|孝感',
'1897121':'湖北|孝感',
'1897130':'湖北|黄冈',
'1897131':'湖北|黄冈',
'1897140':'湖北|黄石',
'1897141':'湖北|黄石',
'1897150':'湖北|咸宁',
'1897151':'湖北|咸宁',
'1897160':'湖北|荆州',
'1897161':'湖北|荆州',
'1897170':'湖北|宜昌',
'1897171':'湖北|宜昌',
'1897180':'湖北|恩施',
'1897181':'湖北|恩施',
'1897190':'湖北|十堰',
'1897191':'湖北|十堰',
'1897220':'湖北|随州',
'1897221':'湖北|随州',
'1897240':'湖北|荆门',
'1897241':'湖北|荆门',
'1897300':'湖南|岳阳',
'1897301':'湖南|岳阳',
'1897310':'湖南|长沙',
'1897311':'湖南|长沙',
'1897312':'湖南|长沙',
'1897313':'湖南|长沙',
'1897320':'湖南|湘潭',
'1897321':'湖南|湘潭',
'1897330':'湖南|株洲',
'1897331':'湖南|株洲',
'1897340':'湖南|衡阳',
'1897341':'湖南|衡阳',
'1897350':'湖南|郴州',
'1897351':'湖南|郴州',
'1897360':'湖南|常德',
'1897361':'湖南|常德',
'1897370':'湖南|益阳',
'1897371':'湖南|益阳',
'1897380':'湖南|娄底',
'1897381':'湖南|娄底',
'1897390':'湖南|邵阳',
'1897391':'湖南|邵阳',
'1897440':'湖南|张家界',
'1897441':'湖南|张家界',
'1897450':'湖南|怀化',
'1897451':'湖南|怀化',
'1897460':'湖南|永州',
'1897461':'湖南|永州',
'1897500':'广东|江门',
'1897501':'广东|江门',
'1897510':'广东|韶关',
'1897511':'广东|韶关',
'1897520':'广东|惠州',
'1897521':'广东|惠州',
'1897530':'广东|梅州',
'1897531':'广东|梅州',
'1897540':'广东|汕头',
'1897541':'广东|汕头',
'1897550':'广东|深圳',
'1897551':'广东|深圳',
'1897552':'广东|深圳',
'1897553':'广东|深圳',
'1897560':'广东|珠海',
'1897561':'广东|珠海',
'1897570':'广东|佛山',
'1897571':'广东|佛山',
'1897572':'广东|佛山',
'1897580':'广东|肇庆',
'1897581':'广东|肇庆',
'1897590':'广东|湛江',
'1897591':'广东|湛江',
'1897600':'广东|中山',
'1897601':'广东|中山',
'1897620':'广东|河源',
'1897621':'广东|河源',
'1897630':'广东|清远',
'1897631':'广东|清远',
'1897660':'广东|云浮',
'1897661':'广东|云浮',
'1897680':'广东|潮州',
'1897681':'广东|潮州',
'1897690':'广东|东莞',
'1897691':'广东|东莞',
'1897692':'广东|东莞',
'1897700':'广西|防城港',
'1897701':'广西|防城港',
'1897710':'广西|南宁',
'1897711':'广西|南宁',
'1897712':'广西|南宁',
'1897720':'广西|柳州',
'1897721':'广西|柳州',
'1897730':'广西|桂林',
'1897731':'广西|桂林',
'1897740':'广西|梧州',
'1897741':'广西|梧州',
'1897750':'广西|贵港',
'1897751':'广西|贵港',
'1897760':'广西|百色',
'1897761':'广西|百色',
'1897770':'广西|钦州',
'1897771':'广西|钦州',
'1897780':'广西|河池',
'1897781':'广西|河池',
'1897790':'广西|北海',
'1897791':'广西|北海',
'1897900':'江西|新余',
'1897901':'江西|新余',
'1897910':'江西|南昌',
'1897911':'江西|南昌',
'1897912':'江西|南昌',
'1897913':'江西|南昌',
'1897920':'江西|九江',
'1897921':'江西|九江',
'1897930':'江西|上饶',
'1897931':'江西|上饶',
'1897940':'江西|抚州',
'1897941':'江西|抚州',
'1897950':'江西|宜春',
'1897951':'江西|宜春',
'1897960':'江西|吉安',
'1897961':'江西|吉安',
'1897970':'江西|赣州',
'1897971':'江西|赣州',
'1897980':'江西|景德镇',
'1897981':'江西|景德镇',
'1897990':'江西|萍乡',
'1897991':'江西|萍乡',
'1898120':'四川|攀枝花',
'1898121':'四川|攀枝花',
'1898130':'四川|自贡',
'1898131':'四川|自贡',
'1898160':'四川|绵阳',
'1898161':'四川|绵阳',
'1898170':'四川|南充',
'1898171':'四川|南充',
'1898180':'四川|达州',
'1898181':'四川|达州',
'1898250':'四川|遂宁',
'1898251':'四川|遂宁',
'1898260':'四川|广安',
'1898261':'四川|广安',
'1898270':'四川|巴中',
'1898271':'四川|巴中',
'1898300':'重庆',
'1898301':'四川|泸州',
'1898310':'四川|宜宾',
'1898311':'四川|宜宾',
'1898320':'四川|内江',
'1898321':'四川|内江',
'1898330':'四川|乐山',
'1898331':'四川|乐山',
'1898350':'四川|雅安',
'1898351':'四川|雅安',
'1898380':'四川|德阳',
'1898381':'四川|德阳',
'1898390':'四川|广元',
'1898391':'四川|广元',
'1898400':'重庆',
'1898500':'重庆',
'1898510':'贵州|贵阳',
'1898511':'贵州|贵阳',
'1898512':'贵州|贵阳',
'1898520':'贵州|遵义',
'1898521':'贵州|遵义',
'1898530':'贵州|安顺',
'1898531':'贵州|安顺',
'1898560':'贵州|铜仁',
'1898561':'贵州|铜仁',
'1898570':'贵州|毕节',
'1898571':'贵州|毕节',
'1898580':'贵州|六盘水',
'1898581':'贵州|六盘水',
'1898700':'云南|昭通',
'1898701':'云南|昭通',
'1898710':'云南|昆明',
'1898711':'云南|昆明',
'1898712':'云南|昆明',
'1898713':'云南|昆明',
'1898720':'云南|大理',
'1898721':'云南|大理',
'1898740':'云南|曲靖',
'1898741':'云南|曲靖',
'1898750':'云南|保山',
'1898751':'云南|保山',
'1898770':'云南|玉溪',
'1898771':'云南|玉溪',
'1898790':'云南|普洱',
'1898791':'云南|普洱',
'1898880':'云南|丽江',
'1898881':'云南|丽江',
'1898910':'西藏|拉萨',
'1898911':'西藏|拉萨',
'1898920':'西藏|日喀则',
'1898921':'西藏|日喀则',
'1898980':'海南|海口',
'1898981':'海南|海口',
'1898982':'海南|海口',
'1898990':'海南|三亚',
'1898991':'海南|三亚',
'1899110':'陕西|延安',
'1899111':'陕西|延安',
'1899120':'陕西|榆林',
'1899121':'陕西|榆林',
'1899130':'陕西|渭南',
'1899131':'陕西|渭南',
'1899140':'陕西|商洛',
'1899141':'陕西|商洛',
'1899150':'陕西|安康',
'1899151':'陕西|安康',
'1899160':'陕西|汉中',
'1899161':'陕西|汉中',
'1899170':'陕西|宝鸡',
'1899171':'陕西|宝鸡',
'1899190':'陕西|铜川',
'1899191':'陕西|铜川',
'1899310':'甘肃|兰州',
'1899311':'甘肃|兰州',
'1899312':'甘肃|兰州',
'1899370':'甘肃|酒泉',
'1899371':'甘肃|酒泉',
'1899380':'甘肃|天水',
'1899381':'甘肃|天水',
'1899430':'甘肃|白银',
'1899431':'甘肃|白银',
'1899510':'宁夏|银川',
'1899511':'宁夏|银川',
'1899710':'青海|西宁',
'1899711':'青海|西宁',
'1899910':'新疆|乌鲁木齐',
'1899911':'新疆|乌鲁木齐',
'1899912':'新疆|乌鲁木齐',
}